/* Options:
Date: 2026-07-21 14:28:49
Version: 8.90
Tip: To override a DTO option, remove "//" prefix before updating
BaseUrl: https://localhost:5047

//GlobalNamespace: 
//MakePropertiesOptional: False
//AddServiceStackTypes: True
//AddResponseStatus: False
//AddImplicitVersion: 
//AddDescriptionAsComments: True
//IncludeTypes: 
//ExcludeTypes: 
//DefaultImports: 
*/

// Import missing types that ServiceStack doesn't generate
import type { Cookie, NameValueCollection, FileInfo, Func, IDisposable, HttpStatusCode } from './Tmd.dtos.extensions';

export interface IReturn<T>
{
    createResponse(): T;
}

export interface IReturnVoid
{
    createResponse(): void;
}

export interface IHasSessionId
{
    sessionId?: string;
}

export interface IHasBearerToken
{
    bearerToken?: string;
}

export interface IGet
{
}

export interface IPost
{
}

export enum CommitteeType
{
    Committee = 0,
    Group = 1,
}

export class Committee implements IForm
{
    public id?: number;
    public name?: string;
    public rank?: number;
    public adminOnly: boolean;
    public tmdAdminCanEdit: boolean;
    public committeeType?: CommitteeType;
    public active: boolean;
    public createLogin?: boolean;
    public syncGroup?: boolean;
    public onlineGroupId?: number;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<Committee>) { (Object as any).assign(this, init); }
}

export class State
{
    public id?: number;
    public value: string;
    public rank?: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<State>) { (Object as any).assign(this, init); }
}

export class Country
{
    public id?: number;
    public value: string;
    public rank?: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<Country>) { (Object as any).assign(this, init); }
}

export class AddressOption implements IForm
{
    public id?: number;
    public value: string;
    public rank: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<AddressOption>) { (Object as any).assign(this, init); }
}

export enum CalculationMethod
{
    EitherSideOfBaseline = 1,
    AbsoluteValues = 2,
}

export class ItemComponentType implements IForm
{
    public id?: number;
    public value: string;
    public rank?: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<ItemComponentType>) { (Object as any).assign(this, init); }
}

export enum ItemPrimitive
{
    Label = 1,
    Text = 2,
    Comments = 3,
    Date = 4,
    Checkbox = 5,
    Documents = 6,
    Numeric = 7,
    Select = 8,
}

export class ItemComponentPrimitiveOption implements ISubForm
{
    public id: number;
    public itemComponentPrimitiveId: number;
    public value: string;
    public active: boolean;
    public rank: number;
    public measurement: number;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<ItemComponentPrimitiveOption>) { (Object as any).assign(this, init); }
}

export enum ItemPrimitiveRule
{
    IsEnabledIf = 1,
    IsDisabledIf = 2,
    RequiredIf = 3,
    Required = 4,
}

export class ItemComponentRule implements ISubForm
{
    public id: number;
    public itemComponentId: number;
    public itemComponentPrimitiveId: number;
    public itemPrimitiveRule: ItemPrimitiveRule;
    public compareItemComponentPrimitiveId: number;
    public compareItemComponentPrimitiveColumn: number;
    public compareItemComponentPrimitiveIndexInColumn: number;
    public compareValue: string;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<ItemComponentRule>) { (Object as any).assign(this, init); }
}

export class ItemComponentPrimitive implements ISubForm
{
    public id: number;
    public itemComponentId: number;
    public itemComponent: ItemComponent;
    public itemPrimitive: ItemPrimitive;
    public label: string;
    public instructions: string;
    public active: boolean;
    public rank: number;
    public measure: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public itemComponentPrimitiveOptions: ItemComponentPrimitiveOption[];
    public itemComponentRules: ItemComponentRule[];
    public isQuestion: boolean;

    public constructor(init?: Partial<ItemComponentPrimitive>) { (Object as any).assign(this, init); }
}

export enum FileState
{
    Uploading = 1,
    Success = 2,
    Failure = 3,
    Cancelled = 4,
    Empty = 5,
}

export class TemporaryFile
{
    public id: string;
    public name: string;
    public contentType: string;
    public extension: string;
    public fileSize?: number;
    public image?: boolean;
    public dateUploaded?: string;

    public constructor(init?: Partial<TemporaryFile>) { (Object as any).assign(this, init); }
}

export class TemporaryFileInformation
{
    public state: FileState;
    public progress: string;
    public guid: string;
    public temporaryFile: TemporaryFile;

    public constructor(init?: Partial<TemporaryFileInformation>) { (Object as any).assign(this, init); }
}

export class SourceDocument implements IAudited
{
    public id?: number;
    public formName: string;
    public recordId?: number;
    public subRecordId?: number;
    public fileType?: number;
    public name: string;
    public extension: string;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public isPersonnelItem: boolean;
    public sharepointLink: string;
    public image: boolean;
    public fileInformation: TemporaryFileInformation;
    public guid: string;
    public fileSize: number;
    public contentType: string;
    public exists: boolean;
    public certificateDate?: string;
    public expiryDate?: string;

    public constructor(init?: Partial<SourceDocument>) { (Object as any).assign(this, init); }
}

export class ItemComponent implements IForm
{
    public id?: number;
    public name: string;
    public isSystem: boolean;
    public active: boolean;
    public rank: number;
    public customInputControlName: string;
    public itemComponentTypeId?: number;
    public itemComponentType: ItemComponentType;
    public description: string;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public itemComponentPrimitives: ItemComponentPrimitive[];
    public itemComponentRules: ItemComponentRule[];
    public sourceDocuments: SourceDocument[];

    public constructor(init?: Partial<ItemComponent>) { (Object as any).assign(this, init); }
}

export class CollectionSection implements ISubForm
{
    public id: number;
    public collectionId?: number;
    public name: string;
    public rank: number;
    public canAssign: boolean;
    public isNaAllowed: boolean;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<CollectionSection>) { (Object as any).assign(this, init); }
}

export class CollectionItemComponentOverride implements ISubForm
{
    public id: number;
    public collectionId?: number;
    public collectionItemComponentId: number;
    public itemComponentPrimitiveId: number;
    public originalLabel: string;
    public originalInstructions: string;
    public label: string;
    public instructions: string;
    public readonly: boolean;
    public required: boolean;
    public bulkSetValue: string;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public collection: Collection;
    public collectionItemComponent: CollectionItemComponent;

    public constructor(init?: Partial<CollectionItemComponentOverride>) { (Object as any).assign(this, init); }
}

export class ReportingTagCategory
{
    public id?: number;
    public value: string;
    public rank?: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<ReportingTagCategory>) { (Object as any).assign(this, init); }
}

export class ReportingTag
{
    public id?: number;
    public value: string;
    public reportingTagCategoryId?: number;
    public reportingTagCategory: ReportingTagCategory;
    public rank?: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<ReportingTag>) { (Object as any).assign(this, init); }
}

export class CollectionItemComponent implements ISubForm
{
    public id: number;
    public collectionId?: number;
    public itemComponentId: number;
    public collectionSectionId: number;
    public active: boolean;
    public rank: number;
    public column: number;
    public isNaAllowed: boolean;
    public isRequired: boolean;
    public instructions: string;
    public overrideLabel: string;
    public reportingTagId: number;
    public baselineAmount: number;
    public minValue?: number;
    public maxValue?: number;
    public calculationMethod: CalculationMethod;
    public calculation1CollectionItemComponentId?: number;
    public calculation2CollectionItemComponentId?: number;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public itemComponent: ItemComponent;
    public collectionSection: CollectionSection;
    public collectionItemComponentOverrides: CollectionItemComponentOverride[];
    public reportingTag: ReportingTag;
    public isLocked: boolean;

    public constructor(init?: Partial<CollectionItemComponent>) { (Object as any).assign(this, init); }
}

export class Collection implements IForm
{
    public id?: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public collectionItemComponents: CollectionItemComponent[];
    public collectionSections: CollectionSection[];
    public collectionItemComponentOverrides: CollectionItemComponentOverride[];

    public constructor(init?: Partial<Collection>) { (Object as any).assign(this, init); }
}

export class CollectionInstanceData implements ISubForm
{
    public id: number;
    public collectionInstanceId: number;
    public collectionItemComponentId: number;
    public collectionItemComponent: CollectionItemComponent;
    public itemComponentId: number;
    public itemComponent: ItemComponent;
    public itemComponentPrimitiveId: number;
    public itemComponentPrimitive: ItemComponentPrimitive;
    public textValue: string;
    public bitValue?: boolean;
    public numberValue?: number;
    public intValue?: number;
    public dateValue?: string;
    public isNa?: boolean;
    public version: string;
    public justified: boolean;
    public dateJustified?: string;
    public justifiedBy: string;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public isModified: boolean;

    public constructor(init?: Partial<CollectionInstanceData>) { (Object as any).assign(this, init); }
}

export class Salutation
{
    public id?: number;
    public value: string;
    public rank?: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<Salutation>) { (Object as any).assign(this, init); }
}

export class MembershipType
{
    public id?: number;
    public value: string;
    public rank?: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<MembershipType>) { (Object as any).assign(this, init); }
}

export class ProfessionalDiscipline
{
    public id?: number;
    public value: string;
    public rank?: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<ProfessionalDiscipline>) { (Object as any).assign(this, init); }
}

export enum PersonnelRoleSummaryType
{
    General = 1,
    Group = 2,
    MasterGroup = 3,
    Institution = 4,
    Trial = 5,
    TrialCoordinatingGroup = 6,
    TrialInstitution = 7,
    Role = 8,
    Department = 9,
    Laboratory = 10,
    TrialGroup = 11,
    TrialInstitutionLaboratory = 12,
    TrialGroupLaboratory = 13,
}

export class RolePermissionMatrix
{
    public roleGroupId: number;
    public institutionMatch: boolean;
    public configurationDescription: string;
    public moduleName: string;
    public moduleDescription: string;
    public roleId: number;
    public roleName: string;
    public permissionName: string;
    public permissionDescription: string;

    public constructor(init?: Partial<RolePermissionMatrix>) { (Object as any).assign(this, init); }
}

export class GroupedRolePermission
{
    public moduleName: string;
    public moduleDescription: string;
    public permissions: RolePermissionMatrix[];

    public constructor(init?: Partial<GroupedRolePermission>) { (Object as any).assign(this, init); }
}

export class Role
{
    public id?: number;
    public value: string;
    public rank?: number;
    public active: boolean;
    public description: string;
    public openClinciaRoleId?: number;
    public openClinciaInstitutionRoleId?: number;
    public saeRoleId?: number;
    public drugManagementAccess: boolean;
    public opmsAccess: boolean;
    public isSystem: boolean;
    public createLogin?: boolean;
    public restrictedAccessAllowed?: boolean;
    public randomisationAllowed?: boolean;
    public syncGroup?: boolean;
    public unrestrictedByInst?: boolean;
    public forceResendEmail?: boolean;
    public openClinicaLogin?: boolean;
    public openClinicaMonitorAccess?: boolean;
    public cvAndMedicalRegistrationRequired?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public modules: { [index:string]: string; };
    public groupedRolePermissions: GroupedRolePermission[];

    public constructor(init?: Partial<Role>) { (Object as any).assign(this, init); }
}

export class PathologyDepartment implements IForm
{
    public id?: number;
    public name: string;
    public rank?: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<PathologyDepartment>) { (Object as any).assign(this, init); }
}

export class LaboratoryDepartment implements IForm
{
    public id?: number;
    public laboratoryId: number;
    public laboratory: Laboratory;
    public pathologyDepartmentId: number;
    public pathologyDepartment: PathologyDepartment;
    public expiryDate?: string;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<LaboratoryDepartment>) { (Object as any).assign(this, init); }
}

export class LaboratoryPersonnel implements IForm
{
    public id?: number;
    public laboratoryId: number;
    public laboratory: Laboratory;
    public personnelId: number;
    public personnel: Personnel;
    public positionNo?: number;
    public roleId: number;
    public role: Role;
    public dateStarted?: string;
    public dateCeased?: string;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public active: boolean;

    public constructor(init?: Partial<LaboratoryPersonnel>) { (Object as any).assign(this, init); }
}

export class InstitutionType
{
    public id?: number;
    public value: string;
    public rank?: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<InstitutionType>) { (Object as any).assign(this, init); }
}

export class SiteLocation
{
    public id?: number;
    public value: string;
    public rank?: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<SiteLocation>) { (Object as any).assign(this, init); }
}

export class FacilityAllianceMember
{
    public id?: number;
    public value: string;
    public rank?: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<FacilityAllianceMember>) { (Object as any).assign(this, init); }
}

export class KeyContact
{
    public id?: number;
    public value: string;
    public rank?: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<KeyContact>) { (Object as any).assign(this, init); }
}

export class TrialInstitutionStatus implements IForm
{
    public id?: number;
    public value: string;
    public rank?: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<TrialInstitutionStatus>) { (Object as any).assign(this, init); }
}

export class InstitutionClosureReason implements IForm
{
    public id?: number;
    public value: string;
    public rank?: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<InstitutionClosureReason>) { (Object as any).assign(this, init); }
}

export class TrialInstitutionItem implements IForm
{
    public id?: number;
    public trialInstitutionId: number;
    public trialInstitution: TrialInstitution;
    public trialInstitutionItemTemplateId: number;
    public trialInstitutionItemTemplate: TrialInstitutionItemTemplate;
    public version: string;
    public collectionInstanceId?: number;
    public collectionInstance: CollectionInstance;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public search: string;
    public filesAdded: boolean;
    public dataEntered: boolean;

    public constructor(init?: Partial<TrialInstitutionItem>) { (Object as any).assign(this, init); }
}

export class TrialInstitutionItemTemplateCategory implements IForm
{
    public id?: number;
    public value: string;
    public rank?: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public trialInstitutionItems: TrialInstitutionItem[];
    public trialInstitutionItemTemplates: TrialInstitutionItemTemplate[];

    public constructor(init?: Partial<TrialInstitutionItemTemplateCategory>) { (Object as any).assign(this, init); }
}

export class TrialInstitutionItemSummaryVersion
{
    public trialInstitutionItemId?: number;
    public version: string;
    public collectionInstanceId?: number;

    public constructor(init?: Partial<TrialInstitutionItemSummaryVersion>) { (Object as any).assign(this, init); }
}

export class TrialInstitutionItemSummary
{
    public id?: number;
    public name: string;
    public description: string;
    public allowVersions: boolean;
    public version: string;
    public initialVersion: string;
    public rank: number;
    public active: boolean;
    public trialInstitutionItemId?: number;
    public collectionInstanceId?: number;
    public dataEntered: boolean;
    public filesAdded: boolean;
    public trialInstitutionId: number;
    public trialInstitutionItemTemplateId: number;
    public dateEntered?: string;
    public trialInstitutionItemSummaryVersions: TrialInstitutionItemSummaryVersion[];

    public constructor(init?: Partial<TrialInstitutionItemSummary>) { (Object as any).assign(this, init); }
}

export class TrialInstitutionItemCategory
{
    public trialInstitutionItemTemplateCategoryId: number;
    public trialInstitutionItemTemplateCategory: TrialInstitutionItemTemplateCategory;
    public trialInstitutionItems: TrialInstitutionItem[];
    public trialInstitutionItemSummaries: TrialInstitutionItemSummary[];

    public constructor(init?: Partial<TrialInstitutionItemCategory>) { (Object as any).assign(this, init); }
}

export class NoteType implements IForm
{
    public id?: number;
    public value: string;
    public rank?: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<NoteType>) { (Object as any).assign(this, init); }
}

export class PersonnelNote implements IForm
{
    public id?: number;
    public personnelId?: number;
    public personnel: Personnel;
    public noteId?: number;
    public note: Note;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<PersonnelNote>) { (Object as any).assign(this, init); }
}

export class TrialNote implements IForm
{
    public id?: number;
    public trialId?: number;
    public trial: Trial;
    public noteId?: number;
    public note: Note;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<TrialNote>) { (Object as any).assign(this, init); }
}

export class InstitutionNote implements IForm
{
    public id?: number;
    public institutionId?: number;
    public institution: Institution;
    public noteId?: number;
    public note: Note;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<InstitutionNote>) { (Object as any).assign(this, init); }
}

export class TrialInstitutionNote implements IForm
{
    public id?: number;
    public trialInstitutionId?: number;
    public trialInstitution: TrialInstitution;
    public trialId?: number;
    public trial: Trial;
    public institutionId?: number;
    public institution: Institution;
    public noteId?: number;
    public note: Note;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<TrialInstitutionNote>) { (Object as any).assign(this, init); }
}

export class GroupNote implements IForm
{
    public id?: number;
    public groupId?: number;
    public group: Group;
    public noteId?: number;
    public note: Note;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<GroupNote>) { (Object as any).assign(this, init); }
}

export class Note implements IForm
{
    public id?: number;
    public title: string;
    public comments: string;
    public noteTypeId?: number;
    public noteType: NoteType;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public personnelNotes: PersonnelNote[];
    public trialNotes: TrialNote[];
    public institutionNotes: InstitutionNote[];
    public trialInstitutionNotes: TrialInstitutionNote[];
    public groupNotes: GroupNote[];
    public trialInstitutionId?: number;
    public trialId?: number;
    public institutionId?: number;
    public personnelId?: number;
    public groupId?: number;
    public parentDisplay: string;
    public trialDisplay: string;
    public institutionDisplay: string;
    public groupDisplay: string;

    public constructor(init?: Partial<Note>) { (Object as any).assign(this, init); }
}

export class NoteTypeNotes
{
    public noteTypeId: number;
    public noteType: NoteType;
    public notes: Note[];

    public constructor(init?: Partial<NoteTypeNotes>) { (Object as any).assign(this, init); }
}

export class InstitutionCoding implements IForm
{
    public id?: number;
    public value: string;
    public rank?: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<InstitutionCoding>) { (Object as any).assign(this, init); }
}

export class InstitutionCode implements IForm
{
    public id?: number;
    public institutionId?: number;
    public institution: Institution;
    public institutionCodingId?: number;
    public codeValue: string;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public active: boolean;
    public institutionCoding: InstitutionCoding;

    public constructor(init?: Partial<InstitutionCode>) { (Object as any).assign(this, init); }
}

export class TrialInstitutionLaboratoryPersonnel implements IForm
{
    public id?: number;
    public trialInstitutionLaboratoryId: number;
    public trialInstitutionLaboratory: TrialInstitutionLaboratory;
    public personnelId: number;
    public personnel: Personnel;
    public positionNo?: number;
    public roleId: number;
    public role: Role;
    public dateStarted?: string;
    public dateCeased?: string;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public active: boolean;

    public constructor(init?: Partial<TrialInstitutionLaboratoryPersonnel>) { (Object as any).assign(this, init); }
}

export class TrialInstitutionLaboratory
{
    public id?: number;
    public laboratoryId: number;
    public laboratory: Laboratory;
    public trialInstitutionId: number;
    public trialInstitution: TrialInstitution;
    public dateCeased?: string;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public personnels: TrialInstitutionLaboratoryPersonnel[];

    public constructor(init?: Partial<TrialInstitutionLaboratory>) { (Object as any).assign(this, init); }
}

export class GroupLevelType implements IForm
{
    public id?: number;
    public value: string;
    public rank: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<GroupLevelType>) { (Object as any).assign(this, init); }
}

export class TrialPersonnel
{
    public id?: number;
    public trialId?: number;
    public trial: Trial;
    public institutionId?: number;
    public institution: Institution;
    public personnelId?: number;
    public personnel: Personnel;
    public positionNo?: number;
    public groupLevelTypeId?: number;
    public groupLevelType: GroupLevelType;
    public roleId?: number;
    public role: Role;
    public dateStarted?: string;
    public dateCeased?: string;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public active: boolean;
    public groupId?: number;
    public group: Group;

    public constructor(init?: Partial<TrialPersonnel>) { (Object as any).assign(this, init); }
}

export class TrialInstitution
{
    public id?: number;
    public trialId?: number;
    public trial: Trial;
    public institutionId?: number;
    public institution: Institution;
    public parentInstitutionId?: number;
    public parentInstitution: Institution;
    public parentInstitutionDescription: string;
    public groupId?: number;
    public group: Group;
    public active: boolean;
    public trialInstitutionStatusId?: number;
    public trialInstitutionStatus: TrialInstitutionStatus;
    public dateActivated?: string;
    public firstPatient?: string;
    public dateWithdrawn?: string;
    public randomisedPatients?: number;
    public disableRecruitment: boolean;
    public expectedAccrual?: number;
    public totalAccrual?: number;
    public rgoSubmissionDate?: string;
    public rgoApprovalDate?: string;
    public initationMeetingDate?: string;
    public closureDate?: string;
    public institutionClosureReasonId?: number;
    public institutionClosureReason: InstitutionClosureReason;
    public comments: string;
    public ccOnRegistration: string;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public trialInstitutionItemCategories: TrialInstitutionItemCategory[];
    public trialInstitutionItems: TrialInstitutionItem[];
    public notes: NoteTypeNotes[];
    public display: string;
    public groupDisplay: string;
    public isGroupLocked: boolean;
    public trialDisplay: string;
    public institutionDisplay: string;
    public personnelCount: number;
    public minAccrual?: number;
    public maxAccrual?: number;
    public submissionProcessId?: number;
    public institutionCodeId?: number;
    public institutionCode: InstitutionCode;
    public importStatusId?: number;
    public siteRoleId?: number;
    public hrecId?: number;
    public departmentId?: number;
    public ethicsApproval: string;
    public governanceAuthorisation: string;
    public substudyStatus: string;
    public laboratories: TrialInstitutionLaboratory[];
    public personnel: TrialPersonnel[];
    public institutionIds: number[];

    public constructor(init?: Partial<TrialInstitution>) { (Object as any).assign(this, init); }
}

export class DepartmentContact implements IForm
{
    public id?: number;
    public departmentId?: number;
    public department: Department;
    public name: string;
    public professionalDisciplineId?: number;
    public professionalDiscipline: ProfessionalDiscipline;
    public professionalDisciplineDisplay: string;
    public otherDisciplines: string;
    public email: string;
    public phone: string;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<DepartmentContact>) { (Object as any).assign(this, init); }
}

export class Department implements IForm
{
    public id?: number;
    public institutionId?: number;
    public institution: Institution;
    public name: string;
    public address1: string;
    public address2: string;
    public suburb: string;
    public postcode: string;
    public stateId?: number;
    public state: State;
    public stateOther: string;
    public countryId?: number;
    public country: Country;
    public mailAddress1: string;
    public mailAddress2: string;
    public mailSuburb: string;
    public mailPostcode: string;
    public mailStateId?: number;
    public mailState: State;
    public mailStateOther: string;
    public mailCountryId?: number;
    public mailCountry: Country;
    public phone: string;
    public fax: string;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public departmentContacts: DepartmentContact[];
    public personnelRoles: PersonnelRole[];

    public constructor(init?: Partial<Department>) { (Object as any).assign(this, init); }
}

export class HealthDistrict implements IForm
{
    public id?: number;
    public name: string;
    // @References("typeof(TMD.ServiceModel.Types.Dto.State)")
    public stateId: number;

    public state: State;
    public rank?: number;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public active: boolean;

    public constructor(init?: Partial<HealthDistrict>) { (Object as any).assign(this, init); }
}

export class ModifiedMonashModel implements IForm
{
    public id?: number;
    public value: string;
    public rank?: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<ModifiedMonashModel>) { (Object as any).assign(this, init); }
}

export class InstitutionProcedure implements IForm
{
    public id?: number;
    public institutionId?: number;
    public institution: Institution;
    public name: string;
    public location: string;
    public dateOfProcedure?: string;
    public expiryDate?: string;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public sourceDocuments: SourceDocument[];

    public constructor(init?: Partial<InstitutionProcedure>) { (Object as any).assign(this, init); }
}

export class QuickbooksTaxCode implements IForm
{
    public id?: number;
    public value: string;
    public rank?: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<QuickbooksTaxCode>) { (Object as any).assign(this, init); }
}

export class InstitutionFinance implements IForm
{
    public id?: number;
    public institutionId?: number;
    public institution: Institution;
    public bctInvoicingPrefix: string;
    public taxInvoiceName: string;
    public quickbooksTaxCodeId?: number;
    public quickbooksTaxCode: QuickbooksTaxCode;
    public fundingEmailAddress: string;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public sourceDocuments: SourceDocument[];

    public constructor(init?: Partial<InstitutionFinance>) { (Object as any).assign(this, init); }
}

export class InstitutionItemTemplateCategory implements IForm
{
    public id?: number;
    public value: string;
    public rank?: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public institutionItems: InstitutionItem[];
    public institutionItemTemplates: InstitutionItemTemplate[];

    public constructor(init?: Partial<InstitutionItemTemplateCategory>) { (Object as any).assign(this, init); }
}

export class InstitutionItemTemplate implements IForm
{
    public id?: number;
    public institutionId?: number;
    public institution: Institution;
    public institutionItemTemplateCategoryId: number;
    public institutionItemTemplateCategory: InstitutionItemTemplateCategory;
    public name: string;
    public description: string;
    public rank?: number;
    public allowIntraVersions: boolean;
    public pendingDelete: boolean;
    public allowVersionChanges: boolean;
    public initialVersion: string;
    public collectionId?: number;
    public collection: Collection;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<InstitutionItemTemplate>) { (Object as any).assign(this, init); }
}

export class InstitutionItem implements IForm
{
    public id?: number;
    public institutionId: number;
    public institution: Institution;
    public institutionItemTemplateId: number;
    public institutionItemTemplate: InstitutionItemTemplate;
    public collectionInstanceId?: number;
    public collectionInstance: CollectionInstance;
    public version: string;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public search: string;
    public filesAdded: boolean;
    public dataEntered: boolean;

    public constructor(init?: Partial<InstitutionItem>) { (Object as any).assign(this, init); }
}

export class InstitutionItemSummaryVersion
{
    public institutionGroupItemId?: number;
    public version: string;
    public collectionInstanceId?: number;

    public constructor(init?: Partial<InstitutionItemSummaryVersion>) { (Object as any).assign(this, init); }
}

export class InstitutionItemSummary
{
    public id?: number;
    public name: string;
    public description: string;
    public allowVersions: boolean;
    public canEditVersion: boolean;
    public initialVersion: string;
    public version: string;
    public rank: number;
    public active: boolean;
    public institutionInstitutionId?: number;
    public institutionItemId?: number;
    public institutionInstitutionItemId?: number;
    public collectionInstanceId?: number;
    public dataEntered: boolean;
    public filesAdded: boolean;
    public institutionItemSummaryVersions: InstitutionItemSummaryVersion[];
    public institutionId?: number;
    public institutionItemTemplateId: number;
    public dateEntered?: string;

    public constructor(init?: Partial<InstitutionItemSummary>) { (Object as any).assign(this, init); }
}

export class InstitutionItemCategory
{
    public institutionItemTemplateCategoryId: number;
    public institutionItemTemplateCategory: InstitutionItemTemplateCategory;
    public institutionItems: InstitutionItem[];
    public institutionItemSummaries: InstitutionItemSummary[];

    public constructor(init?: Partial<InstitutionItemCategory>) { (Object as any).assign(this, init); }
}

export class Institution
{
    public id?: number;
    public name: string;
    public legalName: string;
    public institutionTypeId?: number;
    public institutionType: InstitutionType;
    public formerNames: string;
    public otherNames: string;
    public abn: string;
    public acn: string;
    public code: string;
    public active: boolean;
    public website: string;
    public address: string;
    public address2: string;
    public suburb: string;
    public postcode: string;
    public stateId?: number;
    public state: State;
    public stateOther: string;
    public countryId?: number;
    public country: Country;
    public mailAddress: string;
    public mailAddress2: string;
    public mailSuburb: string;
    public mailPostcode: string;
    public mailStateId?: number;
    public mailState: State;
    public mailStateOther: string;
    public mailCountryId?: number;
    public mailCountry: Country;
    public phone: string;
    public fax: string;
    public compactusNumber: string;
    public additionalInformation: string;
    public approvedForParticipation: boolean;
    public siteLocationId?: number;
    public siteLocation: SiteLocation;
    public researchGovernanceOfficeName: string;
    public researchGovernanceOfficePhone: string;
    public researchGovernanceOfficeEmail: string;
    public researchGovernanceOfficeWebsite: string;
    public researchGovernanceOfficeIsNMAScheme?: number;
    public acceptElectronicSignature?: number;
    public facilityAllianceMemberId?: number;
    public facilityAllianceMember: FacilityAllianceMember;
    public keyContactId?: number;
    public keyContact: KeyContact;
    public keyContactEmail: string;
    public agreementAddressOptionId?: number;
    public contractingPartyAddress: string;
    public contractingPartyAddress2: string;
    public contractingPartySuburb: string;
    public contractingPartyPostcode: string;
    public contractingPartyStateId?: number;
    public contractingPartyState: State;
    public contractingPartyStateOther: string;
    public contractingPartyCountryId?: number;
    public contractingPartyCountry: Country;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public trialInstitutions: TrialInstitution[];
    public departments: Department[];
    public notes: NoteTypeNotes[];
    public display: string;
    public sourceDocuments: SourceDocument[];
    public facsimileNumber: string;
    public medicalWebsite: string;
    public surgicalWebsite: string;
    public radiationWebsite: string;
    public radiologyWebsite: string;
    public healthDistrictId?: number;
    public healthDistrict: HealthDistrict;
    public laboratories: InstitutionLaboratory[];
    public personnel: TrialPersonnel[];
    public modifiedMonashModelId?: number;
    public modifiedMonashModel: ModifiedMonashModel;
    public procedures: InstitutionProcedure[];
    public institutionFinance: InstitutionFinance;
    public institutionItems: InstitutionItem[];
    public institutionItemCategories: InstitutionItemCategory[];

    public constructor(init?: Partial<Institution>) { (Object as any).assign(this, init); }
}

export class InstitutionLaboratory implements IForm
{
    public id?: number;
    public laboratoryId: number;
    public laboratory: Laboratory;
    public institutionId: number;
    public institution: Institution;
    public dateCeased?: string;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<InstitutionLaboratory>) { (Object as any).assign(this, init); }
}

export class LaboratoryFinance implements IForm
{
    public id?: number;
    public laboratoryId?: number;
    public laboratory: Laboratory;
    public bctInvoicingPrefix: string;
    public taxInvoiceName: string;
    public quickbooksTaxCodeId?: number;
    public quickbooksTaxCode: QuickbooksTaxCode;
    public fundingEmailAddress: string;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<LaboratoryFinance>) { (Object as any).assign(this, init); }
}

export class Laboratory
{
    public id?: number;
    public name: string;
    public address: string;
    public suburb: string;
    public postcode: string;
    public phone: string;
    public countryId?: number;
    public country: Country;
    public stateId?: number;
    public state: State;
    public facsimileNumber: string;
    public additionalInformation: string;
    public accreditationCertificate: string;
    public accreditationNumber: string;
    public ranges: string;
    public yearRange: string;
    public multiSiteAdvisory: string;
    public supportingInformation: string;
    public comments: string;
    public abn: string;
    public active: boolean;
    public dateInactive?: string;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public laboratoryDepartments: LaboratoryDepartment[];
    public laboratoryPersonnels: LaboratoryPersonnel[];
    public institutionLaboratories: InstitutionLaboratory[];
    public laboratoryFinance: LaboratoryFinance;

    public constructor(init?: Partial<Laboratory>) { (Object as any).assign(this, init); }
}

export class PersonnelRole
{
    public id?: number;
    public personnelId?: number;
    public personnel: Personnel;
    public roleId?: number;
    public role: Role;
    public groupId?: number;
    public group: Group;
    public laboratoryId?: number;
    public laboratory: Laboratory;
    public trialId?: number;
    public trial: Trial;
    public institutionId?: number;
    public institution: Institution;
    public dateStarted?: string;
    public dateCeased?: string;
    public emailSent: boolean;
    public departmentId?: number;
    public department: Department;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public dateFrom: string;
    public dateTo: string;
    public personnelRoleSummaryType: PersonnelRoleSummaryType;
    public groupDisplay: string;
    public trialDisplay: string;
    public institutionDisplay: string;
    public personnelDisplay: string;
    public roleDisplay: string;
    public laboratoryDisplay: string;
    public emailNotSentReason: string;

    public constructor(init?: Partial<PersonnelRole>) { (Object as any).assign(this, init); }
}

export class PersonnelRoleSummary
{
    public personnelRoleSummaryType: PersonnelRoleSummaryType;
    public display: string;
    public personnelRole: PersonnelRole;
    public personnelRoleSummaries: PersonnelRoleSummary[];

    public constructor(init?: Partial<PersonnelRoleSummary>) { (Object as any).assign(this, init); }
}

export enum OCSyncStatus
{
    Pending = 1,
    Complete = 2,
    Processing = 3,
    Failed = 4,
    UpdateRequired = 5,
    RemoveRequested = 6,
    Removed = 7,
}

export class OpenClinicaUserRole
{
    public id?: number;
    public personnelId: number;
    public personnel: Personnel;
    public personnelRoleId: number;
    public personnelRole: PersonnelRole;
    public trialId: number;
    public trial: Trial;
    public institutionId?: number;
    public institution: Institution;
    public studyId: number;
    public parentStudyId?: number;
    public studyIdentifier: string;
    public role: string;
    public ocSyncStatus: OCSyncStatus;
    public status: string;
    public errorMessage: string;
    public emailSent: boolean;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public search: string;

    public constructor(init?: Partial<OpenClinicaUserRole>) { (Object as any).assign(this, init); }
}

export class Interest implements IForm
{
    public id?: number;
    public value: string;
    public rank?: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<Interest>) { (Object as any).assign(this, init); }
}

export class PersonnelInterest
{
    public id?: number;
    public personnelId?: number;
    public personnel: Personnel;
    public interestId: number;
    public interest: Interest;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<PersonnelInterest>) { (Object as any).assign(this, init); }
}

export class AddressType implements IForm
{
    public id?: number;
    public value: string;
    public rank: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<AddressType>) { (Object as any).assign(this, init); }
}

export class PersonnelAddress implements IForm
{
    public id?: number;
    public personnelId?: number;
    public personnel: Personnel;
    public addressTypeId?: number;
    public addressType: AddressType;
    public addressLine1: string;
    public addressLine2: string;
    public suburbCity: string;
    public zipPostalCode: string;
    public stateProvinceRegionId?: number;
    public stateProvinceRegion: State;
    public stateOther: string;
    public countryId?: number;
    public country: Country;
    public companyName: string;
    public companyDepartment: string;
    public fixedPhone: string;
    public mobilePhone: string;
    public fax: string;
    public primaryEmail: string;
    public groupEmail: string;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<PersonnelAddress>) { (Object as any).assign(this, init); }
}

export class TrainingType implements IForm
{
    public id?: number;
    public value: string;
    public rank: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<TrainingType>) { (Object as any).assign(this, init); }
}

export class TrainingGeneralSystemType implements IForm
{
    public id?: number;
    public value: string;
    public rank: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<TrainingGeneralSystemType>) { (Object as any).assign(this, init); }
}

export class ExternalLink implements IAudited
{
    public id?: number;
    public formName: string;
    public documentName: string;
    public url: string;
    public recordId?: number;
    public subRecordId?: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<ExternalLink>) { (Object as any).assign(this, init); }
}

export class PersonnelTraining implements IForm
{
    public id?: number;
    public personnelId?: number;
    public personnel: Personnel;
    public trainingTypeId: number;
    public trainingType: TrainingType;
    public dateCompleted?: string;
    public comments: string;
    public courseModule: string;
    public provider: string;
    public certificateNumber: string;
    public trainingGeneralSystemTypeId?: number;
    public trainingGeneralSystemType: TrainingGeneralSystemType;
    public certificate: string;
    public additionalCertificate: string;
    public sourceDocuments: SourceDocument[];
    public externalLinks: ExternalLink[];
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<PersonnelTraining>) { (Object as any).assign(this, init); }
}

export class Fellowship implements IForm
{
    public id?: number;
    public fellowId?: number;
    public fellow: Personnel;
    public supervisorId?: number;
    public supervisor: Personnel;
    public projectTitle: string;
    public disciplineId?: number;
    public awarded: boolean;
    public dateStart?: string;
    public dateExpectedCompletion?: string;
    public dateSixMonthReportDue?: string;
    public dateSixMonthReportReceived?: string;
    public dateFinalOutcomeReportDue?: string;
    public dateFinalOutcomeReportReceived?: string;
    public dateEntered?: string;
    public dateModified?: string;
    public active: boolean;
    public enteredBy: string;
    public modifiedBy: string;
    public sourceDocuments: SourceDocument[];

    public constructor(init?: Partial<Fellowship>) { (Object as any).assign(this, init); }
}

export class Personnel
{
    public id?: number;
    public salutationId?: number;
    public salutation: Salutation;
    public firstName: string;
    public lastName: string;
    public email: string;
    public userName: string;
    public emailSent: boolean;
    public jobTitle: string;
    public cvDate?: string;
    public membershipTypeId?: number;
    public membershipType: MembershipType;
    public membershipExpiryDate?: string;
    public comments: string;
    public professionalDisciplineId?: number;
    public professionalDiscipline: ProfessionalDiscipline;
    public otherInterests: string;
    public otherDisciplines: string;
    public active: boolean;
    public apiKey: string;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public autogeneratePassword: boolean;
    public personnelRoleSummaries: PersonnelRoleSummary[];
    public openClinicaUserRoles: OpenClinicaUserRole[];
    public notes: NoteTypeNotes[];
    public display: string;
    public displayWithSalutation: string;
    public hasActiveDirectoryEntry: boolean;
    public password: string;
    public confirmPassword: string;
    public personnelRoles: PersonnelRole[];
    public personnelInterests: PersonnelInterest[];
    public personnelAddresses: PersonnelAddress[];
    public personalAssistantId?: number;
    public personalAssistant: Personnel;
    public cvNoChangeConfirmedDate?: string;
    public cvRequestSentDate?: string;
    public pmbApprovalNCIInvestigatorNo: string;
    public pmbApprovalDateOfNCIExpiry?: string;
    public medicalRegistrationExpiryDate?: string;
    public medicalIndemnityExpiryDate?: string;
    public sitePiApplicationDateApproved?: string;
    public outlookId: string;
    public personnelTraining: PersonnelTraining[];
    public fellowships: Fellowship[];
    public electronicCV: string;
    public trainingAndCertifications: boolean;
    public sourceDocuments: SourceDocument[];
    public externalLinks: ExternalLink[];

    public constructor(init?: Partial<Personnel>) { (Object as any).assign(this, init); }
}

export class TrialType
{
    public id?: number;
    public value: string;
    public rank?: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<TrialType>) { (Object as any).assign(this, init); }
}

export class TrialStatus
{
    public id?: number;
    public value: string;
    public rank?: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<TrialStatus>) { (Object as any).assign(this, init); }
}

export class InternationalTrialStatus
{
    public id?: number;
    public value: string;
    public rank?: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<InternationalTrialStatus>) { (Object as any).assign(this, init); }
}

export class StandardEmailType implements IForm
{
    public id?: number;
    public value: string;
    public rank: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<StandardEmailType>) { (Object as any).assign(this, init); }
}

export class StandardEmailTemplate implements IForm
{
    public id?: number;
    public value: string;
    public rank?: number;
    public standardEmailTypeId?: number;
    public standardEmailType: StandardEmailType;
    public subject: string;
    public body: string;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<StandardEmailTemplate>) { (Object as any).assign(this, init); }
}

export class Category implements IForm
{
    public id?: number;
    public value: string;
    public rank?: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public trialItems: TrialItem[];
    public trialItemTemplates: TrialItemTemplate[];

    public constructor(init?: Partial<Category>) { (Object as any).assign(this, init); }
}

export class TrialItemTemplate implements IForm
{
    public id?: number;
    public trialId?: number;
    public trial: Trial;
    public categoryId: number;
    public category: Category;
    public name: string;
    public description: string;
    public rank?: number;
    public allowIntraVersions: boolean;
    public pendingDelete: boolean;
    public allowVersionChanges: boolean;
    public initialVersion: string;
    public collectionId?: number;
    public collection: Collection;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<TrialItemTemplate>) { (Object as any).assign(this, init); }
}

export class TrialItem implements IForm
{
    public id?: number;
    public trialId: number;
    public trial: Trial;
    public trialItemTemplateId: number;
    public trialItemTemplate: TrialItemTemplate;
    public collectionInstanceId?: number;
    public collectionInstance: CollectionInstance;
    public version: string;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public search: string;
    public filesAdded: boolean;
    public dataEntered: boolean;

    public constructor(init?: Partial<TrialItem>) { (Object as any).assign(this, init); }
}

export class TrialGroupItemTemplate implements IForm
{
    public id?: number;
    public groupId?: number;
    public group: Group;
    public trialGroupItemTemplateCategoryId: number;
    public trialGroupItemTemplateCategory: TrialGroupItemTemplateCategory;
    public name: string;
    public description: string;
    public rank?: number;
    public allowIntraVersions: boolean;
    public pendingDelete: boolean;
    public allowVersionChanges: boolean;
    public initialVersion: string;
    public collectionId?: number;
    public collection: Collection;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<TrialGroupItemTemplate>) { (Object as any).assign(this, init); }
}

export class TrialGroupItem implements IForm
{
    public id?: number;
    public trialGroupId: number;
    public trialGroup: TrialGroup;
    public trialGroupItemTemplateId: number;
    public trialGroupItemTemplate: TrialGroupItemTemplate;
    public version: string;
    public collectionInstanceId?: number;
    public collectionInstance: CollectionInstance;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public search: string;
    public filesAdded: boolean;
    public dataEntered: boolean;

    public constructor(init?: Partial<TrialGroupItem>) { (Object as any).assign(this, init); }
}

export class TrialGroupItemTemplateCategory implements IForm
{
    public id?: number;
    public value: string;
    public rank?: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public trialGroupItems: TrialGroupItem[];
    public trialGroupItemTemplates: TrialGroupItemTemplate[];

    public constructor(init?: Partial<TrialGroupItemTemplateCategory>) { (Object as any).assign(this, init); }
}

export class TrialGroupItemSummaryVersion
{
    public trialGroupItemId?: number;
    public version: string;
    public collectionInstanceId?: number;

    public constructor(init?: Partial<TrialGroupItemSummaryVersion>) { (Object as any).assign(this, init); }
}

export class TrialGroupItemSummary
{
    public id?: number;
    public name: string;
    public description: string;
    public allowVersions: boolean;
    public version: string;
    public initialVersion: string;
    public rank: number;
    public active: boolean;
    public trialGroupItemId?: number;
    public collectionInstanceId?: number;
    public dataEntered: boolean;
    public filesAdded: boolean;
    public trialGroupId: number;
    public trialGroupItemTemplateId: number;
    public dateEntered?: string;
    public trialGroupItemSummaryVersions: TrialGroupItemSummaryVersion[];

    public constructor(init?: Partial<TrialGroupItemSummary>) { (Object as any).assign(this, init); }
}

export class TrialGroupItemCategory
{
    public categoryId: number;
    public trialGroupItemTemplateCategory: TrialGroupItemTemplateCategory;
    public trialGroupItems: TrialGroupItem[];
    public trialGroupItemSummaries: TrialGroupItemSummary[];

    public constructor(init?: Partial<TrialGroupItemCategory>) { (Object as any).assign(this, init); }
}

export class TrialGroupLaboratoryPersonnel implements IForm
{
    public id?: number;
    public trialGroupLaboratoryId: number;
    public trialGroupLaboratory: TrialGroupLaboratory;
    public personnelId: number;
    public personnel: Personnel;
    public positionNo?: number;
    public roleId: number;
    public role: Role;
    public dateStarted?: string;
    public dateCeased?: string;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public active: boolean;

    public constructor(init?: Partial<TrialGroupLaboratoryPersonnel>) { (Object as any).assign(this, init); }
}

export class TrialGroupLaboratory
{
    public id?: number;
    public laboratoryId: number;
    public laboratory: Laboratory;
    public trialGroupId: number;
    public trialGroup: TrialGroup;
    public dateCeased?: string;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public personnels: TrialGroupLaboratoryPersonnel[];

    public constructor(init?: Partial<TrialGroupLaboratory>) { (Object as any).assign(this, init); }
}

export class TrialGroup implements IForm
{
    public id?: number;
    public trialId: number;
    public trial: Trial;
    public groupId: number;
    public group: Group;
    public parentId?: number;
    public parent: Group;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public administratesForGroupMembers: boolean;
    public status?: number;
    public dateActivated?: string;
    public dateInvite?: string;
    public registrationEmails?: string;
    public randomisationEmails?: string;
    public screeningEmails?: string;
    public eligibilityEmails?: string;
    public saeEmails?: string;
    public trialGroupItemCategories: TrialGroupItemCategory[];
    public trialGroupItems: TrialGroupItem[];
    public children: Group[];
    public laboratories: TrialGroupLaboratory[];
    public personnel: TrialPersonnel[];

    public constructor(init?: Partial<TrialGroup>) { (Object as any).assign(this, init); }
}

export class TrialItemSummaryVersion
{
    public trialGroupItemId?: number;
    public version: string;
    public collectionInstanceId?: number;

    public constructor(init?: Partial<TrialItemSummaryVersion>) { (Object as any).assign(this, init); }
}

export class TrialItemSummary
{
    public id?: number;
    public name: string;
    public description: string;
    public allowVersions: boolean;
    public canEditVersion: boolean;
    public initialVersion: string;
    public version: string;
    public rank: number;
    public active: boolean;
    public trialInstitutionId?: number;
    public trialItemId?: number;
    public trialInstitutionItemId?: number;
    public collectionInstanceId?: number;
    public dataEntered: boolean;
    public filesAdded: boolean;
    public trialItemSummaryVersions: TrialItemSummaryVersion[];
    public trialId?: number;
    public trialItemTemplateId: number;
    public dateEntered?: string;

    public constructor(init?: Partial<TrialItemSummary>) { (Object as any).assign(this, init); }
}

export class TrialItemCategory
{
    public categoryId: number;
    public category: Category;
    public trialItems: TrialItem[];
    public trialItemSummaries: TrialItemSummary[];

    public constructor(init?: Partial<TrialItemCategory>) { (Object as any).assign(this, init); }
}

export class Trial
{
    public id?: number;
    public protocolID: string;
    public newProposalNumber: string;
    public trialDevelopmentNumber: string;
    public allIdentifiers: string;
    public studyAcronym: string;
    public title: string;
    public shortTitle: string;
    public trialChair1PersonnelId?: number;
    public trialChair1Personnel: Personnel;
    public trialChair2PersonnelId?: number;
    public trialChair2Personnel: Personnel;
    public active: boolean;
    public comments: string;
    public confidentialityDeedRequired: boolean;
    public institutionCodingId?: number;
    public institutionCoding: InstitutionCoding;
    public trialTypeId?: number;
    public trialType: TrialType;
    public apiKey: string;
    public registrationWebsite: string;
    public openClinciaProtocolID: string;
    public patientDetailsCRF: string;
    public initialsCrfItemName: string;
    public treatmentCrfItemName: string;
    public trialStatusId?: number;
    public trialStatus: TrialStatus;
    public dateActivated?: string;
    public dateFirstPatient?: string;
    public dateAccrualComplete?: string;
    public dateStudyClosed?: string;
    public dateCompletedWithdrawn?: string;
    public completeDate?: string;
    public internationalTrialStatusId?: number;
    public internationalTrialStatus: InternationalTrialStatus;
    public internationalDateActivated?: string;
    public internationalDateAccrualCompleted?: string;
    public internationalCompleteDate?: string;
    public targetAccrual?: number;
    public totalAccrual?: number;
    public targetDateAccrualCompleted?: string;
    public targetDateFollowupCompletion?: string;
    public internationalTargetAccrual?: number;
    public internationalTotalAccrual?: number;
    public internationalTargetDateAccrualCompleted?: string;
    public internationalTargetDateFollowupCompletion?: string;
    public openClinciaInstitutionPrefix: string;
    public australianLeadGroup: string;
    public internationalLeadGroup: string;
    public isLegacyUserDatabase: boolean;
    public sendReminderEmail: boolean;
    public sendReminderAfterDays: number;
    public sendReminderStandardEmailTemplateId?: number;
    public sendReminderStandardEmailTemplate: StandardEmailTemplate;
    public projectProtocolID: string;
    public projectScientificTitle: string;
    public projectShortTitle: string;
    public projectAckSource: string;
    public projectTrialDeveloperId?: number;
    public projectDateSubmitted?: string;
    public projectOutcomeId?: number;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public trialItems: TrialItem[];
    public trialGroups: TrialGroup[];
    public trialInstitutions: TrialInstitution[];
    public trialItemCategories: TrialItemCategory[];
    public globalRoleSummaries: PersonnelRoleSummary[];
    public notes: NoteTypeNotes[];
    public display: string;
    public displayName: string;
    public shortDisplay: string;
    public personnelCount: number;
    public dateEndorsedBySAC?: string;
    public substudyOfTrial: boolean;
    public substudyId?: number;
    public substudy: Trial;
    public dateInvitationSent?: string;
    public recruitmentTimeline: string;
    public trialCoordination: string;
    public specialNote: string;
    public publicationAcknowledgments: string;
    public viewCode: string;
    public importProjectId?: number;
    public personnel: TrialPersonnel[];

    public constructor(init?: Partial<Trial>) { (Object as any).assign(this, init); }
}

export class TrialInstitutionItemTemplate implements IForm
{
    public id?: number;
    public trialId?: number;
    public trial: Trial;
    public trialInstitutionItemTemplateCategoryId: number;
    public trialInstitutionItemTemplateCategory: TrialInstitutionItemTemplateCategory;
    public name: string;
    public description: string;
    public rank?: number;
    public allowIntraVersions: boolean;
    public pendingDelete: boolean;
    public allowVersionChanges: boolean;
    public initialVersion: string;
    public collectionId?: number;
    public collection: Collection;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<TrialInstitutionItemTemplate>) { (Object as any).assign(this, init); }
}

export class ItemComponentWithData
{
    public itemComponent: ItemComponent;
    public collectionSectionId: number;
    public isNaAllowed: boolean;
    public isRequired: boolean;
    public isFirstPrimitive: boolean;
    public isLastPrimitive: boolean;
    public instructions: string;
    public overrideLabel: string;
    public isQuestion: boolean;
    public isAnswered: boolean;
    public formLocked: boolean;
    public isNotApplicable: boolean;
    public itemComponentRules: ItemComponentRule[];
    public itemComponentPrimitive: ItemComponentPrimitive;
    public collectionItemComponent: CollectionItemComponent;
    public collectionInstance: CollectionInstance;
    public trialInstitutionItemTemplate: TrialInstitutionItemTemplate;
    public trialInstitutionId?: number;
    public collectionInstanceData: CollectionInstanceData;

    public constructor(init?: Partial<ItemComponentWithData>) { (Object as any).assign(this, init); }
}

export class CollectionInstanceSection implements ISubForm
{
    public id: number;
    public collectionInstanceId?: number;
    public collectionInstance: CollectionInstance;
    public collectionSectionId?: number;
    public collectionSection: CollectionSection;
    public isNa: boolean;
    public assignedToId?: number;
    public assignedRoleId?: number;
    public assignmentTypeId?: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public isDefault: boolean;
    public columnFormat: string;
    public expanded: boolean;
    public locked: boolean;
    public formLocked: boolean;
    public column1: ItemComponentWithData[];
    public column2: ItemComponentWithData[];
    public column3: ItemComponentWithData[];
    public documents: ItemComponentWithData[];
    public isMissingRequiredData: boolean;
    public summary: string;

    public constructor(init?: Partial<CollectionInstanceSection>) { (Object as any).assign(this, init); }
}

export class CollectionInstanceTrackerType implements IForm
{
    public id?: number;
    public value: string;
    public rank: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<CollectionInstanceTrackerType>) { (Object as any).assign(this, init); }
}

export class CollectionInstanceTracker implements ISubForm
{
    public id: number;
    public collectionInstanceId?: number;
    public collectionInstance: CollectionInstance;
    public collectionInstanceTrackerTypeId?: number;
    public trackingNumber: number;
    public date?: string;
    public comment: string;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public collectionInstanceTrackerType: CollectionInstanceTrackerType;
    public modified: boolean;

    public constructor(init?: Partial<CollectionInstanceTracker>) { (Object as any).assign(this, init); }
}

export class CollectionInstance implements IForm
{
    public id?: number;
    public collectionId?: number;
    public collection: Collection;
    public dataEntered: boolean;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public collectionInstanceDatas: CollectionInstanceData[];
    public sourceDocuments: SourceDocument[];
    public itemComponentRules: ItemComponentRule[];
    public columnFormat: string;
    public column1: ItemComponentWithData[];
    public column2: ItemComponentWithData[];
    public column3: ItemComponentWithData[];
    public documents: ItemComponentWithData[];
    public sections: CollectionInstanceSection[];
    public isModified: boolean;
    public hasSections: boolean;
    public collectionInstanceTrackers: CollectionInstanceTracker[];
    public trialInstitutionItemId: number;
    public version: string;
    public canEditVersion: boolean;

    public constructor(init?: Partial<CollectionInstance>) { (Object as any).assign(this, init); }
}

export class GroupItem implements IForm
{
    public id?: number;
    public groupId: number;
    public group: Group;
    public groupItemTemplateId: number;
    public groupItemTemplate: GroupItemTemplate;
    public collectionInstanceId?: number;
    public collectionInstance?: CollectionInstance;
    public version: string;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public search: string;
    public filesAdded: boolean;
    public dataEntered: boolean;

    public constructor(init?: Partial<GroupItem>) { (Object as any).assign(this, init); }
}

export class GroupItemTemplateCategory implements IForm
{
    public id?: number;
    public value: string;
    public rank?: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public groupItemTemplates: GroupItemTemplate[];

    public constructor(init?: Partial<GroupItemTemplateCategory>) { (Object as any).assign(this, init); }
}

export class GroupItemSummaryVersion
{
    public groupItemId?: number;
    public version: string;
    public collectionInstanceId?: number;

    public constructor(init?: Partial<GroupItemSummaryVersion>) { (Object as any).assign(this, init); }
}

export class GroupItemSummary
{
    public id?: number;
    public name: string;
    public description: string;
    public allowVersions: boolean;
    public version: string;
    public initialVersion: string;
    public rank: number;
    public active: boolean;
    public groupItemId?: number;
    public collectionInstanceId?: number;
    public dataEntered: boolean;
    public filesAdded: boolean;
    public groupId: number;
    public groupItemTemplateId: number;
    public dateEntered?: string;
    public groupItemSummaryVersions: GroupItemSummaryVersion[];

    public constructor(init?: Partial<GroupItemSummary>) { (Object as any).assign(this, init); }
}

export class GroupItemCategory
{
    public categoryId: number;
    public groupItemTemplateCategory: GroupItemTemplateCategory;
    public groupItems: GroupItem[];
    public groupItemSummaries: GroupItemSummary[];

    public constructor(init?: Partial<GroupItemCategory>) { (Object as any).assign(this, init); }
}

export class GroupFinance implements IForm
{
    public id?: number;
    public groupId?: number;
    public group: Group;
    public bctInvoicingPrefix: string;
    public taxInvoiceName: string;
    public quickbooksTaxCodeId?: number;
    public quickbooksTaxCode: QuickbooksTaxCode;
    public fundingEmailAddress: string;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<GroupFinance>) { (Object as any).assign(this, init); }
}

export class Group
{
    public id?: number;
    public name: string;
    public otherNames: string;
    public code: string;
    public rank: number;
    public address: string;
    public address2: string;
    public suburb: string;
    public postcode: string;
    public stateId?: number;
    public state: State;
    public stateOther: string;
    public countryId?: number;
    public country: Country;
    public mailAddress: string;
    public mailAddress2: string;
    public mailSuburb: string;
    public mailPostcode: string;
    public mailStateId?: number;
    public mailState: State;
    public mailStateOther: string;
    public mailCountryId?: number;
    public mailCountry: Country;
    public phone: string;
    public fax: string;
    public website: string;
    public legalName: string;
    public agreementAddressOptionId?: number;
    public addressOption: AddressOption;
    public contractingPartyAddress: string;
    public contractingPartyAddress2: string;
    public contractingPartySuburb: string;
    public contractingPartyPostcode: string;
    public contractingPartyStateId?: number;
    public contractingPartyState: State;
    public contractingPartyStateOther: string;
    public contractingPartyCountryId?: number;
    public contractingPartyCountry: Country;
    public abn: string;
    public acn: string;
    public contactNotice: string;
    public emailNotice: string;
    public phoneNotice: string;
    public faxNotice: string;
    public acceptElectronicSignature?: number;
    public isDefault: boolean;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public groupItems: GroupItem[];
    public groupItemCategories: GroupItemCategory[];
    public notes: NoteTypeNotes[];
    public healthDistrictId?: number;
    public facsimileNumber: string;
    public additionalInformation: string;
    public groupFinance: GroupFinance;

    public constructor(init?: Partial<Group>) { (Object as any).assign(this, init); }
}

export class GroupItemTemplate implements IForm
{
    public id?: number;
    public groupId: number;
    public group: Group;
    public groupItemTemplateCategoryId: number;
    public groupItemTemplateCategory: GroupItemTemplateCategory;
    public name: string;
    public description: string;
    public rank?: number;
    public allowIntraVersions: boolean;
    public pendingDelete: boolean;
    public allowVersionChanges: boolean;
    public initialVersion: string;
    public collectionId?: number;
    public collection: Collection;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<GroupItemTemplate>) { (Object as any).assign(this, init); }
}

export class Hrec implements IForm
{
    public id?: number;
    public hrecNo: string;
    public fullName: string;
    public shortName: string;
    public website: string;
    public entityName: string;
    public chair: string;
    public administratorId?: number;
    public administrator: Personnel;
    public mutualAcceptanceReview?: number;
    public nhmrcCertificate?: number;
    public comments: string;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public trialInstitutions: TrialInstitution[];

    public constructor(init?: Partial<Hrec>) { (Object as any).assign(this, init); }
}

export class CommitteeMeetingType implements IForm
{
    public id?: number;
    public value: string;
    public rank?: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<CommitteeMeetingType>) { (Object as any).assign(this, init); }
}

export class CommitteeMemberRoleType implements IForm
{
    public id?: number;
    public value: string;
    public rank?: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<CommitteeMemberRoleType>) { (Object as any).assign(this, init); }
}

export class CommitteeMemberRole
{
    public id?: number;
    public committeeId: number;
    public committee: Committee;
    public personnelId: number;
    public personnel: Personnel;
    public positionNo?: number;
    public committeeMemberRoleTypeId: number;
    public committeeMemberRoleType: CommitteeMemberRoleType;
    public dateStarted?: string;
    public dateCeased?: string;
    public comment: string;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public committeeMemberId?: number;
    public committeeMember: CommitteeMember;

    public constructor(init?: Partial<CommitteeMemberRole>) { (Object as any).assign(this, init); }
}

export class CommitteeMember implements IForm
{
    public id?: number;
    public committeeId?: number;
    public committee: Committee;
    public personnelId?: number;
    public personnel: Personnel;
    public comment: string;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public committeeMemberRoles: CommitteeMemberRole[];

    public constructor(init?: Partial<CommitteeMember>) { (Object as any).assign(this, init); }
}

export class CommitteeRegularInvitee implements IForm
{
    public id?: number;
    public committeeId?: number;
    public committee: Committee;
    public personnelId?: number;
    public personnel: Personnel;
    public comment: string;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<CommitteeRegularInvitee>) { (Object as any).assign(this, init); }
}

export class CommitteeMeeting implements IForm
{
    public id?: number;
    public committeeId?: number;
    public committee: Committee;
    public meetingDate?: string;
    public location: string;
    public website: string;
    public comments: string;
    public committeeMeetingTypeId?: number;
    public committeeMeetingType: CommitteeMeetingType;
    public city: string;
    public time: string;
    public room: string;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public committeeMembers: CommitteeMember[];
    public committeeRegularInvitees: CommitteeRegularInvitee[];

    public constructor(init?: Partial<CommitteeMeeting>) { (Object as any).assign(this, init); }
}

export class Outcome implements IForm
{
    public id?: number;
    public value: string;
    public rank: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<Outcome>) { (Object as any).assign(this, init); }
}

export class Discussion implements IForm
{
    public id?: number;
    public trialId?: number;
    public trial: Trial;
    public committeeId?: number;
    public committee: Committee;
    public committeeMeetingId?: number;
    public committeeMeeting: CommitteeMeeting;
    public outcomeId?: number;
    public outcome: Outcome;
    public comment: string;
    public studyChairId?: number;
    public studyChair: Personnel;
    public coChairId?: number;
    public coChair: Personnel;
    public endorseDate?: string;
    public submitFundingId?: number;
    public submitFundingDate?: string;
    public submitFundingToId?: number;
    public approvalId?: number;
    public approvalDate?: string;
    public approvalComment: string;
    public fundingId?: number;
    public fundingDate?: string;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<Discussion>) { (Object as any).assign(this, init); }
}

export class ProjectItemTemplateCategory implements IForm
{
    public id?: number;
    public value: string;
    public rank?: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public projectItemTemplates: ProjectItemTemplate[];

    public constructor(init?: Partial<ProjectItemTemplateCategory>) { (Object as any).assign(this, init); }
}

export class ProjectItemTemplate implements IForm
{
    public id?: number;
    public trialId?: number;
    public trial: Trial;
    public name: string;
    public description: string;
    public rank: number;
    public projectItemTemplateCategoryId: number;
    public projectItemTemplateCategory: ProjectItemTemplateCategory;
    public auditOnSave: boolean;
    public allowVersions: boolean;
    public collectionId?: number;
    public collection: Collection;
    public isDefault: boolean;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<ProjectItemTemplate>) { (Object as any).assign(this, init); }
}

export class ProjectItem implements IForm
{
    public id?: number;
    public projectId?: number;
    public projectItemTemplateId?: number;
    public projectItemTemplate: ProjectItemTemplate;
    public collectionInstanceId?: number;
    public collectionInstance: CollectionInstance;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public search: string;
    public filesAdded: boolean;
    public dataEntered: boolean;

    public constructor(init?: Partial<ProjectItem>) { (Object as any).assign(this, init); }
}

export class FormTemplateFileType implements IForm
{
    public id?: number;
    public value: string;
    public rank?: number;
    public formName: string;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<FormTemplateFileType>) { (Object as any).assign(this, init); }
}

export class FormTemplate implements IForm
{
    public id?: number;
    public name: string;
    public description: string;
    public rank?: number;
    public itemComponentTypeId: number;
    public formTemplateCategoryId: number;
    public auditOnSave: boolean;
    public allowVersions: boolean;
    public collectionId?: number;
    public collection: Collection;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<FormTemplate>) { (Object as any).assign(this, init); }
}

export class TaskType implements IForm
{
    public id?: number;
    public value: string;
    public rank?: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<TaskType>) { (Object as any).assign(this, init); }
}

export class TrackerMilestone implements IForm
{
    public id?: number;
    public value: string;
    public rank?: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<TrackerMilestone>) { (Object as any).assign(this, init); }
}

export class TrackerType implements IForm
{
    public id?: number;
    public value: string;
    public rank?: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<TrackerType>) { (Object as any).assign(this, init); }
}

export class TrialDoi implements IForm
{
    public id?: number;
    public trialId?: number;
    public trial: Trial;
    public ardcTrialEntry: string;
    public yearAvailable?: number;
    public doi: string;
    public protocolLabel: string;
    public protocol: string;
    public dataDictionaryLabel: string;
    public dataDictionary: string;
    public citation: string;
    public showOnPortal: boolean;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<TrialDoi>) { (Object as any).assign(this, init); }
}

export class TrialWebsite implements IForm
{
    public id?: number;
    public trialId?: number;
    public trial: Trial;
    public registered: string;
    public enquiryEmail: string;
    public phoneNumber: string;
    public live: boolean;
    public hidePublic: boolean;
    public shortDescription: string;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<TrialWebsite>) { (Object as any).assign(this, init); }
}

export enum RoleType
{
    SuperUser = 1,
    StudyChair = 3,
    Pharmacist = 6,
    TrialCoordinator = 8,
    PrincipalInvestigator = 13,
    LeadCoordinatingInvestigator = 15,
    CoInvestigator = 18,
    Pathologist = 19,
    EthicsCoordinator = 20,
    CollaborativeOrganisation = 21,
    StudyCoChair = 22,
    TrialCoordinatorBackup = 23,
    BCTSupportStaff = 24,
    BCTTeamLeader = 25,
    BCTSeniorTrialsCoordinator = 26,
    BCTChiefOperatingOfficer = 27,
    BCTTrialCoordinator = 28,
    BCTRecruitmentCoordinator = 29,
    Finance = 30,
    ExpressionOfInterest = 31,
    BCTEthicsCoordinator = 32,
    Registrar = 33,
    NOExpressionofInterest = 34,
    CTRAContact = 35,
    PharmacistBackup = 36,
    BCTERAProjectOfficer = 37,
    SafetyReporting = 38,
    BCTProgramManager = 39,
    BCTStreamLead = 40,
    BCTClinicalResearchAssociate = 41,
    BCTClinicalTrialAdministrator = 42,
    CentralScientist = 43,
    SteeringCommittee = 44,
    TranslationalCommitttee = 45,
    Statistician = 46,
    PharmacistNoLogin = 47,
    MedicalReviewer = 48,
    SiteManager = 49,
    ClinicalTrialAssistant = 50,
    ClinicalStudyManager = 51,
    ClinicalResearchAssociate = 52,
    Patient = 53,
    InternationalStudyChair = 54,
    CentralCounsellor = 55,
    Radiologist = 56,
    BCTFinance = 57,
    CentralReviewer = 58,
    StartUpCoordinator = 59,
}

export class QuickbooksAccount implements IForm
{
    public id?: number;
    public value: string;
    public rank?: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<QuickbooksAccount>) { (Object as any).assign(this, init); }
}

export class QuickbooksClass implements IForm
{
    public id?: number;
    public value: string;
    public rank?: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<QuickbooksClass>) { (Object as any).assign(this, init); }
}

export class TrialFinance implements IForm
{
    public id?: number;
    public trialId?: number;
    public trial: Trial;
    public quickbooksAccountId?: number;
    public quickbooksAccount: QuickbooksAccount;
    public quickbooksClassId?: number;
    public quickbooksClass: QuickbooksClass;
    public ctaClauseReference: string;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<TrialFinance>) { (Object as any).assign(this, init); }
}

export class TrialGroupContract implements IForm
{
    public id?: number;
    public trialGroupId?: number;
    public trialGroup: TrialGroup;
    public name: string;
    public location: string;
    public dateSentToSite?: string;
    public dateConfirmedBySite?: string;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<TrialGroupContract>) { (Object as any).assign(this, init); }
}

export class TrialGroupFinance implements IForm
{
    public id?: number;
    public trialGroupId: number;
    public trialGroup: TrialGroup;
    public overrideFundingEmail: boolean;
    public fundingEmail: string;
    public bsbSwift: string;
    public accountNumber: string;
    public siteCostCentre: string;
    public requireInvoiceFromSite: boolean;
    public overridePaymentDetails: boolean;
    public abn: string;
    public taxInvoiceName: string;
    public quickbooksTaxCodeId?: number;
    public quickbooksTaxCode: QuickbooksTaxCode;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<TrialGroupFinance>) { (Object as any).assign(this, init); }
}

export class TrialGroupLaboratoryContract implements IForm
{
    public id?: number;
    public trialGroupLaboratoryId?: number;
    public trialGroupLaboratory: TrialGroupLaboratory;
    public name: string;
    public location: string;
    public dateSentToSite?: string;
    public dateConfirmedBySite?: string;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<TrialGroupLaboratoryContract>) { (Object as any).assign(this, init); }
}

export class TrialGroupLaboratoryFinance implements IForm
{
    public id?: number;
    public trialGroupLaboratoryId: number;
    public trialGroupLaboratory: TrialGroupLaboratory;
    public overrideFundingEmail: boolean;
    public fundingEmail: string;
    public bsbSwift: string;
    public accountNumber: string;
    public siteCostCentre: string;
    public requireInvoiceFromSite: boolean;
    public overridePaymentDetails: boolean;
    public abn: string;
    public taxInvoiceName: string;
    public quickbooksTaxCodeId?: number;
    public quickbooksTaxCode: QuickbooksTaxCode;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<TrialGroupLaboratoryFinance>) { (Object as any).assign(this, init); }
}

export class TrialInstitutionContract implements IForm
{
    public id?: number;
    public trialInstitutionId?: number;
    public trialInstitution: TrialInstitution;
    public name: string;
    public location: string;
    public dateSentToSite?: string;
    public dateConfirmedBySite?: string;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public sourceDocuments: SourceDocument[];

    public constructor(init?: Partial<TrialInstitutionContract>) { (Object as any).assign(this, init); }
}

export class TrialInstitutionFinance implements IForm
{
    public id?: number;
    public trialInstitutionId: number;
    public trialInstitution: TrialInstitution;
    public overrideFundingEmail: boolean;
    public fundingEmail: string;
    public bsbSwift: string;
    public accountNumber: string;
    public siteCostCentre: string;
    public requireInvoiceFromSite: boolean;
    public overridePaymentDetails: boolean;
    public abn: string;
    public taxInvoiceName: string;
    public quickbooksTaxCodeId?: number;
    public quickbooksTaxCode: QuickbooksTaxCode;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<TrialInstitutionFinance>) { (Object as any).assign(this, init); }
}

export class TrialItemSelectionCategory
{
    public id: number;
    public originalIndex: number;
    public name: string;

    public constructor(init?: Partial<TrialItemSelectionCategory>) { (Object as any).assign(this, init); }
}

export class TrialItemSelectionPrimitive
{
    public id: number;
    public originalIndex: number;
    public label: string;
    public selected: boolean;
    public itemPrimitive: ItemPrimitive;

    public constructor(init?: Partial<TrialItemSelectionPrimitive>) { (Object as any).assign(this, init); }
}

export class TrialItemSelectionItemComponent
{
    public id: number;
    public collectionId: number;
    public originalIndex: number;
    public name: string;
    public selected: boolean;
    public hasConditions: boolean;
    public trialItemSelectionPrimitives: TrialItemSelectionPrimitive[];

    public constructor(init?: Partial<TrialItemSelectionItemComponent>) { (Object as any).assign(this, init); }
}

export class TrialItemSelectionItem
{
    public id: number;
    public originalIndex: number;
    public name: string;
    public trialItemSelectionItemComponents: TrialItemSelectionItemComponent[];

    public constructor(init?: Partial<TrialItemSelectionItem>) { (Object as any).assign(this, init); }
}

export class TrialItemSelection
{
    public category: TrialItemSelectionCategory;
    public trialItemSelectionItems: TrialItemSelectionItem[];

    public constructor(init?: Partial<TrialItemSelection>) { (Object as any).assign(this, init); }
}

export class TrialItemDataEntryColumn
{
    public itemComponentWithDataIndex: number;

    public constructor(init?: Partial<TrialItemDataEntryColumn>) { (Object as any).assign(this, init); }
}

export class TrialItemDataEntryByInstitution
{
    public trialInstitutionId: number;
    public institutionId: number;
    public institutionDisplay: string;
    public trialItemDataEntryColumns: TrialItemDataEntryColumn[];

    public constructor(init?: Partial<TrialItemDataEntryByInstitution>) { (Object as any).assign(this, init); }
}

export class TrialItemDataEntryByItemComponentPrimitive
{
    public display: string;
    public trialInstitutionItemTemplateId?: number;
    public trialInstitutionItemTemplateLabel: string;
    public isFirstTrialItem: boolean;
    public collectionItemComponentId?: number;
    public itemComponentPrimitiveId?: number;
    public trialItemDataEntryColumns: TrialItemDataEntryColumn[];

    public constructor(init?: Partial<TrialItemDataEntryByItemComponentPrimitive>) { (Object as any).assign(this, init); }
}

export class CustomDataEntryColumn
{
    public itemComponentPrimitiveId?: number;
    public itemComponentPrimitive: ItemComponentPrimitive;
    public columnName: string;
    public collectionItemComponentId?: number;
    public collectionId?: number;
    public trialInstitutionTemplateId?: number;
    public trialInstitutionItemTemplateLabel: string;
    public isFirstTrialItem: boolean;

    public constructor(init?: Partial<CustomDataEntryColumn>) { (Object as any).assign(this, init); }
}

export class TrialInstitutionItemCustomView implements IForm
{
    public id?: number;
    public trialId?: number;
    public personnelId?: number;
    public name: string;
    public description: string;
    public sortOrder: number;
    public isShared: boolean;
    public compactTextArea: boolean;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public trialInstitutionItemCustomViewItems: TrialInstitutionItemCustomViewItem[];
    public trialItemSelections: TrialItemSelection[];
    public trialItemDataEntryByInstitutions: TrialItemDataEntryByInstitution[];
    public trialItemDataEntryByItemComponentPrimitives: TrialItemDataEntryByItemComponentPrimitive[];
    public itemComponentRules: ItemComponentRule[];
    public customDataEntryColumns: CustomDataEntryColumn[];
    public trialInstitutions: TrialInstitution[];
    public itemComponentWithDatas: ItemComponentWithData[];

    public constructor(init?: Partial<TrialInstitutionItemCustomView>) { (Object as any).assign(this, init); }
}

export class TrialInstitutionItemCustomViewItem implements ISubForm
{
    public id: number;
    public trialInstitutionItemCustomViewId?: number;
    public trialInstitutionItemCustomView: TrialInstitutionItemCustomView;
    public trialInstitutionItemTemplateId: number;
    public collectionId: number;
    public collectionItemComponentId: number;
    public itemComponentPrimitiveId: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public collectionInstanceId?: number;

    public constructor(init?: Partial<TrialInstitutionItemCustomViewItem>) { (Object as any).assign(this, init); }
}

export enum TrialInstitutionItemTemplateCategoryType
{
    Unclassified = 1,
    Protocol = 2,
    InvestigatorBrochure = 3,
    PatientInformationConsent = 4,
    SignaturePages = 5,
    Agreements = 6,
    PreStudy = 7,
    Activation = 8,
    Governance = 9,
    RegulatoryStatus = 10,
    PMB = 11,
    PromotionAndRecruitment = 12,
    Closure = 13,
    Safety = 14,
    Reports = 15,
    MedicalReview = 16,
    PatientTools = 17,
    TemplateLettersToParticipants = 18,
    Questionnaires = 19,
    EthicsAndGovernance = 20,
    TemplateLetterToGP = 21,
}

export enum TrialInstitutionItemComponentId
{
    Sent = 401,
    SendSite = 402,
    SendPharmaAus = 403,
    ClosureFileAndDate = 404,
    Received = 405,
    ReceiveSite = 406,
    ReceivePharma = 407,
    ReceiveOther = 408,
    Acknowledgement = 409,
    SignaturePage = 410,
    Ethics = 411,
    Renewal = 412,
    PisIc = 413,
    PI = 414,
    NumberedList = 415,
    ReturnDestruction = 416,
    Comments = 417,
    Completed = 418,
    Confirmed = 419,
    Approved = 420,
    Submitted = 421,
    YesNoNa = 422,
    SendPharmaInt1 = 423,
    SendPharmaInt2 = 424,
    SendOtherInt1 = 425,
    SendOtherInt2 = 426,
    SendOtherAus = 427,
    Tracking = 428,
    Documents = 429,
    ClosureReason = 430,
    Separator = 499,
}

export class TrialInstitutionLaboratoryContract implements IForm
{
    public id?: number;
    public trialInstitutionLaboratoryId?: number;
    public trialInstitutionLaboratory: TrialInstitutionLaboratory;
    public name: string;
    public location: string;
    public dateSentToSite?: string;
    public dateConfirmedBySite?: string;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<TrialInstitutionLaboratoryContract>) { (Object as any).assign(this, init); }
}

export class TrialInstitutionLaboratoryFinance implements IForm
{
    public id?: number;
    public trialInstitutionLaboratoryId: number;
    public trialInstitutionLaboratory: TrialInstitutionLaboratory;
    public overrideFundingEmail: boolean;
    public fundingEmail: string;
    public bsbSwift: string;
    public accountNumber: string;
    public siteCostCentre: string;
    public requireInvoiceFromSite: boolean;
    public overridePaymentDetails: boolean;
    public abn: string;
    public taxInvoiceName: string;
    public quickbooksTaxCodeId?: number;
    public quickbooksTaxCode: QuickbooksTaxCode;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<TrialInstitutionLaboratoryFinance>) { (Object as any).assign(this, init); }
}

export class TrialItemImport implements IForm
{
    public id?: number;
    // @References("typeof(TMD.ServiceModel.Types.Dto.Trial)")
    public trialId?: number;

    public trial: Trial;
    public templateCategories: Category[];
    public addGroups: boolean;
    public display: string;
    public selectedItems: number[];
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<TrialItemImport>) { (Object as any).assign(this, init); }
}

export class TrialItemInstitutionSummary
{
    public institutionId: number;
    public name: string;
    public collectionInstanceId: number;
    public version: string;
    public itemComponentRules: ItemComponentRule[];
    public columnFormat: string;
    public column1: ItemComponentWithData[];
    public column2: ItemComponentWithData[];
    public column3: ItemComponentWithData[];
    public documents: ItemComponentWithData[];
    public isModified: boolean;

    public constructor(init?: Partial<TrialItemInstitutionSummary>) { (Object as any).assign(this, init); }
}

export class TrialItemUpdate implements IForm
{
    public id?: number;
    public display: string;
    public trialItems: TrialItem[];
    public trialItemId?: number;
    public trialItemInstitutions: TrialItemInstitutionSummary[];
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<TrialItemUpdate>) { (Object as any).assign(this, init); }
}

export class QuillDocumentImage implements IForm
{
    public id?: number;
    public quillDocumentId?: number;
    public name: string;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<QuillDocumentImage>) { (Object as any).assign(this, init); }
}

export enum QuillDocumentType
{
    Help = 1,
}

export enum Page
{
    CommitteeMeetingAttendance = 1,
    CommitteeMeetingAttendances = 2,
    CommitteeMeeting = 3,
    CommitteeMeetings = 4,
    CommitteeMember = 5,
    CommitteeMemberRole = 6,
    CommitteeMemberRoles = 7,
    CommitteeMembers = 8,
    Committee = 9,
    CommitteeRegularInvitee = 10,
    CommitteeRegularInvitees = 11,
    Committees = 12,
    Countries = 13,
    Country = 14,
    Dashboard = 15,
    Discussion = 16,
    Discussions = 17,
    Error = 18,
    FacilityAllianceMember = 19,
    FacilityAllianceMembers = 20,
    Fellowship = 21,
    Fellowships = 22,
    FormTemplateFileType = 23,
    FormTemplateFileTypes = 24,
    FormTemplate = 25,
    FormTemplates = 26,
    GeneralSettings = 27,
    GroupContract = 28,
    GroupFinance = 29,
    GroupItemTemplateCategory = 30,
    GroupItemTemplateCategorys = 31,
    GroupItemTemplate = 32,
    GroupItemTemplates = 33,
    GroupItems = 34,
    GroupNotes = 35,
    Group = 36,
    GroupPersonnel = 37,
    GroupPersonnels = 38,
    GroupSettings = 39,
    GroupTrials = 40,
    Groups = 41,
    HealthDistrict = 42,
    HealthDistricts = 43,
    Hrec = 44,
    Hrecs = 45,
    InstitutionCode = 46,
    InstitutionCodes = 47,
    InstitutionCoding = 48,
    InstitutionCodings = 49,
    InstitutionContract = 50,
    InstitutionDepartmentContactEdit = 51,
    InstitutionDepartmentEdit = 52,
    InstitutionDepartmentPersonnelEdit = 53,
    InstitutionDepartments = 54,
    InstitutionFinance = 55,
    InstitutionItemTemplateCategories = 56,
    InstitutionItemTemplateCategory = 57,
    InstitutionItemTemplate = 58,
    InstitutionItemTemplates = 59,
    InstitutionItems = 60,
    InstitutionLaboratories = 61,
    InstitutionLaboratory = 62,
    InstitutionNotes = 63,
    Institution = 64,
    InstitutionPersonnel = 65,
    InstitutionPersonnels = 66,
    InstitutionProcedure = 67,
    InstitutionProcedures = 68,
    InstitutionSettings = 69,
    InstitutionTrials = 70,
    InstitutionType = 71,
    InstitutionTypes = 72,
    Institutions = 73,
    Interest = 74,
    Interests = 75,
    ItemComponent = 76,
    ItemComponentType = 77,
    ItemComponentTypes = 78,
    ItemComponents = 79,
    KeyContact = 80,
    KeyContacts = 81,
    LabContract = 82,
    LabDepartment = 83,
    LabDepartments = 84,
    LabFinance = 85,
    LabInstitution = 86,
    LabInstitutions = 87,
    Lab = 88,
    LabPersonnel = 89,
    LabPersonnels = 90,
    Labs = 91,
    MembershipType = 92,
    MembershipTypes = 93,
    MyTrials = 94,
    Note = 95,
    NoteType = 96,
    NoteTypes = 97,
    OpenClinicaUserRoles = 98,
    PersonnelActiveDirectory = 99,
    PersonnelByRoles = 100,
    PersonnelNotes = 101,
    PersonnelOCRoles = 102,
    Personnel = 103,
    PersonnelPermissions = 104,
    PersonnelRole = 105,
    PersonnelRoles = 106,
    PersonnelTrainingCertification = 107,
    Personnels = 108,
    ProfessionalDiscipline = 109,
    ProfessionalDisciplines = 110,
    ProjectInvestigator = 111,
    ProjectItemImport = 112,
    ProjectItemTemplateCategory = 113,
    ProjectItemTemplateCategorys = 114,
    ProjectItemTemplate = 115,
    ProjectItemTemplates = 116,
    ProjectItems = 117,
    Project = 118,
    ProjectSettings = 119,
    Projects = 120,
    QAEmailTemplate = 121,
    QAEmailTemplates = 123,
    QaSettings = 124,
    ReportingTagCategories = 125,
    ReportingTagCategory = 126,
    ReportingTag = 127,
    ReportingTags = 128,
    Role = 129,
    Roles = 130,
    Salutation = 131,
    Salutations = 132,
    Search = 133,
    Settings = 134,
    SiteLocation = 135,
    SiteLocations = 136,
    State = 137,
    States = 138,
    TaskType = 139,
    TaskTypes = 140,
    TrackerMilestone = 141,
    TrackerMilestones = 142,
    TrackerType = 143,
    TrackerTypes = 144,
    TrialAccruals = 145,
    TrialDoi = 146,
    TrialFinance = 147,
    TrialGroupContract = 148,
    TrialGroupContracts = 149,
    TrialGroupFinance = 150,
    TrialGroupItemTemplateCategories = 151,
    TrialGroupItemTemplateCategory = 152,
    TrialGroupItemTemplate = 153,
    TrialGroupItemTemplates = 154,
    TrialGroupItems = 155,
    TrialGroupLaboratories = 156,
    TrialGroupLaboratoryContract = 157,
    TrialGroupLaboratoryContracts = 158,
    TrialGroupLaboratoryFinance = 159,
    TrialGroupLaboratory = 160,
    TrialGroupLaboratoryPersonnel = 161,
    TrialGroupLaboratoryPersonnels = 162,
    TrialGroup = 163,
    TrialGroupPersonnel = 164,
    TrialGroupPersonnels = 165,
    TrialGroupSettings = 166,
    TrialGroups = 167,
    TrialInstitutionContract = 168,
    TrialInstitutionContracts = 169,
    TrialInstitutionFinance = 170,
    TrialInstitutionItemCustomViewDataEntry = 171,
    TrialInstitutionItemCustomView = 172,
    TrialInstitutionItemCustomViews = 173,
    TrialInstitutionItemTemplateCategories = 174,
    TrialInstitutionItemTemplateCategory = 175,
    TrialInstitutionItemTemplate = 176,
    TrialInstitutionItemTemplates = 177,
    TrialInstitutionItems = 178,
    TrialInstitutionLaboratories = 179,
    TrialInstitutionLaboratoryContract = 180,
    TrialInstitutionLaboratoryContracts = 181,
    TrialInstitutionLaboratoryFinance = 182,
    TrialInstitutionLaboratory = 183,
    TrialInstitutionLaboratoryPersonnel = 184,
    TrialInstitutionLaboratoryPersonnels = 185,
    TrialInstitutionNotes = 186,
    TrialInstitution = 187,
    TrialInstitutionPersonnel = 188,
    TrialInstitutionPersonnels = 189,
    TrialInstitutionSettings = 190,
    TrialInstitutions = 191,
    TrialItemImport = 192,
    TrialItem = 193,
    TrialItemTemplateCategories = 194,
    TrialItemTemplateCategory = 195,
    TrialItemTemplate = 196,
    TrialItemTemplates = 197,
    TrialItemUpdate = 198,
    TrialItems = 199,
    TrialNotes = 200,
    Trial = 201,
    TrialPersonnel = 202,
    TrialPersonnels = 203,
    TrialSettings = 204,
    TrialType = 205,
    TrialTypes = 206,
    TrialWebsite = 207,
    Trials = 208,
    Monitorings = 209,
    Monitoring = 210,
    MonitoringDocuments = 211,
    MonitoringDocument = 212,
    MonitoringIssues = 213,
    MonitoringIssue = 214,
    MonitoringIssueDocuments = 215,
    MonitoringIssueDocument = 216,
    TrialLaboratories = 217,
}

export class QuillDocument implements IForm
{
    public id?: number;
    public type: QuillDocumentType;
    public page: Page;
    public title: string;
    public editorState: string;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public quillDocumentImages: QuillDocumentImage[];

    public constructor(init?: Partial<QuillDocument>) { (Object as any).assign(this, init); }
}

export class ProjectInvestigator implements IForm
{
    public id?: number;
    public trialId?: number;
    public trial: Trial;
    public personnelId?: number;
    public personnel: Personnel;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<ProjectInvestigator>) { (Object as any).assign(this, init); }
}

export class Project implements IForm
{
    public id?: number;
    public trialStatusId?: number;
    public projectProtocolID: string;
    public projectScientificTitle: string;
    public projectShortTitle: string;
    public projectAckSource: string;
    public projectTrialDeveloperId?: number;
    public projectDateSubmitted?: string;
    public projectOutcomeId?: number;
    public protocolID: string;
    public studyAcronym: string;
    public shortTitle: string;
    public title: string;
    public internationalTrialStatusId?: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public display: string;
    public displayName: string;
    public shortDisplay: string;
    public projectInvestigators: ProjectInvestigator[];

    public constructor(init?: Partial<Project>) { (Object as any).assign(this, init); }
}

export class ProjectItemImport implements IForm
{
    public id?: number;
    // @References("typeof(TMD.ServiceModel.Types.Dto.Project)")
    public projectId?: number;

    public project: Project;
    public templateCategories: ProjectItemTemplateCategory[];
    public display: string;
    public selectedItems: number[];
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<ProjectItemImport>) { (Object as any).assign(this, init); }
}

export class ProjectedAccrual
{
    public id?: number;
    public trialId: number;
    public date: string;
    public value?: number;

    public constructor(init?: Partial<ProjectedAccrual>) { (Object as any).assign(this, init); }
}

export enum AllOfAnyOf
{
    AllOf = 0,
    AnyOf = 1,
}

export class SearchPersonnelAdvanced
{
    public allAnyTmdRoles: AllOfAnyOf;
    public tmdRoles: number[];
    public allAnyTmdTrials: AllOfAnyOf;
    public tmdTrials: number[];
    public allAnyCategories: AllOfAnyOf;
    public membershipTypeCategories: number[];
    public professionalDisciplineCategories: number[];
    public allAnyTrialGroups: AllOfAnyOf;
    public trialGroups: number[];
    public andAllAnyTmdRoles: AllOfAnyOf;
    public andTmdRoles: number[];
    public andAllAnyTmdTrials: AllOfAnyOf;
    public andTmdTrials: number[];
    public andAllAnyCategories: AllOfAnyOf;
    public andMembershipTypeCategories: number[];
    public andProfessionalDisciplineCategories: number[];
    public andAllAnyTrialGroups: AllOfAnyOf;
    public andTrialGroups: number[];
    public notAllAnyTmdRoles: AllOfAnyOf;
    public notTmdRoles: number[];
    public notAllAnyTmdTrials: AllOfAnyOf;
    public notTmdTrials: number[];
    public notAllAnyCategories: AllOfAnyOf;
    public notMembershipTypeCategories: number[];
    public notProfessionalDisciplineCategories: number[];
    public notAllAnyTrialGroups: AllOfAnyOf;
    public notTrialGroups: number[];
    public otherSurname: string;
    public otherFirstName: string;
    public otherInstitution: string;

    public constructor(init?: Partial<SearchPersonnelAdvanced>) { (Object as any).assign(this, init); }
}

export enum Permission
{
    TrialView = 1,
    TrialCreate = 2,
    TrialDetailsView = 3,
    TrialUpdate = 4,
    DashboardView = 5,
    TrialInstitutionView = 6,
    TrialInstitutionCreate = 7,
    TrialInstitutionUpdate = 8,
    TrialPersonnelRoleView = 9,
    TrialPersonnelRoleCreate = 10,
    TrialPersonnelRoleUpdate = 11,
    TrialItemView = 12,
    TrialItemCreate = 13,
    TrialItemUpdate = 14,
    TrialNoteView = 15,
    TrialNoteCreate = 16,
    TrialNoteUpdate = 17,
    TrialGroupView = 18,
    TrialGroupCreate = 19,
    TrialGroupUpdate = 20,
    InstitutionView = 21,
    InstitutionCreate = 22,
    InstitutionDetailsView = 23,
    InstitutionUpdate = 24,
    InstitutionDepartmentView = 25,
    InstitutionDepartmentCreate = 26,
    InstitutionDepartmentUpdate = 27,
    InstitutionPersonnelView = 28,
    InstitutionPersonnelCreate = 29,
    InstitutionPersonnelUpdate = 30,
    InstitutionNoteView = 31,
    InstitutionNoteCreate = 32,
    InstitutionNoteUpdate = 33,
    PersonnelView = 34,
    PersonnelCreate = 35,
    PersonnelUpdate = 36,
    PersonnelRoleView = 37,
    PersonnelRoleCreate = 38,
    PersonnelRoleUpdate = 39,
    PersonnelNoteView = 40,
    PersonnelNoteCreate = 41,
    PersonnelNoteUpdate = 42,
    PersonnelSecurityView = 43,
    PersonnelSecurityCreate = 44,
    PersonnelSecurityUpdate = 45,
    PersonnelOpenClinicaView = 46,
    PersonnelOpenClinicaCreate = 47,
    PersonnelOpenClinicaUpdate = 48,
    GroupView = 49,
    GroupCreate = 50,
    GroupUpdate = 51,
    GroupItemTemplatesView = 52,
    GroupItemTemplatesCreate = 53,
    GroupItemTemplatesUpdate = 54,
    GroupPersonnelRoleView = 55,
    GroupPersonnelRoleCreate = 56,
    GroupPersonnelRoleUpdate = 57,
    GroupNotesView = 58,
    GroupNotesCreate = 59,
    GroupNotesUpdate = 60,
    CategoriesView = 61,
    CategoriesCreate = 62,
    CategoriesUpdate = 63,
    RolesView = 64,
    RolesCreate = 65,
    RolesUpdate = 66,
    CountriesView = 67,
    CountriesCreate = 68,
    CountriesUpdate = 69,
    StatesView = 70,
    StatesCreate = 71,
    StatesUpdate = 72,
    ItemComponentTypesView = 73,
    ItemComponentTypesCreate = 74,
    ItemComponentTypesUpdate = 75,
    NoteTypesView = 76,
    NoteTypesCreate = 77,
    NoteTypesUpdate = 78,
    InterestsView = 79,
    InterestsCreate = 80,
    InterestsUpdate = 81,
    MembershipTypesView = 82,
    MembershipTypesCreate = 83,
    MembershipTypesUpdate = 84,
    ProfessionalDisciplinesView = 85,
    ProfessionalDisciplinesCreate = 86,
    ProfessionalDisciplinesUpdate = 87,
    SalutationsView = 88,
    SalutationsCreate = 89,
    SalutationsUpdate = 90,
    TrialTypesView = 91,
    TrialTypesCreate = 92,
    TrialTypesUpdate = 93,
    SiteLocationsView = 94,
    SiteLocationsCreate = 95,
    SiteLocationsUpdate = 96,
    KeyContactsView = 97,
    KeyContactsCreate = 98,
    KeyContactsUpdate = 99,
    FacilityAllianceMembersView = 100,
    FacilityAllianceMembersCreate = 101,
    FacilityAllianceMembersUpdate = 102,
    InstitutionTypesView = 103,
    InstitutionTypesCreate = 104,
    InstitutionTypesUpdate = 105,
    InstitutionCodingView = 106,
    InstitutionCodingCreate = 107,
    InstitutionCodingUpdate = 108,
    FormTemplatesView = 109,
    FormTemplatesCreate = 110,
    FormTemplatesUpdate = 111,
    FormComponentsView = 112,
    FormComponentsCreate = 113,
    FormComponentsUpdate = 114,
    ReportingTagsView = 115,
    ReportingTagsCreate = 116,
    ReportingTagsUpdate = 117,
    ReportingTagCategoriesView = 118,
    ReportingTagCategoriesCreate = 119,
    ReportingTagCategoriesUpdate = 120,
    ItemComponentsView = 121,
    ItemComponentsCreate = 122,
    ItemComponentsUpdate = 123,
    OpenClinicaUserRolesView = 124,
    OpenClinicaUserRolesCreate = 125,
    OpenClinicaUserRolesUpdate = 126,
    TaskTypesView = 127,
    TaskTypesCreate = 128,
    TaskTypesUpdate = 129,
    FormTemplateFileTypesView = 130,
    FormTemplateFileTypesCreate = 131,
    FormTemplateFileTypesUpdate = 132,
    QAEmailTemplatesView = 133,
    QAEmailTemplatesCreate = 134,
    QAEmailTemplatesUpdate = 135,
    ProjectView = 136,
    ProjectCreate = 137,
    ProjectUpdate = 138,
    ProjectInvestigatorsView = 139,
    ProjectInvestigatorsUpdate = 140,
    ProjectInvestigatorsCreate = 141,
    ProjectItemComponentsView = 142,
    ProjectItemComponentsUpdate = 143,
    ProjectItemComponentsCreate = 144,
    ProjectItemTemplatesView = 145,
    ProjectItemTemplatesUpdate = 146,
    ProjectItemTemplatesCreate = 147,
    ProjectItemCategoriesView = 148,
    ProjectItemCategoriesUpdate = 149,
    ProjectItemCategoriesCreate = 150,
    ProjectItemsView = 151,
    ProjectItemsUpdate = 152,
    ProjectItemsCreate = 153,
    GroupItemComponentsView = 154,
    GroupItemComponentsUpdate = 155,
    GroupItemComponentsCreate = 156,
    GroupItemCategoriesView = 157,
    GroupItemCategoriesUpdate = 158,
    GroupItemCategoriesCreate = 159,
    TrainingCertificationsView = 160,
    TrainingCertificationsUpdate = 161,
    TrainingCertificationsCreate = 162,
    HrecView = 163,
    HrecCreate = 164,
    HrecDetailsView = 165,
    HrecUpdate = 166,
    HealthDistrictView = 167,
    HealthDistrictCreate = 168,
    HealthDistrictDetailsView = 169,
    HealthDistrictUpdate = 170,
    FellowshipView = 171,
    FellowshipCreate = 172,
    FellowshipDetailsView = 173,
    FellowshipUpdate = 174,
    GroupContractView = 175,
    GroupContractCreate = 176,
    GroupContractUpdate = 177,
    GroupFinanceView = 178,
    GroupFinanceCreate = 179,
    GroupFinanceUpdate = 180,
    CommitteeView = 181,
    CommitteeCreate = 182,
    CommitteeUpdate = 183,
    CommitteeMeetingView = 184,
    CommitteeMeetingCreate = 185,
    CommitteeMeetingUpdate = 186,
    CommitteeMeetingAttendanceView = 187,
    CommitteeMeetingAttendanceCreate = 188,
    CommitteeMeetingAttendanceUpdate = 189,
    CommitteeMemberView = 190,
    CommitteeMemberCreate = 191,
    CommitteeMemberUpdate = 192,
    CommitteeMemberRoleView = 193,
    CommitteeMemberRoleCreate = 194,
    CommitteeMemberRoleUpdate = 195,
    CommitteeRegularInviteeView = 196,
    CommitteeRegularInviteeCreate = 197,
    CommitteeRegularInviteeUpdate = 198,
    GroupItemView = 199,
    GroupItemCreate = 200,
    GroupItemUpdate = 201,
    TrialAccrualView = 202,
    TrialAccrualCreate = 203,
    TrialAccrualUpdate = 204,
    LabView = 205,
    LabCreate = 206,
    LabDetailsView = 207,
    LabUpdate = 208,
    LabDepartmentView = 209,
    LabDepartmentCreate = 210,
    LabDepartmentUpdate = 211,
    LabPersonnelView = 212,
    LabPersonnelCreate = 213,
    LabPersonnelUpdate = 214,
    LabInstitutionView = 215,
    LabInstitutionCreate = 216,
    LabInstitutionUpdate = 217,
    TrialInstitutionLabView = 218,
    TrialInstitutionLabCreate = 219,
    TrialInstitutionLabUpdate = 220,
    TrialGroupLabView = 221,
    TrialGroupLabCreate = 222,
    TrialGroupLabUpdate = 223,
    ProjectDiscussionView = 224,
    ProjectDiscussionCreate = 225,
    ProjectDiscussionUpdate = 226,
    TrialDoiView = 227,
    TrialDoiCreate = 228,
    TrialDoiUpdate = 229,
    TrialWebsiteView = 230,
    TrialWebsiteCreate = 231,
    TrialWebsiteUpdate = 232,
    InstitutionProcedureView = 233,
    InstitutionProcedureCreate = 234,
    InstitutionProcedureUpdate = 235,
    InstitutionFinanceView = 236,
    InstitutionFinanceCreate = 237,
    InstitutionFinanceUpdate = 238,
    InstitutionContractView = 239,
    InstitutionContractCreate = 240,
    InstitutionContractUpdate = 241,
    InstitutionConfidentialityDeedView = 242,
    InstitutionConfidentialityDeedCreate = 243,
    InstitutionConfidentialityDeedUpdate = 244,
    LabFinanceView = 245,
    LabFinanceCreate = 246,
    LabFinanceUpdate = 247,
    LabContractView = 248,
    LabContractCreate = 249,
    LabContractUpdate = 250,
    LabConfidentialityDeedView = 251,
    LabConfidentialityDeedCreate = 252,
    LabConfidentialityDeedUpdate = 253,
    GroupConfidentialityDeedView = 254,
    GroupConfidentialityDeedCreate = 255,
    GroupConfidentialityDeedUpdate = 256,
    TrialFinanceView = 257,
    TrialFinanceCreate = 258,
    TrialFinanceUpdate = 259,
    TrialInstitutionFinanceView = 260,
    TrialInstitutionFinanceCreate = 261,
    TrialInstitutionFinanceUpdate = 262,
    TrialInstitutionContractView = 263,
    TrialInstitutionContractCreate = 264,
    TrialInstitutionContractUpdate = 265,
    TrialGroupFinanceView = 266,
    TrialGroupFinanceCreate = 267,
    TrialGroupFinanceUpdate = 268,
    TrialGroupContractView = 269,
    TrialGroupContractCreate = 270,
    TrialGroupContractUpdate = 271,
    TrialInstitutionLaboratoryFinanceView = 272,
    TrialInstitutionLaboratoryFinanceCreate = 273,
    TrialInstitutionLaboratoryFinanceUpdate = 274,
    TrialInstitutionLaboratoryContractView = 275,
    TrialInstitutionLaboratoryContractCreate = 276,
    TrialInstitutionLaboratoryContractUpdate = 277,
    TrialGroupLaboratoryFinanceView = 278,
    TrialGroupLaboratoryFinanceCreate = 279,
    TrialGroupLaboratoryFinanceUpdate = 280,
    TrialGroupLaboratoryContractView = 281,
    TrialGroupLaboratoryContractCreate = 282,
    TrialGroupLaboratoryContractUpdate = 283,
    InstitutionItemView = 284,
    InstitutionItemCreate = 285,
    InstitutionItemUpdate = 286,
    InstitutionItemTemplateCategoriesView = 287,
    InstitutionItemTemplateCategoriesCreate = 288,
    InstitutionItemTemplateCategoriesUpdate = 289,
    InstitutionItemComponentsView = 290,
    InstitutionItemComponentsUpdate = 291,
    InstitutionItemComponentsCreate = 292,
    TrialInstitutionItemTemplatesView = 293,
    TrialInstitutionItemTemplatesCreate = 294,
    TrialInstitutionItemTemplatesUpdate = 295,
    TrialInstitutionItemTemplateCategoriesView = 296,
    TrialInstitutionItemTemplateCategoriesCreate = 297,
    TrialInstitutionItemTemplateCategoriesUpdate = 298,
    TrialInstitutionItemComponentsView = 299,
    TrialInstitutionItemComponentsUpdate = 300,
    TrialInstitutionItemComponentsCreate = 301,
    TrialGroupItemTemplatesView = 302,
    TrialGroupItemTemplatesCreate = 303,
    TrialGroupItemTemplatesUpdate = 304,
    TrialGroupItemTemplateCategoriesView = 305,
    TrialGroupItemTemplateCategoriesCreate = 306,
    TrialGroupItemTemplateCategoriesUpdate = 307,
    TrialGroupItemComponentsView = 308,
    TrialGroupItemComponentsUpdate = 309,
    TrialGroupItemComponentsCreate = 310,
    InstitutionCodeView = 311,
    InstitutionCodeUpdate = 312,
    InstitutionCodeCreate = 313,
    TrialGroupItemView = 314,
    TrialGroupItemCreate = 315,
    TrialGroupItemUpdate = 316,
    TrialInstitutionItemView = 317,
    TrialInstitutionItemCreate = 318,
    TrialInstitutionItemUpdate = 319,
    SettingsView = 320,
    GeneralSettingsView = 321,
    ProjectSettingsView = 322,
    TrialSettingsView = 323,
    TrialInstitutionSettingsView = 324,
    TrialGroupSettingsView = 325,
    GroupSettingsView = 326,
    InstitutionSettingsView = 327,
    QaSettingsView = 328,
    MonitoringView = 329,
    MonitoringCreate = 330,
    MonitoringUpdate = 331,
    MonitoringDocumentView = 332,
    MonitoringDocumentCreate = 333,
    MonitoringDocumentUpdate = 334,
    MonitoringIssueView = 335,
    MonitoringIssueCreate = 336,
    MonitoringIssueUpdate = 337,
    MonitoringIssueDocumentView = 338,
    MonitoringIssueDocumentCreate = 339,
    MonitoringIssueDocumentUpdate = 340,
    QuillDocumentsView = 341,
    QuillDocumentsCreate = 342,
    QuillDocumentsUpdate = 343,
    OpmsAccess = 344,
    OpmsInstitutionView = 345,
    OpmsAdminister = 346,
    OpmsPatientView = 347,
    SystemAdminister = 348,
    OpmsPatientUpdate = 349,
    OpmsMasterGroupAdminister = 350,
    OpmsCoordinatingGroupAdminister = 351,
    PathologyTestAdminister = 352,
    BlockShipmentDetailsView = 353,
    OpmsPatientRegister = 354,
    OpmsPatientRandomise = 355,
    SaeView = 356,
    SaeReview = 357,
    ScreeningLogView = 358,
    ScreeningLogUpdate = 359,
    TeleformView = 360,
    TeleformManage = 361,
    EcrfView = 362,
    SaeAdminister = 363,
    MedicalReviewAccess = 364,
    MedicalReviewPerform = 365,
    MedicalReviewAdminister = 366,
    HistopathologyAccess = 367,
    DrugManagementView = 368,
    DrugManagementAdminister = 369,
    DrugManagementDispenseDrug = 370,
    OpmsProView = 371,
    OpmsProUpdate = 372,
    OpmsProAdminister = 373,
    OpmsPatientImpersonate = 374,
    OpmsPatientAccountManagement = 375,
    OpmsCrfView = 376,
    OpmsCrfUpdate = 377,
    OpmsEventView = 378,
    OpmsEventUpdate = 379,
    OpmsConsentAdminister = 380,
    OpmsCoordinatingGroupContactView = 381,
    OpmsSaeInvestigatorNotify = 382,
    EConsentView = 383,
    EConsentAdminister = 384,
    EConsentManage = 385,
    PISignOffView = 386,
    PISignOffPerform = 387,
    PISignOffAdminister = 388,
    OpmsDataManage = 389,
    RedactVerificationAccess = 390,
    ReconsentAdminister = 391,
    TrialManagementAccess = 392,
    SourceDataVerificationAccess = 393,
    TrialParticipantAccess = 394,
    StaffTrainingAccess = 395,
    TrainingAccess = 396,
    ReportAccess = 397,
    WebsiteImporterAccess = 398,
    ConstituentManagerAccess = 399,
    OpmsBypassErrors = 400,
    RadiologyReviewAccess = 401,
    ApproveInvoice = 402,
    PrescreeningAccess = 403,
    PrescreeningAdminister = 404,
    InvoiceExportView = 405,
    InvoiceExportUpdate = 406,
    InvoiceRequisitionView = 407,
    InvoiceRequisitionUpdate = 408,
    CanCentralReview = 409,
    InvoiceView = 410,
    InvoiceUpdate = 411,
    IsSiteUser = 412,
    TissueBankAdmin = 413,
    TrialLaboratoryView = 414,
    CanViewQuerySummaries = 415,
}

export enum PermissionResolutionType
{
    DatabaseConfiguration = 1,
    ClassConfiguration = 2,
    FileConfiguration = 3,
}

export class PermissionContext
{
    public trialId?: number;
    public masterGroupId?: number;
    public coordinatingGroupId?: number;
    public institutionCode: string;
    public patientStudyNumber: string;

    public constructor(init?: Partial<PermissionContext>) { (Object as any).assign(this, init); }
}

export class PermissionQuery
{
    public permission?: Permission;
    public permissionResolutionType?: PermissionResolutionType;
    public permissionContext: PermissionContext;

    public constructor(init?: Partial<PermissionQuery>) { (Object as any).assign(this, init); }
}

export enum UserSessionType
{
    Normal = 1,
    Patient = 2,
}

export class Monitor implements IForm
{
    public id?: number;
    public monitoringId?: number;
    public monitoring: Monitoring;
    public personnelId?: number;
    public personnel: Personnel;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<Monitor>) { (Object as any).assign(this, init); }
}

export class MonitoringVisitType implements IForm
{
    public id?: number;
    public value: string;
    public rank?: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<MonitoringVisitType>) { (Object as any).assign(this, init); }
}

export class MonitoringPharmacyVisit implements IForm
{
    public id?: number;
    public value: string;
    public rank?: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<MonitoringPharmacyVisit>) { (Object as any).assign(this, init); }
}

export class MonitoringMeeting implements IForm
{
    public id?: number;
    public value: string;
    public rank?: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<MonitoringMeeting>) { (Object as any).assign(this, init); }
}

export class MonitoringStatus implements IForm
{
    public id?: number;
    public value: string;
    public rank?: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<MonitoringStatus>) { (Object as any).assign(this, init); }
}

export class MonitoringIssueType implements IForm
{
    public id?: number;
    public value: string;
    public rank?: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<MonitoringIssueType>) { (Object as any).assign(this, init); }
}

export class MonitoringIssueDeviationType implements IForm
{
    public id?: number;
    public value: string;
    public rank?: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<MonitoringIssueDeviationType>) { (Object as any).assign(this, init); }
}

export class MonitoringIssueCategory implements IForm
{
    public id?: number;
    public value: string;
    public rank?: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<MonitoringIssueCategory>) { (Object as any).assign(this, init); }
}

export class MonitoringIssueExecutiveInformed implements IForm
{
    public id?: number;
    public value: string;
    public rank?: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<MonitoringIssueExecutiveInformed>) { (Object as any).assign(this, init); }
}

export class MonitoringIssueActionTaken implements IForm
{
    public id?: number;
    public value: string;
    public rank?: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<MonitoringIssueActionTaken>) { (Object as any).assign(this, init); }
}

export class MonitoringIssueNotified implements IForm
{
    public id?: number;
    public value: string;
    public rank?: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<MonitoringIssueNotified>) { (Object as any).assign(this, init); }
}

export class MonitoringIssueStatus implements IForm
{
    public id?: number;
    public value: string;
    public rank?: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<MonitoringIssueStatus>) { (Object as any).assign(this, init); }
}

export class MonitoringIssue implements IForm
{
    public id?: number;
    public monitoringId?: number;
    public monitoring: Monitoring;
    public monitoringIssueTypeId?: number;
    public monitoringIssueType: MonitoringIssueType;
    public monitoringIssueDeviationTypeId?: number;
    public monitoringIssueDeviationType: MonitoringIssueDeviationType;
    public monitoringIssueCategoryId?: number;
    public monitoringIssueCategory: MonitoringIssueCategory;
    public comments: string;
    public correctiveAction: string;
    public monitoringIssueExecutiveInformedId?: number;
    public monitoringIssueExecutiveInformed: MonitoringIssueExecutiveInformed;
    public executiveInformedDate?: string;
    public monitoringIssueActionTakenId?: number;
    public monitoringIssueActionTaken: MonitoringIssueActionTaken;
    public monitoringIssueNotifiedId?: number;
    public monitoringIssueNotified: MonitoringIssueNotified;
    public notifiedDate?: string;
    public monitoringIssueStatusId?: number;
    public monitoringIssueStatus: MonitoringIssueStatus;
    public closedDate?: string;
    public patient: string;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<MonitoringIssue>) { (Object as any).assign(this, init); }
}

export class MonitoringDocument implements IForm
{
    public id?: number;
    public monitoringId?: number;
    public monitoring: Monitoring;
    public name: string;
    public location: string;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<MonitoringDocument>) { (Object as any).assign(this, init); }
}

export class Monitoring implements IForm
{
    public id?: number;
    public trialInstitutionId?: number;
    public trialInstitution: TrialInstitution;
    public startDate?: string;
    public endDate?: string;
    public monitors: Monitor[];
    public monitoringVisitTypeId?: number;
    public monitoringVisitType: MonitoringVisitType;
    public monitoringPharmacyVisitId?: number;
    public monitoringPharmacyVisit: MonitoringPharmacyVisit;
    public monitoringMeetingId?: number;
    public monitoringMeeting: MonitoringMeeting;
    public hoursMonitoring?: number;
    public minorDeviations?: number;
    public submittedTo: string;
    public submittedDate?: string;
    public monitoringStatusId?: number;
    public monitoringStatus: MonitoringStatus;
    public approvedDate?: string;
    public mailedDate?: string;
    public mailedNa?: boolean;
    public comments: string;
    public uploadedDate?: string;
    public uploadedNa?: boolean;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public monitoringIssues: MonitoringIssue[];
    public pharmacyClosureDate?: string;
    public monitoringDocuments: MonitoringDocument[];

    public constructor(init?: Partial<Monitoring>) { (Object as any).assign(this, init); }
}

export class MonitoringIssueDocument implements IForm
{
    public id?: number;
    public monitoringIssueId?: number;
    public monitoringIssue: MonitoringIssue;
    public name: string;
    public location: string;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<MonitoringIssueDocument>) { (Object as any).assign(this, init); }
}

export class LaboratoryConfidentialityDeed
{
    public id?: number;
    public laboratoryId?: number;
    public laboratory: Laboratory;
    public name: string;
    public location: string;
    public dateOfDeed?: string;
    public dateFullyExecuted?: string;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<LaboratoryConfidentialityDeed>) { (Object as any).assign(this, init); }
}

export class LaboratoryContractSiteType implements IForm
{
    public id?: number;
    public value: string;
    public rank?: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<LaboratoryContractSiteType>) { (Object as any).assign(this, init); }
}

export class LaboratoryContract implements IForm
{
    public id?: number;
    public laboratoryId?: number;
    public laboratory: Laboratory;
    public agreementName: string;
    public noOfOriginalCTRARequired?: number;
    public laboratoryContractSiteTypeId?: number;
    public laboratoryContractSiteType: LaboratoryContractSiteType;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public laboratoryConfidentialityDeed: LaboratoryConfidentialityDeed;

    public constructor(init?: Partial<LaboratoryContract>) { (Object as any).assign(this, init); }
}

export class FormPropertyErrorMessage
{
    public propertyName: string;
    public label: string;

    public constructor(init?: Partial<FormPropertyErrorMessage>) { (Object as any).assign(this, init); }
}

export class FormProperty
{
    public formName: string;
    public propertyName: string;
    public label: string;
    public detailedLabel: string;
    public formPropertyErrorMessages: FormPropertyErrorMessage[];

    public constructor(init?: Partial<FormProperty>) { (Object as any).assign(this, init); }
}

export class RegistrationFormProperty
{
    public id: number;
    public registrationFormId: number;
    public formName: string;
    public propertyName: string;
    public label: string;

    public constructor(init?: Partial<RegistrationFormProperty>) { (Object as any).assign(this, init); }
}

export class InstitutionConfidentialityDeed
{
    public id?: number;
    public institutionId?: number;
    public institution: Institution;
    public name: string;
    public location: string;
    public dateOfDeed?: string;
    public dateFullyExecuted?: string;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public sourceDocuments: SourceDocument[];

    public constructor(init?: Partial<InstitutionConfidentialityDeed>) { (Object as any).assign(this, init); }
}

export class InstitutionContractSiteType implements IForm
{
    public id?: number;
    public value: string;
    public rank?: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<InstitutionContractSiteType>) { (Object as any).assign(this, init); }
}

export class InstitutionContract implements IForm
{
    public id?: number;
    public institutionId?: number;
    public institution: Institution;
    public agreementName: string;
    public noOfOriginalCTRARequired?: number;
    public institutionContractSiteTypeId?: number;
    public institutionContractSiteType: InstitutionContractSiteType;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public institutionConfidentialityDeed: InstitutionConfidentialityDeed;

    public constructor(init?: Partial<InstitutionContract>) { (Object as any).assign(this, init); }
}

export class GroupConfidentialityDeed
{
    public id?: number;
    public groupId?: number;
    public group: Group;
    public name: string;
    public location: string;
    public dateOfDeed?: string;
    public dateFullyExecuted?: string;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<GroupConfidentialityDeed>) { (Object as any).assign(this, init); }
}

export class GroupContractSiteType implements IForm
{
    public id?: number;
    public value: string;
    public rank: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<GroupContractSiteType>) { (Object as any).assign(this, init); }
}

export class GroupContract implements IForm
{
    public id?: number;
    public groupId?: number;
    public group: Group;
    public agreementName: string;
    public noOfOriginalCTRARequired?: number;
    public groupContractSiteTypeId?: number;
    public groupContractSiteType: GroupContractSiteType;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public groupConfidentialityDeed: GroupConfidentialityDeed;

    public constructor(init?: Partial<GroupContract>) { (Object as any).assign(this, init); }
}

export class GroupItemImport implements IForm
{
    public id?: number;
    // @References("typeof(TMD.ServiceModel.Types.Dto.TrialGroup)")
    public trialGroupId?: number;

    public trialGroup: TrialGroup;
    public templateCategories: GroupItemTemplateCategory[];
    public trialDisplay: string;
    public groupDisplay: string;
    public selectedItems: number[];
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<GroupItemImport>) { (Object as any).assign(this, init); }
}

export class CommitteeMeetingAttendanceStatus implements IForm
{
    public id?: number;
    public value: string;
    public rank?: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<CommitteeMeetingAttendanceStatus>) { (Object as any).assign(this, init); }
}

export class CommitteeMeetingAttendance implements IForm
{
    public id?: number;
    public committeeMeetingId?: number;
    public committeeMeeting: CommitteeMeeting;
    public personnelId: number;
    public personnel: Personnel;
    public committeeMeetingAttendanceStatusId?: number;
    public committeeMeetingAttendanceStatus: CommitteeMeetingAttendanceStatus;
    public comment: string;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<CommitteeMeetingAttendance>) { (Object as any).assign(this, init); }
}

export enum RequestedMembershipType
{
    FullMember = 1,
    AffiliateMember = 2,
}

export enum YesNo
{
    No = 0,
    Yes = 1,
}

export enum MemberInterest
{
    BasicScience = 1,
    Biostatistics = 2,
    BoneHealth = 3,
    BoneMetastases = 4,
    BrainMetastases = 5,
    BreastCancerPrevention = 6,
    BreastReconstruction = 7,
    CardiacHealth = 8,
    CtDnaCirculatingTumourCells = 9,
    Dcis = 10,
    EndocrineTherapy = 11,
    Epidemiology = 12,
    FamilialCancerGenetics = 13,
    Fertility = 14,
    HealthEconomics = 15,
    HealthServicesResearch = 16,
    Her2PositiveDisease = 17,
    ImagingScreening = 18,
    Immunotherapy = 19,
    ImplementationResearch = 20,
    LifestyleInterventions = 21,
    LocoRegionalClinicalTrials = 22,
    Menopause = 23,
    MetastaticDisease = 24,
    NeoadjuvantTrials = 25,
    NextGenerationSequencing = 26,
    OlderPatients = 27,
    PalliativeCare = 28,
    Pathology = 29,
    PatientReportedOutcomesQualityOfLife = 30,
    Psychooncology = 31,
    PublicHealthResearch = 32,
    RadiationResearch = 33,
    StereotacticRadiation = 34,
    SupportiveCare = 35,
    SurgicalTrials = 36,
    Survivorship = 37,
    TranslationalResearch = 38,
    TripleNegativeBreastCancer = 39,
    YoungPatients = 40,
    OtherPleaseSpecify = 41,
}

export class InterestArea
{
    public id?: number;
    public memberId?: number;
    public interestId?: MemberInterest;
    public specify?: string;

    public constructor(init?: Partial<InterestArea>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ResearchMemberApplication
{
    /** @description The applicant's title. */
    // @DataMember(Order=1)
    // @ApiMember(DataType="string", Description="The applicant's title.", IsRequired=true, Name="Title", ParameterType="model")
    public title: string;

    /** @description The applicant's first name. */
    // @DataMember(Order=2)
    // @ApiMember(DataType="string", Description="The applicant's first name.", IsRequired=true, Name="FirstName", ParameterType="model")
    public firstName: string;

    /** @description The applicant's last name. */
    // @DataMember(Order=3)
    // @ApiMember(DataType="string", Description="The applicant's last name.", IsRequired=true, Name="LastName", ParameterType="model")
    public lastName: string;

    /** @description The applicant's institution. */
    // @DataMember(Order=4)
    // @ApiMember(DataType="string", Description="The applicant's institution.", IsRequired=true, Name="Institution", ParameterType="model")
    public institution: string;

    /** @description The applicant's address. */
    // @DataMember(Order=5)
    // @ApiMember(DataType="string", Description="The applicant's address.", IsRequired=true, Name="Address", ParameterType="model")
    public address: string;

    /** @description The applicant's suburb. */
    // @DataMember(Order=6)
    // @ApiMember(DataType="string", Description="The applicant's suburb.", IsRequired=true, Name="Suburb", ParameterType="model")
    public suburb: string;

    /** @description The applicant's state. Required when country = "Australia". */
    // @DataMember(Order=7)
    // @ApiMember(DataType="string", Description="The applicant's state. Required when country = \"Australia\".", Name="State", ParameterType="model")
    public state?: string;

    /** @description The applicant's postcode. */
    // @DataMember(Order=8)
    // @ApiMember(DataType="string", Description="The applicant's postcode.", IsRequired=true, Name="Postcode", ParameterType="model")
    public postcode: string;

    /** @description The applicant's country. */
    // @DataMember(Order=9)
    // @ApiMember(DataType="string", Description="The applicant's country.", IsRequired=true, Name="Country", ParameterType="model")
    public country: string;

    /** @description The applicant's email address. */
    // @DataMember(Order=10)
    // @ApiMember(DataType="string", Description="The applicant's email address.", IsRequired=true, Name="Email", ParameterType="model")
    public email: string;

    /** @description The applicant's phone number. */
    // @DataMember(Order=11)
    // @ApiMember(DataType="string", Description="The applicant's phone number.", IsRequired=true, Name="Phone", ParameterType="model")
    public phone: string;

    /** @description The applicant's mobile number. */
    // @DataMember(Order=12)
    // @ApiMember(DataType="string", Description="The applicant's mobile number.", Name="Mobile", ParameterType="model")
    public mobile?: string;

    /** @description The applicant's Fax number. */
    // @DataMember(Order=13)
    // @ApiMember(DataType="string", Description="The applicant's Fax number.", Name="Fax", ParameterType="model")
    public fax?: string;

    /** @description The applicant's speciality. */
    // @DataMember(Order=14)
    // @ApiMember(DataType="integer", Description="The applicant's speciality.", Format="int32", IsRequired=true, Name="Speciality", ParameterType="model")
    public speciality: number;

    /** @description The applicant's speciality manual specification. Required when speciality = "NonClinicalParticipant" or "Other". */
    // @DataMember(Order=15)
    // @ApiMember(DataType="string", Description="The applicant's speciality manual specification. Required when speciality = \"NonClinicalParticipant\" or \"Other\".", Name="SpecialitySpecification", ParameterType="model")
    public specialitySpecification?: string;

    /** @description The applicant's current invlovement in BCT activities. */
    // @DataMember(Order=16)
    // @ApiMember(DataType="string", Description="The applicant's current invlovement in BCT activities.", IsRequired=true, Name="Involvement", ParameterType="model")
    public involvement: string;

    /** @description The applicant's reason for membership. */
    // @DataMember(Order=17)
    // @ApiMember(DataType="string", Description="The applicant's reason for membership.", IsRequired=true, Name="Reason", ParameterType="model")
    public reason: string;

    /** @description The applicant's requested membership type. */
    // @DataMember(Order=18)
    // @ApiMember(DataType="integer", Description="The applicant's requested membership type.", Format="int32", IsRequired=true, Name="MembershipTypeId", ParameterType="model")
    public membershipTypeId: RequestedMembershipType;

    /** @description The applicant does not know any existing members to support their application. */
    // @DataMember(Order=19)
    // @ApiMember(DataType="boolean", Description="The applicant does not know any existing members to support their application.", IsRequired=true, Name="NoSupporters", ParameterType="model")
    public noSupporters: boolean;

    /** @description The applicant's proposer, identified via member id. Required unless no supporters = "true". */
    // @DataMember(Order=20)
    // @ApiMember(DataType="string", Description="The applicant's proposer, identified via member id. Required unless no supporters = \"true\".", Name="ProposerId", ParameterType="model")
    public proposerId?: string;

    /** @description The applicant's seconder, identified via member id. Required unless no supporters = "true". */
    // @DataMember(Order=21)
    // @ApiMember(DataType="string", Description="The applicant's seconder, identified via member id. Required unless no supporters = \"true\".", Name="SeconderId", ParameterType="model")
    public seconderId?: string;

    /** @description The applicant agrees to BCT providing their email address to other group members and associated collaborative research groups if requested. */
    // @DataMember(Order=22)
    // @ApiMember(DataType="boolean", Description="The applicant agrees to BCT providing their email address to other group members and associated collaborative research groups if requested.", IsRequired=true, Name="AgreeToEmailShare", ParameterType="model")
    public agreeToEmailShare: boolean;

    /** @description The applicant's agrees to their contact details being included in the members only access section of BCT's website. */
    // @DataMember(Order=23)
    // @ApiMember(DataType="boolean", Description="The applicant's agrees to their contact details being included in the members only access section of BCT's website.", IsRequired=true, Name="AgreeToDetailShare", ParameterType="model")
    public agreeToDetailShare: boolean;

    /** @description The applicant's agrees to the terms and conditions set by the BCT. */
    // @DataMember(Order=24)
    // @ApiMember(DataType="boolean", Description="The applicant's agrees to the terms and conditions set by the BCT.", IsRequired=true, Name="AgreeToTerms", ParameterType="model")
    public agreeToTerms: boolean;

    /** @description Whether the applicant is a trainee in their primary speciality. */
    // @DataMember(Order=25)
    // @ApiMember(DataType="boolean", Description="Whether the applicant is a trainee in their primary speciality.", Name="Trainee", ParameterType="model")
    public trainee?: boolean;

    /** @description Whether the applicant has a higher degree. */
    // @DataMember(Order=26)
    // @ApiMember(DataType="integer", Description="Whether the applicant has a higher degree.", Format="int32", Name="HigherDegree", ParameterType="model")
    public higherDegree?: YesNo;

    /** @description The year the higher degree was awarded. */
    // @DataMember(Order=27)
    // @ApiMember(DataType="integer", Description="The year the higher degree was awarded.", Format="int32", Name="YearAwarded", ParameterType="model")
    public yearAwarded?: number;

    /** @description The type of higher degree. */
    // @DataMember(Order=28)
    // @ApiMember(DataType="string", Description="The type of higher degree.", Name="DegreeType", ParameterType="model")
    public degreeType?: string;

    /** @description Whether the applicant is interested in peer review. */
    // @DataMember(Order=30)
    // @ApiMember(DataType="integer", Description="Whether the applicant is interested in peer review.", Format="int32", Name="InterestPeerReview", ParameterType="model")
    public interestPeerReview?: YesNo;

    /** @description Whether the applicant is interested in concept development. */
    // @DataMember(Order=31)
    // @ApiMember(DataType="integer", Description="Whether the applicant is interested in concept development.", Format="int32", Name="InterestConceptDevelopment", ParameterType="model")
    public interestConceptDevelopment?: YesNo;

    /** @description Any additional specialities the applicant may have. */
    // @DataMember(Order=32)
    // @ApiMember(DataType="array", Description="Any additional specialities the applicant may have.", Name="AdditionalSpecialities", ParameterType="model")
    public additionalSpecialities?: string[];

    /** @description Any additional interests the applicant may have. */
    // @DataMember(Order=33)
    // @ApiMember(DataType="array", Description="Any additional interests the applicant may have.", Name="InterestAreas", ParameterType="model")
    public interestAreas?: InterestArea[];

    public constructor(init?: Partial<ResearchMemberApplication>) { (Object as any).assign(this, init); }
}

export enum ApplicationState
{
    Received = 0,
    Denied = 1,
    Processed = 2,
}

export class Application
{
    public id?: number;
    public memberId?: number;
    public guid?: string;
    public dateEntered?: string;
    public dateModified?: string;
    public supportEmail?: string;
    public chooseEmail?: string;
    public chooseSupporter?: string;
    public supportEmailDate?: string;
    public noSupporters?: boolean;
    public supportEmailAdmin?: string;
    public inactiveEmail?: string;
    public applicationStateId?: ApplicationState;

    public constructor(init?: Partial<Application>) { (Object as any).assign(this, init); }
}

export class AdditionalSpeciality
{
    public id?: number;
    public memberId?: number;
    public speciality?: string;

    public constructor(init?: Partial<AdditionalSpeciality>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ResponseError
{
    // @DataMember(Order=1)
    public errorCode: string;

    // @DataMember(Order=2)
    public fieldName: string;

    // @DataMember(Order=3)
    public message: string;

    // @DataMember(Order=4)
    public meta?: { [index:string]: string; };

    public constructor(init?: Partial<ResponseError>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ResponseStatus
{
    // @DataMember(Order=1)
    public errorCode: string;

    // @DataMember(Order=2)
    public message?: string;

    // @DataMember(Order=3)
    public stackTrace?: string;

    // @DataMember(Order=4)
    public errors?: ResponseError[];

    // @DataMember(Order=5)
    public meta?: { [index:string]: string; };

    public constructor(init?: Partial<ResponseStatus>) { (Object as any).assign(this, init); }
}

export class LookupValue
{
    public id?: number;
    public value: string;
    public rank?: number;
    public active: boolean;
    public groupId?: number;
    public group: string;
    public groupRank?: number;

    public constructor(init?: Partial<LookupValue>) { (Object as any).assign(this, init); }
}

export class LookupGroup
{
    public id?: number;
    public value: string;
    public values: LookupValue[];

    public constructor(init?: Partial<LookupGroup>) { (Object as any).assign(this, init); }
}

export class Lookup
{
    public type: string;
    public propertyName: string;
    public values: LookupValue[];
    public groupedValues: LookupGroup[];

    public constructor(init?: Partial<Lookup>) { (Object as any).assign(this, init); }
}

export interface IHasLookups
{
    lookups: Lookup[];
}

export enum FormStatus
{
    Enabled = 1,
    Disabled = 2,
}

export class FormState
{
    public id: number;
    public formId: number;
    public formStatus?: FormStatus;
    public validate?: boolean;
    public blockSave?: boolean;

    public constructor(init?: Partial<FormState>) { (Object as any).assign(this, init); }
}

export class ProjectItemCategory
{
    public categoryId: number;
    public projectItemTemplateCategory: ProjectItemTemplateCategory;
    public projectItems: ProjectItem[];

    public constructor(init?: Partial<ProjectItemCategory>) { (Object as any).assign(this, init); }
}

export class SentrySettings
{
    public dsn: string;
    public environment: string;
    public customer: string;
    public sendDefaultPii?: boolean;
    public enableMetrics?: boolean;
    public attachStacktrace?: boolean;
    public debug?: boolean;
    public enableLogs?: boolean;
    public enableReportABug?: boolean;
    public replaysOnErrorSampleRate?: number;
    public replaysSessionSampleRate?: number;
    public tracesSampleRate?: number;

    public constructor(init?: Partial<SentrySettings>) { (Object as any).assign(this, init); }
}

export class ClientAppSettings
{
    public sentry: SentrySettings;

    public constructor(init?: Partial<ClientAppSettings>) { (Object as any).assign(this, init); }
}

export enum AddressTypeId
{
    Home = 1,
    Business = 2,
    Other = 3,
    Delivery = 4,
}

export enum TrialInstitutionItemComponentPrimitiveId
{
    DateSent = 401,
    DateSentToSite = 402,
    DateSentToPharmaAus = 403,
    DateSentToPharmaInt1 = 404,
    DateSentToPharmaInt2 = 405,
    DateSentToOtherInt1 = 406,
    DateSentToOtherInt2 = 407,
    DateSentToOtherAus = 408,
    FileLocation = 409,
    DateClosureApproved = 410,
    ClosureReason = 411,
    DateReceived = 412,
    DateReceivedFromSite = 413,
    DateReceivedFromPharma = 414,
    DateReceivedFromOther = 415,
    DateAcknowledgeRecptRec = 416,
    DateSignaturePageReceived = 417,
    DateSubmittedToHrec = 418,
    ApprovedByHrec = 419,
    DateHrecApproved = 420,
    CommListCompNote = 421,
    ValidUntil = 422,
    VersionReason = 423,
    DateBctInitialReview = 424,
    DateBctFinalReview = 425,
    PiName = 426,
    DocumentNumbers = 427,
    DateReturnedDestroyed = 428,
    DateCompleted = 429,
    DateConfirmed = 430,
    DateApproved = 431,
    DateSubmitted = 432,
    Required = 433,
    ItemDocuments = 434,
    Comments = 435,
}

export enum TrialInstitutionItemComponentPrimitiveOptionId
{
    FileLocationWithInvestigatorFiles = 401,
    FileLocationArchivedAtPharmacy = 402,
    FileLocationArchivedOffSite = 403,
    FileLocationArchivedOnSite = 404,
    ClosureReasonTrialComplete = 405,
    ClosureReasonTrialAccrualClosed = 406,
    ClosureReasonInvestigatorRequest = 407,
    ClosureReasonSponsorDecision = 408,
    ClosureReasonEthicsWithdrawn = 409,
    ClosureReasonOther = 410,
    ApprovedByHrecNo = 411,
    ApprovedByHrecYes = 412,
    ApprovedByHrecNA = 413,
    CommListCompNoteNo = 414,
    CommListCompNoteYes = 415,
    CommListCompNoteNA = 416,
    RequiredNo = 417,
    RequiredYes = 418,
    RequiredNA = 419,
}

export class User
{
    public userName: string;
    public firstName: string;
    public lastName: string;
    public fullName: string;
    public email: string;
    public trialId?: number;
    public groups: string[];
    public institutions: string[];
    public roles: { [index:string]: string[]; };

    public constructor(init?: Partial<User>) { (Object as any).assign(this, init); }
}

export class PersonnelTmdPermissions
{
    public personnelId: number;
    public userName: string;
    public trialId?: number;
    public protocolID: string;
    public institutionId?: number;
    public code: string;
    public roleGroupId: number;
    public trialMatch: boolean;
    public institutionMatch: boolean;
    public requirementDescription: string;
    public configurationDescription: string;
    public moduleName: string;
    public moduleDescription: string;
    public roleId: number;
    public roleName: string;
    public permission: Permission;
    public permissionName: string;
    public permissionDescription: string;

    public constructor(init?: Partial<PersonnelTmdPermissions>) { (Object as any).assign(this, init); }
}

export class UserSummary
{
    public hasTrialRoles: boolean;
    public hasInstitutionRoles: boolean;
    public hasTrialInstitutionRoles: boolean;
    public institutions: Institution[];
    public permissions: PersonnelTmdPermissions[];

    public constructor(init?: Partial<UserSummary>) { (Object as any).assign(this, init); }
}

export class TrialInstitutionRole
{
    public trialInstitution: TrialInstitution;
    public personnelRole: PersonnelRole;
    public patients: string[];

    public constructor(init?: Partial<TrialInstitutionRole>) { (Object as any).assign(this, init); }
}

export class ApiUser
{
    public id?: number;
    public title: string;
    public firstName: string;
    public lastName: string;
    public subjectId: string;
    public username: string;
    public email: string;
    public apiKey: string;
    public committeeMembership: CommitteeMember[];
    public trialInstitutionRoles: TrialInstitutionRole[];
    public personnelRoles: PersonnelRole[];

    public constructor(init?: Partial<ApiUser>) { (Object as any).assign(this, init); }
}

// @DataContract
export class TrialUser
{
    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public firstName: string;

    // @DataMember(Order=3)
    public lastName: string;

    // @DataMember(Order=4)
    public email: string;

    // @DataMember(Order=5)
    public username: string;

    // @DataMember(Order=6)
    public roles: { [index:number]: { [index:string]: TrialUserRoleContext; }; };

    public constructor(init?: Partial<TrialUser>) { (Object as any).assign(this, init); }
}

export class TrialCoordinatingGroup
{
    public id: number;
    public masterGroupId?: number;
    public name: string;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<TrialCoordinatingGroup>) { (Object as any).assign(this, init); }
}

export class TrialMasterGroup
{
    public id?: number;
    public name: string;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<TrialMasterGroup>) { (Object as any).assign(this, init); }
}

// @DataContract
export class TrialInstitutionItemInstApproved implements ITrialItem
{
    // @DataMember(Order=1)
    public trialId?: number;

    // @DataMember(Order=2)
    public itemNo?: number;

    // @DataMember(Order=3)
    public owner?: number;

    // @DataMember(Order=4)
    public dateApproved?: string;

    // @DataMember(Order=5)
    public itemName: string;

    // @DataMember(Order=6)
    public itemVersion: string;

    // @DataMember(Order=7)
    public itemCategory?: TrialInstitutionItemTemplateCategoryType;

    public constructor(init?: Partial<TrialInstitutionItemInstApproved>) { (Object as any).assign(this, init); }
}

export class TrialInstitutionItemDataCollectionInstance
{
    public id?: number;
    public collectionId?: number;
    public dataEntered: boolean;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public collectionInstanceDatas: CollectionInstanceData[];
    public sourceDocuments: SourceDocument[];

    public constructor(init?: Partial<TrialInstitutionItemDataCollectionInstance>) { (Object as any).assign(this, init); }
}

export class TrialInstitutionItemData
{
    public id?: number;
    public trialInstitutionId: number;
    public trialInstitution: TrialInstitution;
    public trialInstitutionItemTemplateId: number;
    public version: string;
    public trialInstitutionItemTemplate: TrialInstitutionItemTemplate;
    public collectionInstanceId?: number;
    public collectionInstance: TrialInstitutionItemDataCollectionInstance;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public search: string;
    public filesAdded: boolean;
    public dataEntered: boolean;

    public constructor(init?: Partial<TrialInstitutionItemData>) { (Object as any).assign(this, init); }
}

// @DataContract
export class TrialInstitutionItemImage
{
    // @DataMember(Order=1)
    public trialId?: number;

    // @DataMember(Order=2)
    public itemNo?: number;

    // @DataMember(Order=3)
    public owner?: number;

    // @DataMember(Order=4)
    public imageNo?: number;

    // @DataMember(Order=5)
    public name: string;

    // @DataMember(Order=6)
    public rowId?: number;

    // @DataMember(Order=7)
    public docImage: string;

    // @DataMember(Order=8)
    public rotation?: number;

    // @DataMember(Order=9)
    public extension: string;

    // @DataMember(Order=10)
    public itemName: string;

    // @DataMember(Order=11)
    public itemVersion: string;

    // @DataMember(Order=12)
    public itemCategory?: TrialInstitutionItemTemplateCategoryType;

    public constructor(init?: Partial<TrialInstitutionItemImage>) { (Object as any).assign(this, init); }
}

export enum TrialInstitutionStatusType
{
    InvitedExpressedInterest = 1,
    ActivationPending = 2,
    Activated = 3,
    Withdrawn = 4,
    NotInvited = 5,
    EoiNotSelected = 6,
}

export class TrialInstitutionWithGroupProps extends TrialInstitution
{
    public masterGroupId?: number;
    public coordinatingGroupId?: number;
    public trialInstitutionStatusType?: TrialInstitutionStatusType;

    public constructor(init?: Partial<TrialInstitutionWithGroupProps>) { super(init); (Object as any).assign(this, init); }
}

export class SearchResult implements IForm
{
    public searchFor: string;
    public institutions: Institution[];
    public trials: Trial[];
    public personnel: Personnel[];
    public projects: Project[];
    public laboratories: Laboratory[];
    public committees: Committee[];
    public groups: Group[];
    public hrecs: Hrec[];
    public healthDistricts: HealthDistrict[];
    public id?: number;
    public active: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;

    public constructor(init?: Partial<SearchResult>) { (Object as any).assign(this, init); }
}

export class PersonnelOption
{
    public label: string;
    public value: number;

    public constructor(init?: Partial<PersonnelOption>) { (Object as any).assign(this, init); }
}

export class ModulePermission
{
    public name: string;
    public description: string;

    public constructor(init?: Partial<ModulePermission>) { (Object as any).assign(this, init); }
}

export interface IVirtualDirectory
{
}

export interface IVirtualPathProvider
{
    rootDirectory: IVirtualDirectory;
    virtualPathSeparator: string;
    realPathSeparator: string;
}

export interface IVirtualFile
{
    virtualPathProvider: IVirtualPathProvider;
    extension: string;
    length: number;
}

// @Flags()
export enum CacheControl
{
    None = 0,
    Public = 1,
    Private = 2,
    MustRevalidate = 4,
    NoCache = 8,
    NoStore = 16,
    NoTransform = 32,
    ProxyRevalidate = 64,
}

export interface IContentTypeWriter
{
}

// @Flags()
export enum RequestAttributes
{
    None = 0,
    Localhost = 1,
    LocalSubnet = 2,
    External = 4,
    Secure = 8,
    InSecure = 16,
    AnySecurityMode = 24,
    HttpHead = 32,
    HttpGet = 64,
    HttpPost = 128,
    HttpPut = 256,
    HttpDelete = 512,
    HttpPatch = 1024,
    HttpOptions = 2048,
    HttpOther = 4096,
    AnyHttpMethod = 8160,
    OneWay = 8192,
    Reply = 16384,
    AnyCallStyle = 24576,
    Soap11 = 32768,
    Soap12 = 65536,
    Xml = 131072,
    Json = 262144,
    Jsv = 524288,
    ProtoBuf = 1048576,
    Csv = 2097152,
    Html = 4194304,
    Jsonl = 8388608,
    MsgPack = 16777216,
    FormatOther = 33554432,
    AnyFormat = 67076096,
    Http = 67108864,
    MessageQueue = 134217728,
    Tcp = 268435456,
    Grpc = 536870912,
    EndpointOther = 1073741824,
    AnyEndpoint = 2080374784,
    InProcess = -2147483648,
    InternalNetworkAccess = -2147483645,
    AnyNetworkAccessType = -2147483641,
    Any = -1,
}

export interface IRequestPreferences
{
    acceptsBrotli: boolean;
    acceptsDeflate: boolean;
    acceptsGzip: boolean;
}

export interface IHttpFile
{
    name: string;
    fileName: string;
    contentLength: number;
    contentType: string;
    inputStream: string;
}

export interface IRequest
{
    originalRequest: Object;
    response: IResponse;
    operationName: string;
    verb: string;
    requestAttributes: RequestAttributes;
    requestPreferences: IRequestPreferences;
    dto: Object;
    contentType: string;
    isLocal: boolean;
    userAgent: string;
    cookies: { [index:string]: Cookie; };
    responseContentType: string;
    hasExplicitResponseContentType: boolean;
    items: { [index:string]: Object; };
    headers: NameValueCollection;
    queryString: NameValueCollection;
    formData: NameValueCollection;
    useBufferedStream: boolean;
    rawUrl: string;
    absoluteUri: string;
    userHostAddress: string;
    remoteIp: string;
    authorization: string;
    isSecureConnection: boolean;
    acceptTypes: string[];
    pathInfo: string;
    originalPathInfo: string;
    inputStream: string;
    contentLength: number;
    files: IHttpFile[];
    urlReferrer: string;
}

export interface IResponse
{
    originalResponse: Object;
    request: IRequest;
    statusCode: number;
    statusDescription: string;
    contentType: string;
    outputStream: string;
    dto: Object;
    useBufferedStream: boolean;
    isClosed: boolean;
    keepAlive: boolean;
    hasStarted: boolean;
    items: { [index:string]: Object; };
}

export class PersonnelPermission
{
    public personnelId: number;
    public userName: string;
    public roleName: string;
    public trialId: number;
    public protocolID: string;
    public shortTitle: string;
    public studyAcronym: string;
    public institutionId: number;
    public institution: string;
    public code: string;
    public moduleDescription: string;
    public permissionName: string;
    public permissionDescription: string;
    public group: string;
    public trialDisplay: string;
    public institutionDisplay: string;

    public constructor(init?: Partial<PersonnelPermission>) { (Object as any).assign(this, init); }
}

export class PersonnelPermissionGroup
{
    public name: string;
    public personnelPermissions: PersonnelPermission[];

    public constructor(init?: Partial<PersonnelPermissionGroup>) { (Object as any).assign(this, init); }
}

export class RolePersonnel
{
    public roleId: number;
    public roleName: string;
    public roleRank: number;
    public dateStarted?: string;
    public dateCeased?: string;
    public userName: string;
    public personnelId: number;
    public firstName: string;
    public lastName: string;
    public trialId?: number;
    public protocolID: string;
    public shortTitle: string;
    public studyAcronym: string;
    public institutionId?: number;
    public institutionName: string;
    public institutionCode: string;
    public isGlobal: boolean;
    public trialDisplay: string;
    public personnelDisplay: string;
    public institutionDisplay: string;

    public constructor(init?: Partial<RolePersonnel>) { (Object as any).assign(this, init); }
}

export class RolePersonnelGrouping
{
    public roleId: number;
    public roleName: string;
    public roleRank: number;
    public rolePersonnels: RolePersonnel[];

    public constructor(init?: Partial<RolePersonnelGrouping>) { (Object as any).assign(this, init); }
}

export enum CategoryType
{
    MembershipType = 0,
    ProfessionalDisipline = 1,
}

export class PersonnelCategory
{
    public id: number;
    public name: string;
    public selected: boolean;
    public categoryType: CategoryType;

    public constructor(init?: Partial<PersonnelCategory>) { (Object as any).assign(this, init); }
}

export class PersonnelTmdRole
{
    public id: number;
    public name: string;
    public selected: boolean;

    public constructor(init?: Partial<PersonnelTmdRole>) { (Object as any).assign(this, init); }
}

export class PersonnelTmdTrial
{
    public id: number;
    public name: string;
    public selected: boolean;

    public constructor(init?: Partial<PersonnelTmdTrial>) { (Object as any).assign(this, init); }
}

export class PersonnelTrialGroup
{
    public id: number;
    public name: string;
    public selected: boolean;

    public constructor(init?: Partial<PersonnelTrialGroup>) { (Object as any).assign(this, init); }
}

export class KeyValuePair<TKey, TValue>
{
    public key: TKey;
    public value: TValue;

    public constructor(init?: Partial<KeyValuePair<TKey, TValue>>) { (Object as any).assign(this, init); }
}

export class PermissionConfiguration
{
    public id?: number;
    public permission?: Permission;
    public description: string;

    public constructor(init?: Partial<PermissionConfiguration>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UserPermissionContext
{
    // @DataMember(Order=1)
    public permissionContext: PermissionContext;

    // @DataMember(Order=2)
    public permissions: Permission[];

    public constructor(init?: Partial<UserPermissionContext>) { (Object as any).assign(this, init); }
}

export class Patient
{
    public randNo: string;
    public init: string;
    public dob?: string;
    public randDate?: string;
    public randInst: string;
    public currentInst: string;

    public constructor(init?: Partial<Patient>) { (Object as any).assign(this, init); }
}

export enum DatabaseStatus
{
    Available = 1,
    DatabaseNotFound = 2,
    FunctionOrViewNotFound = 3,
    Error = 4,
    DatabaseNotConfigured = 5,
}

export enum RegistrationFormStatus
{
    Enabled = 1,
    Disabled = 2,
}

export class RegistrationFormState
{
    public id: number;
    public registrationFormId: number;
    public formState?: RegistrationFormStatus;
    public validate?: boolean;
    public blockSave?: boolean;

    public constructor(init?: Partial<RegistrationFormState>) { (Object as any).assign(this, init); }
}

export class InstitutionUrl
{
    public institutionId?: number;
    public institution: string;
    public department: string;

    public constructor(init?: Partial<InstitutionUrl>) { (Object as any).assign(this, init); }
}

export class AccrualANZ
{
    public id?: number;
    public trialId?: number;
    public institutionId?: number;
    public year: string;
    public january?: number;
    public february?: number;
    public march?: number;
    public april?: number;
    public may?: number;
    public june?: number;
    public july?: number;
    public august?: number;
    public september?: number;
    public october?: number;
    public november?: number;
    public december?: number;
    public foreignInstitutionCode: string;

    public constructor(init?: Partial<AccrualANZ>) { (Object as any).assign(this, init); }
}

export enum MembershipStatus
{
    Approved = 1,
    NotApproved = 2,
    ApplicationReceived = 3,
    AwaitingBoardApproval = 4,
}

export enum MembershipCategory
{
    Full = 1,
    Affiliate = 2,
    Life = 3,
}

export class MemberStatus
{
    public id?: number;
    public memberId?: string;
    public dateFrom: string;
    public dateTo?: string;
    public dateApproved?: string;
    public dateRenewed?: string;
    public membershipCategory?: MembershipCategory;
    public comments?: string;

    public constructor(init?: Partial<MemberStatus>) { (Object as any).assign(this, init); }
}

export enum MemberCommitteeType
{
    BoardOfDirectors = 1,
    ConsumerAdvisoryPanel = 2,
    StaffMember = 3,
    FinanceAndAuditCommittee = 4,
}

export class MemberCommittee
{
    public memberId?: string;
    public committeeId: number;
    public committeeTypeId: MemberCommitteeType;
    public startDate?: string;
    public endDate?: string;

    public constructor(init?: Partial<MemberCommittee>) { (Object as any).assign(this, init); }
}

export class Title
{
    public id?: number;
    public value?: string;
    public rank?: number;

    public constructor(init?: Partial<Title>) { (Object as any).assign(this, init); }
}

export enum AreaOther
{
    Normal = 0,
    Other = 1,
    Area = 2,
}

export class Speciality
{
    public specialityId?: number;
    public speciality: string;
    public areaOther?: AreaOther;
    public allowTrainee?: boolean;

    public constructor(init?: Partial<Speciality>) { (Object as any).assign(this, init); }
}

export class Member
{
    public id?: number;
    public memberId?: string;
    public title?: number;
    public lastname?: string;
    public firstname?: string;
    public address1?: string;
    public address2?: string;
    public address3?: string;
    public address4?: string;
    public suburb?: string;
    public state?: string;
    public postcode?: string;
    public country?: string;
    public workPhone?: string;
    public workFax?: string;
    public mobile?: string;
    public email?: string;
    public speciality?: number;
    public areaOther?: string;
    public institution?: string;
    public membershipStatus?: MembershipStatus;
    public dateRec?: string;
    public dateActivated?: string;
    public dateAckSent?: string;
    public dateAcceptLetter?: string;
    public articlesSent?: number;
    public memCeaseDate?: string;
    public memCeaseReason?: string;
    public memCeaseBy?: number;
    public memCeaseComment?: string;
    public membershipCeased?: number;
    public conEmail?: number;
    public conEmailDate?: string;
    public conContact?: number;
    public conContactDate?: string;
    public proposer?: string;
    public seconder?: string;
    public proposerApproved?: number;
    public seconderApproved?: number;
    public outlookId?: string;
    public prevProposer?: string;
    public prevSeconder?: string;
    public hardcopy?: boolean;
    public onlineId?: string;
    public requestedMembershipType?: RequestedMembershipType;
    public involvement?: string;
    public memberReason?: string;
    public recommendCancel?: boolean;
    public recommendCancelComment?: string;
    public websiteUsername?: string;
    public websitePassword?: string;
    public lastWebsiteUpdate?: string;
    public upgradeRequested?: boolean;
    public comments?: string;
    public enteredBy?: string;
    public company?: string;
    public position?: string;
    public applicationEmail?: string;
    public adminApplyNotes?: string;
    public trainee?: boolean;
    public higherDegree?: YesNo;
    public yearAwarded?: number;
    public degreeType?: string;
    public interestPeerReview?: YesNo;
    public interestConceptDevelopment?: YesNo;
    public application?: Application;
    public memberStatuses?: MemberStatus[];
    public committees?: MemberCommittee[];
    public titleLookup?: Title;
    public specialityLookup?: Speciality;
    public additionalSpecialities?: AdditionalSpeciality[];
    public interestAreas?: InterestArea[];

    public constructor(init?: Partial<Member>) { (Object as any).assign(this, init); }
}

export class InterestLookup
{
    public id?: number;
    public value?: string;
    public rank?: number;
    public allowSpecify: boolean;

    public constructor(init?: Partial<InterestLookup>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UserApiKey
{
    // @DataMember(Order=1)
    public key: string;

    // @DataMember(Order=2)
    public keyType: string;

    // @DataMember(Order=3)
    public expiryDate?: string;

    // @DataMember(Order=4)
    public meta: { [index:string]: string; };

    public constructor(init?: Partial<UserApiKey>) { (Object as any).assign(this, init); }
}

export interface IForm extends IAudited
{
    id?: number;
}

export interface IAudited extends IDateTimeStamped, IUserStamped
{
    active: boolean;
}

export interface IDateTimeStamped
{
    dateEntered?: string;
    dateModified?: string;
}

export interface IUserStamped
{
    enteredBy: string;
    modifiedBy: string;
}

export interface ITrialItem
{
    trialId?: number;
    itemNo?: number;
    owner?: number;
}

export interface ISubForm extends IAudited
{
    id: number;
}

// @DataContract
export class TrialUserRole
{
    // @DataMember(Order=1)
    public startDate?: string;

    // @DataMember(Order=2)
    public endDate?: string;

    // @DataMember(Order=3)
    public active: boolean;

    public constructor(init?: Partial<TrialUserRole>) { (Object as any).assign(this, init); }
}

// @DataContract
export class TrialUserRoleContext
{
    // @DataMember(Order=1)
    public onTrial: TrialUserRole[];

    // @DataMember(Order=2)
    public masterGroups: { [index:number]: TrialUserRole[]; };

    // @DataMember(Order=3)
    public coordinatingGroups: { [index:number]: TrialUserRole[]; };

    // @DataMember(Order=4)
    public institutions: { [index:number]: TrialUserRole[]; };

    // @DataMember(Order=5)
    public countries: { [index:number]: TrialUserRole[]; };

    public constructor(init?: Partial<TrialUserRoleContext>) { (Object as any).assign(this, init); }
}

export class GetCommitteesResponse
{
    public responseStatus: ResponseStatus;
    public committees: Committee[];
    public lookups: Lookup[];

    public constructor(init?: Partial<GetCommitteesResponse>) { (Object as any).assign(this, init); }
}

export class GetCommitteeByIdResponse
{
    public responseStatus: ResponseStatus;
    public committee: Committee;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetCommitteeByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetCommitteeResponse
{
    public responseStatus: ResponseStatus;
    public committee: Committee;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetCommitteeResponse>) { (Object as any).assign(this, init); }
}

export class CreateCommitteeResponse
{
    public responseStatus: ResponseStatus;
    public committee: Committee;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateCommitteeResponse>) { (Object as any).assign(this, init); }
}

export class ValidateCommitteeResponse
{
    public responseStatus: ResponseStatus;
    public committee: Committee;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateCommitteeResponse>) { (Object as any).assign(this, init); }
}

export class GetGroupItemTemplateCategorysResponse
{
    public responseStatus: ResponseStatus;
    public groupItemTemplateCategorys: GroupItemTemplateCategory[];

    public constructor(init?: Partial<GetGroupItemTemplateCategorysResponse>) { (Object as any).assign(this, init); }
}

export class GetGroupItemTemplateCategoryByIdResponse
{
    public responseStatus: ResponseStatus;
    public groupItemTemplateCategory: GroupItemTemplateCategory;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetGroupItemTemplateCategoryByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetGroupItemTemplateCategoryResponse
{
    public responseStatus: ResponseStatus;
    public groupItemTemplateCategory: GroupItemTemplateCategory;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetGroupItemTemplateCategoryResponse>) { (Object as any).assign(this, init); }
}

export class CreateGroupItemTemplateCategoryResponse
{
    public responseStatus: ResponseStatus;
    public groupItemTemplateCategory: GroupItemTemplateCategory;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateGroupItemTemplateCategoryResponse>) { (Object as any).assign(this, init); }
}

export class ValidateGroupItemTemplateCategoryResponse
{
    public responseStatus: ResponseStatus;
    public groupItemTemplateCategory: GroupItemTemplateCategory;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateGroupItemTemplateCategoryResponse>) { (Object as any).assign(this, init); }
}

export class GetGroupItemTemplatesResponse
{
    public responseStatus: ResponseStatus;
    public groupItemTemplates: GroupItemTemplate[];
    public groupItemsByCategory: GroupItemTemplateCategory[];
    public lookups: Lookup[];

    public constructor(init?: Partial<GetGroupItemTemplatesResponse>) { (Object as any).assign(this, init); }
}

export class GetGroupItemTemplateByIdResponse
{
    public responseStatus: ResponseStatus;
    public groupItemTemplate: GroupItemTemplate;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetGroupItemTemplateByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetGroupItemTemplateResponse
{
    public responseStatus: ResponseStatus;
    public groupItemTemplate: GroupItemTemplate;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetGroupItemTemplateResponse>) { (Object as any).assign(this, init); }
}

export class CreateGroupItemTemplateResponse
{
    public responseStatus: ResponseStatus;
    public groupItemTemplate: GroupItemTemplate;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateGroupItemTemplateResponse>) { (Object as any).assign(this, init); }
}

export class ValidateGroupItemTemplateResponse
{
    public responseStatus: ResponseStatus;
    public groupItemTemplate: GroupItemTemplate;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateGroupItemTemplateResponse>) { (Object as any).assign(this, init); }
}

export class GetHrecsResponse
{
    public responseStatus: ResponseStatus;
    public hrecs: Hrec[];
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetHrecsResponse>) { (Object as any).assign(this, init); }
}

export class GetHrecByIdResponse
{
    public responseStatus: ResponseStatus;
    public hrec: Hrec;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetHrecByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetHrecResponse
{
    public responseStatus: ResponseStatus;
    public hrec: Hrec;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetHrecResponse>) { (Object as any).assign(this, init); }
}

export class CreateHrecResponse
{
    public responseStatus: ResponseStatus;
    public hrec: Hrec;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateHrecResponse>) { (Object as any).assign(this, init); }
}

export class ValidateHrecResponse
{
    public responseStatus: ResponseStatus;
    public hrec: Hrec;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateHrecResponse>) { (Object as any).assign(this, init); }
}

export class GetInstitutionTypesResponse
{
    public responseStatus: ResponseStatus;
    public institutionTypes: InstitutionType[];

    public constructor(init?: Partial<GetInstitutionTypesResponse>) { (Object as any).assign(this, init); }
}

export class GetInstitutionTypeByIdResponse
{
    public responseStatus: ResponseStatus;
    public institutionType: InstitutionType;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetInstitutionTypeByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetInstitutionTypeResponse
{
    public responseStatus: ResponseStatus;
    public institutionType: InstitutionType;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetInstitutionTypeResponse>) { (Object as any).assign(this, init); }
}

export class CreateInstitutionTypeResponse
{
    public responseStatus: ResponseStatus;
    public institutionType: InstitutionType;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateInstitutionTypeResponse>) { (Object as any).assign(this, init); }
}

export class ValidateInstitutionTypeResponse
{
    public responseStatus: ResponseStatus;
    public institutionType: InstitutionType;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateInstitutionTypeResponse>) { (Object as any).assign(this, init); }
}

export class GetInterestsResponse
{
    public responseStatus: ResponseStatus;
    public interests: Interest[];

    public constructor(init?: Partial<GetInterestsResponse>) { (Object as any).assign(this, init); }
}

export class GetInterestByIdResponse
{
    public responseStatus: ResponseStatus;
    public interest: Interest;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetInterestByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetInterestResponse
{
    public responseStatus: ResponseStatus;
    public interest: Interest;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetInterestResponse>) { (Object as any).assign(this, init); }
}

export class CreateInterestResponse
{
    public responseStatus: ResponseStatus;
    public interest: Interest;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateInterestResponse>) { (Object as any).assign(this, init); }
}

export class ValidateInterestResponse
{
    public responseStatus: ResponseStatus;
    public interest: Interest;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateInterestResponse>) { (Object as any).assign(this, init); }
}

export class GetKeyContactsResponse
{
    public responseStatus: ResponseStatus;
    public keyContacts: KeyContact[];

    public constructor(init?: Partial<GetKeyContactsResponse>) { (Object as any).assign(this, init); }
}

export class GetKeyContactByIdResponse
{
    public responseStatus: ResponseStatus;
    public keyContact: KeyContact;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetKeyContactByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetKeyContactResponse
{
    public responseStatus: ResponseStatus;
    public keyContact: KeyContact;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetKeyContactResponse>) { (Object as any).assign(this, init); }
}

export class CreateKeyContactResponse
{
    public responseStatus: ResponseStatus;
    public keyContact: KeyContact;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateKeyContactResponse>) { (Object as any).assign(this, init); }
}

export class ValidateKeyContactResponse
{
    public responseStatus: ResponseStatus;
    public keyContact: KeyContact;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateKeyContactResponse>) { (Object as any).assign(this, init); }
}

export class GetMembershipTypesResponse
{
    public responseStatus: ResponseStatus;
    public membershipTypes: MembershipType[];

    public constructor(init?: Partial<GetMembershipTypesResponse>) { (Object as any).assign(this, init); }
}

export class GetMembershipTypeByIdResponse
{
    public responseStatus: ResponseStatus;
    public membershipType: MembershipType;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetMembershipTypeByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetMembershipTypeResponse
{
    public responseStatus: ResponseStatus;
    public membershipType: MembershipType;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetMembershipTypeResponse>) { (Object as any).assign(this, init); }
}

export class CreateMembershipTypeResponse
{
    public responseStatus: ResponseStatus;
    public membershipType: MembershipType;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateMembershipTypeResponse>) { (Object as any).assign(this, init); }
}

export class ValidateMembershipTypeResponse
{
    public responseStatus: ResponseStatus;
    public membershipType: MembershipType;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateMembershipTypeResponse>) { (Object as any).assign(this, init); }
}

export class GetProfessionalDisciplinesResponse
{
    public responseStatus: ResponseStatus;
    public professionalDisciplines: ProfessionalDiscipline[];

    public constructor(init?: Partial<GetProfessionalDisciplinesResponse>) { (Object as any).assign(this, init); }
}

export class GetProfessionalDisciplineByIdResponse
{
    public responseStatus: ResponseStatus;
    public professionalDiscipline: ProfessionalDiscipline;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetProfessionalDisciplineByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetProfessionalDisciplineResponse
{
    public responseStatus: ResponseStatus;
    public professionalDiscipline: ProfessionalDiscipline;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetProfessionalDisciplineResponse>) { (Object as any).assign(this, init); }
}

export class CreateProfessionalDisciplineResponse
{
    public responseStatus: ResponseStatus;
    public professionalDiscipline: ProfessionalDiscipline;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateProfessionalDisciplineResponse>) { (Object as any).assign(this, init); }
}

export class ValidateProfessionalDisciplineResponse
{
    public responseStatus: ResponseStatus;
    public professionalDiscipline: ProfessionalDiscipline;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateProfessionalDisciplineResponse>) { (Object as any).assign(this, init); }
}

export class GetSalutationsResponse
{
    public responseStatus: ResponseStatus;
    public salutations: Salutation[];

    public constructor(init?: Partial<GetSalutationsResponse>) { (Object as any).assign(this, init); }
}

export class GetSalutationByIdResponse
{
    public responseStatus: ResponseStatus;
    public salutation: Salutation;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetSalutationByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetSalutationResponse
{
    public responseStatus: ResponseStatus;
    public salutation: Salutation;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetSalutationResponse>) { (Object as any).assign(this, init); }
}

export class CreateSalutationResponse
{
    public responseStatus: ResponseStatus;
    public salutation: Salutation;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateSalutationResponse>) { (Object as any).assign(this, init); }
}

export class ValidateSalutationResponse
{
    public responseStatus: ResponseStatus;
    public salutation: Salutation;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateSalutationResponse>) { (Object as any).assign(this, init); }
}

export class GetSiteLocationsResponse
{
    public responseStatus: ResponseStatus;
    public siteLocations: SiteLocation[];

    public constructor(init?: Partial<GetSiteLocationsResponse>) { (Object as any).assign(this, init); }
}

export class GetSiteLocationByIdResponse
{
    public responseStatus: ResponseStatus;
    public siteLocation: SiteLocation;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetSiteLocationByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetSiteLocationResponse
{
    public responseStatus: ResponseStatus;
    public siteLocation: SiteLocation;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetSiteLocationResponse>) { (Object as any).assign(this, init); }
}

export class CreateSiteLocationResponse
{
    public responseStatus: ResponseStatus;
    public siteLocation: SiteLocation;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateSiteLocationResponse>) { (Object as any).assign(this, init); }
}

export class ValidateSiteLocationResponse
{
    public responseStatus: ResponseStatus;
    public siteLocation: SiteLocation;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateSiteLocationResponse>) { (Object as any).assign(this, init); }
}

export class GetStatesResponse
{
    public responseStatus: ResponseStatus;
    public states: State[];

    public constructor(init?: Partial<GetStatesResponse>) { (Object as any).assign(this, init); }
}

export class GetStateByIdResponse
{
    public responseStatus: ResponseStatus;
    public state: State;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetStateByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetStateResponse
{
    public responseStatus: ResponseStatus;
    public state: State;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetStateResponse>) { (Object as any).assign(this, init); }
}

export class CreateStateResponse
{
    public responseStatus: ResponseStatus;
    public state: State;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateStateResponse>) { (Object as any).assign(this, init); }
}

export class ValidateStateResponse
{
    public responseStatus: ResponseStatus;
    public state: State;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateStateResponse>) { (Object as any).assign(this, init); }
}

export class GetDiscussionsResponse
{
    public responseStatus: ResponseStatus;
    public discussions: Discussion[];
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetDiscussionsResponse>) { (Object as any).assign(this, init); }
}

export class GetDiscussionByIdResponse
{
    public responseStatus: ResponseStatus;
    public discussion: Discussion;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetDiscussionByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetDiscussionResponse
{
    public responseStatus: ResponseStatus;
    public discussion: Discussion;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetDiscussionResponse>) { (Object as any).assign(this, init); }
}

export class CreateDiscussionResponse
{
    public responseStatus: ResponseStatus;
    public discussion: Discussion;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateDiscussionResponse>) { (Object as any).assign(this, init); }
}

export class ValidateDiscussionResponse
{
    public responseStatus: ResponseStatus;
    public discussion: Discussion;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateDiscussionResponse>) { (Object as any).assign(this, init); }
}

export class GetProjectItemsByProjectIdResponse
{
    public responseStatus: ResponseStatus;
    public projectItems: ProjectItem[];
    public projectItemCategories: ProjectItemCategory[];

    public constructor(init?: Partial<GetProjectItemsByProjectIdResponse>) { (Object as any).assign(this, init); }
}

export class SetProjectItemResponse
{
    public responseStatus: ResponseStatus;
    public projectItem: ProjectItem;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetProjectItemResponse>) { (Object as any).assign(this, init); }
}

export class CreateProjectItemResponse
{
    public responseStatus: ResponseStatus;
    public projectItem: ProjectItem;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateProjectItemResponse>) { (Object as any).assign(this, init); }
}

export class GetProjectItemTemplateCategorysResponse
{
    public responseStatus: ResponseStatus;
    public projectItemTemplateCategorys: ProjectItemTemplateCategory[];

    public constructor(init?: Partial<GetProjectItemTemplateCategorysResponse>) { (Object as any).assign(this, init); }
}

export class GetProjectItemTemplateCategoryByIdResponse
{
    public responseStatus: ResponseStatus;
    public projectItemTemplateCategory: ProjectItemTemplateCategory;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetProjectItemTemplateCategoryByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetProjectItemTemplateCategoryResponse
{
    public responseStatus: ResponseStatus;
    public projectItemTemplateCategory: ProjectItemTemplateCategory;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetProjectItemTemplateCategoryResponse>) { (Object as any).assign(this, init); }
}

export class CreateProjectItemTemplateCategoryResponse
{
    public responseStatus: ResponseStatus;
    public projectItemTemplateCategory: ProjectItemTemplateCategory;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateProjectItemTemplateCategoryResponse>) { (Object as any).assign(this, init); }
}

export class ValidateProjectItemTemplateCategoryResponse
{
    public responseStatus: ResponseStatus;
    public projectItemTemplateCategory: ProjectItemTemplateCategory;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateProjectItemTemplateCategoryResponse>) { (Object as any).assign(this, init); }
}

export class GetProjectItemTemplatesResponse
{
    public responseStatus: ResponseStatus;
    public projectItemTemplates: ProjectItemTemplate[];
    public projectItemsByCategory: ProjectItemTemplateCategory[];
    public lookups: Lookup[];

    public constructor(init?: Partial<GetProjectItemTemplatesResponse>) { (Object as any).assign(this, init); }
}

export class GetProjectItemTemplateByIdResponse
{
    public responseStatus: ResponseStatus;
    public projectItemTemplate: ProjectItemTemplate;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetProjectItemTemplateByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetProjectItemTemplateResponse
{
    public responseStatus: ResponseStatus;
    public projectItemTemplate: ProjectItemTemplate;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetProjectItemTemplateResponse>) { (Object as any).assign(this, init); }
}

export class CreateProjectItemTemplateResponse
{
    public responseStatus: ResponseStatus;
    public projectItemTemplate: ProjectItemTemplate;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateProjectItemTemplateResponse>) { (Object as any).assign(this, init); }
}

export class ValidateProjectItemTemplateResponse
{
    public responseStatus: ResponseStatus;
    public projectItemTemplate: ProjectItemTemplate;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateProjectItemTemplateResponse>) { (Object as any).assign(this, init); }
}

export class GetFormTemplateFileTypesResponse
{
    public responseStatus: ResponseStatus;
    public formTemplateFileTypes: FormTemplateFileType[];

    public constructor(init?: Partial<GetFormTemplateFileTypesResponse>) { (Object as any).assign(this, init); }
}

export class GetFormTemplateFileTypeByIdResponse
{
    public responseStatus: ResponseStatus;
    public formTemplateFileType: FormTemplateFileType;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetFormTemplateFileTypeByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetFormTemplateFileTypeResponse
{
    public responseStatus: ResponseStatus;
    public formTemplateFileType: FormTemplateFileType;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetFormTemplateFileTypeResponse>) { (Object as any).assign(this, init); }
}

export class CreateFormTemplateFileTypeResponse
{
    public responseStatus: ResponseStatus;
    public formTemplateFileType: FormTemplateFileType;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateFormTemplateFileTypeResponse>) { (Object as any).assign(this, init); }
}

export class ValidateFormTemplateFileTypeResponse
{
    public responseStatus: ResponseStatus;
    public formTemplateFileType: FormTemplateFileType;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateFormTemplateFileTypeResponse>) { (Object as any).assign(this, init); }
}

export class GetFormTemplatesResponse
{
    public responseStatus: ResponseStatus;
    public formTemplates: FormTemplate[];
    public lookups: Lookup[];

    public constructor(init?: Partial<GetFormTemplatesResponse>) { (Object as any).assign(this, init); }
}

export class GetFormTemplateByIdResponse
{
    public responseStatus: ResponseStatus;
    public formTemplate: FormTemplate;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetFormTemplateByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetFormTemplateResponse
{
    public responseStatus: ResponseStatus;
    public formTemplate: FormTemplate;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetFormTemplateResponse>) { (Object as any).assign(this, init); }
}

export class CreateFormTemplateResponse
{
    public responseStatus: ResponseStatus;
    public formTemplate: FormTemplate;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateFormTemplateResponse>) { (Object as any).assign(this, init); }
}

export class ValidateFormTemplateResponse
{
    public responseStatus: ResponseStatus;
    public formTemplate: FormTemplate;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateFormTemplateResponse>) { (Object as any).assign(this, init); }
}

export class GetReportingTagsResponse
{
    public responseStatus: ResponseStatus;
    public reportingTags: ReportingTag[];

    public constructor(init?: Partial<GetReportingTagsResponse>) { (Object as any).assign(this, init); }
}

export class GetReportingTagByIdResponse
{
    public responseStatus: ResponseStatus;
    public reportingTag: ReportingTag;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetReportingTagByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetReportingTagResponse
{
    public responseStatus: ResponseStatus;
    public reportingTag: ReportingTag;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetReportingTagResponse>) { (Object as any).assign(this, init); }
}

export class CreateReportingTagResponse
{
    public responseStatus: ResponseStatus;
    public reportingTag: ReportingTag;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateReportingTagResponse>) { (Object as any).assign(this, init); }
}

export class ValidateReportingTagResponse
{
    public responseStatus: ResponseStatus;
    public reportingTag: ReportingTag;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateReportingTagResponse>) { (Object as any).assign(this, init); }
}

export class GetReportingTagCategoriesResponse
{
    public responseStatus: ResponseStatus;
    public reportingTagCategories: ReportingTagCategory[];

    public constructor(init?: Partial<GetReportingTagCategoriesResponse>) { (Object as any).assign(this, init); }
}

export class GetReportingTagCategoryByIdResponse
{
    public responseStatus: ResponseStatus;
    public reportingTagCategory: ReportingTagCategory;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetReportingTagCategoryByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetReportingTagCategoryResponse
{
    public responseStatus: ResponseStatus;
    public reportingTagCategory: ReportingTagCategory;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetReportingTagCategoryResponse>) { (Object as any).assign(this, init); }
}

export class CreateReportingTagCategoryResponse
{
    public responseStatus: ResponseStatus;
    public reportingTagCategory: ReportingTagCategory;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateReportingTagCategoryResponse>) { (Object as any).assign(this, init); }
}

export class ValidateReportingTagCategoryResponse
{
    public responseStatus: ResponseStatus;
    public reportingTagCategory: ReportingTagCategory;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateReportingTagCategoryResponse>) { (Object as any).assign(this, init); }
}

export class GetTaskTypesResponse
{
    public responseStatus: ResponseStatus;
    public taskTypes: TaskType[];

    public constructor(init?: Partial<GetTaskTypesResponse>) { (Object as any).assign(this, init); }
}

export class GetTaskTypeByIdResponse
{
    public responseStatus: ResponseStatus;
    public taskType: TaskType;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTaskTypeByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetTaskTypeResponse
{
    public responseStatus: ResponseStatus;
    public taskType: TaskType;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetTaskTypeResponse>) { (Object as any).assign(this, init); }
}

export class CreateTaskTypeResponse
{
    public responseStatus: ResponseStatus;
    public taskType: TaskType;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateTaskTypeResponse>) { (Object as any).assign(this, init); }
}

export class ValidateTaskTypeResponse
{
    public responseStatus: ResponseStatus;
    public taskType: TaskType;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateTaskTypeResponse>) { (Object as any).assign(this, init); }
}

export class GetTrackerMilestonesResponse
{
    public responseStatus: ResponseStatus;
    public trackerMilestones: TrackerMilestone[];

    public constructor(init?: Partial<GetTrackerMilestonesResponse>) { (Object as any).assign(this, init); }
}

export class GetTrackerMilestoneByIdResponse
{
    public responseStatus: ResponseStatus;
    public trackerMilestone: TrackerMilestone;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrackerMilestoneByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetTrackerMilestoneResponse
{
    public responseStatus: ResponseStatus;
    public trackerMilestone: TrackerMilestone;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetTrackerMilestoneResponse>) { (Object as any).assign(this, init); }
}

export class CreateTrackerMilestoneResponse
{
    public responseStatus: ResponseStatus;
    public trackerMilestone: TrackerMilestone;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateTrackerMilestoneResponse>) { (Object as any).assign(this, init); }
}

export class ValidateTrackerMilestoneResponse
{
    public responseStatus: ResponseStatus;
    public trackerMilestone: TrackerMilestone;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateTrackerMilestoneResponse>) { (Object as any).assign(this, init); }
}

export class GetTrackerTypesResponse
{
    public responseStatus: ResponseStatus;
    public trackerTypes: TrackerType[];

    public constructor(init?: Partial<GetTrackerTypesResponse>) { (Object as any).assign(this, init); }
}

export class GetTrackerTypeByIdResponse
{
    public responseStatus: ResponseStatus;
    public trackerType: TrackerType;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrackerTypeByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetTrackerTypeResponse
{
    public responseStatus: ResponseStatus;
    public trackerType: TrackerType;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetTrackerTypeResponse>) { (Object as any).assign(this, init); }
}

export class CreateTrackerTypeResponse
{
    public responseStatus: ResponseStatus;
    public trackerType: TrackerType;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateTrackerTypeResponse>) { (Object as any).assign(this, init); }
}

export class ValidateTrackerTypeResponse
{
    public responseStatus: ResponseStatus;
    public trackerType: TrackerType;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateTrackerTypeResponse>) { (Object as any).assign(this, init); }
}

export class GetStandardEmailTemplatesResponse
{
    public responseStatus: ResponseStatus;
    public standardEmailTemplates: StandardEmailTemplate[];

    public constructor(init?: Partial<GetStandardEmailTemplatesResponse>) { (Object as any).assign(this, init); }
}

export class GetStandardEmailTemplateByIdResponse
{
    public responseStatus: ResponseStatus;
    public standardEmailTemplate: StandardEmailTemplate;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetStandardEmailTemplateByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetStandardEmailTemplateResponse
{
    public responseStatus: ResponseStatus;
    public standardEmailTemplate: StandardEmailTemplate;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetStandardEmailTemplateResponse>) { (Object as any).assign(this, init); }
}

export class CreateStandardEmailTemplateResponse
{
    public responseStatus: ResponseStatus;
    public standardEmailTemplate: StandardEmailTemplate;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateStandardEmailTemplateResponse>) { (Object as any).assign(this, init); }
}

export class ValidateStandardEmailTemplateResponse
{
    public responseStatus: ResponseStatus;
    public standardEmailTemplate: StandardEmailTemplate;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateStandardEmailTemplateResponse>) { (Object as any).assign(this, init); }
}

export class GetAppSettingsResponse
{
    public buildMode: string;
    public reportServerUrl: string;
    public reportFolder: string;
    public settings: ClientAppSettings;

    public constructor(init?: Partial<GetAppSettingsResponse>) { (Object as any).assign(this, init); }
}

export class GetEnumerationTypesResponse
{
    public addressTypeId?: AddressTypeId;
    public trialInstitutionItemComponentPrimitiveId: TrialInstitutionItemComponentPrimitiveId;
    public trialInstitutionItemComponentPrimitiveOptionId: TrialInstitutionItemComponentPrimitiveOptionId;

    public constructor(init?: Partial<GetEnumerationTypesResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialDoiByTrialIdResponse
{
    public responseStatus: ResponseStatus;
    public trialDoi: TrialDoi;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrialDoiByTrialIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialDoiByIdResponse
{
    public responseStatus: ResponseStatus;
    public trialDoi: TrialDoi;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrialDoiByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetTrialDoiResponse
{
    public responseStatus: ResponseStatus;
    public trialDoi: TrialDoi;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetTrialDoiResponse>) { (Object as any).assign(this, init); }
}

export class CreateTrialDoiResponse
{
    public responseStatus: ResponseStatus;
    public trialDoi: TrialDoi;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateTrialDoiResponse>) { (Object as any).assign(this, init); }
}

export class ValidateTrialDoiResponse
{
    public responseStatus: ResponseStatus;
    public trialDoi: TrialDoi;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateTrialDoiResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialGroupItemByIdResponse
{
    public responseStatus: ResponseStatus;
    public trialGroupItem: TrialGroupItem;

    public constructor(init?: Partial<GetTrialGroupItemByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialGroupItemsByTrialGroupIdResponse
{
    public responseStatus: ResponseStatus;
    public trialGroupItems: TrialGroupItem[];
    public trialGroupItemCategories: TrialGroupItemCategory[];

    public constructor(init?: Partial<GetTrialGroupItemsByTrialGroupIdResponse>) { (Object as any).assign(this, init); }
}

export class SetTrialGroupItemResponse
{
    public responseStatus: ResponseStatus;
    public trialGroupItem: TrialGroupItem;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetTrialGroupItemResponse>) { (Object as any).assign(this, init); }
}

export class CreateTrialGroupItemResponse
{
    public responseStatus: ResponseStatus;
    public trialGroupItem: TrialGroupItem;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateTrialGroupItemResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialGroupItemTemplatesResponse
{
    public responseStatus: ResponseStatus;
    public trialGroupItemTemplates: TrialGroupItemTemplate[];
    public trialGroupItemsByTrialGroupItemTemplateCategory: TrialGroupItemTemplateCategory[];
    public lookups: Lookup[];

    public constructor(init?: Partial<GetTrialGroupItemTemplatesResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialGroupItemTemplateByIdResponse
{
    public responseStatus: ResponseStatus;
    public trialGroupItemTemplate: TrialGroupItemTemplate;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrialGroupItemTemplateByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetTrialGroupItemTemplateResponse
{
    public responseStatus: ResponseStatus;
    public trialGroupItemTemplate: TrialGroupItemTemplate;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetTrialGroupItemTemplateResponse>) { (Object as any).assign(this, init); }
}

export class CreateTrialGroupItemTemplateResponse
{
    public responseStatus: ResponseStatus;
    public trialGroupItemTemplate: TrialGroupItemTemplate;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateTrialGroupItemTemplateResponse>) { (Object as any).assign(this, init); }
}

export class ValidateTrialGroupItemTemplateResponse
{
    public responseStatus: ResponseStatus;
    public trialGroupItemTemplate: TrialGroupItemTemplate;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateTrialGroupItemTemplateResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialInstitutionItemTemplatesResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionItemTemplates: TrialInstitutionItemTemplate[];
    public trialInstitutionItemsByTrialInstitutionItemTemplateCategory: TrialInstitutionItemTemplateCategory[];
    public lookups: Lookup[];

    public constructor(init?: Partial<GetTrialInstitutionItemTemplatesResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialInstitutionItemTemplateByIdResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionItemTemplate: TrialInstitutionItemTemplate;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrialInstitutionItemTemplateByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetTrialInstitutionItemTemplateResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionItemTemplate: TrialInstitutionItemTemplate;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetTrialInstitutionItemTemplateResponse>) { (Object as any).assign(this, init); }
}

export class CreateTrialInstitutionItemTemplateResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionItemTemplate: TrialInstitutionItemTemplate;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateTrialInstitutionItemTemplateResponse>) { (Object as any).assign(this, init); }
}

export class ValidateTrialInstitutionItemTemplateResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionItemTemplate: TrialInstitutionItemTemplate;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateTrialInstitutionItemTemplateResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialItemTemplatesResponse
{
    public responseStatus: ResponseStatus;
    public trialItemTemplates: TrialItemTemplate[];
    public trialItemsByCategory: Category[];
    public lookups: Lookup[];

    public constructor(init?: Partial<GetTrialItemTemplatesResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialItemTemplateByIdResponse
{
    public responseStatus: ResponseStatus;
    public trialItemTemplate: TrialItemTemplate;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrialItemTemplateByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetTrialItemTemplateResponse
{
    public responseStatus: ResponseStatus;
    public trialItemTemplate: TrialItemTemplate;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetTrialItemTemplateResponse>) { (Object as any).assign(this, init); }
}

export class CreateTrialItemTemplateResponse
{
    public responseStatus: ResponseStatus;
    public trialItemTemplate: TrialItemTemplate;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateTrialItemTemplateResponse>) { (Object as any).assign(this, init); }
}

export class ValidateTrialItemTemplateResponse
{
    public responseStatus: ResponseStatus;
    public trialItemTemplate: TrialItemTemplate;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateTrialItemTemplateResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialWebsiteByTrialIdResponse
{
    public responseStatus: ResponseStatus;
    public trialWebsite: TrialWebsite;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrialWebsiteByTrialIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialWebsiteByIdResponse
{
    public responseStatus: ResponseStatus;
    public trialWebsite: TrialWebsite;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrialWebsiteByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetTrialWebsiteResponse
{
    public responseStatus: ResponseStatus;
    public trialWebsite: TrialWebsite;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetTrialWebsiteResponse>) { (Object as any).assign(this, init); }
}

export class CreateTrialWebsiteResponse
{
    public responseStatus: ResponseStatus;
    public trialWebsite: TrialWebsite;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateTrialWebsiteResponse>) { (Object as any).assign(this, init); }
}

export class ValidateTrialWebsiteResponse
{
    public responseStatus: ResponseStatus;
    public trialWebsite: TrialWebsite;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateTrialWebsiteResponse>) { (Object as any).assign(this, init); }
}

export class GetUserResponse
{
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=2)
    public user: User;

    // @DataMember(Order=3)
    public userSummary: UserSummary;

    public constructor(init?: Partial<GetUserResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetApiUserByUsernameResponse
{
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=2)
    public user: ApiUser;

    public constructor(init?: Partial<GetApiUserByUsernameResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetUsernameForPersonnelResponse
{
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=2)
    public username: string;

    public constructor(init?: Partial<GetUsernameForPersonnelResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetTrialUsersByTrialIdResponse
{
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=2)
    public trialUsers: TrialUser[];

    public constructor(init?: Partial<GetTrialUsersByTrialIdResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetTrialInstitutionsByTrialAndUserResponse
{
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=2)
    public trialInstitutions: TrialInstitution[];

    public constructor(init?: Partial<GetTrialInstitutionsByTrialAndUserResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialItemByIdResponse
{
    public responseStatus: ResponseStatus;
    public trialItem: TrialItem;

    public constructor(init?: Partial<GetTrialItemByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialItemsByTrialIdResponse
{
    public responseStatus: ResponseStatus;
    public trialItems: TrialItem[];
    public trialItemCategories: TrialItemCategory[];

    public constructor(init?: Partial<GetTrialItemsByTrialIdResponse>) { (Object as any).assign(this, init); }
}

export class SetTrialItemResponse
{
    public responseStatus: ResponseStatus;
    public trialItem: TrialItem;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetTrialItemResponse>) { (Object as any).assign(this, init); }
}

export class CreateTrialItemResponse
{
    public responseStatus: ResponseStatus;
    public trialItem: TrialItem;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateTrialItemResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialFinanceByTrialIdResponse
{
    public responseStatus: ResponseStatus;
    public trialFinance: TrialFinance;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrialFinanceByTrialIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialFinanceByIdResponse
{
    public responseStatus: ResponseStatus;
    public trialFinance: TrialFinance;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrialFinanceByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetTrialFinanceResponse
{
    public responseStatus: ResponseStatus;
    public trialFinance: TrialFinance;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetTrialFinanceResponse>) { (Object as any).assign(this, init); }
}

export class CreateTrialFinanceResponse
{
    public responseStatus: ResponseStatus;
    public trialFinance: TrialFinance;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateTrialFinanceResponse>) { (Object as any).assign(this, init); }
}

export class ValidateTrialFinanceResponse
{
    public responseStatus: ResponseStatus;
    public trialFinance: TrialFinance;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateTrialFinanceResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialGroupContractByTrialGroupIdResponse
{
    public responseStatus: ResponseStatus;
    public trialGroupContract: TrialGroupContract[];
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrialGroupContractByTrialGroupIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialGroupContractByIdResponse
{
    public responseStatus: ResponseStatus;
    public trialGroupContract: TrialGroupContract;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrialGroupContractByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetTrialGroupContractResponse
{
    public responseStatus: ResponseStatus;
    public trialGroupContract: TrialGroupContract;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetTrialGroupContractResponse>) { (Object as any).assign(this, init); }
}

export class CreateTrialGroupContractResponse
{
    public responseStatus: ResponseStatus;
    public trialGroupContract: TrialGroupContract;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateTrialGroupContractResponse>) { (Object as any).assign(this, init); }
}

export class ValidateTrialGroupContractResponse
{
    public responseStatus: ResponseStatus;
    public trialGroupContract: TrialGroupContract;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateTrialGroupContractResponse>) { (Object as any).assign(this, init); }
}

export class DeleteTrialGroupContractResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteTrialGroupContractResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialGroupFinanceByTrialGroupIdResponse
{
    public responseStatus: ResponseStatus;
    public trialGroupFinance: TrialGroupFinance;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrialGroupFinanceByTrialGroupIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialGroupFinanceByIdResponse
{
    public responseStatus: ResponseStatus;
    public trialGroupFinance: TrialGroupFinance;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrialGroupFinanceByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetTrialGroupFinanceResponse
{
    public responseStatus: ResponseStatus;
    public trialGroupFinance: TrialGroupFinance;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetTrialGroupFinanceResponse>) { (Object as any).assign(this, init); }
}

export class CreateTrialGroupFinanceResponse
{
    public responseStatus: ResponseStatus;
    public trialGroupFinance: TrialGroupFinance;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateTrialGroupFinanceResponse>) { (Object as any).assign(this, init); }
}

export class ValidateTrialGroupFinanceResponse
{
    public responseStatus: ResponseStatus;
    public trialGroupFinance: TrialGroupFinance;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateTrialGroupFinanceResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialGroupItemCategoriesByTrialGroupIdResponse
{
    public responseStatus: ResponseStatus;
    public trialGroupItemCategories: TrialGroupItemCategory[];
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrialGroupItemCategoriesByTrialGroupIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialGroupItemTemplateCategoriesResponse
{
    public responseStatus: ResponseStatus;
    public trialGroupItemTemplateCategories: TrialGroupItemTemplateCategory[];

    public constructor(init?: Partial<GetTrialGroupItemTemplateCategoriesResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialGroupItemTemplateCategoryByIdResponse
{
    public responseStatus: ResponseStatus;
    public trialGroupItemTemplateCategory: TrialGroupItemTemplateCategory;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrialGroupItemTemplateCategoryByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetTrialGroupItemTemplateCategoryResponse
{
    public responseStatus: ResponseStatus;
    public trialGroupItemTemplateCategory: TrialGroupItemTemplateCategory;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetTrialGroupItemTemplateCategoryResponse>) { (Object as any).assign(this, init); }
}

export class CreateTrialGroupItemTemplateCategoryResponse
{
    public responseStatus: ResponseStatus;
    public trialGroupItemTemplateCategory: TrialGroupItemTemplateCategory;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateTrialGroupItemTemplateCategoryResponse>) { (Object as any).assign(this, init); }
}

export class ValidateTrialGroupItemTemplateCategoryResponse
{
    public responseStatus: ResponseStatus;
    public trialGroupItemTemplateCategory: TrialGroupItemTemplateCategory;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateTrialGroupItemTemplateCategoryResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialGroupLaboratoryContractByTrialGroupLaboratoryIdResponse
{
    public responseStatus: ResponseStatus;
    public trialGroupLaboratoryContract: TrialGroupLaboratoryContract[];
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrialGroupLaboratoryContractByTrialGroupLaboratoryIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialGroupLaboratoryContractByIdResponse
{
    public responseStatus: ResponseStatus;
    public trialGroupLaboratoryContract: TrialGroupLaboratoryContract;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrialGroupLaboratoryContractByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetTrialGroupLaboratoryContractResponse
{
    public responseStatus: ResponseStatus;
    public trialGroupLaboratoryContract: TrialGroupLaboratoryContract;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetTrialGroupLaboratoryContractResponse>) { (Object as any).assign(this, init); }
}

export class CreateTrialGroupLaboratoryContractResponse
{
    public responseStatus: ResponseStatus;
    public trialGroupLaboratoryContract: TrialGroupLaboratoryContract;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateTrialGroupLaboratoryContractResponse>) { (Object as any).assign(this, init); }
}

export class ValidateTrialGroupLaboratoryContractResponse
{
    public responseStatus: ResponseStatus;
    public trialGroupLaboratoryContract: TrialGroupLaboratoryContract;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateTrialGroupLaboratoryContractResponse>) { (Object as any).assign(this, init); }
}

export class DeleteTrialGroupLaboratoryContractResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteTrialGroupLaboratoryContractResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialGroupLaboratoryFinanceByTrialGroupLaboratoryIdResponse
{
    public responseStatus: ResponseStatus;
    public trialGroupLaboratoryFinance: TrialGroupLaboratoryFinance;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrialGroupLaboratoryFinanceByTrialGroupLaboratoryIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialGroupLaboratoryFinanceByIdResponse
{
    public responseStatus: ResponseStatus;
    public trialGroupLaboratoryFinance: TrialGroupLaboratoryFinance;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrialGroupLaboratoryFinanceByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetTrialGroupLaboratoryFinanceResponse
{
    public responseStatus: ResponseStatus;
    public trialGroupLaboratoryFinance: TrialGroupLaboratoryFinance;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetTrialGroupLaboratoryFinanceResponse>) { (Object as any).assign(this, init); }
}

export class CreateTrialGroupLaboratoryFinanceResponse
{
    public responseStatus: ResponseStatus;
    public trialGroupLaboratoryFinance: TrialGroupLaboratoryFinance;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateTrialGroupLaboratoryFinanceResponse>) { (Object as any).assign(this, init); }
}

export class ValidateTrialGroupLaboratoryFinanceResponse
{
    public responseStatus: ResponseStatus;
    public trialGroupLaboratoryFinance: TrialGroupLaboratoryFinance;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateTrialGroupLaboratoryFinanceResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialGroupLaboratoryPersonnelsResponse
{
    public responseStatus: ResponseStatus;
    public trialGroupLaboratoryPersonnels: TrialGroupLaboratoryPersonnel[];
    public lookups: Lookup[];

    public constructor(init?: Partial<GetTrialGroupLaboratoryPersonnelsResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialGroupLaboratoryPersonnelByIdResponse
{
    public responseStatus: ResponseStatus;
    public trialGroupLaboratoryPersonnel: TrialGroupLaboratoryPersonnel;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrialGroupLaboratoryPersonnelByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialGroupLaboratoryPersonnelByLaboratoryIdResponse
{
    public responseStatus: ResponseStatus;
    public trialGroupLaboratoryPersonnel: TrialGroupLaboratoryPersonnel[];
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrialGroupLaboratoryPersonnelByLaboratoryIdResponse>) { (Object as any).assign(this, init); }
}

export class SetTrialGroupLaboratoryPersonnelResponse
{
    public responseStatus: ResponseStatus;
    public trialGroupLaboratoryPersonnel: TrialGroupLaboratoryPersonnel;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetTrialGroupLaboratoryPersonnelResponse>) { (Object as any).assign(this, init); }
}

export class CreateTrialGroupLaboratoryPersonnelResponse
{
    public responseStatus: ResponseStatus;
    public trialGroupLaboratoryPersonnel: TrialGroupLaboratoryPersonnel;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateTrialGroupLaboratoryPersonnelResponse>) { (Object as any).assign(this, init); }
}

export class ValidateTrialGroupLaboratoryPersonnelResponse
{
    public responseStatus: ResponseStatus;
    public trialGroupLaboratoryPersonnel: TrialGroupLaboratoryPersonnel;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateTrialGroupLaboratoryPersonnelResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialGroupLaboratoriesResponse
{
    public responseStatus: ResponseStatus;
    public trialGroupLaboratories: TrialGroupLaboratory[];
    public lookups: Lookup[];

    public constructor(init?: Partial<GetTrialGroupLaboratoriesResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialGroupLaboratoriesByTrialGroupIdResponse
{
    public responseStatus: ResponseStatus;
    public trialGroupLaboratories: TrialGroupLaboratory[];
    public lookups: Lookup[];

    public constructor(init?: Partial<GetTrialGroupLaboratoriesByTrialGroupIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialGroupLaboratoriesByTrialIdResponse
{
    public responseStatus: ResponseStatus;
    public trialGroupLaboratories: TrialGroupLaboratory[];
    public lookups: Lookup[];

    public constructor(init?: Partial<GetTrialGroupLaboratoriesByTrialIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialGroupLaboratoryByIdResponse
{
    public responseStatus: ResponseStatus;
    public trialGroupLaboratory: TrialGroupLaboratory;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrialGroupLaboratoryByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialGroupLaboratoryByLaboratoryIdResponse
{
    public responseStatus: ResponseStatus;
    public trialGroupLaboratory: TrialGroupLaboratory[];
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrialGroupLaboratoryByLaboratoryIdResponse>) { (Object as any).assign(this, init); }
}

export class SetTrialGroupLaboratoryResponse
{
    public responseStatus: ResponseStatus;
    public trialGroupLaboratory: TrialGroupLaboratory;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetTrialGroupLaboratoryResponse>) { (Object as any).assign(this, init); }
}

export class CreateTrialGroupLaboratoryResponse
{
    public responseStatus: ResponseStatus;
    public trialGroupLaboratory: TrialGroupLaboratory;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateTrialGroupLaboratoryResponse>) { (Object as any).assign(this, init); }
}

export class DeleteTrialGroupLaboratoryResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteTrialGroupLaboratoryResponse>) { (Object as any).assign(this, init); }
}

export class ValidateTrialGroupLaboratoryResponse
{
    public responseStatus: ResponseStatus;
    public trialGroupLaboratory: TrialGroupLaboratory;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateTrialGroupLaboratoryResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialGroupsResponse
{
    public responseStatus: ResponseStatus;
    public trialGroups: TrialGroup[];
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrialGroupsResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialGroupByIdResponse
{
    public responseStatus: ResponseStatus;
    public trialGroup: TrialGroup;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrialGroupByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialGroupsByGroupIdResponse
{
    public responseStatus: ResponseStatus;
    public trialGroups: TrialGroup[];
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrialGroupsByGroupIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialGroupsByTrialIdResponse
{
    public responseStatus: ResponseStatus;
    public trialGroups: TrialGroup[];
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrialGroupsByTrialIdResponse>) { (Object as any).assign(this, init); }
}

export class SetTrialGroupResponse
{
    public responseStatus: ResponseStatus;
    public trialGroup: TrialGroup;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetTrialGroupResponse>) { (Object as any).assign(this, init); }
}

export class CreateTrialGroupResponse
{
    public responseStatus: ResponseStatus;
    public trialGroup: TrialGroup;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateTrialGroupResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetTrialCoordinatingGroupsByTrialIdResponse
{
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=2)
    public trialCoordinatingGroups: TrialCoordinatingGroup[];

    public constructor(init?: Partial<GetTrialCoordinatingGroupsByTrialIdResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetTrialMasterGroupsByTrialIdResponse
{
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=2)
    public trialMasterGroups: TrialMasterGroup[];

    public constructor(init?: Partial<GetTrialMasterGroupsByTrialIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialInstitutionContractByTrialInstitutionIdResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionContract: TrialInstitutionContract[];
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrialInstitutionContractByTrialInstitutionIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialInstitutionContractByIdResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionContract: TrialInstitutionContract;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrialInstitutionContractByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetTrialInstitutionContractResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionContract: TrialInstitutionContract;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetTrialInstitutionContractResponse>) { (Object as any).assign(this, init); }
}

export class CreateTrialInstitutionContractResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionContract: TrialInstitutionContract;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateTrialInstitutionContractResponse>) { (Object as any).assign(this, init); }
}

export class ValidateTrialInstitutionContractResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionContract: TrialInstitutionContract;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateTrialInstitutionContractResponse>) { (Object as any).assign(this, init); }
}

export class DeleteTrialInstitutionContractResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteTrialInstitutionContractResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialInstitutionFinanceByTrialInstitutionIdResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionFinance: TrialInstitutionFinance;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrialInstitutionFinanceByTrialInstitutionIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialInstitutionFinanceByIdResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionFinance: TrialInstitutionFinance;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrialInstitutionFinanceByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetTrialInstitutionFinanceResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionFinance: TrialInstitutionFinance;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetTrialInstitutionFinanceResponse>) { (Object as any).assign(this, init); }
}

export class CreateTrialInstitutionFinanceResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionFinance: TrialInstitutionFinance;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateTrialInstitutionFinanceResponse>) { (Object as any).assign(this, init); }
}

export class ValidateTrialInstitutionFinanceResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionFinance: TrialInstitutionFinance;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateTrialInstitutionFinanceResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialInstitutionItemCategoriesByTrialInstitutionIdResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionItemCategories: TrialInstitutionItemCategory[];
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrialInstitutionItemCategoriesByTrialInstitutionIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialInstitutionItemCustomViewsResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionItemCustomViews: TrialInstitutionItemCustomView[];
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrialInstitutionItemCustomViewsResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialInstitutionItemCustomViewByIdResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionItemCustomView: TrialInstitutionItemCustomView;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrialInstitutionItemCustomViewByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetTrialInstitutionItemCustomViewResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionItemCustomView: TrialInstitutionItemCustomView;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetTrialInstitutionItemCustomViewResponse>) { (Object as any).assign(this, init); }
}

export class CreateTrialInstitutionItemCustomViewResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionItemCustomView: TrialInstitutionItemCustomView;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateTrialInstitutionItemCustomViewResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialInstitutionItemCustomViewDataEntryByIdResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionItemCustomView: TrialInstitutionItemCustomView;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrialInstitutionItemCustomViewDataEntryByIdResponse>) { (Object as any).assign(this, init); }
}

export class PostTrialInstitutionItemCustomViewDataEntryByIdResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionItemCustomView: TrialInstitutionItemCustomView;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<PostTrialInstitutionItemCustomViewDataEntryByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialInstitutionItemByIdResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionItem: TrialInstitutionItem;

    public constructor(init?: Partial<GetTrialInstitutionItemByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialInstitutionItemsSiteClosureResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionItems: TrialInstitutionItem[];

    public constructor(init?: Partial<GetTrialInstitutionItemsSiteClosureResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialInstitutionItemsByTrialInstitutionIdResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionItems: TrialInstitutionItem[];
    public trialInstitutionItemCategories: TrialInstitutionItemCategory[];

    public constructor(init?: Partial<GetTrialInstitutionItemsByTrialInstitutionIdResponse>) { (Object as any).assign(this, init); }
}

export class SetTrialInstitutionItemResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionItem: TrialInstitutionItem;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetTrialInstitutionItemResponse>) { (Object as any).assign(this, init); }
}

export class CreateTrialInstitutionItemResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionItem: TrialInstitutionItem;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateTrialInstitutionItemResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetTrialInstitutionItemsInstApprovedResponse
{
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=2)
    public trialInstitutionItemsInstApproved: TrialInstitutionItemInstApproved[];

    public constructor(init?: Partial<GetTrialInstitutionItemsInstApprovedResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetTrialInstitutionItemDataResponse
{
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=2)
    public trialInstitutionItemData: TrialInstitutionItemData[];

    public constructor(init?: Partial<GetTrialInstitutionItemDataResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetTrialInstitutionItemImagesResponse
{
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=2)
    public trialInstitutionItemImages: TrialInstitutionItemImage[];

    public constructor(init?: Partial<GetTrialInstitutionItemImagesResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialInstitutionItemTemplateCategoriesResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionItemTemplateCategories: TrialInstitutionItemTemplateCategory[];

    public constructor(init?: Partial<GetTrialInstitutionItemTemplateCategoriesResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialInstitutionItemTemplateCategoryByIdResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionItemTemplateCategory: TrialInstitutionItemTemplateCategory;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrialInstitutionItemTemplateCategoryByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetTrialInstitutionItemTemplateCategoryResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionItemTemplateCategory: TrialInstitutionItemTemplateCategory;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetTrialInstitutionItemTemplateCategoryResponse>) { (Object as any).assign(this, init); }
}

export class CreateTrialInstitutionItemTemplateCategoryResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionItemTemplateCategory: TrialInstitutionItemTemplateCategory;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateTrialInstitutionItemTemplateCategoryResponse>) { (Object as any).assign(this, init); }
}

export class ValidateTrialInstitutionItemTemplateCategoryResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionItemTemplateCategory: TrialInstitutionItemTemplateCategory;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateTrialInstitutionItemTemplateCategoryResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialInstitutionLaboratoryContractByTrialInstitutionLaboratoryIdResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionLaboratoryContract: TrialInstitutionLaboratoryContract[];
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrialInstitutionLaboratoryContractByTrialInstitutionLaboratoryIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialInstitutionLaboratoryContractByIdResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionLaboratoryContract: TrialInstitutionLaboratoryContract;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrialInstitutionLaboratoryContractByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetTrialInstitutionLaboratoryContractResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionLaboratoryContract: TrialInstitutionLaboratoryContract;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetTrialInstitutionLaboratoryContractResponse>) { (Object as any).assign(this, init); }
}

export class CreateTrialInstitutionLaboratoryContractResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionLaboratoryContract: TrialInstitutionLaboratoryContract;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateTrialInstitutionLaboratoryContractResponse>) { (Object as any).assign(this, init); }
}

export class ValidateTrialInstitutionLaboratoryContractResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionLaboratoryContract: TrialInstitutionLaboratoryContract;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateTrialInstitutionLaboratoryContractResponse>) { (Object as any).assign(this, init); }
}

export class DeleteTrialInstitutionLaboratoryContractResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteTrialInstitutionLaboratoryContractResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialInstitutionLaboratoryFinanceByTrialInstitutionLaboratoryIdResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionLaboratoryFinance: TrialInstitutionLaboratoryFinance;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrialInstitutionLaboratoryFinanceByTrialInstitutionLaboratoryIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialInstitutionLaboratoryFinanceByIdResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionLaboratoryFinance: TrialInstitutionLaboratoryFinance;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrialInstitutionLaboratoryFinanceByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetTrialInstitutionLaboratoryFinanceResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionLaboratoryFinance: TrialInstitutionLaboratoryFinance;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetTrialInstitutionLaboratoryFinanceResponse>) { (Object as any).assign(this, init); }
}

export class CreateTrialInstitutionLaboratoryFinanceResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionLaboratoryFinance: TrialInstitutionLaboratoryFinance;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateTrialInstitutionLaboratoryFinanceResponse>) { (Object as any).assign(this, init); }
}

export class ValidateTrialInstitutionLaboratoryFinanceResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionLaboratoryFinance: TrialInstitutionLaboratoryFinance;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateTrialInstitutionLaboratoryFinanceResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialInstitutionLaboratoryPersonnelsResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionLaboratoryPersonnels: TrialInstitutionLaboratoryPersonnel[];
    public lookups: Lookup[];

    public constructor(init?: Partial<GetTrialInstitutionLaboratoryPersonnelsResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialInstitutionLaboratoryPersonnelByIdResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionLaboratoryPersonnel: TrialInstitutionLaboratoryPersonnel;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrialInstitutionLaboratoryPersonnelByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialInstitutionLaboratoryPersonnelByLaboratoryIdResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionLaboratoryPersonnel: TrialInstitutionLaboratoryPersonnel[];
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrialInstitutionLaboratoryPersonnelByLaboratoryIdResponse>) { (Object as any).assign(this, init); }
}

export class SetTrialInstitutionLaboratoryPersonnelResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionLaboratoryPersonnel: TrialInstitutionLaboratoryPersonnel;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetTrialInstitutionLaboratoryPersonnelResponse>) { (Object as any).assign(this, init); }
}

export class CreateTrialInstitutionLaboratoryPersonnelResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionLaboratoryPersonnel: TrialInstitutionLaboratoryPersonnel;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateTrialInstitutionLaboratoryPersonnelResponse>) { (Object as any).assign(this, init); }
}

export class ValidateTrialInstitutionLaboratoryPersonnelResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionLaboratoryPersonnel: TrialInstitutionLaboratoryPersonnel;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateTrialInstitutionLaboratoryPersonnelResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialInstitutionLaboratoriesResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionLaboratories: TrialInstitutionLaboratory[];
    public lookups: Lookup[];

    public constructor(init?: Partial<GetTrialInstitutionLaboratoriesResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialInstitutionLaboratoriesByTrialInstitutionIdResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionLaboratories: TrialInstitutionLaboratory[];
    public lookups: Lookup[];

    public constructor(init?: Partial<GetTrialInstitutionLaboratoriesByTrialInstitutionIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialInstitutionLaboratoriesByTrialIdResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionLaboratories: TrialInstitutionLaboratory[];
    public lookups: Lookup[];

    public constructor(init?: Partial<GetTrialInstitutionLaboratoriesByTrialIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialInstitutionLaboratoryByIdResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionLaboratory: TrialInstitutionLaboratory;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrialInstitutionLaboratoryByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialInstitutionLaboratoryByLaboratoryIdResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionLaboratory: TrialInstitutionLaboratory[];
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrialInstitutionLaboratoryByLaboratoryIdResponse>) { (Object as any).assign(this, init); }
}

export class SetTrialInstitutionLaboratoryResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionLaboratory: TrialInstitutionLaboratory;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetTrialInstitutionLaboratoryResponse>) { (Object as any).assign(this, init); }
}

export class CreateTrialInstitutionLaboratoryResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionLaboratory: TrialInstitutionLaboratory;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateTrialInstitutionLaboratoryResponse>) { (Object as any).assign(this, init); }
}

export class DeleteTrialInstitutionLaboratoryResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteTrialInstitutionLaboratoryResponse>) { (Object as any).assign(this, init); }
}

export class ValidateTrialInstitutionLaboratoryResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionLaboratory: TrialInstitutionLaboratory;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateTrialInstitutionLaboratoryResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialInstitutionsResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutions: TrialInstitution[];
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrialInstitutionsResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialInstitutionsByTrialIdResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutions: TrialInstitution[];
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrialInstitutionsByTrialIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialInstitutionsByInstitutionIdResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutions: TrialInstitution[];
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrialInstitutionsByInstitutionIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialInstitutionByIdResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitution: TrialInstitution;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrialInstitutionByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetTrialInstitutionResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitution: TrialInstitution;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetTrialInstitutionResponse>) { (Object as any).assign(this, init); }
}

export class CreateTrialInstitutionResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitution: TrialInstitution;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateTrialInstitutionResponse>) { (Object as any).assign(this, init); }
}

export class ValidateTrialInstitutionResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitution: TrialInstitution;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateTrialInstitutionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetTrialInstitutionsWithGroupsByTrialResponse
{
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=2)
    public trialInstitutions: TrialInstitutionWithGroupProps[];

    public constructor(init?: Partial<GetTrialInstitutionsWithGroupsByTrialResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetTrialInstitutionWithGroupsByTrialAndIdResponse
{
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=2)
    public trialInstitution: TrialInstitutionWithGroupProps;

    public constructor(init?: Partial<GetTrialInstitutionWithGroupsByTrialAndIdResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetTrialInstitutionWithGroupsByTrialAndCodeResponse
{
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=2)
    public trialInstitution: TrialInstitutionWithGroupProps;

    public constructor(init?: Partial<GetTrialInstitutionWithGroupsByTrialAndCodeResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialItemCategoriesByTrialIdResponse
{
    public responseStatus: ResponseStatus;
    public trialItemCategories: TrialItemCategory[];
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrialItemCategoriesByTrialIdResponse>) { (Object as any).assign(this, init); }
}

export class SetTrialItemImportResponse
{
    public responseStatus: ResponseStatus;
    public trialItemImport: TrialItemImport;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetTrialItemImportResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialItemUpdateByIdResponse
{
    public responseStatus: ResponseStatus;
    public trialItemUpdate: TrialItemUpdate;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrialItemUpdateByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetTrialItemUpdateResponse
{
    public responseStatus: ResponseStatus;
    public trialItemUpdate: TrialItemUpdate;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetTrialItemUpdateResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialPersonnelByIdResponse
{
    public responseStatus: ResponseStatus;
    public trialPersonnel: TrialPersonnel;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrialPersonnelByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialPersonnelsByPersonnelIdResponse
{
    public responseStatus: ResponseStatus;
    public trialPersonnels: TrialPersonnel[];
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrialPersonnelsByPersonnelIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialPersonnelsByTrialIdResponse
{
    public responseStatus: ResponseStatus;
    public trialPersonnels: TrialPersonnel[];
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrialPersonnelsByTrialIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialPersonnelsByInstitutionIdResponse
{
    public responseStatus: ResponseStatus;
    public trialPersonnels: TrialPersonnel[];
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrialPersonnelsByInstitutionIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialPersonnelsByTrialInstitutionIdResponse
{
    public responseStatus: ResponseStatus;
    public trialPersonnels: TrialPersonnel[];
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrialPersonnelsByTrialInstitutionIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialPersonnelsByTrialGroupIdResponse
{
    public responseStatus: ResponseStatus;
    public trialPersonnels: TrialPersonnel[];
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrialPersonnelsByTrialGroupIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialPersonnelsByGroupIdResponse
{
    public responseStatus: ResponseStatus;
    public trialPersonnels: TrialPersonnel[];
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrialPersonnelsByGroupIdResponse>) { (Object as any).assign(this, init); }
}

export class SetTrialPersonnelResponse
{
    public responseStatus: ResponseStatus;
    public trialPersonnel: TrialPersonnel;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetTrialPersonnelResponse>) { (Object as any).assign(this, init); }
}

export class CreateTrialPersonnelResponse
{
    public responseStatus: ResponseStatus;
    public trialPersonnel: TrialPersonnel;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateTrialPersonnelResponse>) { (Object as any).assign(this, init); }
}

export class ValidateTrialPersonnelResponse
{
    public responseStatus: ResponseStatus;
    public trialPersonnel: TrialPersonnel;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateTrialPersonnelResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialsResponse
{
    public responseStatus: ResponseStatus;
    public trials: Trial[];
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrialsResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialByIdResponse
{
    public responseStatus: ResponseStatus;
    public trial: Trial;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrialByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetTrialResponse
{
    public responseStatus: ResponseStatus;
    public trial: Trial;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetTrialResponse>) { (Object as any).assign(this, init); }
}

export class CreateTrialResponse
{
    public responseStatus: ResponseStatus;
    public trial: Trial;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateTrialResponse>) { (Object as any).assign(this, init); }
}

export class GetParentTrialsResponse
{
    public responseStatus: ResponseStatus;
    public trials: Trial[];
    public lookups: Lookup[];

    public constructor(init?: Partial<GetParentTrialsResponse>) { (Object as any).assign(this, init); }
}

export class ValidateTrialResponse
{
    public responseStatus: ResponseStatus;
    public trial: Trial;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateTrialResponse>) { (Object as any).assign(this, init); }
}

export class GetInstitutionItemByIdResponse
{
    public responseStatus: ResponseStatus;
    public institutionItem: InstitutionItem;

    public constructor(init?: Partial<GetInstitutionItemByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetInstitutionItemsByInstitutionIdResponse
{
    public responseStatus: ResponseStatus;
    public institutionItems: InstitutionItem[];
    public institutionItemCategories: InstitutionItemCategory[];

    public constructor(init?: Partial<GetInstitutionItemsByInstitutionIdResponse>) { (Object as any).assign(this, init); }
}

export class SetInstitutionItemResponse
{
    public responseStatus: ResponseStatus;
    public institutionItem: InstitutionItem;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetInstitutionItemResponse>) { (Object as any).assign(this, init); }
}

export class CreateInstitutionItemResponse
{
    public responseStatus: ResponseStatus;
    public institutionItem: InstitutionItem;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateInstitutionItemResponse>) { (Object as any).assign(this, init); }
}

export class SearchResponse
{
    public responseStatus: ResponseStatus;
    public search: SearchResult;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SearchResponse>) { (Object as any).assign(this, init); }
}

export class SearchPersonnelResponse
{
    public responseStatus: ResponseStatus;
    public personnelOptions: PersonnelOption[];
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SearchPersonnelResponse>) { (Object as any).assign(this, init); }
}

export class GetRolesResponse
{
    public responseStatus: ResponseStatus;
    public roles: Role[];
    public lookups: Lookup[];
    public modules: ModulePermission[];

    public constructor(init?: Partial<GetRolesResponse>) { (Object as any).assign(this, init); }
}

export class GetRoleByIdResponse
{
    public responseStatus: ResponseStatus;
    public role: Role;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetRoleByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetRoleResponse
{
    public responseStatus: ResponseStatus;
    public role: Role;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetRoleResponse>) { (Object as any).assign(this, init); }
}

export class CreateRoleResponse
{
    public responseStatus: ResponseStatus;
    public role: Role;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateRoleResponse>) { (Object as any).assign(this, init); }
}

export class ValidateRoleResponse
{
    public responseStatus: ResponseStatus;
    public role: Role;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateRoleResponse>) { (Object as any).assign(this, init); }
}

export class GetQuillDocumentImageByIdResponse
{
    public responseStatus: ResponseStatus;
    public quillDocumentImage: QuillDocumentImage;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetQuillDocumentImageByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetQuillDocumentImageByQuillDocumentIdResponse
{
    public responseStatus: ResponseStatus;
    public quillDocumentImages: QuillDocumentImage[];
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetQuillDocumentImageByQuillDocumentIdResponse>) { (Object as any).assign(this, init); }
}

export class SetQuillDocumentImageResponse
{
    public responseStatus: ResponseStatus;
    public quillDocumentImage: QuillDocumentImage;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetQuillDocumentImageResponse>) { (Object as any).assign(this, init); }
}

export class CreateQuillDocumentImageResponse
{
    public responseStatus: ResponseStatus;
    public quillDocumentImage: QuillDocumentImage;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateQuillDocumentImageResponse>) { (Object as any).assign(this, init); }
}

export class HttpResult
{
    public responseText: string;
    public responseStream: string;
    public fileInfo: FileInfo;
    public virtualFile: IVirtualFile;
    public contentType: string;
    public headers: { [index:string]: string; };
    public cookies: Cookie[];
    public eTag: string;
    public age?: string;
    public maxAge?: string;
    public expires?: string;
    public lastModified?: string;
    public cacheControl: CacheControl;
    public resultScope: Func<IDisposable>;
    public allowsPartialResponse: boolean;
    public options: { [index:string]: string; };
    public status: number;
    public statusCode: HttpStatusCode;
    public statusDescription: string;
    public response: Object;
    public responseFilter: IContentTypeWriter;
    public requestContext: IRequest;
    public view: string;
    public template: string;
    public paddingLength: number;
    public isPartialRequest: boolean;

    public constructor(init?: Partial<HttpResult>) { (Object as any).assign(this, init); }
}

export class UploadQuillDocumentImageResponse
{
    public responseStatus: ResponseStatus;
    public url: string;
    public quillDocumentImage: QuillDocumentImage;

    public constructor(init?: Partial<UploadQuillDocumentImageResponse>) { (Object as any).assign(this, init); }
}

export class GetQuillDocumentByIdResponse
{
    public responseStatus: ResponseStatus;
    public quillDocument: QuillDocument;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetQuillDocumentByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetQuillDocumentByTypeAndPageResponse
{
    public responseStatus: ResponseStatus;
    public quillDocument: QuillDocument;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetQuillDocumentByTypeAndPageResponse>) { (Object as any).assign(this, init); }
}

export class GetQuillDocumentsBySearchResponse
{
    public responseStatus: ResponseStatus;
    public quillDocuments: QuillDocument[];
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetQuillDocumentsBySearchResponse>) { (Object as any).assign(this, init); }
}

export class SetQuillDocumentResponse
{
    public responseStatus: ResponseStatus;
    public quillDocument: QuillDocument;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetQuillDocumentResponse>) { (Object as any).assign(this, init); }
}

export class CreateQuillDocumentResponse
{
    public responseStatus: ResponseStatus;
    public quillDocument: QuillDocument;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateQuillDocumentResponse>) { (Object as any).assign(this, init); }
}

export class ValidateQuillDocumentResponse
{
    public responseStatus: ResponseStatus;
    public quillDocument: QuillDocument;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateQuillDocumentResponse>) { (Object as any).assign(this, init); }
}

export class GetProjectInvestigatorByIdResponse
{
    public responseStatus: ResponseStatus;
    public projectInvestigator: ProjectInvestigator;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetProjectInvestigatorByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetProjectInvestigatorsByProjectIdResponse
{
    public responseStatus: ResponseStatus;
    public projectInvestigators: ProjectInvestigator[];
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetProjectInvestigatorsByProjectIdResponse>) { (Object as any).assign(this, init); }
}

export class SetProjectInvestigatorResponse
{
    public responseStatus: ResponseStatus;
    public projectInvestigator: ProjectInvestigator;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetProjectInvestigatorResponse>) { (Object as any).assign(this, init); }
}

export class CreateProjectInvestigatorResponse
{
    public responseStatus: ResponseStatus;
    public projectInvestigator: ProjectInvestigator;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateProjectInvestigatorResponse>) { (Object as any).assign(this, init); }
}

export class ValidateProjectInvestigatorResponse
{
    public responseStatus: ResponseStatus;
    public projectInvestigator: ProjectInvestigator;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateProjectInvestigatorResponse>) { (Object as any).assign(this, init); }
}

export class GetProjectItemImportByIdResponse
{
    public responseStatus: ResponseStatus;
    public projectItemImport: ProjectItemImport;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetProjectItemImportByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetProjectItemImportResponse
{
    public responseStatus: ResponseStatus;
    public projectItemImport: ProjectItemImport;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetProjectItemImportResponse>) { (Object as any).assign(this, init); }
}

export class GetProjectsResponse
{
    public responseStatus: ResponseStatus;
    public projects: Project[];
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetProjectsResponse>) { (Object as any).assign(this, init); }
}

export class GetProjectByIdResponse
{
    public responseStatus: ResponseStatus;
    public project: Project;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetProjectByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetProjectResponse
{
    public responseStatus: ResponseStatus;
    public project: Project;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetProjectResponse>) { (Object as any).assign(this, init); }
}

export class CreateProjectResponse
{
    public responseStatus: ResponseStatus;
    public project: Project;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateProjectResponse>) { (Object as any).assign(this, init); }
}

export class ValidateProjectResponse
{
    public responseStatus: ResponseStatus;
    public project: Project;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateProjectResponse>) { (Object as any).assign(this, init); }
}

export class GetProjectedAccrualByTrialIdResponse
{
    public responseStatus: ResponseStatus;
    public projectedAccruals: ProjectedAccrual[];

    public constructor(init?: Partial<GetProjectedAccrualByTrialIdResponse>) { (Object as any).assign(this, init); }
}

export class GetProjectedAccrualByIdResponse
{
    public responseStatus: ResponseStatus;
    public projectedAccrual: ProjectedAccrual;

    public constructor(init?: Partial<GetProjectedAccrualByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetProjectedAccrualResponse
{
    public responseStatus: ResponseStatus;
    public projectedAccrual: ProjectedAccrual;

    public constructor(init?: Partial<SetProjectedAccrualResponse>) { (Object as any).assign(this, init); }
}

export class UpdateProjectedAccrualResponse
{
    public responseStatus: ResponseStatus;
    public projectedAccruals: ProjectedAccrual[];

    public constructor(init?: Partial<UpdateProjectedAccrualResponse>) { (Object as any).assign(this, init); }
}

export class GetOpenClinicaUserRolesResponse
{
    public responseStatus: ResponseStatus;
    public openClinicaUserRoles: OpenClinicaUserRole[];

    public constructor(init?: Partial<GetOpenClinicaUserRolesResponse>) { (Object as any).assign(this, init); }
}

export class SetOpenClinicaUserRoleRebuildResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<SetOpenClinicaUserRoleRebuildResponse>) { (Object as any).assign(this, init); }
}

export class PostOpenClinicaUserRoleChangeStatusResponse
{
    public openClinicaUserRole: OpenClinicaUserRole;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<PostOpenClinicaUserRoleChangeStatusResponse>) { (Object as any).assign(this, init); }
}

export class PostOpenClinicaUserRoleResendEmailResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<PostOpenClinicaUserRoleResendEmailResponse>) { (Object as any).assign(this, init); }
}

export class PostOpenClinicaUserRoleImportResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<PostOpenClinicaUserRoleImportResponse>) { (Object as any).assign(this, init); }
}

export class GetPersonnelRoleByIdResponse
{
    public responseStatus: ResponseStatus;
    public personnelRole: PersonnelRole;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetPersonnelRoleByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetPersonnelRoleResponse
{
    public responseStatus: ResponseStatus;
    public personnelRole: PersonnelRole;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetPersonnelRoleResponse>) { (Object as any).assign(this, init); }
}

export class ValidatePersonnelRoleResponse
{
    public responseStatus: ResponseStatus;
    public personnelRole: PersonnelRole;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidatePersonnelRoleResponse>) { (Object as any).assign(this, init); }
}

export class CreatePersonnelRoleResponse
{
    public responseStatus: ResponseStatus;
    public personnelRole: PersonnelRole;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreatePersonnelRoleResponse>) { (Object as any).assign(this, init); }
}

export class PostPersonnelRoleResendEmailResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<PostPersonnelRoleResendEmailResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetTrialPersonnelByPersonIdAndTrialInstitutionResponse
{
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=2)
    public trialPersonnel: TrialPersonnel[];

    public constructor(init?: Partial<GetTrialPersonnelByPersonIdAndTrialInstitutionResponse>) { (Object as any).assign(this, init); }
}

export class GetPersonnelResponse
{
    public responseStatus: ResponseStatus;
    public personnel: Personnel[];
    public lookups: Lookup[];

    public constructor(init?: Partial<GetPersonnelResponse>) { (Object as any).assign(this, init); }
}

export class GetPersonnelByIdResponse
{
    public responseStatus: ResponseStatus;
    public personnel: Personnel;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetPersonnelByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetPersonnelResponse
{
    public responseStatus: ResponseStatus;
    public personnel: Personnel;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetPersonnelResponse>) { (Object as any).assign(this, init); }
}

export class ValidatePersonnelResponse
{
    public responseStatus: ResponseStatus;
    public personnel: Personnel;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidatePersonnelResponse>) { (Object as any).assign(this, init); }
}

export class CreatePersonnelResponse
{
    public responseStatus: ResponseStatus;
    public personnel: Personnel;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreatePersonnelResponse>) { (Object as any).assign(this, init); }
}

export class PostPersonnelResendEmailResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<PostPersonnelResendEmailResponse>) { (Object as any).assign(this, init); }
}

export class GetPersonnelPermissionsByIdResponse
{
    public responseStatus: ResponseStatus;
    public groupedPersonnelPermissions: PersonnelPermissionGroup[];
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetPersonnelPermissionsByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetPersonnelByRoleResponse
{
    public responseStatus: ResponseStatus;
    public rolePersonnelGroupings: RolePersonnelGrouping[];
    public lookups: Lookup[];

    public constructor(init?: Partial<GetPersonnelByRoleResponse>) { (Object as any).assign(this, init); }
}

export class GetPersonnelCategoryResponse
{
    public responseStatus: ResponseStatus;
    public category: PersonnelCategory[];

    public constructor(init?: Partial<GetPersonnelCategoryResponse>) { (Object as any).assign(this, init); }
}

export class GetPersonnelAdvancedSearchResponse
{
    public responseStatus: ResponseStatus;
    public personnel: Personnel[];
    public lookups: Lookup[];

    public constructor(init?: Partial<GetPersonnelAdvancedSearchResponse>) { (Object as any).assign(this, init); }
}

export class GetPersonnelTmdRoleResponse
{
    public responseStatus: ResponseStatus;
    public tmdRole: PersonnelTmdRole[];

    public constructor(init?: Partial<GetPersonnelTmdRoleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetPersonnelByTrialResponse
{
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=2)
    public personnel: Personnel[];

    public constructor(init?: Partial<GetPersonnelByTrialResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetPersonnelByTrialInstitutionResponse
{
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=2)
    public personnel: Personnel[];

    public constructor(init?: Partial<GetPersonnelByTrialInstitutionResponse>) { (Object as any).assign(this, init); }
}

export class GetPersonnelTmdTrialResponse
{
    public responseStatus: ResponseStatus;
    public tmdTrial: PersonnelTmdTrial[];

    public constructor(init?: Partial<GetPersonnelTmdTrialResponse>) { (Object as any).assign(this, init); }
}

export class GetPersonnelTrialGroupResponse
{
    public responseStatus: ResponseStatus;
    public trialGroup: PersonnelTrialGroup[];

    public constructor(init?: Partial<GetPersonnelTrialGroupResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetPersonnelByIdsResponse
{
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=2)
    public personnel: Personnel[];

    public constructor(init?: Partial<GetPersonnelByIdsResponse>) { (Object as any).assign(this, init); }
}

export class GetPersonnelTrainingByIdResponse
{
    public responseStatus: ResponseStatus;
    public personnelTraining: PersonnelTraining;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetPersonnelTrainingByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetPersonnelTrainingByPersonnelIdResponse
{
    public responseStatus: ResponseStatus;
    public personnelTraining: PersonnelTraining[];
    public lookups: Lookup[];

    public constructor(init?: Partial<GetPersonnelTrainingByPersonnelIdResponse>) { (Object as any).assign(this, init); }
}

export class SetPersonnelTrainingResponse
{
    public responseStatus: ResponseStatus;
    public personnelTraining: PersonnelTraining;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetPersonnelTrainingResponse>) { (Object as any).assign(this, init); }
}

export class CreatePersonnelTrainingResponse
{
    public responseStatus: ResponseStatus;
    public personnelTraining: PersonnelTraining;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreatePersonnelTrainingResponse>) { (Object as any).assign(this, init); }
}

export class ValidatePersonnelTrainingResponse
{
    public responseStatus: ResponseStatus;
    public personnelTraining: PersonnelTraining;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidatePersonnelTrainingResponse>) { (Object as any).assign(this, init); }
}

export class HasPermissionResponse
{
    public responseStatus: ResponseStatus;
    public hasPermission: boolean;

    public constructor(init?: Partial<HasPermissionResponse>) { (Object as any).assign(this, init); }
}

export class HasPermissionsResponse
{
    public responseStatus: ResponseStatus;
    public permissionResults: { [index:number]: boolean; };

    public constructor(init?: Partial<HasPermissionsResponse>) { (Object as any).assign(this, init); }
}

export class HasPermissionsAnyResponse
{
    public responseStatus: ResponseStatus;
    public hasPermission: boolean;

    public constructor(init?: Partial<HasPermissionsAnyResponse>) { (Object as any).assign(this, init); }
}

export class HasPermissionsAllResponse
{
    public responseStatus: ResponseStatus;
    public hasPermission: boolean;

    public constructor(init?: Partial<HasPermissionsAllResponse>) { (Object as any).assign(this, init); }
}

export class EvaluateAllPermissionsResponse
{
    public responseStatus: ResponseStatus;
    public permissionResults: KeyValuePair<PermissionQuery,boolean>[];

    public constructor(init?: Partial<EvaluateAllPermissionsResponse>) { (Object as any).assign(this, init); }
}

export class GetPermissionConfigurationsResponse
{
    public responseStatus: ResponseStatus;
    public permissionConfigurations: PermissionConfiguration[];

    public constructor(init?: Partial<GetPermissionConfigurationsResponse>) { (Object as any).assign(this, init); }
}

export class GetPermissionConfigurationByPermissionIdResponse
{
    public responseStatus: ResponseStatus;
    public permissionConfigurations: PermissionConfiguration[];

    public constructor(init?: Partial<GetPermissionConfigurationByPermissionIdResponse>) { (Object as any).assign(this, init); }
}

export class GetPermissionsForUserAndContextResponse
{
    public responseStatus: ResponseStatus;
    public permissions: Permission[];

    public constructor(init?: Partial<GetPermissionsForUserAndContextResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetPermissionsByUsernameResponse
{
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=2)
    public permissions: UserPermissionContext[];

    public constructor(init?: Partial<GetPermissionsByUsernameResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetUserGroupsByUsernameResponse
{
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=2)
    public userGroupPermissions: UserPermissionContext[];

    public constructor(init?: Partial<GetUserGroupsByUsernameResponse>) { (Object as any).assign(this, init); }
}

export class GetPatientsByTrialInstitutionResponse
{
    public responseStatus: ResponseStatus;
    public patients: Patient[];
    public databaseStatus: DatabaseStatus;
    public statusMessage: string;

    public constructor(init?: Partial<GetPatientsByTrialInstitutionResponse>) { (Object as any).assign(this, init); }
}

export class GetNoteByIdResponse
{
    public responseStatus: ResponseStatus;
    public note: Note;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetNoteByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetNoteResponse
{
    public responseStatus: ResponseStatus;
    public note: Note;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetNoteResponse>) { (Object as any).assign(this, init); }
}

export class CreateNoteResponse
{
    public responseStatus: ResponseStatus;
    public note: Note;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateNoteResponse>) { (Object as any).assign(this, init); }
}

export class ValidateNoteResponse
{
    public responseStatus: ResponseStatus;
    public note: Note;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateNoteResponse>) { (Object as any).assign(this, init); }
}

export class GetNoteTypeNotesByTrialIdResponse
{
    public responseStatus: ResponseStatus;
    public noteTypeNotes: NoteTypeNotes[];
    public lookups: Lookup[];

    public constructor(init?: Partial<GetNoteTypeNotesByTrialIdResponse>) { (Object as any).assign(this, init); }
}

export class GetNoteTypeNotesByTrialInstitutionIdResponse
{
    public responseStatus: ResponseStatus;
    public noteTypeNotes: NoteTypeNotes[];
    public lookups: Lookup[];

    public constructor(init?: Partial<GetNoteTypeNotesByTrialInstitutionIdResponse>) { (Object as any).assign(this, init); }
}

export class GetNoteTypeNotesByInstitutionIdResponse
{
    public responseStatus: ResponseStatus;
    public noteTypeNotes: NoteTypeNotes[];
    public lookups: Lookup[];

    public constructor(init?: Partial<GetNoteTypeNotesByInstitutionIdResponse>) { (Object as any).assign(this, init); }
}

export class GetNoteTypeNotesByPersonnelIdResponse
{
    public responseStatus: ResponseStatus;
    public noteTypeNotes: NoteTypeNotes[];
    public lookups: Lookup[];

    public constructor(init?: Partial<GetNoteTypeNotesByPersonnelIdResponse>) { (Object as any).assign(this, init); }
}

export class GetMonitorsResponse
{
    public responseStatus: ResponseStatus;
    public monitors: Monitor[];
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetMonitorsResponse>) { (Object as any).assign(this, init); }
}

export class GetMonitorsByMonitoringIdResponse
{
    public responseStatus: ResponseStatus;
    public monitors: Monitor[];
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetMonitorsByMonitoringIdResponse>) { (Object as any).assign(this, init); }
}

export class GetMonitorByIdResponse
{
    public responseStatus: ResponseStatus;
    public monitor: Monitor;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetMonitorByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetMonitorResponse
{
    public responseStatus: ResponseStatus;
    public monitor: Monitor;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetMonitorResponse>) { (Object as any).assign(this, init); }
}

export class CreateMonitorResponse
{
    public responseStatus: ResponseStatus;
    public monitor: Monitor;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateMonitorResponse>) { (Object as any).assign(this, init); }
}

export class ValidateMonitorResponse
{
    public responseStatus: ResponseStatus;
    public monitor: Monitor;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateMonitorResponse>) { (Object as any).assign(this, init); }
}

export class GetMonitoringIssuesResponse
{
    public responseStatus: ResponseStatus;
    public monitoringIssues: MonitoringIssue[];
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetMonitoringIssuesResponse>) { (Object as any).assign(this, init); }
}

export class GetMonitoringIssuesByMonitoringIdResponse
{
    public responseStatus: ResponseStatus;
    public monitoringIssues: MonitoringIssue[];
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetMonitoringIssuesByMonitoringIdResponse>) { (Object as any).assign(this, init); }
}

export class GetMonitoringIssueByIdResponse
{
    public responseStatus: ResponseStatus;
    public monitoringIssue: MonitoringIssue;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetMonitoringIssueByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetMonitoringIssueResponse
{
    public responseStatus: ResponseStatus;
    public monitoringIssue: MonitoringIssue;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetMonitoringIssueResponse>) { (Object as any).assign(this, init); }
}

export class CreateMonitoringIssueResponse
{
    public responseStatus: ResponseStatus;
    public monitoringIssue: MonitoringIssue;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateMonitoringIssueResponse>) { (Object as any).assign(this, init); }
}

export class ValidateMonitoringIssueResponse
{
    public responseStatus: ResponseStatus;
    public monitoringIssue: MonitoringIssue;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateMonitoringIssueResponse>) { (Object as any).assign(this, init); }
}

export class GetMonitoringsResponse
{
    public responseStatus: ResponseStatus;
    public monitorings: Monitoring[];
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetMonitoringsResponse>) { (Object as any).assign(this, init); }
}

export class GetMonitoringsByTrialInstitutionIdResponse
{
    public responseStatus: ResponseStatus;
    public monitorings: Monitoring[];
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetMonitoringsByTrialInstitutionIdResponse>) { (Object as any).assign(this, init); }
}

export class GetMonitoringByIdResponse
{
    public responseStatus: ResponseStatus;
    public monitoring: Monitoring;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetMonitoringByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetMonitoringResponse
{
    public responseStatus: ResponseStatus;
    public monitoring: Monitoring;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetMonitoringResponse>) { (Object as any).assign(this, init); }
}

export class CreateMonitoringResponse
{
    public responseStatus: ResponseStatus;
    public monitoring: Monitoring;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateMonitoringResponse>) { (Object as any).assign(this, init); }
}

export class ValidateMonitoringResponse
{
    public responseStatus: ResponseStatus;
    public monitoring: Monitoring;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateMonitoringResponse>) { (Object as any).assign(this, init); }
}

export class GetMonitoringIssueDocumentsResponse
{
    public responseStatus: ResponseStatus;
    public monitoringIssueDocuments: MonitoringIssueDocument[];
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetMonitoringIssueDocumentsResponse>) { (Object as any).assign(this, init); }
}

export class GetMonitoringIssueDocumentsByMonitoringIssueIdResponse
{
    public responseStatus: ResponseStatus;
    public monitoringIssueDocuments: MonitoringIssueDocument[];
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetMonitoringIssueDocumentsByMonitoringIssueIdResponse>) { (Object as any).assign(this, init); }
}

export class GetMonitoringIssueDocumentByIdResponse
{
    public responseStatus: ResponseStatus;
    public monitoringIssueDocument: MonitoringIssueDocument;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetMonitoringIssueDocumentByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetMonitoringIssueDocumentResponse
{
    public responseStatus: ResponseStatus;
    public monitoringIssueDocument: MonitoringIssueDocument;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetMonitoringIssueDocumentResponse>) { (Object as any).assign(this, init); }
}

export class CreateMonitoringIssueDocumentResponse
{
    public responseStatus: ResponseStatus;
    public monitoringIssueDocument: MonitoringIssueDocument;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateMonitoringIssueDocumentResponse>) { (Object as any).assign(this, init); }
}

export class ValidateMonitoringIssueDocumentResponse
{
    public responseStatus: ResponseStatus;
    public monitoringIssueDocument: MonitoringIssueDocument;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateMonitoringIssueDocumentResponse>) { (Object as any).assign(this, init); }
}

export class GetMonitoringDocumentsResponse
{
    public responseStatus: ResponseStatus;
    public monitoringDocuments: MonitoringDocument[];
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetMonitoringDocumentsResponse>) { (Object as any).assign(this, init); }
}

export class GetMonitoringDocumentsByMonitoringIdResponse
{
    public responseStatus: ResponseStatus;
    public monitoringDocuments: MonitoringDocument[];
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetMonitoringDocumentsByMonitoringIdResponse>) { (Object as any).assign(this, init); }
}

export class GetMonitoringDocumentByIdResponse
{
    public responseStatus: ResponseStatus;
    public monitoringDocument: MonitoringDocument;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetMonitoringDocumentByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetMonitoringDocumentResponse
{
    public responseStatus: ResponseStatus;
    public monitoringDocument: MonitoringDocument;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetMonitoringDocumentResponse>) { (Object as any).assign(this, init); }
}

export class CreateMonitoringDocumentResponse
{
    public responseStatus: ResponseStatus;
    public monitoringDocument: MonitoringDocument;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateMonitoringDocumentResponse>) { (Object as any).assign(this, init); }
}

export class ValidateMonitoringDocumentResponse
{
    public responseStatus: ResponseStatus;
    public monitoringDocument: MonitoringDocument;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateMonitoringDocumentResponse>) { (Object as any).assign(this, init); }
}

export class GetCategoriesResponse
{
    public responseStatus: ResponseStatus;
    public categories: Category[];

    public constructor(init?: Partial<GetCategoriesResponse>) { (Object as any).assign(this, init); }
}

export class GetCategoryByIdResponse
{
    public responseStatus: ResponseStatus;
    public category: Category;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetCategoryByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetCategoryResponse
{
    public responseStatus: ResponseStatus;
    public category: Category;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetCategoryResponse>) { (Object as any).assign(this, init); }
}

export class CreateCategoryResponse
{
    public responseStatus: ResponseStatus;
    public category: Category;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateCategoryResponse>) { (Object as any).assign(this, init); }
}

export class ValidateCategoryResponse
{
    public responseStatus: ResponseStatus;
    public category: Category;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateCategoryResponse>) { (Object as any).assign(this, init); }
}

export class GetCountriesResponse
{
    public responseStatus: ResponseStatus;
    public countries: Country[];

    public constructor(init?: Partial<GetCountriesResponse>) { (Object as any).assign(this, init); }
}

export class GetCountryByIdResponse
{
    public responseStatus: ResponseStatus;
    public country: Country;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetCountryByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetCountryResponse
{
    public responseStatus: ResponseStatus;
    public country: Country;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetCountryResponse>) { (Object as any).assign(this, init); }
}

export class CreateCountryResponse
{
    public responseStatus: ResponseStatus;
    public country: Country;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateCountryResponse>) { (Object as any).assign(this, init); }
}

export class ValidateCountryResponse
{
    public responseStatus: ResponseStatus;
    public country: Country;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateCountryResponse>) { (Object as any).assign(this, init); }
}

export class GetInstitutionCodingsResponse
{
    public responseStatus: ResponseStatus;
    public institutionCodings: InstitutionCoding[];

    public constructor(init?: Partial<GetInstitutionCodingsResponse>) { (Object as any).assign(this, init); }
}

export class GetInstitutionCodingByIdResponse
{
    public responseStatus: ResponseStatus;
    public institutionCoding: InstitutionCoding;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetInstitutionCodingByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetInstitutionCodingResponse
{
    public responseStatus: ResponseStatus;
    public institutionCoding: InstitutionCoding;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetInstitutionCodingResponse>) { (Object as any).assign(this, init); }
}

export class CreateInstitutionCodingResponse
{
    public responseStatus: ResponseStatus;
    public institutionCoding: InstitutionCoding;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateInstitutionCodingResponse>) { (Object as any).assign(this, init); }
}

export class ValidateInstitutionCodingResponse
{
    public responseStatus: ResponseStatus;
    public institutionCoding: InstitutionCoding;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateInstitutionCodingResponse>) { (Object as any).assign(this, init); }
}

export class GetItemComponentTypesResponse
{
    public responseStatus: ResponseStatus;
    public itemComponentTypes: ItemComponentType[];

    public constructor(init?: Partial<GetItemComponentTypesResponse>) { (Object as any).assign(this, init); }
}

export class GetItemComponentTypeByIdResponse
{
    public responseStatus: ResponseStatus;
    public itemComponentType: ItemComponentType;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetItemComponentTypeByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetItemComponentTypeResponse
{
    public responseStatus: ResponseStatus;
    public itemComponentType: ItemComponentType;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetItemComponentTypeResponse>) { (Object as any).assign(this, init); }
}

export class CreateItemComponentTypeResponse
{
    public responseStatus: ResponseStatus;
    public itemComponentType: ItemComponentType;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateItemComponentTypeResponse>) { (Object as any).assign(this, init); }
}

export class ValidateItemComponentTypeResponse
{
    public responseStatus: ResponseStatus;
    public itemComponentType: ItemComponentType;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateItemComponentTypeResponse>) { (Object as any).assign(this, init); }
}

export class GetNoteTypesResponse
{
    public responseStatus: ResponseStatus;
    public noteTypes: NoteType[];

    public constructor(init?: Partial<GetNoteTypesResponse>) { (Object as any).assign(this, init); }
}

export class GetNoteTypeByIdResponse
{
    public responseStatus: ResponseStatus;
    public noteType: NoteType;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetNoteTypeByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetNoteTypeResponse
{
    public responseStatus: ResponseStatus;
    public noteType: NoteType;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetNoteTypeResponse>) { (Object as any).assign(this, init); }
}

export class CreateNoteTypeResponse
{
    public responseStatus: ResponseStatus;
    public noteType: NoteType;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateNoteTypeResponse>) { (Object as any).assign(this, init); }
}

export class ValidateNoteTypeResponse
{
    public responseStatus: ResponseStatus;
    public noteType: NoteType;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateNoteTypeResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialTypesResponse
{
    public responseStatus: ResponseStatus;
    public trialTypes: TrialType[];

    public constructor(init?: Partial<GetTrialTypesResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialTypeByIdResponse
{
    public responseStatus: ResponseStatus;
    public trialType: TrialType;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetTrialTypeByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetTrialTypeResponse
{
    public responseStatus: ResponseStatus;
    public trialType: TrialType;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetTrialTypeResponse>) { (Object as any).assign(this, init); }
}

export class CreateTrialTypeResponse
{
    public responseStatus: ResponseStatus;
    public trialType: TrialType;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateTrialTypeResponse>) { (Object as any).assign(this, init); }
}

export class ValidateTrialTypeResponse
{
    public responseStatus: ResponseStatus;
    public trialType: TrialType;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateTrialTypeResponse>) { (Object as any).assign(this, init); }
}

export class GetLaboratoryConfidentialityDeedByLaboratoryIdResponse
{
    public responseStatus: ResponseStatus;
    public laboratoryConfidentialityDeed: LaboratoryConfidentialityDeed;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetLaboratoryConfidentialityDeedByLaboratoryIdResponse>) { (Object as any).assign(this, init); }
}

export class GetLaboratoryConfidentialityDeedByIdResponse
{
    public responseStatus: ResponseStatus;
    public laboratoryConfidentialityDeed: LaboratoryConfidentialityDeed;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetLaboratoryConfidentialityDeedByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetLaboratoryConfidentialityDeedResponse
{
    public responseStatus: ResponseStatus;
    public laboratoryConfidentialityDeed: LaboratoryConfidentialityDeed;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetLaboratoryConfidentialityDeedResponse>) { (Object as any).assign(this, init); }
}

export class CreateLaboratoryConfidentialityDeedResponse
{
    public responseStatus: ResponseStatus;
    public laboratoryConfidentialityDeed: LaboratoryConfidentialityDeed;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateLaboratoryConfidentialityDeedResponse>) { (Object as any).assign(this, init); }
}

export class ValidateLaboratoryConfidentialityDeedResponse
{
    public responseStatus: ResponseStatus;
    public laboratoryConfidentialityDeed: LaboratoryConfidentialityDeed;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateLaboratoryConfidentialityDeedResponse>) { (Object as any).assign(this, init); }
}

export class DeleteLaboratoryConfidentialityDeedResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteLaboratoryConfidentialityDeedResponse>) { (Object as any).assign(this, init); }
}

export class GetLaboratoryContractByLaboratoryIdResponse
{
    public responseStatus: ResponseStatus;
    public laboratoryContract: LaboratoryContract;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetLaboratoryContractByLaboratoryIdResponse>) { (Object as any).assign(this, init); }
}

export class GetLaboratoryContractByIdResponse
{
    public responseStatus: ResponseStatus;
    public laboratoryContract: LaboratoryContract;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetLaboratoryContractByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetLaboratoryContractResponse
{
    public responseStatus: ResponseStatus;
    public laboratoryContract: LaboratoryContract;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetLaboratoryContractResponse>) { (Object as any).assign(this, init); }
}

export class CreateLaboratoryContractResponse
{
    public responseStatus: ResponseStatus;
    public laboratoryContract: LaboratoryContract;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateLaboratoryContractResponse>) { (Object as any).assign(this, init); }
}

export class ValidateLaboratoryContractResponse
{
    public responseStatus: ResponseStatus;
    public laboratoryContract: LaboratoryContract;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateLaboratoryContractResponse>) { (Object as any).assign(this, init); }
}

export class GetLaboratoryDepartmentsResponse
{
    public responseStatus: ResponseStatus;
    public laboratoryDepartments: LaboratoryDepartment[];
    public lookups: Lookup[];

    public constructor(init?: Partial<GetLaboratoryDepartmentsResponse>) { (Object as any).assign(this, init); }
}

export class GetLaboratoryDepartmentByIdResponse
{
    public responseStatus: ResponseStatus;
    public laboratoryDepartment: LaboratoryDepartment;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetLaboratoryDepartmentByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetLaboratoryDepartmentsByLaboratoryIdResponse
{
    public responseStatus: ResponseStatus;
    public laboratoryDepartments: LaboratoryDepartment[];
    public lookups: Lookup[];

    public constructor(init?: Partial<GetLaboratoryDepartmentsByLaboratoryIdResponse>) { (Object as any).assign(this, init); }
}

export class SetLaboratoryDepartmentResponse
{
    public responseStatus: ResponseStatus;
    public laboratoryDepartment: LaboratoryDepartment;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetLaboratoryDepartmentResponse>) { (Object as any).assign(this, init); }
}

export class CreateLaboratoryDepartmentResponse
{
    public responseStatus: ResponseStatus;
    public laboratoryDepartment: LaboratoryDepartment;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateLaboratoryDepartmentResponse>) { (Object as any).assign(this, init); }
}

export class DeleteLaboratoryDepartmentResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteLaboratoryDepartmentResponse>) { (Object as any).assign(this, init); }
}

export class ValidateLaboratoryDepartmentResponse
{
    public responseStatus: ResponseStatus;
    public laboratoryDepartment: LaboratoryDepartment;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateLaboratoryDepartmentResponse>) { (Object as any).assign(this, init); }
}

export class GetLaboratoryFinanceByLaboratoryIdResponse
{
    public responseStatus: ResponseStatus;
    public laboratoryFinance: LaboratoryFinance;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetLaboratoryFinanceByLaboratoryIdResponse>) { (Object as any).assign(this, init); }
}

export class GetLaboratoryFinanceByIdResponse
{
    public responseStatus: ResponseStatus;
    public laboratoryFinance: LaboratoryFinance;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetLaboratoryFinanceByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetLaboratoryFinanceResponse
{
    public responseStatus: ResponseStatus;
    public laboratoryFinance: LaboratoryFinance;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetLaboratoryFinanceResponse>) { (Object as any).assign(this, init); }
}

export class CreateLaboratoryFinanceResponse
{
    public responseStatus: ResponseStatus;
    public laboratoryFinance: LaboratoryFinance;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateLaboratoryFinanceResponse>) { (Object as any).assign(this, init); }
}

export class ValidateLaboratoryFinanceResponse
{
    public responseStatus: ResponseStatus;
    public laboratoryFinance: LaboratoryFinance;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateLaboratoryFinanceResponse>) { (Object as any).assign(this, init); }
}

export class GetLaboratoryPersonnelsResponse
{
    public responseStatus: ResponseStatus;
    public laboratoryPersonnels: LaboratoryPersonnel[];
    public lookups: Lookup[];

    public constructor(init?: Partial<GetLaboratoryPersonnelsResponse>) { (Object as any).assign(this, init); }
}

export class GetLaboratoryPersonnelByIdResponse
{
    public responseStatus: ResponseStatus;
    public laboratoryPersonnel: LaboratoryPersonnel;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetLaboratoryPersonnelByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetLaboratoryPersonnelByLaboratoryIdResponse
{
    public responseStatus: ResponseStatus;
    public laboratoryPersonnel: LaboratoryPersonnel[];
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetLaboratoryPersonnelByLaboratoryIdResponse>) { (Object as any).assign(this, init); }
}

export class SetLaboratoryPersonnelResponse
{
    public responseStatus: ResponseStatus;
    public laboratoryPersonnel: LaboratoryPersonnel;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetLaboratoryPersonnelResponse>) { (Object as any).assign(this, init); }
}

export class CreateLaboratoryPersonnelResponse
{
    public responseStatus: ResponseStatus;
    public laboratoryPersonnel: LaboratoryPersonnel;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateLaboratoryPersonnelResponse>) { (Object as any).assign(this, init); }
}

export class ValidateLaboratoryPersonnelResponse
{
    public responseStatus: ResponseStatus;
    public laboratoryPersonnel: LaboratoryPersonnel;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateLaboratoryPersonnelResponse>) { (Object as any).assign(this, init); }
}

export class GetLaboratoriesResponse
{
    public responseStatus: ResponseStatus;
    public laboratories: Laboratory[];
    public lookups: Lookup[];

    public constructor(init?: Partial<GetLaboratoriesResponse>) { (Object as any).assign(this, init); }
}

export class GetLaboratoryByIdResponse
{
    public responseStatus: ResponseStatus;
    public laboratory: Laboratory;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetLaboratoryByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetLaboratoryResponse
{
    public responseStatus: ResponseStatus;
    public laboratory: Laboratory;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetLaboratoryResponse>) { (Object as any).assign(this, init); }
}

export class CreateLaboratoryResponse
{
    public responseStatus: ResponseStatus;
    public laboratory: Laboratory;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateLaboratoryResponse>) { (Object as any).assign(this, init); }
}

export class ValidateLaboratoryResponse
{
    public responseStatus: ResponseStatus;
    public laboratory: Laboratory;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateLaboratoryResponse>) { (Object as any).assign(this, init); }
}

export class GetItemComponentsResponse
{
    public responseStatus: ResponseStatus;
    public itemComponents: ItemComponent[];
    public lookups: Lookup[];

    public constructor(init?: Partial<GetItemComponentsResponse>) { (Object as any).assign(this, init); }
}

export class GetItemComponentByIdResponse
{
    public responseStatus: ResponseStatus;
    public itemComponent: ItemComponent;
    public registrationFormState: RegistrationFormState;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];
    public registrationFormProperties: RegistrationFormProperty[];

    public constructor(init?: Partial<GetItemComponentByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetItemComponentResponse
{
    public responseStatus: ResponseStatus;
    public itemComponent: ItemComponent;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetItemComponentResponse>) { (Object as any).assign(this, init); }
}

export class CreateItemComponentResponse
{
    public responseStatus: ResponseStatus;
    public itemComponent: ItemComponent;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateItemComponentResponse>) { (Object as any).assign(this, init); }
}

export class GetDepartmentContactsResponse
{
    public responseStatus: ResponseStatus;
    public departmentContacts: DepartmentContact[];
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetDepartmentContactsResponse>) { (Object as any).assign(this, init); }
}

export class GetDepartmentContactByIdResponse
{
    public responseStatus: ResponseStatus;
    public departmentContact: DepartmentContact;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetDepartmentContactByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetDepartmentContactResponse
{
    public responseStatus: ResponseStatus;
    public departmentContact: DepartmentContact;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetDepartmentContactResponse>) { (Object as any).assign(this, init); }
}

export class CreateDepartmentContactResponse
{
    public responseStatus: ResponseStatus;
    public departmentContact: DepartmentContact;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateDepartmentContactResponse>) { (Object as any).assign(this, init); }
}

export class GetDepartmentsResponse
{
    public responseStatus: ResponseStatus;
    public departments: Department[];
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetDepartmentsResponse>) { (Object as any).assign(this, init); }
}

export class GetDepartmentByIdResponse
{
    public responseStatus: ResponseStatus;
    public department: Department;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetDepartmentByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetDepartmentResponse
{
    public responseStatus: ResponseStatus;
    public department: Department;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetDepartmentResponse>) { (Object as any).assign(this, init); }
}

export class CreateDepartmentResponse
{
    public responseStatus: ResponseStatus;
    public department: Department;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateDepartmentResponse>) { (Object as any).assign(this, init); }
}

export class GetInstitutionCodesResponse
{
    public responseStatus: ResponseStatus;
    public institutionCodes: InstitutionCode[];

    public constructor(init?: Partial<GetInstitutionCodesResponse>) { (Object as any).assign(this, init); }
}

export class GetInstitutionCodesByInstitutionIdResponse
{
    public responseStatus: ResponseStatus;
    public institutionCodes: InstitutionCode[];
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetInstitutionCodesByInstitutionIdResponse>) { (Object as any).assign(this, init); }
}

export class GetInstitutionCodeByIdResponse
{
    public responseStatus: ResponseStatus;
    public institutionCode: InstitutionCode;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetInstitutionCodeByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetInstitutionCodeResponse
{
    public responseStatus: ResponseStatus;
    public institutionCode: InstitutionCode;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetInstitutionCodeResponse>) { (Object as any).assign(this, init); }
}

export class CreateInstitutionCodeResponse
{
    public responseStatus: ResponseStatus;
    public institutionCode: InstitutionCode;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateInstitutionCodeResponse>) { (Object as any).assign(this, init); }
}

export class ValidateInstitutionCodeResponse
{
    public responseStatus: ResponseStatus;
    public institutionCode: InstitutionCode;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateInstitutionCodeResponse>) { (Object as any).assign(this, init); }
}

export class GetInstitutionConfidentialityDeedByInstitutionIdResponse
{
    public responseStatus: ResponseStatus;
    public institutionConfidentialityDeed: InstitutionConfidentialityDeed;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetInstitutionConfidentialityDeedByInstitutionIdResponse>) { (Object as any).assign(this, init); }
}

export class GetInstitutionConfidentialityDeedByIdResponse
{
    public responseStatus: ResponseStatus;
    public institutionConfidentialityDeed: InstitutionConfidentialityDeed;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetInstitutionConfidentialityDeedByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetInstitutionConfidentialityDeedResponse
{
    public responseStatus: ResponseStatus;
    public institutionConfidentialityDeed: InstitutionConfidentialityDeed;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetInstitutionConfidentialityDeedResponse>) { (Object as any).assign(this, init); }
}

export class CreateInstitutionConfidentialityDeedResponse
{
    public responseStatus: ResponseStatus;
    public institutionConfidentialityDeed: InstitutionConfidentialityDeed;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateInstitutionConfidentialityDeedResponse>) { (Object as any).assign(this, init); }
}

export class ValidateInstitutionConfidentialityDeedResponse
{
    public responseStatus: ResponseStatus;
    public institutionConfidentialityDeed: InstitutionConfidentialityDeed;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateInstitutionConfidentialityDeedResponse>) { (Object as any).assign(this, init); }
}

export class DeleteInstitutionConfidentialityDeedResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteInstitutionConfidentialityDeedResponse>) { (Object as any).assign(this, init); }
}

export class GetInstitutionContractByInstitutionIdResponse
{
    public responseStatus: ResponseStatus;
    public institutionContract: InstitutionContract;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetInstitutionContractByInstitutionIdResponse>) { (Object as any).assign(this, init); }
}

export class GetInstitutionContractByIdResponse
{
    public responseStatus: ResponseStatus;
    public institutionContract: InstitutionContract;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetInstitutionContractByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetInstitutionContractResponse
{
    public responseStatus: ResponseStatus;
    public institutionContract: InstitutionContract;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetInstitutionContractResponse>) { (Object as any).assign(this, init); }
}

export class CreateInstitutionContractResponse
{
    public responseStatus: ResponseStatus;
    public institutionContract: InstitutionContract;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateInstitutionContractResponse>) { (Object as any).assign(this, init); }
}

export class ValidateInstitutionContractResponse
{
    public responseStatus: ResponseStatus;
    public institutionContract: InstitutionContract;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateInstitutionContractResponse>) { (Object as any).assign(this, init); }
}

export class GetInstitutionFinanceByInstitutionIdResponse
{
    public responseStatus: ResponseStatus;
    public institutionFinance: InstitutionFinance;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetInstitutionFinanceByInstitutionIdResponse>) { (Object as any).assign(this, init); }
}

export class GetInstitutionFinanceByIdResponse
{
    public responseStatus: ResponseStatus;
    public institutionFinance: InstitutionFinance;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetInstitutionFinanceByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetInstitutionFinanceResponse
{
    public responseStatus: ResponseStatus;
    public institutionFinance: InstitutionFinance;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetInstitutionFinanceResponse>) { (Object as any).assign(this, init); }
}

export class CreateInstitutionFinanceResponse
{
    public responseStatus: ResponseStatus;
    public institutionFinance: InstitutionFinance;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateInstitutionFinanceResponse>) { (Object as any).assign(this, init); }
}

export class ValidateInstitutionFinanceResponse
{
    public responseStatus: ResponseStatus;
    public institutionFinance: InstitutionFinance;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateInstitutionFinanceResponse>) { (Object as any).assign(this, init); }
}

export class GetInstitutionItemCategoriesByInstitutionIdResponse
{
    public responseStatus: ResponseStatus;
    public institutionItemCategories: InstitutionItemCategory[];
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetInstitutionItemCategoriesByInstitutionIdResponse>) { (Object as any).assign(this, init); }
}

export class GetInstitutionItemTemplateCategoriesResponse
{
    public responseStatus: ResponseStatus;
    public institutionItemTemplateCategories: InstitutionItemTemplateCategory[];

    public constructor(init?: Partial<GetInstitutionItemTemplateCategoriesResponse>) { (Object as any).assign(this, init); }
}

export class GetInstitutionItemTemplateCategoryByIdResponse
{
    public responseStatus: ResponseStatus;
    public institutionItemTemplateCategory: InstitutionItemTemplateCategory;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetInstitutionItemTemplateCategoryByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetInstitutionItemTemplateCategoryResponse
{
    public responseStatus: ResponseStatus;
    public institutionItemTemplateCategory: InstitutionItemTemplateCategory;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetInstitutionItemTemplateCategoryResponse>) { (Object as any).assign(this, init); }
}

export class CreateInstitutionItemTemplateCategoryResponse
{
    public responseStatus: ResponseStatus;
    public institutionItemTemplateCategory: InstitutionItemTemplateCategory;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateInstitutionItemTemplateCategoryResponse>) { (Object as any).assign(this, init); }
}

export class ValidateInstitutionItemTemplateCategoryResponse
{
    public responseStatus: ResponseStatus;
    public institutionItemTemplateCategory: InstitutionItemTemplateCategory;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateInstitutionItemTemplateCategoryResponse>) { (Object as any).assign(this, init); }
}

export class GetInstitutionItemTemplatesResponse
{
    public responseStatus: ResponseStatus;
    public institutionItemTemplates: InstitutionItemTemplate[];
    public institutionItemsByCategory: InstitutionItemTemplateCategory[];
    public lookups: Lookup[];

    public constructor(init?: Partial<GetInstitutionItemTemplatesResponse>) { (Object as any).assign(this, init); }
}

export class GetInstitutionItemTemplateByIdResponse
{
    public responseStatus: ResponseStatus;
    public institutionItemTemplate: InstitutionItemTemplate;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetInstitutionItemTemplateByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetInstitutionItemTemplateResponse
{
    public responseStatus: ResponseStatus;
    public institutionItemTemplate: InstitutionItemTemplate;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetInstitutionItemTemplateResponse>) { (Object as any).assign(this, init); }
}

export class CreateInstitutionItemTemplateResponse
{
    public responseStatus: ResponseStatus;
    public institutionItemTemplate: InstitutionItemTemplate;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateInstitutionItemTemplateResponse>) { (Object as any).assign(this, init); }
}

export class ValidateInstitutionItemTemplateResponse
{
    public responseStatus: ResponseStatus;
    public institutionItemTemplate: InstitutionItemTemplate;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateInstitutionItemTemplateResponse>) { (Object as any).assign(this, init); }
}

export class GetInstitutionLaboratoriesResponse
{
    public responseStatus: ResponseStatus;
    public institutionLaboratories: InstitutionLaboratory[];
    public lookups: Lookup[];

    public constructor(init?: Partial<GetInstitutionLaboratoriesResponse>) { (Object as any).assign(this, init); }
}

export class GetInstitutionLaboratoryByIdResponse
{
    public responseStatus: ResponseStatus;
    public institutionLaboratory: InstitutionLaboratory;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetInstitutionLaboratoryByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetInstitutionLaboratoryByLaboratoryIdResponse
{
    public responseStatus: ResponseStatus;
    public institutionLaboratory: InstitutionLaboratory[];
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetInstitutionLaboratoryByLaboratoryIdResponse>) { (Object as any).assign(this, init); }
}

export class GetInstitutionLaboratoryByInstitutionIdResponse
{
    public responseStatus: ResponseStatus;
    public institutionLaboratory: InstitutionLaboratory[];
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetInstitutionLaboratoryByInstitutionIdResponse>) { (Object as any).assign(this, init); }
}

export class SetInstitutionLaboratoryResponse
{
    public responseStatus: ResponseStatus;
    public institutionLaboratory: InstitutionLaboratory;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetInstitutionLaboratoryResponse>) { (Object as any).assign(this, init); }
}

export class CreateInstitutionLaboratoryResponse
{
    public responseStatus: ResponseStatus;
    public institutionLaboratory: InstitutionLaboratory;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateInstitutionLaboratoryResponse>) { (Object as any).assign(this, init); }
}

export class DeleteInstitutionLaboratoryResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteInstitutionLaboratoryResponse>) { (Object as any).assign(this, init); }
}

export class ValidateInstitutionLaboratoryResponse
{
    public responseStatus: ResponseStatus;
    public institutionLaboratory: InstitutionLaboratory;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateInstitutionLaboratoryResponse>) { (Object as any).assign(this, init); }
}

export class GetInstitutionProceduresByInstitutionIdResponse
{
    public responseStatus: ResponseStatus;
    public institutionProcedures: InstitutionProcedure[];

    public constructor(init?: Partial<GetInstitutionProceduresByInstitutionIdResponse>) { (Object as any).assign(this, init); }
}

export class GetInstitutionProcedureByIdResponse
{
    public responseStatus: ResponseStatus;
    public institutionProcedure: InstitutionProcedure;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetInstitutionProcedureByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetInstitutionProcedureResponse
{
    public responseStatus: ResponseStatus;
    public institutionProcedure: InstitutionProcedure;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetInstitutionProcedureResponse>) { (Object as any).assign(this, init); }
}

export class CreateInstitutionProcedureResponse
{
    public responseStatus: ResponseStatus;
    public institutionProcedure: InstitutionProcedure;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateInstitutionProcedureResponse>) { (Object as any).assign(this, init); }
}

export class ValidateInstitutionProcedureResponse
{
    public responseStatus: ResponseStatus;
    public institutionProcedure: InstitutionProcedure;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateInstitutionProcedureResponse>) { (Object as any).assign(this, init); }
}

export class GetInstitutionsResponse
{
    public responseStatus: ResponseStatus;
    public institutions: Institution[];
    public lookups: Lookup[];

    public constructor(init?: Partial<GetInstitutionsResponse>) { (Object as any).assign(this, init); }
}

export class GetInstitutionByIdResponse
{
    public responseStatus: ResponseStatus;
    public institution: Institution;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetInstitutionByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetInstitutionResponse
{
    public responseStatus: ResponseStatus;
    public institution: Institution;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetInstitutionResponse>) { (Object as any).assign(this, init); }
}

export class CreateInstitutionResponse
{
    public responseStatus: ResponseStatus;
    public institution: Institution;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateInstitutionResponse>) { (Object as any).assign(this, init); }
}

export class ValidateInstitutionResponse
{
    public responseStatus: ResponseStatus;
    public institution: Institution;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateInstitutionResponse>) { (Object as any).assign(this, init); }
}

export class GetBrokenInstitutionUrlsResponse
{
    public responseStatus: ResponseStatus;
    public brokenUrls: InstitutionUrl[];

    public constructor(init?: Partial<GetBrokenInstitutionUrlsResponse>) { (Object as any).assign(this, init); }
}

export class GetHealthDistrictsResponse
{
    public responseStatus: ResponseStatus;
    public healthDistricts: HealthDistrict[];
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetHealthDistrictsResponse>) { (Object as any).assign(this, init); }
}

export class GetHealthDistrictByIdResponse
{
    public responseStatus: ResponseStatus;
    public healthDistrict: HealthDistrict;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetHealthDistrictByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetHealthDistrictResponse
{
    public responseStatus: ResponseStatus;
    public healthDistrict: HealthDistrict;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetHealthDistrictResponse>) { (Object as any).assign(this, init); }
}

export class CreateHealthDistrictResponse
{
    public responseStatus: ResponseStatus;
    public healthDistrict: HealthDistrict;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateHealthDistrictResponse>) { (Object as any).assign(this, init); }
}

export class ValidateHealthDistrictResponse
{
    public responseStatus: ResponseStatus;
    public healthDistrict: HealthDistrict;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateHealthDistrictResponse>) { (Object as any).assign(this, init); }
}

export class GetGroupConfidentialityDeedByGroupIdResponse
{
    public responseStatus: ResponseStatus;
    public groupConfidentialityDeed: GroupConfidentialityDeed;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetGroupConfidentialityDeedByGroupIdResponse>) { (Object as any).assign(this, init); }
}

export class GetGroupConfidentialityDeedByIdResponse
{
    public responseStatus: ResponseStatus;
    public groupConfidentialityDeed: GroupConfidentialityDeed;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetGroupConfidentialityDeedByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetGroupConfidentialityDeedResponse
{
    public responseStatus: ResponseStatus;
    public groupConfidentialityDeed: GroupConfidentialityDeed;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetGroupConfidentialityDeedResponse>) { (Object as any).assign(this, init); }
}

export class CreateGroupConfidentialityDeedResponse
{
    public responseStatus: ResponseStatus;
    public groupConfidentialityDeed: GroupConfidentialityDeed;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateGroupConfidentialityDeedResponse>) { (Object as any).assign(this, init); }
}

export class ValidateGroupConfidentialityDeedResponse
{
    public responseStatus: ResponseStatus;
    public groupConfidentialityDeed: GroupConfidentialityDeed;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateGroupConfidentialityDeedResponse>) { (Object as any).assign(this, init); }
}

export class DeleteGroupConfidentialityDeedResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteGroupConfidentialityDeedResponse>) { (Object as any).assign(this, init); }
}

export class GetGroupContractByGroupIdResponse
{
    public responseStatus: ResponseStatus;
    public groupContract: GroupContract;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetGroupContractByGroupIdResponse>) { (Object as any).assign(this, init); }
}

export class GetGroupContractByIdResponse
{
    public responseStatus: ResponseStatus;
    public groupContract: GroupContract;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetGroupContractByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetGroupContractResponse
{
    public responseStatus: ResponseStatus;
    public groupContract: GroupContract;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetGroupContractResponse>) { (Object as any).assign(this, init); }
}

export class CreateGroupContractResponse
{
    public responseStatus: ResponseStatus;
    public groupContract: GroupContract;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateGroupContractResponse>) { (Object as any).assign(this, init); }
}

export class ValidateGroupContractResponse
{
    public responseStatus: ResponseStatus;
    public groupContract: GroupContract;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateGroupContractResponse>) { (Object as any).assign(this, init); }
}

export class GetGroupFinanceByGroupIdResponse
{
    public responseStatus: ResponseStatus;
    public groupFinance: GroupFinance;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetGroupFinanceByGroupIdResponse>) { (Object as any).assign(this, init); }
}

export class GetGroupFinanceByIdResponse
{
    public responseStatus: ResponseStatus;
    public groupFinance: GroupFinance;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetGroupFinanceByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetGroupFinanceResponse
{
    public responseStatus: ResponseStatus;
    public groupFinance: GroupFinance;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetGroupFinanceResponse>) { (Object as any).assign(this, init); }
}

export class CreateGroupFinanceResponse
{
    public responseStatus: ResponseStatus;
    public groupFinance: GroupFinance;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateGroupFinanceResponse>) { (Object as any).assign(this, init); }
}

export class ValidateGroupFinanceResponse
{
    public responseStatus: ResponseStatus;
    public groupFinance: GroupFinance;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateGroupFinanceResponse>) { (Object as any).assign(this, init); }
}

export class GetGroupItemCategoriesByGroupIdResponse
{
    public responseStatus: ResponseStatus;
    public groupItemCategories: GroupItemCategory[];
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetGroupItemCategoriesByGroupIdResponse>) { (Object as any).assign(this, init); }
}

export class GetGroupItemImportByIdResponse
{
    public responseStatus: ResponseStatus;
    public groupItemImport: GroupItemImport;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetGroupItemImportByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetGroupItemImportResponse
{
    public responseStatus: ResponseStatus;
    public groupItemImport: GroupItemImport;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetGroupItemImportResponse>) { (Object as any).assign(this, init); }
}

export class GetGroupItemByIdResponse
{
    public responseStatus: ResponseStatus;
    public groupItem: GroupItem;

    public constructor(init?: Partial<GetGroupItemByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetGroupItemsByGroupIdResponse
{
    public responseStatus: ResponseStatus;
    public groupItems: GroupItem[];
    public groupItemCategories: GroupItemCategory[];

    public constructor(init?: Partial<GetGroupItemsByGroupIdResponse>) { (Object as any).assign(this, init); }
}

export class SetGroupItemResponse
{
    public responseStatus: ResponseStatus;
    public groupItem: GroupItem;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetGroupItemResponse>) { (Object as any).assign(this, init); }
}

export class CreateGroupItemResponse
{
    public responseStatus: ResponseStatus;
    public groupItem: GroupItem;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateGroupItemResponse>) { (Object as any).assign(this, init); }
}

export class GetGroupsResponse
{
    public responseStatus: ResponseStatus;
    public groups: Group[];
    public lookups: Lookup[];

    public constructor(init?: Partial<GetGroupsResponse>) { (Object as any).assign(this, init); }
}

export class GetGroupByIdResponse
{
    public responseStatus: ResponseStatus;
    public group: Group;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetGroupByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetGroupResponse
{
    public responseStatus: ResponseStatus;
    public group: Group;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetGroupResponse>) { (Object as any).assign(this, init); }
}

export class CreateGroupResponse
{
    public responseStatus: ResponseStatus;
    public group: Group;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateGroupResponse>) { (Object as any).assign(this, init); }
}

export class ValidateGroupResponse
{
    public responseStatus: ResponseStatus;
    public group: Group;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateGroupResponse>) { (Object as any).assign(this, init); }
}

export class UploadTempFileResponse
{
    public responseStatus: ResponseStatus;
    public guid: string;

    public constructor(init?: Partial<UploadTempFileResponse>) { (Object as any).assign(this, init); }
}

export class GetTempFileInfoResponse
{
    public responseStatus: ResponseStatus;
    public temporaryFile: TemporaryFile;

    public constructor(init?: Partial<GetTempFileInfoResponse>) { (Object as any).assign(this, init); }
}

export class GetFellowshipsResponse
{
    public responseStatus: ResponseStatus;
    public fellowships: Fellowship[];
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetFellowshipsResponse>) { (Object as any).assign(this, init); }
}

export class GetFellowshipByIdResponse
{
    public responseStatus: ResponseStatus;
    public fellowship: Fellowship;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetFellowshipByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetFellowshipsByPersonnelIdResponse
{
    public responseStatus: ResponseStatus;
    public fellowships: Fellowship[];

    public constructor(init?: Partial<GetFellowshipsByPersonnelIdResponse>) { (Object as any).assign(this, init); }
}

export class SetFellowshipResponse
{
    public responseStatus: ResponseStatus;
    public fellowship: Fellowship;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetFellowshipResponse>) { (Object as any).assign(this, init); }
}

export class CreateFellowshipResponse
{
    public responseStatus: ResponseStatus;
    public fellowship: Fellowship;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateFellowshipResponse>) { (Object as any).assign(this, init); }
}

export class ValidateFellowshipResponse
{
    public responseStatus: ResponseStatus;
    public fellowship: Fellowship;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateFellowshipResponse>) { (Object as any).assign(this, init); }
}

export class GetCommitteeMeetingAttendancesResponse
{
    public responseStatus: ResponseStatus;
    public committeeMeetingAttendances: CommitteeMeetingAttendance[];
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetCommitteeMeetingAttendancesResponse>) { (Object as any).assign(this, init); }
}

export class GetCommitteeMeetingAttendanceByIdResponse
{
    public responseStatus: ResponseStatus;
    public committeeMeetingAttendance: CommitteeMeetingAttendance;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetCommitteeMeetingAttendanceByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetCommitteeMeetingAttendanceByCommitteeMeetingIdResponse
{
    public responseStatus: ResponseStatus;
    public committeeMeetingAttendance: CommitteeMeetingAttendance[];
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetCommitteeMeetingAttendanceByCommitteeMeetingIdResponse>) { (Object as any).assign(this, init); }
}

export class SetCommitteeMeetingAttendanceResponse
{
    public responseStatus: ResponseStatus;
    public committeeMeetingAttendance: CommitteeMeetingAttendance;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetCommitteeMeetingAttendanceResponse>) { (Object as any).assign(this, init); }
}

export class CreateCommitteeMeetingAttendanceResponse
{
    public responseStatus: ResponseStatus;
    public committeeMeetingAttendance: CommitteeMeetingAttendance;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateCommitteeMeetingAttendanceResponse>) { (Object as any).assign(this, init); }
}

export class ValidateCommitteeMeetingAttendanceResponse
{
    public responseStatus: ResponseStatus;
    public committeeMeetingAttendance: CommitteeMeetingAttendance;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateCommitteeMeetingAttendanceResponse>) { (Object as any).assign(this, init); }
}

export class GetCommitteeMeetingsResponse
{
    public responseStatus: ResponseStatus;
    public committeeMeetings: CommitteeMeeting[];
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetCommitteeMeetingsResponse>) { (Object as any).assign(this, init); }
}

export class GetCommitteeMeetingByIdResponse
{
    public responseStatus: ResponseStatus;
    public committeeMeeting: CommitteeMeeting;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetCommitteeMeetingByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetCommitteeMeetingByCommitteeIdResponse
{
    public responseStatus: ResponseStatus;
    public committeeMeeting: CommitteeMeeting[];
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetCommitteeMeetingByCommitteeIdResponse>) { (Object as any).assign(this, init); }
}

export class SetCommitteeMeetingResponse
{
    public responseStatus: ResponseStatus;
    public committeeMeeting: CommitteeMeeting;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetCommitteeMeetingResponse>) { (Object as any).assign(this, init); }
}

export class CreateCommitteeMeetingResponse
{
    public responseStatus: ResponseStatus;
    public committeeMeeting: CommitteeMeeting;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateCommitteeMeetingResponse>) { (Object as any).assign(this, init); }
}

export class ValidateCommitteeMeetingResponse
{
    public responseStatus: ResponseStatus;
    public committeeMeeting: CommitteeMeeting;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateCommitteeMeetingResponse>) { (Object as any).assign(this, init); }
}

export class GetCommitteeMemberRolesResponse
{
    public responseStatus: ResponseStatus;
    public committeeMemberRoles: CommitteeMemberRole[];
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetCommitteeMemberRolesResponse>) { (Object as any).assign(this, init); }
}

export class GetCommitteeMemberRoleByIdResponse
{
    public responseStatus: ResponseStatus;
    public committeeMemberRole: CommitteeMemberRole;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetCommitteeMemberRoleByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetCommitteeMemberRolesByPersonnelIdResponse
{
    public responseStatus: ResponseStatus;
    public committeeMemberRoles: CommitteeMemberRole[];
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetCommitteeMemberRolesByPersonnelIdResponse>) { (Object as any).assign(this, init); }
}

export class GetCommitteeMemberRoleByCommitteeIdResponse
{
    public responseStatus: ResponseStatus;
    public committeeMemberRole: CommitteeMemberRole[];
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetCommitteeMemberRoleByCommitteeIdResponse>) { (Object as any).assign(this, init); }
}

export class SetCommitteeMemberRoleResponse
{
    public responseStatus: ResponseStatus;
    public committeeMemberRole: CommitteeMemberRole;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetCommitteeMemberRoleResponse>) { (Object as any).assign(this, init); }
}

export class CreateCommitteeMemberRoleResponse
{
    public responseStatus: ResponseStatus;
    public committeeMemberRole: CommitteeMemberRole;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateCommitteeMemberRoleResponse>) { (Object as any).assign(this, init); }
}

export class ValidateCommitteeMemberRoleResponse
{
    public responseStatus: ResponseStatus;
    public committeeMemberRole: CommitteeMemberRole;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateCommitteeMemberRoleResponse>) { (Object as any).assign(this, init); }
}

export class GetCommitteeMembersResponse
{
    public responseStatus: ResponseStatus;
    public committeeMembers: CommitteeMember[];
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetCommitteeMembersResponse>) { (Object as any).assign(this, init); }
}

export class GetCommitteeMemberByIdResponse
{
    public responseStatus: ResponseStatus;
    public committeeMember: CommitteeMember;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetCommitteeMemberByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetCommitteeMemberByCommitteeIdResponse
{
    public responseStatus: ResponseStatus;
    public committeeMember: CommitteeMember[];
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetCommitteeMemberByCommitteeIdResponse>) { (Object as any).assign(this, init); }
}

export class SetCommitteeMemberResponse
{
    public responseStatus: ResponseStatus;
    public committeeMember: CommitteeMember;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetCommitteeMemberResponse>) { (Object as any).assign(this, init); }
}

export class CreateCommitteeMemberResponse
{
    public responseStatus: ResponseStatus;
    public committeeMember: CommitteeMember;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateCommitteeMemberResponse>) { (Object as any).assign(this, init); }
}

export class ValidateCommitteeMemberResponse
{
    public responseStatus: ResponseStatus;
    public committeeMember: CommitteeMember;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateCommitteeMemberResponse>) { (Object as any).assign(this, init); }
}

export class GetCommitteeRegularInviteesResponse
{
    public responseStatus: ResponseStatus;
    public committeeRegularInvitees: CommitteeRegularInvitee[];
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetCommitteeRegularInviteesResponse>) { (Object as any).assign(this, init); }
}

export class GetCommitteeRegularInviteeByIdResponse
{
    public responseStatus: ResponseStatus;
    public committeeRegularInvitee: CommitteeRegularInvitee;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetCommitteeRegularInviteeByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetCommitteeRegularInviteeByCommitteeIdResponse
{
    public responseStatus: ResponseStatus;
    public committeeRegularInvitees: CommitteeRegularInvitee[];
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetCommitteeRegularInviteeByCommitteeIdResponse>) { (Object as any).assign(this, init); }
}

export class SetCommitteeRegularInviteeResponse
{
    public responseStatus: ResponseStatus;
    public committeeRegularInvitee: CommitteeRegularInvitee;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetCommitteeRegularInviteeResponse>) { (Object as any).assign(this, init); }
}

export class CreateCommitteeRegularInviteeResponse
{
    public responseStatus: ResponseStatus;
    public committeeRegularInvitee: CommitteeRegularInvitee;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateCommitteeRegularInviteeResponse>) { (Object as any).assign(this, init); }
}

export class ValidateCommitteeRegularInviteeResponse
{
    public responseStatus: ResponseStatus;
    public committeeRegularInvitee: CommitteeRegularInvitee;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<ValidateCommitteeRegularInviteeResponse>) { (Object as any).assign(this, init); }
}

export class GetCollectionInstanceByIdResponse
{
    public responseStatus: ResponseStatus;
    public collectionInstance: CollectionInstance;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetCollectionInstanceByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetCollectionInstanceResponse
{
    public responseStatus: ResponseStatus;
    public collectionInstance: CollectionInstance;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetCollectionInstanceResponse>) { (Object as any).assign(this, init); }
}

export class GetCollectionByIdResponse
{
    public responseStatus: ResponseStatus;
    public collection: Collection;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<GetCollectionByIdResponse>) { (Object as any).assign(this, init); }
}

export class SetCollectionResponse
{
    public responseStatus: ResponseStatus;
    public collection: Collection;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<SetCollectionResponse>) { (Object as any).assign(this, init); }
}

export class CreateCollectionResponse
{
    public responseStatus: ResponseStatus;
    public collection: Collection;
    public formState: FormState;
    public lookups: Lookup[];
    public formProperties: FormProperty[];

    public constructor(init?: Partial<CreateCollectionResponse>) { (Object as any).assign(this, init); }
}

export class GetAccrualANZByIdResponse
{
    public responseStatus: ResponseStatus;
    public accrualANZ: AccrualANZ;

    public constructor(init?: Partial<GetAccrualANZByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetAccrualANZByTrialIdResponse
{
    public responseStatus: ResponseStatus;
    public accrualANZ: AccrualANZ[];
    public groupItemCategories: GroupItemCategory[];

    public constructor(init?: Partial<GetAccrualANZByTrialIdResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetMemberByOutlookIdResponse
{
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public member?: Member;

    public constructor(init?: Partial<GetMemberByOutlookIdResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetMemberByMemberIdResponse
{
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public member?: Member;

    public constructor(init?: Partial<GetMemberByMemberIdResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetMemberByUsernameResponse
{
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public member?: Member;

    public constructor(init?: Partial<GetMemberByUsernameResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetMemberByMemberStatusIdResponse
{
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public member?: Member;

    public constructor(init?: Partial<GetMemberByMemberStatusIdResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetMemberByMemberIdsResponse
{
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public members?: Member[];

    public constructor(init?: Partial<GetMemberByMemberIdsResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetMembersWithOutstandingApplicationsResponse
{
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public members?: Member[];

    public constructor(init?: Partial<GetMembersWithOutstandingApplicationsResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetMembershipTypeResponse
{
    // @DataMember(Order=1)
    public type?: MembershipCategory;

    // @DataMember(Order=2)
    public member?: Member;

    // @DataMember(Order=3)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<GetMembershipTypeResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class MemberRenewResponse
{
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public success?: boolean;

    public constructor(init?: Partial<MemberRenewResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class MemberCancelResponse
{
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public success?: boolean;

    public constructor(init?: Partial<MemberCancelResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PostResearchMemberApplicationResponse
{
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public member?: Member;

    public constructor(init?: Partial<PostResearchMemberApplicationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PostResearchMemberApplicationSupporterResponse
{
    /** @description The information about any issue that may have occurred */
    // @DataMember(Order=1)
    // @ApiMember(Description="The information about any issue that may have occurred", Name="ResponseStatus", ParameterType="model")
    public responseStatus?: ResponseStatus;

    /** @description The member id of the supporter. NULL if the supporter is not found. */
    // @DataMember(Order=2)
    // @ApiMember(Description="The member id of the supporter. NULL if the supporter is not found.", Name="MemberId")
    public memberId?: string;

    public constructor(init?: Partial<PostResearchMemberApplicationSupporterResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PostResearchMemberApplicationSupportResponse
{
    /** @description The information about any issue that may have occurred */
    // @DataMember(Order=1)
    // @ApiMember(Description="The information about any issue that may have occurred", Name="ResponseStatus", ParameterType="model")
    public responseStatus?: ResponseStatus;

    /** @description The updated membership. */
    // @DataMember(Order=2)
    // @ApiMember(Description="The updated membership.", Name="Member")
    public member?: Member;

    public constructor(init?: Partial<PostResearchMemberApplicationSupportResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class FinaliseMemberApplicationBoardApproveResponse
{
    /** @description The information about any issue that may have occurred */
    // @DataMember(Order=1)
    // @ApiMember(Description="The information about any issue that may have occurred", Name="ResponseStatus", ParameterType="model")
    public responseStatus?: ResponseStatus;

    /** @description The updated member. */
    // @DataMember(Order=2)
    // @ApiMember(Description="The updated member.", Name="Member")
    public member?: Member;

    public constructor(init?: Partial<FinaliseMemberApplicationBoardApproveResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SaveApplicationResponse
{
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public application?: Application;

    public constructor(init?: Partial<SaveApplicationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetMemberExistsResponse
{
    // @DataMember(Order=1)
    public exists?: boolean;

    // @DataMember(Order=2)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<GetMemberExistsResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetSpecialitiesResponse
{
    // @DataMember(Order=1)
    public specialities?: Speciality[];

    // @DataMember(Order=2)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<GetSpecialitiesResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetInterestLookupResponse
{
    // @DataMember(Order=1)
    public interests?: InterestLookup[];

    // @DataMember(Order=2)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<GetInterestLookupResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PostMemberProfileUpdateResponse
{
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public member?: Member;

    public constructor(init?: Partial<PostMemberProfileUpdateResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AuthenticateResponse implements IHasSessionId, IHasBearerToken
{
    // @DataMember(Order=1)
    public userId: string;

    // @DataMember(Order=2)
    public sessionId: string;

    // @DataMember(Order=3)
    public userName: string;

    // @DataMember(Order=4)
    public displayName: string;

    // @DataMember(Order=5)
    public referrerUrl: string;

    // @DataMember(Order=6)
    public bearerToken: string;

    // @DataMember(Order=7)
    public refreshToken: string;

    // @DataMember(Order=8)
    public refreshTokenExpiry?: string;

    // @DataMember(Order=9)
    public profileUrl: string;

    // @DataMember(Order=10)
    public roles: string[];

    // @DataMember(Order=11)
    public permissions: string[];

    // @DataMember(Order=12)
    public authProvider: string;

    // @DataMember(Order=13)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=14)
    public meta: { [index:string]: string; };

    public constructor(init?: Partial<AuthenticateResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AssignRolesResponse
{
    // @DataMember(Order=1)
    public allRoles: string[];

    // @DataMember(Order=2)
    public allPermissions: string[];

    // @DataMember(Order=3)
    public meta: { [index:string]: string; };

    // @DataMember(Order=4)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<AssignRolesResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UnAssignRolesResponse
{
    // @DataMember(Order=1)
    public allRoles: string[];

    // @DataMember(Order=2)
    public allPermissions: string[];

    // @DataMember(Order=3)
    public meta: { [index:string]: string; };

    // @DataMember(Order=4)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<UnAssignRolesResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetApiKeysResponse
{
    // @DataMember(Order=1)
    public results: UserApiKey[];

    // @DataMember(Order=2)
    public meta: { [index:string]: string; };

    // @DataMember(Order=3)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetApiKeysResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class RegenerateApiKeysResponse
{
    // @DataMember(Order=1)
    public results: UserApiKey[];

    // @DataMember(Order=2)
    public meta: { [index:string]: string; };

    // @DataMember(Order=3)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<RegenerateApiKeysResponse>) { (Object as any).assign(this, init); }
}

// @Route("/api/committees", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetCommittees implements IReturn<GetCommitteesResponse>
{
    public showInActive: boolean;

    public constructor(init?: Partial<GetCommittees>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCommittees'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetCommitteesResponse(); }
}

// @Route("/api/committee/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Committee not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetCommitteeById implements IReturn<GetCommitteeByIdResponse>, IGet
{
    /** @description The primary key Id of the Committee */
    // @ApiMember(DataType="string", Description="The primary key Id of the Committee", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetCommitteeById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCommitteeById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetCommitteeByIdResponse(); }
}

// @Route("/api/committee/save/{Id}", "POST")
// @Route("/api/committee/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetCommittee implements IReturn<SetCommitteeResponse>
{
    /** @description The Committee Form data to save */
    // @ApiMember(DataType="Committee", Description="The Committee Form data to save", IsRequired=true, Name="committee", ParameterType="body")
    public committee: Committee;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetCommittee>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetCommittee'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetCommitteeResponse(); }
}

// @Route("/api/committee/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateCommittee implements IReturn<CreateCommitteeResponse>
{

    public constructor(init?: Partial<CreateCommittee>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateCommittee'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateCommitteeResponse(); }
}

// @Route("/api/committee/validate/{Id}", "POST")
// @Route("/api/committee/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateCommittee implements IReturn<ValidateCommitteeResponse>
{
    /** @description The Committee Form data to validate */
    // @ApiMember(DataType="Committee", Description="The Committee Form data to validate", IsRequired=true, Name="committee", ParameterType="body")
    public committee: Committee;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateCommittee>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateCommittee'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateCommitteeResponse(); }
}

// @Route("/api/groupitemtemplatecategories", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetGroupItemTemplateCategorys implements IReturn<GetGroupItemTemplateCategorysResponse>
{

    public constructor(init?: Partial<GetGroupItemTemplateCategorys>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetGroupItemTemplateCategorys'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetGroupItemTemplateCategorysResponse(); }
}

// @Route("/api/groupitemtemplatecategory/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="GroupItemTemplateCategory not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetGroupItemTemplateCategoryById implements IReturn<GetGroupItemTemplateCategoryByIdResponse>, IGet
{
    /** @description The primary key Id of the groupItemTemplateCategorys */
    // @ApiMember(DataType="string", Description="The primary key Id of the groupItemTemplateCategorys", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetGroupItemTemplateCategoryById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetGroupItemTemplateCategoryById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetGroupItemTemplateCategoryByIdResponse(); }
}

// @Route("/api/groupitemtemplatecategory/save/{Id}", "POST")
// @Route("/api/groupitemtemplatecategory/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetGroupItemTemplateCategory implements IReturn<SetGroupItemTemplateCategoryResponse>
{
    /** @description The GroupItemTemplateCategory Form data to save */
    // @ApiMember(DataType="GroupItemTemplateCategory", Description="The GroupItemTemplateCategory Form data to save", IsRequired=true, Name="GroupItemTemplateCategory", ParameterType="body")
    public groupItemTemplateCategory: GroupItemTemplateCategory;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetGroupItemTemplateCategory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetGroupItemTemplateCategory'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetGroupItemTemplateCategoryResponse(); }
}

// @Route("/api/groupitemtemplatecategory/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateGroupItemTemplateCategory implements IReturn<CreateGroupItemTemplateCategoryResponse>
{

    public constructor(init?: Partial<CreateGroupItemTemplateCategory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateGroupItemTemplateCategory'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateGroupItemTemplateCategoryResponse(); }
}

// @Route("/api/groupitemtemplatecategory/validate/{Id}", "POST")
// @Route("/api/groupitemtemplatecategory/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateGroupItemTemplateCategory implements IReturn<ValidateGroupItemTemplateCategoryResponse>
{
    /** @description The GroupItemTemplateCategory Form data to validate */
    // @ApiMember(DataType="GroupItemTemplateCategory", Description="The GroupItemTemplateCategory Form data to validate", IsRequired=true, Name="GroupItemTemplateCategory", ParameterType="body")
    public groupItemTemplateCategory: GroupItemTemplateCategory;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateGroupItemTemplateCategory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateGroupItemTemplateCategory'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateGroupItemTemplateCategoryResponse(); }
}

// @Route("/api/groupitemtemplates", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetGroupItemTemplates implements IReturn<GetGroupItemTemplatesResponse>
{
    public groupId: number;

    public constructor(init?: Partial<GetGroupItemTemplates>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetGroupItemTemplates'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetGroupItemTemplatesResponse(); }
}

// @Route("/api/groupitemtemplate/id/{id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Group Item Template not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetGroupItemTemplateById implements IReturn<GetGroupItemTemplateByIdResponse>, IGet
{
    /** @description The primary key Id of the GroupItemtemplate */
    // @ApiMember(DataType="string", Description="The primary key Id of the GroupItemtemplate", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetGroupItemTemplateById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetGroupItemTemplateById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetGroupItemTemplateByIdResponse(); }
}

// @Route("/api/groupitemtemplate/save/{id}", "POST")
// @Route("/api/groupitemtemplate/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetGroupItemTemplate implements IReturn<SetGroupItemTemplateResponse>
{
    /** @description The GroupItemTemplate Form data to save */
    // @ApiMember(DataType="GroupItemTemplate", Description="The GroupItemTemplate Form data to save", IsRequired=true, Name="GroupItemTemplate", ParameterType="body")
    public groupItemTemplate: GroupItemTemplate;

    public collection: Collection;
    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetGroupItemTemplate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetGroupItemTemplate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetGroupItemTemplateResponse(); }
}

// @Route("/api/groupitemtemplate/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateGroupItemTemplate implements IReturn<CreateGroupItemTemplateResponse>
{
    public groupId: number;

    public constructor(init?: Partial<CreateGroupItemTemplate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateGroupItemTemplate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateGroupItemTemplateResponse(); }
}

// @Route("/api/groupitemtemplate/validate/{id}", "POST")
// @Route("/api/groupitemtemplate/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateGroupItemTemplate implements IReturn<ValidateGroupItemTemplateResponse>
{
    /** @description The GroupItemTemplate Form data to validate */
    // @ApiMember(DataType="GroupItemTemplate", Description="The GroupItemTemplate Form data to validate", IsRequired=true, Name="GroupItemTemplate", ParameterType="body")
    public groupItemTemplate: GroupItemTemplate;

    public collection: Collection;
    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateGroupItemTemplate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateGroupItemTemplate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateGroupItemTemplateResponse(); }
}

// @Route("/api/hrecs", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetHrecs implements IReturn<GetHrecsResponse>
{
    public showInActiveHrecItems: boolean;

    public constructor(init?: Partial<GetHrecs>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetHrecs'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetHrecsResponse(); }
}

// @Route("/api/hrec/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Hrec not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetHrecById implements IReturn<GetHrecByIdResponse>, IGet
{
    /** @description The primary key Id of the Hrec */
    // @ApiMember(DataType="string", Description="The primary key Id of the Hrec", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetHrecById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetHrecById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetHrecByIdResponse(); }
}

// @Route("/api/hrec/save/{Id}", "POST")
// @Route("/api/hrec/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetHrec implements IReturn<SetHrecResponse>
{
    /** @description The Hrec Form data to save */
    // @ApiMember(DataType="Hrec", Description="The Hrec Form data to save", IsRequired=true, Name="hrec", ParameterType="body")
    public hrec: Hrec;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetHrec>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetHrec'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetHrecResponse(); }
}

// @Route("/api/hrec/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateHrec implements IReturn<CreateHrecResponse>
{

    public constructor(init?: Partial<CreateHrec>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateHrec'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateHrecResponse(); }
}

// @Route("/api/hrec/validate/{Id}", "POST")
// @Route("/api/hrec/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateHrec implements IReturn<ValidateHrecResponse>
{
    /** @description The Hrec Form data to validate */
    // @ApiMember(DataType="Hrec", Description="The Hrec Form data to validate", IsRequired=true, Name="hrec", ParameterType="body")
    public hrec: Hrec;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateHrec>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateHrec'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateHrecResponse(); }
}

// @Route("/api/institutiontypes", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetInstitutionTypes implements IReturn<GetInstitutionTypesResponse>
{

    public constructor(init?: Partial<GetInstitutionTypes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInstitutionTypes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetInstitutionTypesResponse(); }
}

// @Route("/api/institutiontype/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="InstitutionType not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetInstitutionTypeById implements IReturn<GetInstitutionTypeByIdResponse>, IGet
{
    /** @description The primary key Id of the institutionTypes */
    // @ApiMember(DataType="string", Description="The primary key Id of the institutionTypes", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetInstitutionTypeById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInstitutionTypeById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetInstitutionTypeByIdResponse(); }
}

// @Route("/api/institutiontype/save/{Id}", "POST")
// @Route("/api/institutiontype/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetInstitutionType implements IReturn<SetInstitutionTypeResponse>
{
    /** @description The InstitutionType Form data to save */
    // @ApiMember(DataType="InstitutionType", Description="The InstitutionType Form data to save", IsRequired=true, Name="InstitutionType", ParameterType="body")
    public institutionType: InstitutionType;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetInstitutionType>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetInstitutionType'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetInstitutionTypeResponse(); }
}

// @Route("/api/institutiontype/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateInstitutionType implements IReturn<CreateInstitutionTypeResponse>
{

    public constructor(init?: Partial<CreateInstitutionType>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateInstitutionType'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateInstitutionTypeResponse(); }
}

// @Route("/api/institutiontype/validate/{Id}", "POST")
// @Route("/api/institutiontype/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateInstitutionType implements IReturn<ValidateInstitutionTypeResponse>
{
    /** @description The InstitutionType Form data to validate */
    // @ApiMember(DataType="InstitutionType", Description="The InstitutionType Form data to validate", IsRequired=true, Name="InstitutionType", ParameterType="body")
    public institutionType: InstitutionType;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateInstitutionType>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateInstitutionType'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateInstitutionTypeResponse(); }
}

// @Route("/api/interests", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetInterests implements IReturn<GetInterestsResponse>
{

    public constructor(init?: Partial<GetInterests>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInterests'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetInterestsResponse(); }
}

// @Route("/api/interest/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Interest not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetInterestById implements IReturn<GetInterestByIdResponse>, IGet
{
    /** @description The primary key Id of the interests */
    // @ApiMember(DataType="string", Description="The primary key Id of the interests", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetInterestById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInterestById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetInterestByIdResponse(); }
}

// @Route("/api/interest/save/{Id}", "POST")
// @Route("/api/interest/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetInterest implements IReturn<SetInterestResponse>
{
    /** @description The Interest Form data to save */
    // @ApiMember(DataType="Interest", Description="The Interest Form data to save", IsRequired=true, Name="Interest", ParameterType="body")
    public interest: Interest;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetInterest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetInterest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetInterestResponse(); }
}

// @Route("/api/interest/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateInterest implements IReturn<CreateInterestResponse>
{

    public constructor(init?: Partial<CreateInterest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateInterest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateInterestResponse(); }
}

// @Route("/api/interest/validate/{Id}", "POST")
// @Route("/api/interest/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateInterest implements IReturn<ValidateInterestResponse>
{
    /** @description The Interest Form data to validate */
    // @ApiMember(DataType="Interest", Description="The Interest Form data to validate", IsRequired=true, Name="Interest", ParameterType="body")
    public interest: Interest;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateInterest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateInterest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateInterestResponse(); }
}

// @Route("/api/keycontacts", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetKeyContacts implements IReturn<GetKeyContactsResponse>
{

    public constructor(init?: Partial<GetKeyContacts>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetKeyContacts'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetKeyContactsResponse(); }
}

// @Route("/api/keycontact/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="KeyContact not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetKeyContactById implements IReturn<GetKeyContactByIdResponse>, IGet
{
    /** @description The primary key Id of the keycontacts */
    // @ApiMember(DataType="string", Description="The primary key Id of the keycontacts", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetKeyContactById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetKeyContactById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetKeyContactByIdResponse(); }
}

// @Route("/api/keycontact/save/{Id}", "POST")
// @Route("/api/keycontact/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetKeyContact implements IReturn<SetKeyContactResponse>
{
    /** @description The KeyContact Form data to save */
    // @ApiMember(DataType="KeyContact", Description="The KeyContact Form data to save", IsRequired=true, Name="KeyContact", ParameterType="body")
    public keyContact: KeyContact;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetKeyContact>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetKeyContact'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetKeyContactResponse(); }
}

// @Route("/api/keycontact/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateKeyContact implements IReturn<CreateKeyContactResponse>
{

    public constructor(init?: Partial<CreateKeyContact>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateKeyContact'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateKeyContactResponse(); }
}

// @Route("/api/keycontact/validate/{Id}", "POST")
// @Route("/api/keycontact/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateKeyContact implements IReturn<ValidateKeyContactResponse>
{
    /** @description The KeyContact Form data to validate */
    // @ApiMember(DataType="KeyContact", Description="The KeyContact Form data to validate", IsRequired=true, Name="KeyContact", ParameterType="body")
    public keyContact: KeyContact;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateKeyContact>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateKeyContact'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateKeyContactResponse(); }
}

// @Route("/api/membershiptypes", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetMembershipTypes implements IReturn<GetMembershipTypesResponse>
{

    public constructor(init?: Partial<GetMembershipTypes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMembershipTypes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetMembershipTypesResponse(); }
}

// @Route("/api/membershiptype/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="MembershipType not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetMembershipTypeById implements IReturn<GetMembershipTypeByIdResponse>, IGet
{
    /** @description The primary key Id of the membershiptypes */
    // @ApiMember(DataType="string", Description="The primary key Id of the membershiptypes", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetMembershipTypeById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMembershipTypeById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetMembershipTypeByIdResponse(); }
}

// @Route("/api/membershiptype/save/{Id}", "POST")
// @Route("/api/membershiptype/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetMembershipType implements IReturn<SetMembershipTypeResponse>
{
    /** @description The MembershipType Form data to save */
    // @ApiMember(DataType="MembershipType", Description="The MembershipType Form data to save", IsRequired=true, Name="MembershipType", ParameterType="body")
    public membershipType: MembershipType;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetMembershipType>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetMembershipType'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetMembershipTypeResponse(); }
}

// @Route("/api/membershiptype/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateMembershipType implements IReturn<CreateMembershipTypeResponse>
{

    public constructor(init?: Partial<CreateMembershipType>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateMembershipType'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateMembershipTypeResponse(); }
}

// @Route("/api/membershiptype/validate/{Id}", "POST")
// @Route("/api/membershiptype/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateMembershipType implements IReturn<ValidateMembershipTypeResponse>
{
    /** @description The MembershipType Form data to validate */
    // @ApiMember(DataType="MembershipType", Description="The MembershipType Form data to validate", IsRequired=true, Name="MembershipType", ParameterType="body")
    public membershipType: MembershipType;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateMembershipType>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateMembershipType'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateMembershipTypeResponse(); }
}

// @Route("/api/professionaldisciplines", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetProfessionalDisciplines implements IReturn<GetProfessionalDisciplinesResponse>
{

    public constructor(init?: Partial<GetProfessionalDisciplines>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetProfessionalDisciplines'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetProfessionalDisciplinesResponse(); }
}

// @Route("/api/professionaldiscipline/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="ProfessionalDiscipline not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetProfessionalDisciplineById implements IReturn<GetProfessionalDisciplineByIdResponse>, IGet
{
    /** @description The primary key Id of the professionaldisciplines */
    // @ApiMember(DataType="string", Description="The primary key Id of the professionaldisciplines", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetProfessionalDisciplineById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetProfessionalDisciplineById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetProfessionalDisciplineByIdResponse(); }
}

// @Route("/api/professionaldiscipline/save/{Id}", "POST")
// @Route("/api/professionaldiscipline/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetProfessionalDiscipline implements IReturn<SetProfessionalDisciplineResponse>
{
    /** @description The ProfessionalDiscipline Form data to save */
    // @ApiMember(DataType="ProfessionalDiscipline", Description="The ProfessionalDiscipline Form data to save", IsRequired=true, Name="ProfessionalDiscipline", ParameterType="body")
    public professionalDiscipline: ProfessionalDiscipline;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetProfessionalDiscipline>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetProfessionalDiscipline'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetProfessionalDisciplineResponse(); }
}

// @Route("/api/professionaldiscipline/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateProfessionalDiscipline implements IReturn<CreateProfessionalDisciplineResponse>
{

    public constructor(init?: Partial<CreateProfessionalDiscipline>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateProfessionalDiscipline'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateProfessionalDisciplineResponse(); }
}

// @Route("/api/professionaldiscipline/validate/{Id}", "POST")
// @Route("/api/professionaldiscipline/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateProfessionalDiscipline implements IReturn<ValidateProfessionalDisciplineResponse>
{
    /** @description The ProfessionalDiscipline Form data to validate */
    // @ApiMember(DataType="ProfessionalDiscipline", Description="The ProfessionalDiscipline Form data to validate", IsRequired=true, Name="ProfessionalDiscipline", ParameterType="body")
    public professionalDiscipline: ProfessionalDiscipline;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateProfessionalDiscipline>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateProfessionalDiscipline'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateProfessionalDisciplineResponse(); }
}

// @Route("/api/salutations", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetSalutations implements IReturn<GetSalutationsResponse>
{

    public constructor(init?: Partial<GetSalutations>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSalutations'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetSalutationsResponse(); }
}

// @Route("/api/salutation/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Salutation not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetSalutationById implements IReturn<GetSalutationByIdResponse>, IGet
{
    /** @description The primary key Id of the salutations */
    // @ApiMember(DataType="string", Description="The primary key Id of the salutations", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetSalutationById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSalutationById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetSalutationByIdResponse(); }
}

// @Route("/api/salutation/save/{Id}", "POST")
// @Route("/api/salutation/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetSalutation implements IReturn<SetSalutationResponse>
{
    /** @description The Salutation Form data to save */
    // @ApiMember(DataType="Salutation", Description="The Salutation Form data to save", IsRequired=true, Name="Salutation", ParameterType="body")
    public salutation: Salutation;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetSalutation>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetSalutation'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetSalutationResponse(); }
}

// @Route("/api/salutation/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateSalutation implements IReturn<CreateSalutationResponse>
{

    public constructor(init?: Partial<CreateSalutation>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateSalutation'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateSalutationResponse(); }
}

// @Route("/api/salutation/validate/{Id}", "POST")
// @Route("/api/salutation/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateSalutation implements IReturn<ValidateSalutationResponse>
{
    /** @description The Salutation Form data to validate */
    // @ApiMember(DataType="Salutation", Description="The Salutation Form data to validate", IsRequired=true, Name="Salutation", ParameterType="body")
    public salutation: Salutation;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateSalutation>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateSalutation'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateSalutationResponse(); }
}

// @Route("/api/sitelocations", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetSiteLocations implements IReturn<GetSiteLocationsResponse>
{

    public constructor(init?: Partial<GetSiteLocations>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSiteLocations'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetSiteLocationsResponse(); }
}

// @Route("/api/sitelocation/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="SiteLocation not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetSiteLocationById implements IReturn<GetSiteLocationByIdResponse>, IGet
{
    /** @description The primary key Id of the siteLocations */
    // @ApiMember(DataType="string", Description="The primary key Id of the siteLocations", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetSiteLocationById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSiteLocationById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetSiteLocationByIdResponse(); }
}

// @Route("/api/sitelocation/save/{Id}", "POST")
// @Route("/api/sitelocation/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetSiteLocation implements IReturn<SetSiteLocationResponse>
{
    /** @description The SiteLocation Form data to save */
    // @ApiMember(DataType="SiteLocation", Description="The SiteLocation Form data to save", IsRequired=true, Name="SiteLocation", ParameterType="body")
    public siteLocation: SiteLocation;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetSiteLocation>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetSiteLocation'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetSiteLocationResponse(); }
}

// @Route("/api/sitelocation/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateSiteLocation implements IReturn<CreateSiteLocationResponse>
{

    public constructor(init?: Partial<CreateSiteLocation>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateSiteLocation'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateSiteLocationResponse(); }
}

// @Route("/api/sitelocation/validate/{Id}", "POST")
// @Route("/api/sitelocation/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateSiteLocation implements IReturn<ValidateSiteLocationResponse>
{
    /** @description The SiteLocation Form data to validate */
    // @ApiMember(DataType="SiteLocation", Description="The SiteLocation Form data to validate", IsRequired=true, Name="SiteLocation", ParameterType="body")
    public siteLocation: SiteLocation;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateSiteLocation>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateSiteLocation'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateSiteLocationResponse(); }
}

// @Route("/api/states", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetStates implements IReturn<GetStatesResponse>
{

    public constructor(init?: Partial<GetStates>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetStates'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetStatesResponse(); }
}

// @Route("/api/state/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="State not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetStateById implements IReturn<GetStateByIdResponse>, IGet
{
    /** @description The primary key Id of the states */
    // @ApiMember(DataType="string", Description="The primary key Id of the states", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetStateById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetStateById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetStateByIdResponse(); }
}

// @Route("/api/state/save/{Id}", "POST")
// @Route("/api/state/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetState implements IReturn<SetStateResponse>
{
    /** @description The State Form data to save */
    // @ApiMember(DataType="State", Description="The State Form data to save", IsRequired=true, Name="State", ParameterType="body")
    public state: State;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetState>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetState'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetStateResponse(); }
}

// @Route("/api/state/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateState implements IReturn<CreateStateResponse>
{

    public constructor(init?: Partial<CreateState>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateState'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateStateResponse(); }
}

// @Route("/api/state/validate/{Id}", "POST")
// @Route("/api/state/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateState implements IReturn<ValidateStateResponse>
{
    /** @description The State Form data to validate */
    // @ApiMember(DataType="State", Description="The State Form data to validate", IsRequired=true, Name="State", ParameterType="body")
    public state: State;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateState>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateState'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateStateResponse(); }
}

// @Route("/api/discussions", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDiscussions implements IReturn<GetDiscussionsResponse>
{
    public projectId: number;

    public constructor(init?: Partial<GetDiscussions>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDiscussions'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDiscussionsResponse(); }
}

// @Route("/api/discussion/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Trial Item not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDiscussionById implements IReturn<GetDiscussionByIdResponse>, IGet
{
    /** @description The primary key Id of the discussion */
    // @ApiMember(DataType="string", Description="The primary key Id of the discussion", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetDiscussionById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDiscussionById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDiscussionByIdResponse(); }
}

// @Route("/api/discussion/save/{Id}", "POST")
// @Route("/api/discussion/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetDiscussion implements IReturn<SetDiscussionResponse>
{
    /** @description The Discussion Form data to save */
    // @ApiMember(DataType="Discussion", Description="The Discussion Form data to save", IsRequired=true, Name="discussion", ParameterType="body")
    public discussion: Discussion;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetDiscussion>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetDiscussion'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetDiscussionResponse(); }
}

// @Route("/api/discussion/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateDiscussion implements IReturn<CreateDiscussionResponse>
{
    public projectId: number;

    public constructor(init?: Partial<CreateDiscussion>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateDiscussion'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateDiscussionResponse(); }
}

// @Route("/api/discussion/validate/{Id}", "POST")
// @Route("/api/discussion/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateDiscussion implements IReturn<ValidateDiscussionResponse>
{
    /** @description The Discussion Form data to validate */
    // @ApiMember(DataType="Discussion", Description="The Discussion Form data to validate", IsRequired=true, Name="discussion", ParameterType="body")
    public discussion: Discussion;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateDiscussion>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateDiscussion'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateDiscussionResponse(); }
}

// @Route("/api/projectitems/project/{projectId}", "GET")
// @ApiResponse(Description="ProjectId is invalid", StatusCode=400)
// @ApiResponse(Description="Project Items not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetProjectItemsByProjectId implements IReturn<GetProjectItemsByProjectIdResponse>, IGet
{
    /** @description The primary key Id of the project */
    // @ApiMember(DataType="string", Description="The primary key Id of the project", IsRequired=true, Name="ProjectId", ParameterType="path")
    public projectId: number;

    public constructor(init?: Partial<GetProjectItemsByProjectId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetProjectItemsByProjectId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetProjectItemsByProjectIdResponse(); }
}

// @Route("/api/projectitem/save/{Id}", "POST")
// @Route("/api/projectitem/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetProjectItem implements IReturn<SetProjectItemResponse>
{
    /** @description The ProjectItem Form data to save */
    // @ApiMember(DataType="ProjectItem", Description="The ProjectItem Form data to save", IsRequired=true, Name="ProjectItem", ParameterType="body")
    public projectItem: ProjectItem;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetProjectItem>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetProjectItem'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetProjectItemResponse(); }
}

// @Route("/api/projectitems/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateProjectItem implements IReturn<CreateProjectItemResponse>
{
    public projectId?: number;

    public constructor(init?: Partial<CreateProjectItem>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateProjectItem'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateProjectItemResponse(); }
}

// @Route("/api/projectItemTemplateCategorys", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetProjectItemTemplateCategorys implements IReturn<GetProjectItemTemplateCategorysResponse>
{

    public constructor(init?: Partial<GetProjectItemTemplateCategorys>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetProjectItemTemplateCategorys'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetProjectItemTemplateCategorysResponse(); }
}

// @Route("/api/projectItemTemplateCategory/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="ProjectItemTemplateCategory not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetProjectItemTemplateCategoryById implements IReturn<GetProjectItemTemplateCategoryByIdResponse>, IGet
{
    /** @description The primary key Id of the projectItemTemplateCategorys */
    // @ApiMember(DataType="string", Description="The primary key Id of the projectItemTemplateCategorys", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetProjectItemTemplateCategoryById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetProjectItemTemplateCategoryById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetProjectItemTemplateCategoryByIdResponse(); }
}

// @Route("/api/projectItemTemplateCategory/save/{Id}", "POST")
// @Route("/api/projectItemTemplateCategory/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetProjectItemTemplateCategory implements IReturn<SetProjectItemTemplateCategoryResponse>
{
    /** @description The ProjectItemTemplateCategory Form data to save */
    // @ApiMember(DataType="ProjectItemTemplateCategory", Description="The ProjectItemTemplateCategory Form data to save", IsRequired=true, Name="ProjectItemTemplateCategory", ParameterType="body")
    public projectItemTemplateCategory: ProjectItemTemplateCategory;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetProjectItemTemplateCategory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetProjectItemTemplateCategory'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetProjectItemTemplateCategoryResponse(); }
}

// @Route("/api/projectItemTemplateCategory/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateProjectItemTemplateCategory implements IReturn<CreateProjectItemTemplateCategoryResponse>
{

    public constructor(init?: Partial<CreateProjectItemTemplateCategory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateProjectItemTemplateCategory'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateProjectItemTemplateCategoryResponse(); }
}

// @Route("/api/projectItemTemplateCategory/validate/{Id}", "POST")
// @Route("/api/projectItemTemplateCategory/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateProjectItemTemplateCategory implements IReturn<ValidateProjectItemTemplateCategoryResponse>
{
    /** @description The ProjectItemTemplateCategory Form data to validate */
    // @ApiMember(DataType="ProjectItemTemplateCategory", Description="The ProjectItemTemplateCategory Form data to validate", IsRequired=true, Name="ProjectItemTemplateCategory", ParameterType="body")
    public projectItemTemplateCategory: ProjectItemTemplateCategory;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateProjectItemTemplateCategory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateProjectItemTemplateCategory'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateProjectItemTemplateCategoryResponse(); }
}

// @Route("/api/projectitemtemplates", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetProjectItemTemplates implements IReturn<GetProjectItemTemplatesResponse>
{
    public trialId?: number;

    public constructor(init?: Partial<GetProjectItemTemplates>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetProjectItemTemplates'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetProjectItemTemplatesResponse(); }
}

// @Route("/api/projectitemtemplates/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="ProjectItemTemplate not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetProjectItemTemplateById implements IReturn<GetProjectItemTemplateByIdResponse>, IGet
{
    /** @description The primary key Id of the ProjectItemTemplate */
    // @ApiMember(DataType="string", Description="The primary key Id of the ProjectItemTemplate", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetProjectItemTemplateById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetProjectItemTemplateById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetProjectItemTemplateByIdResponse(); }
}

// @Route("/api/projectitemtemplates/save/{Id}", "POST")
// @Route("/api/projectitemtemplates/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetProjectItemTemplate implements IReturn<SetProjectItemTemplateResponse>
{
    /** @description The ProjectItemTemplate Form data to save */
    // @ApiMember(DataType="ProjectItemTemplate", Description="The ProjectItemTemplate Form data to save", IsRequired=true, Name="ProjectItemTemplate", ParameterType="body")
    public projectItemTemplate: ProjectItemTemplate;

    public collection: Collection;
    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetProjectItemTemplate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetProjectItemTemplate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetProjectItemTemplateResponse(); }
}

// @Route("/api/projectitemtemplates/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateProjectItemTemplate implements IReturn<CreateProjectItemTemplateResponse>
{
    public trialId?: number;

    public constructor(init?: Partial<CreateProjectItemTemplate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateProjectItemTemplate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateProjectItemTemplateResponse(); }
}

// @Route("/api/projectitemtemplates/validate/{Id}", "POST")
// @Route("/api/projectitemtemplates/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateProjectItemTemplate implements IReturn<ValidateProjectItemTemplateResponse>
{
    /** @description The ProjectItemTemplate Form data to validate */
    // @ApiMember(DataType="ProjectItemTemplate", Description="The ProjectItemTemplate Form data to validate", IsRequired=true, Name="ProjectItemTemplate", ParameterType="body")
    public projectItemTemplate: ProjectItemTemplate;

    public collection: Collection;
    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateProjectItemTemplate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateProjectItemTemplate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateProjectItemTemplateResponse(); }
}

// @Route("/api/formtemplatefiletypes", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetFormTemplateFileTypes implements IReturn<GetFormTemplateFileTypesResponse>
{

    public constructor(init?: Partial<GetFormTemplateFileTypes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetFormTemplateFileTypes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetFormTemplateFileTypesResponse(); }
}

// @Route("/api/formtemplatefiletypes/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="FormTemplateFileType not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetFormTemplateFileTypeById implements IReturn<GetFormTemplateFileTypeByIdResponse>, IGet
{
    /** @description The primary key Id of the FormTemplateFileType */
    // @ApiMember(DataType="string", Description="The primary key Id of the FormTemplateFileType", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetFormTemplateFileTypeById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetFormTemplateFileTypeById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetFormTemplateFileTypeByIdResponse(); }
}

// @Route("/api/formtemplatefiletypes/save/{Id}", "POST")
// @Route("/api/formtemplatefiletypes/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetFormTemplateFileType implements IReturn<SetFormTemplateFileTypeResponse>
{
    /** @description The FormTemplateFileType Form data to save */
    // @ApiMember(DataType="FormTemplateFileType", Description="The FormTemplateFileType Form data to save", IsRequired=true, Name="FormTemplateFileType", ParameterType="body")
    public formTemplateFileType: FormTemplateFileType;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetFormTemplateFileType>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetFormTemplateFileType'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetFormTemplateFileTypeResponse(); }
}

// @Route("/api/formtemplatefiletypes/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateFormTemplateFileType implements IReturn<CreateFormTemplateFileTypeResponse>
{

    public constructor(init?: Partial<CreateFormTemplateFileType>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateFormTemplateFileType'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateFormTemplateFileTypeResponse(); }
}

// @Route("/api/formtemplatefiletypes/validate/{Id}", "POST")
// @Route("/api/formtemplatefiletypes/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateFormTemplateFileType implements IReturn<ValidateFormTemplateFileTypeResponse>
{
    /** @description The FormTemplateFileType Form data to validate */
    // @ApiMember(DataType="FormTemplateFileType", Description="The FormTemplateFileType Form data to validate", IsRequired=true, Name="FormTemplateFileType", ParameterType="body")
    public formTemplateFileType: FormTemplateFileType;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateFormTemplateFileType>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateFormTemplateFileType'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateFormTemplateFileTypeResponse(); }
}

// @Route("/api/formtemplates", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetFormTemplates implements IReturn<GetFormTemplatesResponse>
{

    public constructor(init?: Partial<GetFormTemplates>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetFormTemplates'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetFormTemplatesResponse(); }
}

// @Route("/api/formtemplates/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="FormTemplate not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetFormTemplateById implements IReturn<GetFormTemplateByIdResponse>, IGet
{
    /** @description The primary key Id of the FormTemplate */
    // @ApiMember(DataType="string", Description="The primary key Id of the FormTemplate", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetFormTemplateById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetFormTemplateById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetFormTemplateByIdResponse(); }
}

// @Route("/api/formtemplates/save/{Id}", "POST")
// @Route("/api/formtemplates/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetFormTemplate implements IReturn<SetFormTemplateResponse>
{
    /** @description The FormTemplate Form data to save */
    // @ApiMember(DataType="FormTemplate", Description="The FormTemplate Form data to save", IsRequired=true, Name="FormTemplate", ParameterType="body")
    public formTemplate: FormTemplate;

    public collection: Collection;
    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetFormTemplate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetFormTemplate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetFormTemplateResponse(); }
}

// @Route("/api/formtemplates/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateFormTemplate implements IReturn<CreateFormTemplateResponse>
{

    public constructor(init?: Partial<CreateFormTemplate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateFormTemplate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateFormTemplateResponse(); }
}

// @Route("/api/formtemplates/validate/{Id}", "POST")
// @Route("/api/formtemplates/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateFormTemplate implements IReturn<ValidateFormTemplateResponse>
{
    /** @description The FormTemplate Form data to validate */
    // @ApiMember(DataType="FormTemplate", Description="The FormTemplate Form data to validate", IsRequired=true, Name="FormTemplate", ParameterType="body")
    public formTemplate: FormTemplate;

    public collection: Collection;
    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateFormTemplate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateFormTemplate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateFormTemplateResponse(); }
}

// @Route("/api/reportingtags", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetReportingTags implements IReturn<GetReportingTagsResponse>
{

    public constructor(init?: Partial<GetReportingTags>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetReportingTags'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetReportingTagsResponse(); }
}

// @Route("/api/reportingtags/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="ReportingTag not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetReportingTagById implements IReturn<GetReportingTagByIdResponse>, IGet
{
    /** @description The primary key Id of the ReportingTag */
    // @ApiMember(DataType="string", Description="The primary key Id of the ReportingTag", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetReportingTagById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetReportingTagById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetReportingTagByIdResponse(); }
}

// @Route("/api/reportingtags/save/{Id}", "POST")
// @Route("/api/reportingtags/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetReportingTag implements IReturn<SetReportingTagResponse>
{
    /** @description The ReportingTag Form data to save */
    // @ApiMember(DataType="ReportingTag", Description="The ReportingTag Form data to save", IsRequired=true, Name="ReportingTag", ParameterType="body")
    public reportingTag: ReportingTag;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetReportingTag>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetReportingTag'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetReportingTagResponse(); }
}

// @Route("/api/reportingtags/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateReportingTag implements IReturn<CreateReportingTagResponse>
{

    public constructor(init?: Partial<CreateReportingTag>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateReportingTag'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateReportingTagResponse(); }
}

// @Route("/api/reportingtags/validate/{Id}", "POST")
// @Route("/api/reportingtags/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateReportingTag implements IReturn<ValidateReportingTagResponse>
{
    /** @description The ReportingTag Form data to validate */
    // @ApiMember(DataType="ReportingTag", Description="The ReportingTag Form data to validate", IsRequired=true, Name="ReportingTag", ParameterType="body")
    public reportingTag: ReportingTag;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateReportingTag>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateReportingTag'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateReportingTagResponse(); }
}

// @Route("/api/reportingtagcategories", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetReportingTagCategories implements IReturn<GetReportingTagCategoriesResponse>
{

    public constructor(init?: Partial<GetReportingTagCategories>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetReportingTagCategories'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetReportingTagCategoriesResponse(); }
}

// @Route("/api/reportingtagcategories/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="ReportingTagCategory not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetReportingTagCategoryById implements IReturn<GetReportingTagCategoryByIdResponse>, IGet
{
    /** @description The primary key Id of the ReportingTagCategory */
    // @ApiMember(DataType="string", Description="The primary key Id of the ReportingTagCategory", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetReportingTagCategoryById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetReportingTagCategoryById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetReportingTagCategoryByIdResponse(); }
}

// @Route("/api/reportingtagcategories/save/{Id}", "POST")
// @Route("/api/reportingtagcategories/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetReportingTagCategory implements IReturn<SetReportingTagCategoryResponse>
{
    /** @description The ReportingTagCategory Form data to save */
    // @ApiMember(DataType="ReportingTagCategory", Description="The ReportingTagCategory Form data to save", IsRequired=true, Name="ReportingTagCategory", ParameterType="body")
    public reportingTagCategory: ReportingTagCategory;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetReportingTagCategory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetReportingTagCategory'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetReportingTagCategoryResponse(); }
}

// @Route("/api/reportingtagcategories/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateReportingTagCategory implements IReturn<CreateReportingTagCategoryResponse>
{

    public constructor(init?: Partial<CreateReportingTagCategory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateReportingTagCategory'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateReportingTagCategoryResponse(); }
}

// @Route("/api/reportingtagcategories/validate/{Id}", "POST")
// @Route("/api/reportingtagcategories/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateReportingTagCategory implements IReturn<ValidateReportingTagCategoryResponse>
{
    /** @description The ReportingTagCategory Form data to validate */
    // @ApiMember(DataType="ReportingTagCategory", Description="The ReportingTagCategory Form data to validate", IsRequired=true, Name="ReportingTagCategory", ParameterType="body")
    public reportingTagCategory: ReportingTagCategory;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateReportingTagCategory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateReportingTagCategory'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateReportingTagCategoryResponse(); }
}

// @Route("/api/tasktypes", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTaskTypes implements IReturn<GetTaskTypesResponse>
{

    public constructor(init?: Partial<GetTaskTypes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTaskTypes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTaskTypesResponse(); }
}

// @Route("/api/tasktypes/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="TaskType not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTaskTypeById implements IReturn<GetTaskTypeByIdResponse>, IGet
{
    /** @description The primary key Id of the TaskType */
    // @ApiMember(DataType="string", Description="The primary key Id of the TaskType", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetTaskTypeById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTaskTypeById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTaskTypeByIdResponse(); }
}

// @Route("/api/tasktypes/save/{Id}", "POST")
// @Route("/api/tasktypes/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetTaskType implements IReturn<SetTaskTypeResponse>
{
    /** @description The TaskType Form data to save */
    // @ApiMember(DataType="TaskType", Description="The TaskType Form data to save", IsRequired=true, Name="TaskType", ParameterType="body")
    public taskType: TaskType;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetTaskType>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetTaskType'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetTaskTypeResponse(); }
}

// @Route("/api/tasktypes/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateTaskType implements IReturn<CreateTaskTypeResponse>
{

    public constructor(init?: Partial<CreateTaskType>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateTaskType'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateTaskTypeResponse(); }
}

// @Route("/api/tasktypes/validate/{Id}", "POST")
// @Route("/api/tasktypes/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateTaskType implements IReturn<ValidateTaskTypeResponse>
{
    /** @description The TaskType Form data to validate */
    // @ApiMember(DataType="TaskType", Description="The TaskType Form data to validate", IsRequired=true, Name="TaskType", ParameterType="body")
    public taskType: TaskType;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateTaskType>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateTaskType'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateTaskTypeResponse(); }
}

// @Route("/api/trackermilestones", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrackerMilestones implements IReturn<GetTrackerMilestonesResponse>
{

    public constructor(init?: Partial<GetTrackerMilestones>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrackerMilestones'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrackerMilestonesResponse(); }
}

// @Route("/api/trackermilestones/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="TrackerMilestone not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrackerMilestoneById implements IReturn<GetTrackerMilestoneByIdResponse>, IGet
{
    /** @description The primary key Id of the TrackerMilestone */
    // @ApiMember(DataType="string", Description="The primary key Id of the TrackerMilestone", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetTrackerMilestoneById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrackerMilestoneById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrackerMilestoneByIdResponse(); }
}

// @Route("/api/trackermilestones/save/{Id}", "POST")
// @Route("/api/trackermilestones/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetTrackerMilestone implements IReturn<SetTrackerMilestoneResponse>
{
    /** @description The TrackerMilestone Form data to save */
    // @ApiMember(DataType="TrackerMilestone", Description="The TrackerMilestone Form data to save", IsRequired=true, Name="TrackerMilestone", ParameterType="body")
    public trackerMilestone: TrackerMilestone;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetTrackerMilestone>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetTrackerMilestone'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetTrackerMilestoneResponse(); }
}

// @Route("/api/trackermilestones/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateTrackerMilestone implements IReturn<CreateTrackerMilestoneResponse>
{

    public constructor(init?: Partial<CreateTrackerMilestone>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateTrackerMilestone'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateTrackerMilestoneResponse(); }
}

// @Route("/api/trackermilestones/validate/{Id}", "POST")
// @Route("/api/trackermilestones/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateTrackerMilestone implements IReturn<ValidateTrackerMilestoneResponse>
{
    /** @description The TrackerMilestone Form data to validate */
    // @ApiMember(DataType="TrackerMilestone", Description="The TrackerMilestone Form data to validate", IsRequired=true, Name="TrackerMilestone", ParameterType="body")
    public trackerMilestone: TrackerMilestone;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateTrackerMilestone>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateTrackerMilestone'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateTrackerMilestoneResponse(); }
}

// @Route("/api/trackertypes", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrackerTypes implements IReturn<GetTrackerTypesResponse>
{

    public constructor(init?: Partial<GetTrackerTypes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrackerTypes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrackerTypesResponse(); }
}

// @Route("/api/trackertypes/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="TrackerType not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrackerTypeById implements IReturn<GetTrackerTypeByIdResponse>, IGet
{
    /** @description The primary key Id of the TrackerType */
    // @ApiMember(DataType="string", Description="The primary key Id of the TrackerType", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetTrackerTypeById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrackerTypeById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrackerTypeByIdResponse(); }
}

// @Route("/api/trackertypes/save/{Id}", "POST")
// @Route("/api/trackertypes/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetTrackerType implements IReturn<SetTrackerTypeResponse>
{
    /** @description The TrackerType Form data to save */
    // @ApiMember(DataType="TrackerType", Description="The TrackerType Form data to save", IsRequired=true, Name="TrackerType", ParameterType="body")
    public trackerType: TrackerType;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetTrackerType>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetTrackerType'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetTrackerTypeResponse(); }
}

// @Route("/api/trackertypes/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateTrackerType implements IReturn<CreateTrackerTypeResponse>
{

    public constructor(init?: Partial<CreateTrackerType>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateTrackerType'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateTrackerTypeResponse(); }
}

// @Route("/api/trackertypes/validate/{Id}", "POST")
// @Route("/api/trackertypes/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateTrackerType implements IReturn<ValidateTrackerTypeResponse>
{
    /** @description The TrackerType Form data to validate */
    // @ApiMember(DataType="TrackerType", Description="The TrackerType Form data to validate", IsRequired=true, Name="TrackerType", ParameterType="body")
    public trackerType: TrackerType;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateTrackerType>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateTrackerType'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateTrackerTypeResponse(); }
}

// @Route("/api/standardemailtemplates", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetStandardEmailTemplates implements IReturn<GetStandardEmailTemplatesResponse>
{

    public constructor(init?: Partial<GetStandardEmailTemplates>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetStandardEmailTemplates'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetStandardEmailTemplatesResponse(); }
}

// @Route("/api/standardemailtemplates/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="StandardEmailTemplate not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetStandardEmailTemplateById implements IReturn<GetStandardEmailTemplateByIdResponse>, IGet
{
    /** @description The primary key Id of the StandardEmailTemplate */
    // @ApiMember(DataType="string", Description="The primary key Id of the StandardEmailTemplate", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetStandardEmailTemplateById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetStandardEmailTemplateById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetStandardEmailTemplateByIdResponse(); }
}

// @Route("/api/standardemailtemplates/save/{Id}", "POST")
// @Route("/api/standardemailtemplates/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetStandardEmailTemplate implements IReturn<SetStandardEmailTemplateResponse>
{
    /** @description The StandardEmailTemplate Form data to save */
    // @ApiMember(DataType="StandardEmailTemplate", Description="The StandardEmailTemplate Form data to save", IsRequired=true, Name="StandardEmailTemplate", ParameterType="body")
    public standardEmailTemplate: StandardEmailTemplate;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetStandardEmailTemplate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetStandardEmailTemplate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetStandardEmailTemplateResponse(); }
}

// @Route("/api/standardemailtemplates/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateStandardEmailTemplate implements IReturn<CreateStandardEmailTemplateResponse>
{

    public constructor(init?: Partial<CreateStandardEmailTemplate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateStandardEmailTemplate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateStandardEmailTemplateResponse(); }
}

// @Route("/api/standardemailtemplates/validate/{Id}", "POST")
// @Route("/api/standardemailtemplates/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateStandardEmailTemplate implements IReturn<ValidateStandardEmailTemplateResponse>
{
    /** @description The StandardEmailTemplate Form data to validate */
    // @ApiMember(DataType="StandardEmailTemplate", Description="The StandardEmailTemplate Form data to validate", IsRequired=true, Name="StandardEmailTemplate", ParameterType="body")
    public standardEmailTemplate: StandardEmailTemplate;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateStandardEmailTemplate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateStandardEmailTemplate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateStandardEmailTemplateResponse(); }
}

export class GetAppSettings implements IReturn<GetAppSettingsResponse>
{

    public constructor(init?: Partial<GetAppSettings>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAppSettings'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetAppSettingsResponse(); }
}

export class GetEnumerationTypes implements IReturn<GetEnumerationTypesResponse>
{

    public constructor(init?: Partial<GetEnumerationTypes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetEnumerationTypes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetEnumerationTypesResponse(); }
}

// @Route("/api/trialdoi/trialid/{trialid}", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialDoiByTrialId implements IReturn<GetTrialDoiByTrialIdResponse>
{
    public trialId: number;

    public constructor(init?: Partial<GetTrialDoiByTrialId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialDoiByTrialId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialDoiByTrialIdResponse(); }
}

// @Route("/api/trialdoi/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Trial Item not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialDoiById implements IReturn<GetTrialDoiByIdResponse>, IGet
{
    /** @description The primary key Id of the trial doi */
    // @ApiMember(DataType="string", Description="The primary key Id of the trial doi", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetTrialDoiById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialDoiById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialDoiByIdResponse(); }
}

// @Route("/api/trialdoi/save/{Id}", "POST")
// @Route("/api/trialdoi/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetTrialDoi implements IReturn<SetTrialDoiResponse>
{
    /** @description The TrialDoi Form data to save */
    // @ApiMember(DataType="TrialDoi", Description="The TrialDoi Form data to save", IsRequired=true, Name="trialDoi", ParameterType="body")
    public trialDoi: TrialDoi;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetTrialDoi>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetTrialDoi'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetTrialDoiResponse(); }
}

// @Route("/api/trialdoi/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateTrialDoi implements IReturn<CreateTrialDoiResponse>
{
    public trialId: number;

    public constructor(init?: Partial<CreateTrialDoi>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateTrialDoi'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateTrialDoiResponse(); }
}

// @Route("/api/trialdoi/validate/{Id}", "POST")
// @Route("/api/trialdoi/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateTrialDoi implements IReturn<ValidateTrialDoiResponse>
{
    /** @description The TrialDoi Form data to validate */
    // @ApiMember(DataType="TrialDoi", Description="The TrialDoi Form data to validate", IsRequired=true, Name="trialDoi", ParameterType="body")
    public trialDoi: TrialDoi;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateTrialDoi>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateTrialDoi'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateTrialDoiResponse(); }
}

// @Route("/api/trialgroupitems/trialgroup/{id}", "GET")
// @ApiResponse(Description="TrialGroupItemId is invalid", StatusCode=400)
// @ApiResponse(Description="TrialGroupItem not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialGroupItemById implements IReturn<GetTrialGroupItemByIdResponse>, IGet
{
    /** @description The primary key Id of the TrialGroupItem */
    // @ApiMember(DataType="int", Description="The primary key Id of the TrialGroupItem", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetTrialGroupItemById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialGroupItemById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialGroupItemByIdResponse(); }
}

// @Route("/api/trialgroupitems/trialgroup/{trialgroupid}", "GET")
// @ApiResponse(Description="TrialGroupId is invalid", StatusCode=400)
// @ApiResponse(Description="TrialGroupItems not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialGroupItemsByTrialGroupId implements IReturn<GetTrialGroupItemsByTrialGroupIdResponse>, IGet
{
    /** @description The primary key Id of the trial group */
    // @ApiMember(DataType="string", Description="The primary key Id of the trial group", IsRequired=true, Name="TrialGroupId", ParameterType="path")
    public trialGroupId: number;

    public constructor(init?: Partial<GetTrialGroupItemsByTrialGroupId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialGroupItemsByTrialGroupId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialGroupItemsByTrialGroupIdResponse(); }
}

// @Route("/api/trialgroupitems/save/{id}", "POST")
// @Route("/api/trialgroupitems/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetTrialGroupItem implements IReturn<SetTrialGroupItemResponse>
{
    /** @description The TrialGroupItem Form data to save */
    // @ApiMember(DataType="TrialGroupItem", Description="The TrialGroupItem Form data to save", IsRequired=true, Name="TrialGroupItem", ParameterType="body")
    public trialGroupItem: TrialGroupItem;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetTrialGroupItem>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetTrialGroupItem'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetTrialGroupItemResponse(); }
}

// @Route("/api/trialgroupitems/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateTrialGroupItem implements IReturn<CreateTrialGroupItemResponse>
{
    /** @description The primary key Id of the trial group */
    // @ApiMember(DataType="string", Description="The primary key Id of the trial group", IsRequired=true, Name="TrialGroupId", ParameterType="path")
    public trialGroupId: number;

    public constructor(init?: Partial<CreateTrialGroupItem>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateTrialGroupItem'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateTrialGroupItemResponse(); }
}

// @Route("/api/trialgroupitemtemplates", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialGroupItemTemplates implements IReturn<GetTrialGroupItemTemplatesResponse>
{
    public groupId: number;

    public constructor(init?: Partial<GetTrialGroupItemTemplates>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialGroupItemTemplates'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialGroupItemTemplatesResponse(); }
}

// @Route("/api/trialgroupitemtemplate/id/{id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Trial Group Item Template not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialGroupItemTemplateById implements IReturn<GetTrialGroupItemTemplateByIdResponse>, IGet
{
    /** @description The primary key Id of the TrialGroupItemTemplate */
    // @ApiMember(DataType="string", Description="The primary key Id of the TrialGroupItemTemplate", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetTrialGroupItemTemplateById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialGroupItemTemplateById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialGroupItemTemplateByIdResponse(); }
}

// @Route("/api/trialinsitutionitemtemplate/save/{id}", "POST")
// @Route("/api/trialgroupitemtemplate/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetTrialGroupItemTemplate implements IReturn<SetTrialGroupItemTemplateResponse>
{
    /** @description The TrialGroupItemTemplate Form data to save */
    // @ApiMember(DataType="TrialGroupItemTemplate", Description="The TrialGroupItemTemplate Form data to save", IsRequired=true, Name="TrialGroupItemTemplate", ParameterType="body")
    public trialGroupItemTemplate: TrialGroupItemTemplate;

    public collection: Collection;
    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetTrialGroupItemTemplate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetTrialGroupItemTemplate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetTrialGroupItemTemplateResponse(); }
}

// @Route("/api/trialgroupitemtemplate/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateTrialGroupItemTemplate implements IReturn<CreateTrialGroupItemTemplateResponse>
{
    public groupId?: number;

    public constructor(init?: Partial<CreateTrialGroupItemTemplate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateTrialGroupItemTemplate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateTrialGroupItemTemplateResponse(); }
}

// @Route("/api/trialgroupitemtemplate/validate/{id}", "POST")
// @Route("/api/trialgroupitemtemplate/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateTrialGroupItemTemplate implements IReturn<ValidateTrialGroupItemTemplateResponse>
{
    /** @description The TrialGroupItemTemplate Form data to validate */
    // @ApiMember(DataType="TrialGroupItemTemplate", Description="The TrialGroupItemTemplate Form data to validate", IsRequired=true, Name="TrialGroupItemTemplate", ParameterType="body")
    public trialGroupItemTemplate: TrialGroupItemTemplate;

    public collection: Collection;
    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateTrialGroupItemTemplate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateTrialGroupItemTemplate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateTrialGroupItemTemplateResponse(); }
}

// @Route("/api/trialinstitutionitemtemplates", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialInstitutionItemTemplates implements IReturn<GetTrialInstitutionItemTemplatesResponse>
{
    public trialId: number;

    public constructor(init?: Partial<GetTrialInstitutionItemTemplates>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialInstitutionItemTemplates'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialInstitutionItemTemplatesResponse(); }
}

// @Route("/api/trialinstitutionitemtemplate/id/{id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Trial Institution Item Template not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialInstitutionItemTemplateById implements IReturn<GetTrialInstitutionItemTemplateByIdResponse>, IGet
{
    /** @description The primary key Id of the TrialInstitutionItemTemplate */
    // @ApiMember(DataType="string", Description="The primary key Id of the TrialInstitutionItemTemplate", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetTrialInstitutionItemTemplateById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialInstitutionItemTemplateById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialInstitutionItemTemplateByIdResponse(); }
}

// @Route("/api/trialinsitutionitemtemplate/save/{id}", "POST")
// @Route("/api/trialinstitutionitemtemplate/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetTrialInstitutionItemTemplate implements IReturn<SetTrialInstitutionItemTemplateResponse>
{
    /** @description The TrialInstitutionItemTemplate Form data to save */
    // @ApiMember(DataType="TrialInstitutionItemTemplate", Description="The TrialInstitutionItemTemplate Form data to save", IsRequired=true, Name="TrialInstitutionItemTemplate", ParameterType="body")
    public trialInstitutionItemTemplate: TrialInstitutionItemTemplate;

    public collection: Collection;
    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetTrialInstitutionItemTemplate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetTrialInstitutionItemTemplate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetTrialInstitutionItemTemplateResponse(); }
}

// @Route("/api/trialinstitutionitemtemplate/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateTrialInstitutionItemTemplate implements IReturn<CreateTrialInstitutionItemTemplateResponse>
{
    public trialId?: number;

    public constructor(init?: Partial<CreateTrialInstitutionItemTemplate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateTrialInstitutionItemTemplate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateTrialInstitutionItemTemplateResponse(); }
}

// @Route("/api/trialinstitutionitemtemplate/validate/{id}", "POST")
// @Route("/api/trialinstitutionitemtemplate/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateTrialInstitutionItemTemplate implements IReturn<ValidateTrialInstitutionItemTemplateResponse>
{
    /** @description The TrialInstitutionItemTemplate Form data to validate */
    // @ApiMember(DataType="TrialInstitutionItemTemplate", Description="The TrialInstitutionItemTemplate Form data to validate", IsRequired=true, Name="TrialInstitutionItemTemplate", ParameterType="body")
    public trialInstitutionItemTemplate: TrialInstitutionItemTemplate;

    public collection: Collection;
    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateTrialInstitutionItemTemplate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateTrialInstitutionItemTemplate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateTrialInstitutionItemTemplateResponse(); }
}

// @Route("/api/trialitemtemplates", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialItemTemplates implements IReturn<GetTrialItemTemplatesResponse>
{
    public trialId: number;

    public constructor(init?: Partial<GetTrialItemTemplates>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialItemTemplates'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialItemTemplatesResponse(); }
}

// @Route("/api/trialitemtemplate/id/{id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Trial Item Template not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialItemTemplateById implements IReturn<GetTrialItemTemplateByIdResponse>, IGet
{
    /** @description The primary key Id of the TrialItemtemplate */
    // @ApiMember(DataType="string", Description="The primary key Id of the TrialItemtemplate", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetTrialItemTemplateById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialItemTemplateById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialItemTemplateByIdResponse(); }
}

// @Route("/api/trialitemtemplate/save/{id}", "POST")
// @Route("/api/trialitemtemplate/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetTrialItemTemplate implements IReturn<SetTrialItemTemplateResponse>
{
    /** @description The TrialItemTemplate Form data to save */
    // @ApiMember(DataType="TrialItemTemplate", Description="The TrialItemTemplate Form data to save", IsRequired=true, Name="TrialItemTemplate", ParameterType="body")
    public trialItemTemplate: TrialItemTemplate;

    public collection: Collection;
    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetTrialItemTemplate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetTrialItemTemplate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetTrialItemTemplateResponse(); }
}

// @Route("/api/trialitemtemplate/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateTrialItemTemplate implements IReturn<CreateTrialItemTemplateResponse>
{
    public trialId?: number;

    public constructor(init?: Partial<CreateTrialItemTemplate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateTrialItemTemplate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateTrialItemTemplateResponse(); }
}

// @Route("/api/trialitemtemplate/validate/{id}", "POST")
// @Route("/api/trialitemtemplate/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateTrialItemTemplate implements IReturn<ValidateTrialItemTemplateResponse>
{
    /** @description The TrialItemTemplate Form data to validate */
    // @ApiMember(DataType="TrialItemTemplate", Description="The TrialItemTemplate Form data to validate", IsRequired=true, Name="TrialItemTemplate", ParameterType="body")
    public trialItemTemplate: TrialItemTemplate;

    public collection: Collection;
    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateTrialItemTemplate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateTrialItemTemplate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateTrialItemTemplateResponse(); }
}

// @Route("/api/trialwebsite/trialid/{trialid}", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialWebsiteByTrialId implements IReturn<GetTrialWebsiteByTrialIdResponse>
{
    public trialId: number;

    public constructor(init?: Partial<GetTrialWebsiteByTrialId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialWebsiteByTrialId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialWebsiteByTrialIdResponse(); }
}

// @Route("/api/trialwebsite/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Trial Item not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialWebsiteById implements IReturn<GetTrialWebsiteByIdResponse>, IGet
{
    /** @description The primary key Id of the trial website */
    // @ApiMember(DataType="string", Description="The primary key Id of the trial website", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetTrialWebsiteById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialWebsiteById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialWebsiteByIdResponse(); }
}

// @Route("/api/trialwebsite/save/{Id}", "POST")
// @Route("/api/trialwebsite/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetTrialWebsite implements IReturn<SetTrialWebsiteResponse>
{
    /** @description The TrialWebsite Form data to save */
    // @ApiMember(DataType="TrialWebsite", Description="The TrialWebsite Form data to save", IsRequired=true, Name="trialWebsite", ParameterType="body")
    public trialWebsite: TrialWebsite;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetTrialWebsite>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetTrialWebsite'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetTrialWebsiteResponse(); }
}

// @Route("/api/trialwebsite/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateTrialWebsite implements IReturn<CreateTrialWebsiteResponse>
{
    public trialId: number;

    public constructor(init?: Partial<CreateTrialWebsite>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateTrialWebsite'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateTrialWebsiteResponse(); }
}

// @Route("/api/trialwebsite/validate/{Id}", "POST")
// @Route("/api/trialwebsite/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateTrialWebsite implements IReturn<ValidateTrialWebsiteResponse>
{
    /** @description The TrialWebsite Form data to validate */
    // @ApiMember(DataType="TrialWebsite", Description="The TrialWebsite Form data to validate", IsRequired=true, Name="trialWebsite", ParameterType="body")
    public trialWebsite: TrialWebsite;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateTrialWebsite>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateTrialWebsite'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateTrialWebsiteResponse(); }
}

// @Route("/api/user", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
// @DataContract
export class GetUser implements IReturn<GetUserResponse>
{

    public constructor(init?: Partial<GetUser>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetUser'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetUserResponse(); }
}

/** @description TMD */
// @Route("/user/get-by-username", "GET")
// @Api(Description="TMD")
// @ApiResponse(Description="Not authorized", StatusCode=401)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
// @DataContract
export class GetApiUserByUsername implements IReturn<GetApiUserByUsernameResponse>, IGet
{
    /** @description The username to get the user for */
    // @DataMember(Order=1)
    // @ApiMember(DataType="string", Description="The username to get the user for", IsRequired=true, Name="Username", ParameterType="query")
    public username: string;

    public constructor(init?: Partial<GetApiUserByUsername>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetApiUserByUsername'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetApiUserByUsernameResponse(); }
}

/** @description TMD */
// @Route("/api/user/get-username-by-personnelid", "GET")
// @Api(Description="TMD")
// @ApiResponse(Description="Not authorized", StatusCode=401)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
// @DataContract
export class GetUsernameForPersonnel implements IReturn<GetUsernameForPersonnelResponse>, IGet
{
    /** @description The personnel id to get the username for */
    // @DataMember(Order=1)
    // @ApiMember(DataType="integer", Description="The personnel id to get the username for", IsRequired=true, Name="PersonnelId", ParameterType="query")
    public personnelId: number;

    public constructor(init?: Partial<GetUsernameForPersonnel>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetUsernameForPersonnel'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetUsernameForPersonnelResponse(); }
}

/** @description TMD */
// @Route("/api/trial-user/by-trial", "GET")
// @Api(Description="TMD")
// @ApiResponse(Description="Not authorized", StatusCode=401)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
// @DataContract
export class GetTrialUsersByTrialId implements IReturn<GetTrialUsersByTrialIdResponse>, IGet
{
    /** @description The trial ID that the users are attached to. */
    // @DataMember(Order=1)
    // @ApiMember(DataType="integer", Description="The trial ID that the users are attached to.", IsRequired=true, Name="TrialId", ParameterType="query")
    public trialId: number;

    /** @description The roles to return users for. */
    // @DataMember(Order=2)
    // @ApiMember(Description="The roles to return users for.", Name="Roles", ParameterType="query")
    public roles: RoleType[];

    /** @description Only return active coordinating groups and master groups (default: false) */
    // @DataMember(Order=3)
    // @ApiMember(DataType="boolean", Description="Only return active coordinating groups and master groups (default: false)", Name="ActiveGroupsOnly", ParameterType="query")
    public activeGroupsOnly?: boolean;

    /** @description Only return active institutions (default: false). */
    // @DataMember(Order=4)
    // @ApiMember(DataType="boolean", Description="Only return active institutions (default: false).", Name="ActiveInstitutionsOnly", ParameterType="query")
    public activeInstitutionsOnly?: boolean;

    /** @description Only return active roles (default: false). */
    // @DataMember(Order=5)
    // @ApiMember(DataType="boolean", Description="Only return active roles (default: false).", Name="ActiveRolesOnly", ParameterType="query")
    public activeRolesOnly?: boolean;

    /** @description Only return users if their associated site has signed a confidentiality deed if required (default: false). */
    // @DataMember(Order=6)
    // @ApiMember(DataType="boolean", Description="Only return users if their associated site has signed a confidentiality deed if required (default: false).", Name="SitesMustHaveSignedConfidentialityDeed", ParameterType="query")
    public sitesMustHaveSignedConfidentialityDeed?: boolean;

    /** @description Whether to include countries in the output (default: false). */
    // @DataMember(Order=7)
    // @ApiMember(DataType="boolean", Description="Whether to include countries in the output (default: false).", Name="IncludeCountries", ParameterType="query")
    public includeCountries?: boolean;

    public constructor(init?: Partial<GetTrialUsersByTrialId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialUsersByTrialId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialUsersByTrialIdResponse(); }
}

/** @description TMD */
// @Route("/api/trial-institutions/get-by-trial-and-user", "GET")
// @Api(Description="TMD")
// @ApiResponse(Description="Not authorized", StatusCode=401)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
// @DataContract
export class GetTrialInstitutionsByTrialAndUser implements IReturn<GetTrialInstitutionsByTrialAndUserResponse>, IGet
{
    /** @description The trial id to get the trial institutions for */
    // @DataMember(Order=1)
    // @ApiMember(DataType="int", Description="The trial id to get the trial institutions for", Name="TrialId", ParameterType="query")
    public trialId?: number;

    /** @description Whether or not to return active institutions only */
    // @DataMember(Order=2)
    // @ApiMember(DataType="bool", Description="Whether or not to return active institutions only", Name="ActiveInstsOnly", ParameterType="query")
    public activeInstsOnly?: boolean;

    public constructor(init?: Partial<GetTrialInstitutionsByTrialAndUser>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialInstitutionsByTrialAndUser'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialInstitutionsByTrialAndUserResponse(); }
}

// @Route("/api/trialitem/{id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Trial Item not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialItemById implements IReturn<GetTrialItemByIdResponse>, IGet
{
    /** @description The primary key Id of the trial item */
    // @ApiMember(DataType="string", Description="The primary key Id of the trial item", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetTrialItemById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialItemById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialItemByIdResponse(); }
}

// @Route("/api/trialitems/trial/{trialid}", "GET")
// @ApiResponse(Description="TrialId is invalid", StatusCode=400)
// @ApiResponse(Description="Trial Items not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialItemsByTrialId implements IReturn<GetTrialItemsByTrialIdResponse>, IGet
{
    /** @description The primary key Id of the trial */
    // @ApiMember(DataType="string", Description="The primary key Id of the trial", IsRequired=true, Name="TrialId", ParameterType="path")
    public trialId: number;

    public constructor(init?: Partial<GetTrialItemsByTrialId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialItemsByTrialId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialItemsByTrialIdResponse(); }
}

// @Route("/api/trialitem/save/{id}", "POST")
// @Route("/api/trialitem/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetTrialItem implements IReturn<SetTrialItemResponse>
{
    /** @description The TrialItem Form data to save */
    // @ApiMember(DataType="TrialItem", Description="The TrialItem Form data to save", IsRequired=true, Name="TrialItem", ParameterType="body")
    public trialItem: TrialItem;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetTrialItem>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetTrialItem'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetTrialItemResponse(); }
}

// @Route("/api/trialitems/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateTrialItem implements IReturn<CreateTrialItemResponse>
{
    /** @description The primary key Id of the trial */
    // @ApiMember(DataType="string", Description="The primary key Id of the trial", IsRequired=true, Name="TrialId", ParameterType="path")
    public trialId: number;

    public constructor(init?: Partial<CreateTrialItem>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateTrialItem'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateTrialItemResponse(); }
}

// @Route("/api/trialfinance/trialid/{trialid}", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialFinanceByTrialId implements IReturn<GetTrialFinanceByTrialIdResponse>
{
    public trialId: number;

    public constructor(init?: Partial<GetTrialFinanceByTrialId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialFinanceByTrialId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialFinanceByTrialIdResponse(); }
}

// @Route("/api/trialfinance/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Trial Finance not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialFinanceById implements IReturn<GetTrialFinanceByIdResponse>, IGet
{
    /** @description The primary key Id of the trial finance */
    // @ApiMember(DataType="string", Description="The primary key Id of the trial finance", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetTrialFinanceById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialFinanceById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialFinanceByIdResponse(); }
}

// @Route("/api/trialfinance/save/{Id}", "POST")
// @Route("/api/trialfinance/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetTrialFinance implements IReturn<SetTrialFinanceResponse>
{
    /** @description The TrialFinance Form data to save */
    // @ApiMember(DataType="TrialFinance", Description="The TrialFinance Form data to save", IsRequired=true, Name="trialFinance", ParameterType="body")
    public trialFinance: TrialFinance;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetTrialFinance>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetTrialFinance'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetTrialFinanceResponse(); }
}

// @Route("/api/trialfinance/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateTrialFinance implements IReturn<CreateTrialFinanceResponse>
{
    public trialId: number;

    public constructor(init?: Partial<CreateTrialFinance>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateTrialFinance'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateTrialFinanceResponse(); }
}

// @Route("/api/trialfinance/validate/{Id}", "POST")
// @Route("/api/trialfinance/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateTrialFinance implements IReturn<ValidateTrialFinanceResponse>
{
    /** @description The TrialFinance Form data to validate */
    // @ApiMember(DataType="TrialFinance", Description="The TrialFinance Form data to validate", IsRequired=true, Name="trialFinance", ParameterType="body")
    public trialFinance: TrialFinance;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateTrialFinance>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateTrialFinance'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateTrialFinanceResponse(); }
}

// @Route("/api/trialgroupcontract/trialgroupid/{trialgroupid}", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialGroupContractByTrialGroupId implements IReturn<GetTrialGroupContractByTrialGroupIdResponse>
{
    public trialGroupId: number;

    public constructor(init?: Partial<GetTrialGroupContractByTrialGroupId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialGroupContractByTrialGroupId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialGroupContractByTrialGroupIdResponse(); }
}

// @Route("/api/trialgroupcontract/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Trial Group Contract not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialGroupContractById implements IReturn<GetTrialGroupContractByIdResponse>, IGet
{
    /** @description The primary key Id of the trial group contract */
    // @ApiMember(DataType="string", Description="The primary key Id of the trial group contract", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetTrialGroupContractById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialGroupContractById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialGroupContractByIdResponse(); }
}

// @Route("/api/trialgroupcontract/save/{Id}", "POST")
// @Route("/api/trialgroupcontract/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetTrialGroupContract implements IReturn<SetTrialGroupContractResponse>
{
    /** @description The TrialGroupContract Form data to save */
    // @ApiMember(DataType="TrialGroupContract", Description="The TrialGroupContract Form data to save", IsRequired=true, Name="trialContract", ParameterType="body")
    public trialGroupContract: TrialGroupContract;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetTrialGroupContract>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetTrialGroupContract'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetTrialGroupContractResponse(); }
}

// @Route("/api/trialgroupcontract/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateTrialGroupContract implements IReturn<CreateTrialGroupContractResponse>
{
    public trialGroupId: number;

    public constructor(init?: Partial<CreateTrialGroupContract>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateTrialGroupContract'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateTrialGroupContractResponse(); }
}

// @Route("/api/trialgroupcontract/validate/{Id}", "POST")
// @Route("/api/trialgroupcontract/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateTrialGroupContract implements IReturn<ValidateTrialGroupContractResponse>
{
    /** @description The TrialGroupContract Form data to validate */
    // @ApiMember(DataType="TrialGroupContract", Description="The TrialGroupContract Form data to validate", IsRequired=true, Name="trialContract", ParameterType="body")
    public trialGroupContract: TrialGroupContract;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateTrialGroupContract>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateTrialGroupContract'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateTrialGroupContractResponse(); }
}

// @Route("/api/trialgroupcontract/delete/{Id}", "POST")
// @Route("/api/trialgroupcontract/delete", "POST")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Trial Group Contract not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class DeleteTrialGroupContract implements IReturn<DeleteTrialGroupContractResponse>
{
    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<DeleteTrialGroupContract>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteTrialGroupContract'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new DeleteTrialGroupContractResponse(); }
}

// @Route("/api/trialgroupfinance/trialgroupid/{trialgroupid}", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialGroupFinanceByTrialGroupId implements IReturn<GetTrialGroupFinanceByTrialGroupIdResponse>
{
    public trialGroupId: number;

    public constructor(init?: Partial<GetTrialGroupFinanceByTrialGroupId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialGroupFinanceByTrialGroupId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialGroupFinanceByTrialGroupIdResponse(); }
}

// @Route("/api/trialgroupfinance/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Trial Group Finance not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialGroupFinanceById implements IReturn<GetTrialGroupFinanceByIdResponse>, IGet
{
    /** @description The primary key Id of the trial group finance */
    // @ApiMember(DataType="string", Description="The primary key Id of the trial group finance", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetTrialGroupFinanceById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialGroupFinanceById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialGroupFinanceByIdResponse(); }
}

// @Route("/api/trialgroupfinance/save/{Id}", "POST")
// @Route("/api/trialgroupfinance/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetTrialGroupFinance implements IReturn<SetTrialGroupFinanceResponse>
{
    /** @description The TrialGroupFinance Form data to save */
    // @ApiMember(DataType="TrialGroupFinance", Description="The TrialGroupFinance Form data to save", IsRequired=true, Name="trialFinance", ParameterType="body")
    public trialGroupFinance: TrialGroupFinance;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetTrialGroupFinance>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetTrialGroupFinance'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetTrialGroupFinanceResponse(); }
}

// @Route("/api/trialgroupfinance/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateTrialGroupFinance implements IReturn<CreateTrialGroupFinanceResponse>
{
    public trialGroupId: number;

    public constructor(init?: Partial<CreateTrialGroupFinance>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateTrialGroupFinance'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateTrialGroupFinanceResponse(); }
}

// @Route("/api/trialgroupfinance/validate/{Id}", "POST")
// @Route("/api/trialgroupfinance/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateTrialGroupFinance implements IReturn<ValidateTrialGroupFinanceResponse>
{
    /** @description The TrialGroupFinance Form data to validate */
    // @ApiMember(DataType="TrialGroupFinance", Description="The TrialGroupFinance Form data to validate", IsRequired=true, Name="trialFinance", ParameterType="body")
    public trialGroupFinance: TrialGroupFinance;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateTrialGroupFinance>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateTrialGroupFinance'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateTrialGroupFinanceResponse(); }
}

// @Route("/api/trialgroupitemcategories", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialGroupItemCategoriesByTrialGroupId implements IReturn<GetTrialGroupItemCategoriesByTrialGroupIdResponse>
{
    public trialGroupId?: number;

    public constructor(init?: Partial<GetTrialGroupItemCategoriesByTrialGroupId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialGroupItemCategoriesByTrialGroupId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialGroupItemCategoriesByTrialGroupIdResponse(); }
}

// @Route("/api/trialgroupitemtemplatecategories", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialGroupItemTemplateCategories implements IReturn<GetTrialGroupItemTemplateCategoriesResponse>
{

    public constructor(init?: Partial<GetTrialGroupItemTemplateCategories>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialGroupItemTemplateCategories'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialGroupItemTemplateCategoriesResponse(); }
}

// @Route("/api/trialgroupitemtemplatecategory/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Category not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialGroupItemTemplateCategoryById implements IReturn<GetTrialGroupItemTemplateCategoryByIdResponse>, IGet
{
    /** @description The primary key Id of the categories */
    // @ApiMember(DataType="string", Description="The primary key Id of the categories", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetTrialGroupItemTemplateCategoryById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialGroupItemTemplateCategoryById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialGroupItemTemplateCategoryByIdResponse(); }
}

// @Route("/api/trialgroupitemtemplatecategory/save/{Id}", "POST")
// @Route("/api/trialgroupitemtemplatecategory/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetTrialGroupItemTemplateCategory implements IReturn<SetTrialGroupItemTemplateCategoryResponse>
{
    /** @description The TrialGroupItemTemplateCategory Form data to save */
    // @ApiMember(DataType="TrialGroupItemTemplateCategory", Description="The TrialGroupItemTemplateCategory Form data to save", IsRequired=true, Name="TrialGroupItemTemplateCategory", ParameterType="body")
    public trialGroupItemTemplateCategory: TrialGroupItemTemplateCategory;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetTrialGroupItemTemplateCategory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetTrialGroupItemTemplateCategory'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetTrialGroupItemTemplateCategoryResponse(); }
}

// @Route("/api/trialgroupitemtemplatecategory/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateTrialGroupItemTemplateCategory implements IReturn<CreateTrialGroupItemTemplateCategoryResponse>
{

    public constructor(init?: Partial<CreateTrialGroupItemTemplateCategory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateTrialGroupItemTemplateCategory'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateTrialGroupItemTemplateCategoryResponse(); }
}

// @Route("/api/trialgroupitemtemplatecategory/validate/{Id}", "POST")
// @Route("/api/trialgroupitemtemplatecategory/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateTrialGroupItemTemplateCategory implements IReturn<ValidateTrialGroupItemTemplateCategoryResponse>
{
    /** @description The TrialGroupItemTemplateCategory Form data to validate */
    // @ApiMember(DataType="TrialGroupItemTemplateCategory", Description="The TrialGroupItemTemplateCategory Form data to validate", IsRequired=true, Name="TrialGroupItemTemplateCategory", ParameterType="body")
    public trialGroupItemTemplateCategory: TrialGroupItemTemplateCategory;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateTrialGroupItemTemplateCategory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateTrialGroupItemTemplateCategory'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateTrialGroupItemTemplateCategoryResponse(); }
}

// @Route("/api/trialgrouplaboratorycontract/trialgrouplaboratoryid/{trialgrouplaboratoryid}", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialGroupLaboratoryContractByTrialGroupLaboratoryId implements IReturn<GetTrialGroupLaboratoryContractByTrialGroupLaboratoryIdResponse>
{
    public trialGroupLaboratoryId: number;

    public constructor(init?: Partial<GetTrialGroupLaboratoryContractByTrialGroupLaboratoryId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialGroupLaboratoryContractByTrialGroupLaboratoryId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialGroupLaboratoryContractByTrialGroupLaboratoryIdResponse(); }
}

// @Route("/api/trialgrouplaboratorycontract/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Trial Group Laboratory Contract not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialGroupLaboratoryContractById implements IReturn<GetTrialGroupLaboratoryContractByIdResponse>, IGet
{
    /** @description The primary key Id of the trial group laboratory contract */
    // @ApiMember(DataType="string", Description="The primary key Id of the trial group laboratory contract", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetTrialGroupLaboratoryContractById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialGroupLaboratoryContractById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialGroupLaboratoryContractByIdResponse(); }
}

// @Route("/api/trialgrouplaboratorycontract/save/{Id}", "POST")
// @Route("/api/trialgrouplaboratorycontract/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetTrialGroupLaboratoryContract implements IReturn<SetTrialGroupLaboratoryContractResponse>
{
    /** @description The TrialGroupLaboratoryContract Form data to save */
    // @ApiMember(DataType="TrialGroupLaboratoryContract", Description="The TrialGroupLaboratoryContract Form data to save", IsRequired=true, Name="trialGroupLaboratoryContract", ParameterType="body")
    public trialGroupLaboratoryContract: TrialGroupLaboratoryContract;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetTrialGroupLaboratoryContract>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetTrialGroupLaboratoryContract'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetTrialGroupLaboratoryContractResponse(); }
}

// @Route("/api/trialgrouplaboratorycontract/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateTrialGroupLaboratoryContract implements IReturn<CreateTrialGroupLaboratoryContractResponse>
{
    public trialGroupLaboratoryId: number;

    public constructor(init?: Partial<CreateTrialGroupLaboratoryContract>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateTrialGroupLaboratoryContract'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateTrialGroupLaboratoryContractResponse(); }
}

// @Route("/api/trialgrouplaboratorycontract/validate/{Id}", "POST")
// @Route("/api/trialgrouplaboratorycontract/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateTrialGroupLaboratoryContract implements IReturn<ValidateTrialGroupLaboratoryContractResponse>
{
    /** @description The TrialGroupLaboratoryContract Form data to validate */
    // @ApiMember(DataType="TrialGroupLaboratoryContract", Description="The TrialGroupLaboratoryContract Form data to validate", IsRequired=true, Name="trialGroupLaboratoryContract", ParameterType="body")
    public trialGroupLaboratoryContract: TrialGroupLaboratoryContract;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateTrialGroupLaboratoryContract>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateTrialGroupLaboratoryContract'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateTrialGroupLaboratoryContractResponse(); }
}

// @Route("/api/trialgrouplaboratorycontract/delete/{Id}", "POST")
// @Route("/api/trialgrouplaboratorycontract/delete", "POST")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Trial Group Laboratory Contract not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class DeleteTrialGroupLaboratoryContract implements IReturn<DeleteTrialGroupLaboratoryContractResponse>
{
    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<DeleteTrialGroupLaboratoryContract>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteTrialGroupLaboratoryContract'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new DeleteTrialGroupLaboratoryContractResponse(); }
}

// @Route("/api/trialgrouplaboratoryfinance/trialgrouplaboratoryid/{trialgrouplaboratoryid}", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialGroupLaboratoryFinanceByTrialGroupLaboratoryId implements IReturn<GetTrialGroupLaboratoryFinanceByTrialGroupLaboratoryIdResponse>
{
    public trialGroupLaboratoryId: number;

    public constructor(init?: Partial<GetTrialGroupLaboratoryFinanceByTrialGroupLaboratoryId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialGroupLaboratoryFinanceByTrialGroupLaboratoryId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialGroupLaboratoryFinanceByTrialGroupLaboratoryIdResponse(); }
}

// @Route("/api/trialgrouplaboratoryfinance/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Trial Group Laboratory Finance not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialGroupLaboratoryFinanceById implements IReturn<GetTrialGroupLaboratoryFinanceByIdResponse>, IGet
{
    /** @description The primary key Id of the trial group laboratory finance */
    // @ApiMember(DataType="string", Description="The primary key Id of the trial group laboratory finance", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetTrialGroupLaboratoryFinanceById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialGroupLaboratoryFinanceById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialGroupLaboratoryFinanceByIdResponse(); }
}

// @Route("/api/trialgrouplaboratoryfinance/save/{Id}", "POST")
// @Route("/api/trialgrouplaboratoryfinance/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetTrialGroupLaboratoryFinance implements IReturn<SetTrialGroupLaboratoryFinanceResponse>
{
    /** @description The TrialGroupLaboratoryFinance Form data to save */
    // @ApiMember(DataType="TrialGroupLaboratoryFinance", Description="The TrialGroupLaboratoryFinance Form data to save", IsRequired=true, Name="trialGroupLaboratoryFinance", ParameterType="body")
    public trialGroupLaboratoryFinance: TrialGroupLaboratoryFinance;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetTrialGroupLaboratoryFinance>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetTrialGroupLaboratoryFinance'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetTrialGroupLaboratoryFinanceResponse(); }
}

// @Route("/api/trialgrouplaboratoryfinance/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateTrialGroupLaboratoryFinance implements IReturn<CreateTrialGroupLaboratoryFinanceResponse>
{
    public trialGroupLaboratoryId: number;

    public constructor(init?: Partial<CreateTrialGroupLaboratoryFinance>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateTrialGroupLaboratoryFinance'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateTrialGroupLaboratoryFinanceResponse(); }
}

// @Route("/api/trialgrouplaboratoryfinance/validate/{Id}", "POST")
// @Route("/api/trialgrouplaboratoryfinance/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateTrialGroupLaboratoryFinance implements IReturn<ValidateTrialGroupLaboratoryFinanceResponse>
{
    /** @description The TrialGroupLaboratoryFinance Form data to validate */
    // @ApiMember(DataType="TrialGroupLaboratoryFinance", Description="The TrialGroupLaboratoryFinance Form data to validate", IsRequired=true, Name="trialGroupLaboratoryFinance", ParameterType="body")
    public trialGroupLaboratoryFinance: TrialGroupLaboratoryFinance;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateTrialGroupLaboratoryFinance>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateTrialGroupLaboratoryFinance'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateTrialGroupLaboratoryFinanceResponse(); }
}

// @Route("/api/trialgrouplaboratorypersonnels", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialGroupLaboratoryPersonnels implements IReturn<GetTrialGroupLaboratoryPersonnelsResponse>
{

    public constructor(init?: Partial<GetTrialGroupLaboratoryPersonnels>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialGroupLaboratoryPersonnels'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialGroupLaboratoryPersonnelsResponse(); }
}

// @Route("/api/trialgrouplaboratorypersonnel/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Trial Group Laboratory Personnel not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialGroupLaboratoryPersonnelById implements IReturn<GetTrialGroupLaboratoryPersonnelByIdResponse>, IGet
{
    /** @description The primary key Id of the Trial Group Laboratory Personnel */
    // @ApiMember(DataType="string", Description="The primary key Id of the Trial Group Laboratory Personnel", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetTrialGroupLaboratoryPersonnelById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialGroupLaboratoryPersonnelById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialGroupLaboratoryPersonnelByIdResponse(); }
}

// @Route("/api/trialgrouplaboratorypersonnel/trialgrouplaboratoryid/{trialgrouplaboratoryId}", "GET")
// @ApiResponse(Description="Trial Group Laboratory Id is invalid", StatusCode=400)
// @ApiResponse(Description="Trial Group Laboratory personnel not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialGroupLaboratoryPersonnelByLaboratoryId implements IReturn<GetTrialGroupLaboratoryPersonnelByLaboratoryIdResponse>, IGet
{
    /** @description The trial group laboratory id of the trial group laboratory personnel */
    // @ApiMember(DataType="string", Description="The trial group laboratory id of the trial group laboratory personnel", IsRequired=true, Name="TrialGroupLaboratoryId", ParameterType="path")
    public trialGroupLaboratoryId: number;

    public constructor(init?: Partial<GetTrialGroupLaboratoryPersonnelByLaboratoryId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialGroupLaboratoryPersonnelByLaboratoryId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialGroupLaboratoryPersonnelByLaboratoryIdResponse(); }
}

// @Route("/api/trialgrouplaboratorypersonnel/save/{Id}", "POST")
// @Route("/api/trialgrouplaboratorypersonnel/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetTrialGroupLaboratoryPersonnel implements IReturn<SetTrialGroupLaboratoryPersonnelResponse>
{
    /** @description The Trial Group Laboratory Personnel Form data to save */
    // @ApiMember(DataType="TrialGroupLaboratoryPersonnel", Description="The Trial Group Laboratory Personnel Form data to save", IsRequired=true, Name="TrialGroupLaboratoryPersonnel", ParameterType="body")
    public trialGroupLaboratoryPersonnel: TrialGroupLaboratoryPersonnel;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetTrialGroupLaboratoryPersonnel>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetTrialGroupLaboratoryPersonnel'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetTrialGroupLaboratoryPersonnelResponse(); }
}

// @Route("/api/trialgrouplaboratorypersonnel/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateTrialGroupLaboratoryPersonnel implements IReturn<CreateTrialGroupLaboratoryPersonnelResponse>
{
    /** @description The primary key Id of the Trial Group Laboratory associated to the Trial Group Laboratory Personnel */
    // @ApiMember(DataType="string", Description="The primary key Id of the Trial Group Laboratory associated to the Trial Group Laboratory Personnel", IsRequired=true, Name="TrialGroupLaboratoryId", ParameterType="path")
    public trialGroupLaboratoryId: number;

    public constructor(init?: Partial<CreateTrialGroupLaboratoryPersonnel>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateTrialGroupLaboratoryPersonnel'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateTrialGroupLaboratoryPersonnelResponse(); }
}

// @Route("/api/trialgrouplaboratorypersonnel/validate/{Id}", "POST")
// @Route("/api/trialgrouplaboratorypersonnel/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateTrialGroupLaboratoryPersonnel implements IReturn<ValidateTrialGroupLaboratoryPersonnelResponse>
{
    /** @description The Trial Group Laboratory Personnel Form data to validate */
    // @ApiMember(DataType="TrialGroupLaboratoryPersonnel", Description="The Trial Group Laboratory Personnel Form data to validate", IsRequired=true, Name="TrialGroupLaboratoryPersonnel", ParameterType="body")
    public trialGroupLaboratoryPersonnel: TrialGroupLaboratoryPersonnel;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateTrialGroupLaboratoryPersonnel>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateTrialGroupLaboratoryPersonnel'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateTrialGroupLaboratoryPersonnelResponse(); }
}

// @Route("/api/trialgrouplaboratory", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialGroupLaboratories implements IReturn<GetTrialGroupLaboratoriesResponse>
{

    public constructor(init?: Partial<GetTrialGroupLaboratories>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialGroupLaboratories'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialGroupLaboratoriesResponse(); }
}

// @Route("/api/trialgrouplaboratory/trialgroupid/{trialgroupid}", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialGroupLaboratoriesByTrialGroupId implements IReturn<GetTrialGroupLaboratoriesByTrialGroupIdResponse>
{
    /** @description The primary key Id of the Trial Group */
    // @ApiMember(DataType="int", Description="The primary key Id of the Trial Group", Name="TrialGroupId", ParameterType="path")
    public trialGroupId?: number;

    public constructor(init?: Partial<GetTrialGroupLaboratoriesByTrialGroupId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialGroupLaboratoriesByTrialGroupId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialGroupLaboratoriesByTrialGroupIdResponse(); }
}

// @Route("/api/trialgrouplaboratory/trialid/{trialid}", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialGroupLaboratoriesByTrialId implements IReturn<GetTrialGroupLaboratoriesByTrialIdResponse>
{
    /** @description The primary key Id of the Trial */
    // @ApiMember(DataType="int", Description="The primary key Id of the Trial", Name="TrialId", ParameterType="path")
    public trialId?: number;

    public constructor(init?: Partial<GetTrialGroupLaboratoriesByTrialId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialGroupLaboratoriesByTrialId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialGroupLaboratoriesByTrialIdResponse(); }
}

// @Route("/api/trialgrouplaboratory/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Trial Group Laboratory not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialGroupLaboratoryById implements IReturn<GetTrialGroupLaboratoryByIdResponse>, IGet
{
    /** @description The primary key Id of the Trial Group Laboratory */
    // @ApiMember(DataType="int", Description="The primary key Id of the Trial Group Laboratory", Name="Id", ParameterType="path")
    public id?: number;

    public constructor(init?: Partial<GetTrialGroupLaboratoryById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialGroupLaboratoryById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialGroupLaboratoryByIdResponse(); }
}

// @Route("/api/trialgrouplaboratory/laboratoryid/{laboratoryId}", "GET")
// @ApiResponse(Description="Laboratory Id is invalid", StatusCode=400)
// @ApiResponse(Description="Group Laboratory not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialGroupLaboratoryByLaboratoryId implements IReturn<GetTrialGroupLaboratoryByLaboratoryIdResponse>, IGet
{
    /** @description The laboratory id of the trial group laboratory */
    // @ApiMember(DataType="int", Description="The laboratory id of the trial group laboratory", Name="LaboratoryId", ParameterType="path")
    public laboratoryId?: number;

    public constructor(init?: Partial<GetTrialGroupLaboratoryByLaboratoryId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialGroupLaboratoryByLaboratoryId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialGroupLaboratoryByLaboratoryIdResponse(); }
}

// @Route("/api/trialgrouplaboratory/save/{Id}", "POST")
// @Route("/api/trialgrouplaboratory/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetTrialGroupLaboratory implements IReturn<SetTrialGroupLaboratoryResponse>
{
    /** @description The Trial Group Laboratory Form data to save */
    // @ApiMember(DataType="TrialGroupLaboratory", Description="The Trial Group Laboratory Form data to save", IsRequired=true, Name="Id", ParameterType="body")
    public trialGroupLaboratory: TrialGroupLaboratory;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetTrialGroupLaboratory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetTrialGroupLaboratory'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetTrialGroupLaboratoryResponse(); }
}

// @Route("/api/trialgrouplaboratory/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateTrialGroupLaboratory implements IReturn<CreateTrialGroupLaboratoryResponse>
{
    /** @description The primary key Id of the Laboratory associated to the trial group laboratory */
    // @ApiMember(DataType="int", Description="The primary key Id of the Laboratory associated to the trial group laboratory", Name="LaboratoryId", ParameterType="path")
    public laboratoryId?: number;

    /** @description The primary key Id of the TrialGroup associated to the trial group laboratory */
    // @ApiMember(DataType="int", Description="The primary key Id of the TrialGroup associated to the trial group laboratory", Name="TrialGroupId", ParameterType="path")
    public trialGroupId?: number;

    public constructor(init?: Partial<CreateTrialGroupLaboratory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateTrialGroupLaboratory'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateTrialGroupLaboratoryResponse(); }
}

// @Route("/api/trialgrouplaboratory/delete/{Id}", "POST")
// @Route("/api/trialgrouplaboratory/delete", "POST")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Trial Institution Group not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class DeleteTrialGroupLaboratory implements IReturn<DeleteTrialGroupLaboratoryResponse>
{
    /** @description The Id */
    // @ApiMember(DataType="int", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<DeleteTrialGroupLaboratory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteTrialGroupLaboratory'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new DeleteTrialGroupLaboratoryResponse(); }
}

// @Route("/api/trialgrouplaboratory/validate/{Id}", "POST")
// @Route("/api/trialgrouplaboratory/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateTrialGroupLaboratory implements IReturn<ValidateTrialGroupLaboratoryResponse>
{
    /** @description The Trial Group Laboratory Form data to validate */
    // @ApiMember(DataType="TrialGroupLaboratory", Description="The Trial Group Laboratory Form data to validate", IsRequired=true, Name="Id", ParameterType="body")
    public trialGroupLaboratory: TrialGroupLaboratory;

    /** @description The Id */
    // @ApiMember(DataType="int", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateTrialGroupLaboratory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateTrialGroupLaboratory'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateTrialGroupLaboratoryResponse(); }
}

// @Route("/api/trialgroups", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialGroups implements IReturn<GetTrialGroupsResponse>
{

    public constructor(init?: Partial<GetTrialGroups>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialGroups'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialGroupsResponse(); }
}

// @Route("/api/trialgroup/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Trial Group not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialGroupById implements IReturn<GetTrialGroupByIdResponse>, IGet
{
    /** @description The primary key Id of the trial group */
    // @ApiMember(DataType="string", Description="The primary key Id of the trial group", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetTrialGroupById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialGroupById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialGroupByIdResponse(); }
}

// @Route("/api/trialgroup/groupid/{groupId}", "GET")
// @ApiResponse(Description="Group Id is invalid", StatusCode=400)
// @ApiResponse(Description="Trial Group not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialGroupsByGroupId implements IReturn<GetTrialGroupsByGroupIdResponse>, IGet
{
    /** @description The Group Id of the trial group */
    // @ApiMember(DataType="string", Description="The Group Id of the trial group", IsRequired=true, Name="GroupId", ParameterType="path")
    public groupId: number;

    public constructor(init?: Partial<GetTrialGroupsByGroupId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialGroupsByGroupId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialGroupsByGroupIdResponse(); }
}

// @Route("/api/trialgroup/trialid/{trialid}", "GET")
// @ApiResponse(Description="Trial Id is invalid", StatusCode=400)
// @ApiResponse(Description="Trial Group not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialGroupsByTrialId implements IReturn<GetTrialGroupsByTrialIdResponse>, IGet
{
    /** @description The Trial Id of the trial group */
    // @ApiMember(DataType="string", Description="The Trial Id of the trial group", IsRequired=true, Name="TrialId", ParameterType="path")
    public trialId: number;

    public constructor(init?: Partial<GetTrialGroupsByTrialId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialGroupsByTrialId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialGroupsByTrialIdResponse(); }
}

// @Route("/api/trialgroup/save/{Id}", "POST")
// @Route("/api/trialgroup/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetTrialGroup implements IReturn<SetTrialGroupResponse>
{
    /** @description The TrialGroup Form data to save */
    // @ApiMember(DataType="TrialGroup", Description="The TrialGroup Form data to save", IsRequired=true, Name="TrialGroup", ParameterType="body")
    public trialGroup: TrialGroup;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetTrialGroup>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetTrialGroup'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetTrialGroupResponse(); }
}

// @Route("/api/trialgroup/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateTrialGroup implements IReturn<CreateTrialGroupResponse>
{
    public trialId: number;

    public constructor(init?: Partial<CreateTrialGroup>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateTrialGroup'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateTrialGroupResponse(); }
}

/** @description TMD */
// @Route("/api/trial-coordinatinggroups/get-by-trial-id", "GET")
// @Api(Description="TMD")
// @ApiResponse(Description="Not authorized", StatusCode=401)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
// @DataContract
export class GetTrialCoordinatingGroupsByTrialId implements IReturn<GetTrialCoordinatingGroupsByTrialIdResponse>, IGet
{
    /** @description The trial id to get trial coordinating groups for */
    // @DataMember(Order=1)
    // @ApiMember(DataType="integer", Description="The trial id to get trial coordinating groups for", Format="int32", IsRequired=true, Name="TrialId", ParameterType="query")
    public trialId: number;

    public constructor(init?: Partial<GetTrialCoordinatingGroupsByTrialId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialCoordinatingGroupsByTrialId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialCoordinatingGroupsByTrialIdResponse(); }
}

/** @description TMD */
// @Route("/api/trial-mastergroups/get-by-trial-id", "GET")
// @Api(Description="TMD")
// @ApiResponse(Description="Not authorized", StatusCode=401)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
// @DataContract
export class GetTrialMasterGroupsByTrialId implements IReturn<GetTrialMasterGroupsByTrialIdResponse>, IGet
{
    /** @description The trial id to get trial master groups for */
    // @DataMember(Order=1)
    // @ApiMember(DataType="int", Description="The trial id to get trial master groups for", IsRequired=true, Name="TrialId", ParameterType="query")
    public trialId: number;

    public constructor(init?: Partial<GetTrialMasterGroupsByTrialId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialMasterGroupsByTrialId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialMasterGroupsByTrialIdResponse(); }
}

// @Route("/api/trialinstitutioncontract/trialinstitutionid/{trialinstitutionid}", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialInstitutionContractByTrialInstitutionId implements IReturn<GetTrialInstitutionContractByTrialInstitutionIdResponse>
{
    public trialInstitutionId: number;

    public constructor(init?: Partial<GetTrialInstitutionContractByTrialInstitutionId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialInstitutionContractByTrialInstitutionId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialInstitutionContractByTrialInstitutionIdResponse(); }
}

// @Route("/api/trialinstitutioncontract/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Trial Institution Contract not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialInstitutionContractById implements IReturn<GetTrialInstitutionContractByIdResponse>, IGet
{
    /** @description The primary key Id of the trial institution contract */
    // @ApiMember(DataType="string", Description="The primary key Id of the trial institution contract", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetTrialInstitutionContractById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialInstitutionContractById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialInstitutionContractByIdResponse(); }
}

// @Route("/api/trialinstitutioncontract/save/{Id}", "POST")
// @Route("/api/trialinstitutioncontract/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetTrialInstitutionContract implements IReturn<SetTrialInstitutionContractResponse>
{
    /** @description The TrialInstitutionContract Form data to save */
    // @ApiMember(DataType="TrialInstitutionContract", Description="The TrialInstitutionContract Form data to save", IsRequired=true, Name="trialContract", ParameterType="body")
    public trialInstitutionContract: TrialInstitutionContract;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetTrialInstitutionContract>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetTrialInstitutionContract'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetTrialInstitutionContractResponse(); }
}

// @Route("/api/trialinstitutioncontract/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateTrialInstitutionContract implements IReturn<CreateTrialInstitutionContractResponse>
{
    public trialInstitutionId: number;

    public constructor(init?: Partial<CreateTrialInstitutionContract>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateTrialInstitutionContract'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateTrialInstitutionContractResponse(); }
}

// @Route("/api/trialinstitutioncontract/validate/{Id}", "POST")
// @Route("/api/trialinstitutioncontract/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateTrialInstitutionContract implements IReturn<ValidateTrialInstitutionContractResponse>
{
    /** @description The TrialInstitutionContract Form data to validate */
    // @ApiMember(DataType="TrialInstitutionContract", Description="The TrialInstitutionContract Form data to validate", IsRequired=true, Name="trialContract", ParameterType="body")
    public trialInstitutionContract: TrialInstitutionContract;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateTrialInstitutionContract>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateTrialInstitutionContract'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateTrialInstitutionContractResponse(); }
}

// @Route("/api/trialinstitutioncontract/delete/{Id}", "POST")
// @Route("/api/trialinstitutioncontract/delete", "POST")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Trial Institution Contract not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class DeleteTrialInstitutionContract implements IReturn<DeleteTrialInstitutionContractResponse>
{
    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<DeleteTrialInstitutionContract>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteTrialInstitutionContract'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new DeleteTrialInstitutionContractResponse(); }
}

// @Route("/api/trialinstitutionfinance/trialinstitutionid/{trialinstitutionid}", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialInstitutionFinanceByTrialInstitutionId implements IReturn<GetTrialInstitutionFinanceByTrialInstitutionIdResponse>
{
    public trialInstitutionId: number;

    public constructor(init?: Partial<GetTrialInstitutionFinanceByTrialInstitutionId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialInstitutionFinanceByTrialInstitutionId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialInstitutionFinanceByTrialInstitutionIdResponse(); }
}

// @Route("/api/trialinstitutionfinance/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Trial Institution Finance not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialInstitutionFinanceById implements IReturn<GetTrialInstitutionFinanceByIdResponse>, IGet
{
    /** @description The primary key Id of the trial institution finance */
    // @ApiMember(DataType="string", Description="The primary key Id of the trial institution finance", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetTrialInstitutionFinanceById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialInstitutionFinanceById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialInstitutionFinanceByIdResponse(); }
}

// @Route("/api/trialinstitutionfinance/save/{Id}", "POST")
// @Route("/api/trialinstitutionfinance/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetTrialInstitutionFinance implements IReturn<SetTrialInstitutionFinanceResponse>
{
    /** @description The TrialInstitutionFinance Form data to save */
    // @ApiMember(DataType="TrialInstitutionFinance", Description="The TrialInstitutionFinance Form data to save", IsRequired=true, Name="trialFinance", ParameterType="body")
    public trialInstitutionFinance: TrialInstitutionFinance;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetTrialInstitutionFinance>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetTrialInstitutionFinance'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetTrialInstitutionFinanceResponse(); }
}

// @Route("/api/trialinstitutionfinance/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateTrialInstitutionFinance implements IReturn<CreateTrialInstitutionFinanceResponse>
{
    public trialInstitutionId: number;

    public constructor(init?: Partial<CreateTrialInstitutionFinance>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateTrialInstitutionFinance'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateTrialInstitutionFinanceResponse(); }
}

// @Route("/api/trialinstitutionfinance/validate/{Id}", "POST")
// @Route("/api/trialinstitutionfinance/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateTrialInstitutionFinance implements IReturn<ValidateTrialInstitutionFinanceResponse>
{
    /** @description The TrialInstitutionFinance Form data to validate */
    // @ApiMember(DataType="TrialInstitutionFinance", Description="The TrialInstitutionFinance Form data to validate", IsRequired=true, Name="trialFinance", ParameterType="body")
    public trialInstitutionFinance: TrialInstitutionFinance;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateTrialInstitutionFinance>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateTrialInstitutionFinance'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateTrialInstitutionFinanceResponse(); }
}

// @Route("/api/trialinstitutionitemcategories", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialInstitutionItemCategoriesByTrialInstitutionId implements IReturn<GetTrialInstitutionItemCategoriesByTrialInstitutionIdResponse>
{
    public trialInstitutionId?: number;

    public constructor(init?: Partial<GetTrialInstitutionItemCategoriesByTrialInstitutionId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialInstitutionItemCategoriesByTrialInstitutionId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialInstitutionItemCategoriesByTrialInstitutionIdResponse(); }
}

// @Route("/api/trialinstitutionitemcustomviews", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialInstitutionItemCustomViews implements IReturn<GetTrialInstitutionItemCustomViewsResponse>
{
    public trialId: number;

    public constructor(init?: Partial<GetTrialInstitutionItemCustomViews>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialInstitutionItemCustomViews'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialInstitutionItemCustomViewsResponse(); }
}

// @Route("/api/trialinstitutionitemcustomviews/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Institution custom view not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialInstitutionItemCustomViewById implements IReturn<GetTrialInstitutionItemCustomViewByIdResponse>, IGet
{
    /** @description The primary key Id of the trial institution custom view */
    // @ApiMember(DataType="string", Description="The primary key Id of the trial institution custom view", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetTrialInstitutionItemCustomViewById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialInstitutionItemCustomViewById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialInstitutionItemCustomViewByIdResponse(); }
}

// @Route("/api/trialinstitutionitemcustomviews/id/{Id}/csv", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Institution custom view not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialInstitutionItemCustomViewCsvById implements IReturn<Blob>, IGet
{
    /** @description The primary key Id of the trial institution custom view */
    // @ApiMember(DataType="string", Description="The primary key Id of the trial institution custom view", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetTrialInstitutionItemCustomViewCsvById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialInstitutionItemCustomViewCsvById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/api/trialinstitutionitemcustomviews/save/{Id}", "POST")
// @Route("/api/trialinstitutionitemcustomviews/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetTrialInstitutionItemCustomView implements IReturn<SetTrialInstitutionItemCustomViewResponse>
{
    /** @description The trial institution custom view data to save */
    // @ApiMember(DataType="TrialInstitutionItemCustomView", Description="The trial institution custom view data to save", IsRequired=true, Name="TrialInstitutionItemCustomView", ParameterType="body")
    public trialInstitutionItemCustomView: TrialInstitutionItemCustomView;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetTrialInstitutionItemCustomView>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetTrialInstitutionItemCustomView'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetTrialInstitutionItemCustomViewResponse(); }
}

// @Route("/api/trialinstitutionitemcustomviews/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateTrialInstitutionItemCustomView implements IReturn<CreateTrialInstitutionItemCustomViewResponse>
{
    public trialId: number;
    public institutionId: number;
    public formTemplateId: number;

    public constructor(init?: Partial<CreateTrialInstitutionItemCustomView>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateTrialInstitutionItemCustomView'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateTrialInstitutionItemCustomViewResponse(); }
}

// @Route("/api/trialinstitutionitemcustomviews/dataentry/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Institution custom view not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialInstitutionItemCustomViewDataEntryById implements IReturn<GetTrialInstitutionItemCustomViewDataEntryByIdResponse>, IGet
{
    /** @description The primary key Id of the trial institution custom view */
    // @ApiMember(DataType="string", Description="The primary key Id of the trial institution custom view", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public byInstitutionColumns: boolean;

    public constructor(init?: Partial<GetTrialInstitutionItemCustomViewDataEntryById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialInstitutionItemCustomViewDataEntryById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialInstitutionItemCustomViewDataEntryByIdResponse(); }
}

// @Route("/api/trialinstitutionitemcustomviews/dataentry/{Id}", "POST")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Institution custom view not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class PostTrialInstitutionItemCustomViewDataEntryById implements IReturn<PostTrialInstitutionItemCustomViewDataEntryByIdResponse>, IPost
{
    /** @description The trial institution custom view data to save */
    // @ApiMember(DataType="TrialInstitutionItemCustomView", Description="The trial institution custom view data to save", IsRequired=true, Name="TrialInstitutionItemCustomView", ParameterType="body")
    public trialInstitutionItemCustomView: TrialInstitutionItemCustomView;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<PostTrialInstitutionItemCustomViewDataEntryById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostTrialInstitutionItemCustomViewDataEntryById'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PostTrialInstitutionItemCustomViewDataEntryByIdResponse(); }
}

// @Route("/api/trialinstitutionitems/trialinstitution/{id}", "GET")
// @ApiResponse(Description="TrialInstitutionItemId is invalid", StatusCode=400)
// @ApiResponse(Description="TrialInstitutionItem not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialInstitutionItemById implements IReturn<GetTrialInstitutionItemByIdResponse>, IGet
{
    /** @description The primary key Id of the TrialInstitutionItem */
    // @ApiMember(DataType="int", Description="The primary key Id of the TrialInstitutionItem", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetTrialInstitutionItemById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialInstitutionItemById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialInstitutionItemByIdResponse(); }
}

// @Route("/api/trialinstitutionitems/siteclosures", "GET")
// @ApiResponse(Description="TrialInstitutionItems not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialInstitutionItemsSiteClosure implements IReturn<GetTrialInstitutionItemsSiteClosureResponse>, IGet
{
    /** @description The primary key Id of the trial institutions */
    // @ApiMember(DataType="string", Description="The primary key Id of the trial institutions", IsRequired=true, Name="TrialInstitutionIds", ParameterType="path")
    public trialInstitutionIds: number[] = [];

    public constructor(init?: Partial<GetTrialInstitutionItemsSiteClosure>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialInstitutionItemsSiteClosure'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialInstitutionItemsSiteClosureResponse(); }
}

// @Route("/api/trialinstitutionitems/trialinstitution/{trialinstitutionid}", "GET")
// @ApiResponse(Description="TrialInstitutionId is invalid", StatusCode=400)
// @ApiResponse(Description="TrialInstitutionItems not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialInstitutionItemsByTrialInstitutionId implements IReturn<GetTrialInstitutionItemsByTrialInstitutionIdResponse>, IGet
{
    /** @description The primary key Id of the trial institution */
    // @ApiMember(DataType="string", Description="The primary key Id of the trial institution", IsRequired=true, Name="TrialInstitutionId", ParameterType="path")
    public trialInstitutionId: number;

    public constructor(init?: Partial<GetTrialInstitutionItemsByTrialInstitutionId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialInstitutionItemsByTrialInstitutionId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialInstitutionItemsByTrialInstitutionIdResponse(); }
}

// @Route("/api/trialinstitutionitems/save/{id}", "POST")
// @Route("/api/trialinstitutionitems/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetTrialInstitutionItem implements IReturn<SetTrialInstitutionItemResponse>
{
    /** @description The TrialInstitutionItem Form data to save */
    // @ApiMember(DataType="TrialInstitutionItem", Description="The TrialInstitutionItem Form data to save", IsRequired=true, Name="TrialInstitutionItem", ParameterType="body")
    public trialInstitutionItem: TrialInstitutionItem;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetTrialInstitutionItem>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetTrialInstitutionItem'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetTrialInstitutionItemResponse(); }
}

// @Route("/api/trialinstitutionitems/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateTrialInstitutionItem implements IReturn<CreateTrialInstitutionItemResponse>
{
    /** @description The primary key Id of the trial institution */
    // @ApiMember(DataType="string", Description="The primary key Id of the trial institution", IsRequired=true, Name="TrialInstitutionId", ParameterType="path")
    public trialInstitutionId: number;

    public constructor(init?: Partial<CreateTrialInstitutionItem>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateTrialInstitutionItem'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateTrialInstitutionItemResponse(); }
}

/** @description TMD */
// @Route("/api/itemtrialinst-approved", "GET")
// @Api(Description="TMD")
// @ApiResponse(Description="Not authorized", StatusCode=401)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
// @DataContract
export class GetTrialInstitutionItemsInstApproved implements IReturn<GetTrialInstitutionItemsInstApprovedResponse>, IGet
{
    /** @description The trial id to get the item for */
    // @DataMember(Order=1)
    // @ApiMember(DataType="integer", Description="The trial id to get the item for", Format="int32", IsRequired=true, Name="TrialId", ParameterType="query")
    public trialId: number;

    /** @description The inst id to get the item for */
    // @DataMember(Order=2)
    // @ApiMember(DataType="integer", Description="The inst id to get the item for", Format="int32", Name="InstId", ParameterType="query")
    public instId?: number;

    /** @description The inst code to get the item for, just in case the inst id is not available */
    // @DataMember(Order=3)
    // @ApiMember(DataType="string", Description="The inst code to get the item for, just in case the inst id is not available", Name="InstCode", ParameterType="query")
    public instCode: string;

    /** @description The category of the item */
    // @DataMember(Order=4)
    // @ApiMember(DataType="integer", Description="The category of the item", Format="int32", Name="TrialInstitutionItemTemplateCategory", ParameterType="query")
    public trialInstitutionItemTemplateCategoryId?: TrialInstitutionItemTemplateCategoryType;

    /** @description The itemno of the item */
    // @DataMember(Order=5)
    // @ApiMember(DataType="integer", Description="The itemno of the item", Format="int32", Name="ItemNo", ParameterType="query")
    public itemNo?: number;

    /** @description The name of the item */
    // @DataMember(Order=6)
    // @ApiMember(DataType="string", Description="The name of the item", Name="ItemName", ParameterType="query")
    public itemName: string;

    /** @description The version of the item */
    // @DataMember(Order=7)
    // @ApiMember(DataType="string", Description="The version of the item", Name="ItemVersion", ParameterType="query")
    public itemVersion: string;

    public constructor(init?: Partial<GetTrialInstitutionItemsInstApproved>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialInstitutionItemsInstApproved'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialInstitutionItemsInstApprovedResponse(); }
}

/** @description TMD */
// @Route("/api/itemtrialinst-data", "GET")
// @Api(Description="TMD")
// @ApiResponse(Description="Not authorized", StatusCode=401)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
// @DataContract
export class GetTrialInstitutionItemData implements IReturn<GetTrialInstitutionItemDataResponse>, IGet
{
    /** @description The trial id to get the item for */
    // @DataMember(Order=1)
    // @ApiMember(DataType="integer", Description="The trial id to get the item for", Format="int32", IsRequired=true, Name="TrialId", ParameterType="query")
    public trialId: number;

    /** @description The inst id to get the item for */
    // @DataMember(Order=2)
    // @ApiMember(DataType="integer", Description="The inst id to get the item for", Format="int32", Name="InstId", ParameterType="query")
    public instId?: number;

    /** @description The inst code to get the item for, just in case the inst id is not available */
    // @DataMember(Order=3)
    // @ApiMember(DataType="string", Description="The inst code to get the item for, just in case the inst id is not available", Name="InstCode", ParameterType="query")
    public instCode: string;

    /** @description The category of the item */
    // @DataMember(Order=4)
    // @ApiMember(DataType="integer", Description="The category of the item", Format="int32", Name="TrialInstitutionItemTemplateCategory", ParameterType="query")
    public trialInstitutionItemTemplateCategoryId?: TrialInstitutionItemTemplateCategoryType;

    /** @description The itemno of the item */
    // @DataMember(Order=5)
    // @ApiMember(DataType="integer", Description="The itemno of the item", Format="int32", Name="ItemNo", ParameterType="query")
    public itemNo?: number;

    /** @description The name of the item */
    // @DataMember(Order=6)
    // @ApiMember(DataType="string", Description="The name of the item", Name="ItemName", ParameterType="query")
    public itemName: string;

    /** @description The version of the item */
    // @DataMember(Order=7)
    // @ApiMember(DataType="string", Description="The version of the item", Name="ItemVersion", ParameterType="query")
    public itemVersion: string;

    /** @description The list of item component ids to filter on */
    // @DataMember(Order=8)
    // @ApiMember(Description="The list of item component ids to filter on", Name="ItemComponentIds", ParameterType="query")
    public itemComponentIds: TrialInstitutionItemComponentId[];

    /** @description Whether to include null values in the response */
    // @DataMember(Order=9)
    // @ApiMember(DataType="boolean", Description="Whether to include null values in the response", Name="IncludeNullValues", ParameterType="query")
    public includeNullValues?: boolean;

    /** @description The name of the document */
    // @DataMember(Order=10)
    // @ApiMember(DataType="string", Description="The name of the document", Name="DocumentName", ParameterType="query")
    public documentName: string;

    public constructor(init?: Partial<GetTrialInstitutionItemData>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialInstitutionItemData'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialInstitutionItemDataResponse(); }
}

/** @description TMD */
// @Route("/api/itemtrialinst-image", "GET")
// @Api(Description="TMD")
// @ApiResponse(Description="Not authorized", StatusCode=401)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
// @DataContract
export class GetTrialInstitutionItemImages implements IReturn<GetTrialInstitutionItemImagesResponse>, IGet
{
    /** @description The trial id to get the item for */
    // @DataMember(Order=1)
    // @ApiMember(DataType="integer", Description="The trial id to get the item for", Format="int32", IsRequired=true, Name="TrialId", ParameterType="query")
    public trialId: number;

    /** @description The inst id to get the item for */
    // @DataMember(Order=2)
    // @ApiMember(DataType="integer", Description="The inst id to get the item for", Format="int32", Name="InstId", ParameterType="query")
    public instId?: number;

    /** @description The inst code to get the item for, just in case the inst id is not available */
    // @DataMember(Order=3)
    // @ApiMember(DataType="string", Description="The inst code to get the item for, just in case the inst id is not available", Name="InstCode", ParameterType="query")
    public instCode: string;

    /** @description The category of the item */
    // @DataMember(Order=4)
    // @ApiMember(Description="The category of the item", Name="TrialInstitutionItemTemplateCategoryId", ParameterType="query")
    public trialInstitutionItemTemplateCategoryId?: TrialInstitutionItemTemplateCategoryType;

    /** @description The itemno of the item */
    // @DataMember(Order=5)
    // @ApiMember(DataType="integer", Description="The itemno of the item", Format="int32", Name="ItemNo", ParameterType="query")
    public itemNo?: number;

    /** @description The name of the item */
    // @DataMember(Order=6)
    // @ApiMember(DataType="string", Description="The name of the item", Name="ItemName", ParameterType="query")
    public itemName: string;

    /** @description The version of the item */
    // @DataMember(Order=7)
    // @ApiMember(DataType="string", Description="The version of the item", Name="ItemVersion", ParameterType="query")
    public itemVersion: string;

    /** @description The name of the document */
    // @DataMember(Order=8)
    // @ApiMember(DataType="string", Description="The name of the document", Name="DocumentName", ParameterType="query")
    public documentName: string;

    public constructor(init?: Partial<GetTrialInstitutionItemImages>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialInstitutionItemImages'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialInstitutionItemImagesResponse(); }
}

// @Route("/api/trialinstitutionitemtemplatecategories", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialInstitutionItemTemplateCategories implements IReturn<GetTrialInstitutionItemTemplateCategoriesResponse>
{

    public constructor(init?: Partial<GetTrialInstitutionItemTemplateCategories>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialInstitutionItemTemplateCategories'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialInstitutionItemTemplateCategoriesResponse(); }
}

// @Route("/api/trialinstitutionitemtemplatecategory/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Category not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialInstitutionItemTemplateCategoryById implements IReturn<GetTrialInstitutionItemTemplateCategoryByIdResponse>, IGet
{
    /** @description The primary key Id of the categories */
    // @ApiMember(DataType="string", Description="The primary key Id of the categories", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetTrialInstitutionItemTemplateCategoryById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialInstitutionItemTemplateCategoryById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialInstitutionItemTemplateCategoryByIdResponse(); }
}

// @Route("/api/trialinstitutionitemtemplatecategory/save/{Id}", "POST")
// @Route("/api/trialinstitutionitemtemplatecategory/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetTrialInstitutionItemTemplateCategory implements IReturn<SetTrialInstitutionItemTemplateCategoryResponse>
{
    /** @description The TrialInstitutionItemTemplateCategory Form data to save */
    // @ApiMember(DataType="TrialInstitutionItemTemplateCategory", Description="The TrialInstitutionItemTemplateCategory Form data to save", IsRequired=true, Name="TrialInstitutionItemTemplateCategory", ParameterType="body")
    public trialInstitutionItemTemplateCategory: TrialInstitutionItemTemplateCategory;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetTrialInstitutionItemTemplateCategory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetTrialInstitutionItemTemplateCategory'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetTrialInstitutionItemTemplateCategoryResponse(); }
}

// @Route("/api/trialinstitutionitemtemplatecategory/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateTrialInstitutionItemTemplateCategory implements IReturn<CreateTrialInstitutionItemTemplateCategoryResponse>
{

    public constructor(init?: Partial<CreateTrialInstitutionItemTemplateCategory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateTrialInstitutionItemTemplateCategory'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateTrialInstitutionItemTemplateCategoryResponse(); }
}

// @Route("/api/trialinstitutionitemtemplatecategory/validate/{Id}", "POST")
// @Route("/api/trialinstitutionitemtemplatecategory/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateTrialInstitutionItemTemplateCategory implements IReturn<ValidateTrialInstitutionItemTemplateCategoryResponse>
{
    /** @description The TrialInstitutionItemTemplateCategory Form data to validate */
    // @ApiMember(DataType="TrialInstitutionItemTemplateCategory", Description="The TrialInstitutionItemTemplateCategory Form data to validate", IsRequired=true, Name="TrialInstitutionItemTemplateCategory", ParameterType="body")
    public trialInstitutionItemTemplateCategory: TrialInstitutionItemTemplateCategory;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateTrialInstitutionItemTemplateCategory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateTrialInstitutionItemTemplateCategory'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateTrialInstitutionItemTemplateCategoryResponse(); }
}

// @Route("/api/trialinstitutionlaboratorycontract/trialinstitutionlaboratoryid/{trialinstitutionlaboratoryid}", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialInstitutionLaboratoryContractByTrialInstitutionLaboratoryId implements IReturn<GetTrialInstitutionLaboratoryContractByTrialInstitutionLaboratoryIdResponse>
{
    public trialInstitutionLaboratoryId: number;

    public constructor(init?: Partial<GetTrialInstitutionLaboratoryContractByTrialInstitutionLaboratoryId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialInstitutionLaboratoryContractByTrialInstitutionLaboratoryId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialInstitutionLaboratoryContractByTrialInstitutionLaboratoryIdResponse(); }
}

// @Route("/api/trialinstitutionlaboratorycontract/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Trial Institution Laboratory Contract not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialInstitutionLaboratoryContractById implements IReturn<GetTrialInstitutionLaboratoryContractByIdResponse>, IGet
{
    /** @description The primary key Id of the trial institution laboratory contract */
    // @ApiMember(DataType="string", Description="The primary key Id of the trial institution laboratory contract", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetTrialInstitutionLaboratoryContractById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialInstitutionLaboratoryContractById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialInstitutionLaboratoryContractByIdResponse(); }
}

// @Route("/api/trialinstitutionlaboratorycontract/save/{Id}", "POST")
// @Route("/api/trialinstitutionlaboratorycontract/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetTrialInstitutionLaboratoryContract implements IReturn<SetTrialInstitutionLaboratoryContractResponse>
{
    /** @description The TrialInstitutionLaboratoryContract Form data to save */
    // @ApiMember(DataType="TrialInstitutionLaboratoryContract", Description="The TrialInstitutionLaboratoryContract Form data to save", IsRequired=true, Name="trialInstitutionLaboratoryContract", ParameterType="body")
    public trialInstitutionLaboratoryContract: TrialInstitutionLaboratoryContract;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetTrialInstitutionLaboratoryContract>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetTrialInstitutionLaboratoryContract'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetTrialInstitutionLaboratoryContractResponse(); }
}

// @Route("/api/trialinstitutionlaboratorycontract/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateTrialInstitutionLaboratoryContract implements IReturn<CreateTrialInstitutionLaboratoryContractResponse>
{
    public trialInstitutionLaboratoryId: number;

    public constructor(init?: Partial<CreateTrialInstitutionLaboratoryContract>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateTrialInstitutionLaboratoryContract'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateTrialInstitutionLaboratoryContractResponse(); }
}

// @Route("/api/trialinstitutionlaboratorycontract/validate/{Id}", "POST")
// @Route("/api/trialinstitutionlaboratorycontract/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateTrialInstitutionLaboratoryContract implements IReturn<ValidateTrialInstitutionLaboratoryContractResponse>
{
    /** @description The TrialInstitutionLaboratoryContract Form data to validate */
    // @ApiMember(DataType="TrialInstitutionLaboratoryContract", Description="The TrialInstitutionLaboratoryContract Form data to validate", IsRequired=true, Name="trialInstitutionLaboratoryContract", ParameterType="body")
    public trialInstitutionLaboratoryContract: TrialInstitutionLaboratoryContract;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateTrialInstitutionLaboratoryContract>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateTrialInstitutionLaboratoryContract'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateTrialInstitutionLaboratoryContractResponse(); }
}

// @Route("/api/trialinstitutionlaboratorycontract/delete/{Id}", "POST")
// @Route("/api/trialinstitutionlaboratorycontract/delete", "POST")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Trial Institution Laboratory Contract not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class DeleteTrialInstitutionLaboratoryContract implements IReturn<DeleteTrialInstitutionLaboratoryContractResponse>
{
    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<DeleteTrialInstitutionLaboratoryContract>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteTrialInstitutionLaboratoryContract'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new DeleteTrialInstitutionLaboratoryContractResponse(); }
}

// @Route("/api/trialinstitutionlaboratoryfinance/trialinstitutionlaboratoryid/{trialinstitutionlaboratoryid}", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialInstitutionLaboratoryFinanceByTrialInstitutionLaboratoryId implements IReturn<GetTrialInstitutionLaboratoryFinanceByTrialInstitutionLaboratoryIdResponse>
{
    public trialInstitutionLaboratoryId: number;

    public constructor(init?: Partial<GetTrialInstitutionLaboratoryFinanceByTrialInstitutionLaboratoryId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialInstitutionLaboratoryFinanceByTrialInstitutionLaboratoryId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialInstitutionLaboratoryFinanceByTrialInstitutionLaboratoryIdResponse(); }
}

// @Route("/api/trialinstitutionlaboratoryfinance/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Trial Institution Laboratory Finance not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialInstitutionLaboratoryFinanceById implements IReturn<GetTrialInstitutionLaboratoryFinanceByIdResponse>, IGet
{
    /** @description The primary key Id of the trial institution laboratory finance */
    // @ApiMember(DataType="string", Description="The primary key Id of the trial institution laboratory finance", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetTrialInstitutionLaboratoryFinanceById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialInstitutionLaboratoryFinanceById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialInstitutionLaboratoryFinanceByIdResponse(); }
}

// @Route("/api/trialinstitutionlaboratoryfinance/save/{Id}", "POST")
// @Route("/api/trialinstitutionlaboratoryfinance/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetTrialInstitutionLaboratoryFinance implements IReturn<SetTrialInstitutionLaboratoryFinanceResponse>
{
    /** @description The TrialInstitutionLaboratoryFinance Form data to save */
    // @ApiMember(DataType="TrialInstitutionLaboratoryFinance", Description="The TrialInstitutionLaboratoryFinance Form data to save", IsRequired=true, Name="trialInstitutionLaboratoryFinance", ParameterType="body")
    public trialInstitutionLaboratoryFinance: TrialInstitutionLaboratoryFinance;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetTrialInstitutionLaboratoryFinance>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetTrialInstitutionLaboratoryFinance'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetTrialInstitutionLaboratoryFinanceResponse(); }
}

// @Route("/api/trialinstitutionlaboratoryfinance/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateTrialInstitutionLaboratoryFinance implements IReturn<CreateTrialInstitutionLaboratoryFinanceResponse>
{
    public trialInstitutionLaboratoryId: number;

    public constructor(init?: Partial<CreateTrialInstitutionLaboratoryFinance>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateTrialInstitutionLaboratoryFinance'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateTrialInstitutionLaboratoryFinanceResponse(); }
}

// @Route("/api/trialinstitutionlaboratoryfinance/validate/{Id}", "POST")
// @Route("/api/trialinstitutionlaboratoryfinance/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateTrialInstitutionLaboratoryFinance implements IReturn<ValidateTrialInstitutionLaboratoryFinanceResponse>
{
    /** @description The TrialInstitutionLaboratoryFinance Form data to validate */
    // @ApiMember(DataType="TrialInstitutionLaboratoryFinance", Description="The TrialInstitutionLaboratoryFinance Form data to validate", IsRequired=true, Name="trialInstitutionLaboratoryFinance", ParameterType="body")
    public trialInstitutionLaboratoryFinance: TrialInstitutionLaboratoryFinance;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateTrialInstitutionLaboratoryFinance>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateTrialInstitutionLaboratoryFinance'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateTrialInstitutionLaboratoryFinanceResponse(); }
}

// @Route("/api/trialinstitutionlaboratorypersonnels", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialInstitutionLaboratoryPersonnels implements IReturn<GetTrialInstitutionLaboratoryPersonnelsResponse>
{

    public constructor(init?: Partial<GetTrialInstitutionLaboratoryPersonnels>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialInstitutionLaboratoryPersonnels'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialInstitutionLaboratoryPersonnelsResponse(); }
}

// @Route("/api/trialinstitutionlaboratorypersonnel/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Trial Institution Laboratory Personnel not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialInstitutionLaboratoryPersonnelById implements IReturn<GetTrialInstitutionLaboratoryPersonnelByIdResponse>, IGet
{
    /** @description The primary key Id of the Trial Institution Laboratory Personnel */
    // @ApiMember(DataType="string", Description="The primary key Id of the Trial Institution Laboratory Personnel", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetTrialInstitutionLaboratoryPersonnelById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialInstitutionLaboratoryPersonnelById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialInstitutionLaboratoryPersonnelByIdResponse(); }
}

// @Route("/api/trialinstitutionlaboratorypersonnel/trialinstitutionlaboratoryid/{trialinstitutionlaboratoryId}", "GET")
// @ApiResponse(Description="Trial Institution Laboratory Id is invalid", StatusCode=400)
// @ApiResponse(Description="Trial Institution Laboratory personnel not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialInstitutionLaboratoryPersonnelByLaboratoryId implements IReturn<GetTrialInstitutionLaboratoryPersonnelByLaboratoryIdResponse>, IGet
{
    /** @description The trial institution laboratory id of the trial institution laboratory personnel */
    // @ApiMember(DataType="string", Description="The trial institution laboratory id of the trial institution laboratory personnel", IsRequired=true, Name="TrialInstitutionLaboratoryId", ParameterType="path")
    public trialInstitutionLaboratoryId: number;

    public constructor(init?: Partial<GetTrialInstitutionLaboratoryPersonnelByLaboratoryId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialInstitutionLaboratoryPersonnelByLaboratoryId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialInstitutionLaboratoryPersonnelByLaboratoryIdResponse(); }
}

// @Route("/api/trialinstitutionlaboratorypersonnel/save/{Id}", "POST")
// @Route("/api/trialinstitutionlaboratorypersonnel/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetTrialInstitutionLaboratoryPersonnel implements IReturn<SetTrialInstitutionLaboratoryPersonnelResponse>
{
    /** @description The Trial Institution Laboratory Personnel Form data to save */
    // @ApiMember(DataType="TrialInstitutionLaboratoryPersonnel", Description="The Trial Institution Laboratory Personnel Form data to save", IsRequired=true, Name="TrialInstitutionLaboratoryPersonnel", ParameterType="body")
    public trialInstitutionLaboratoryPersonnel: TrialInstitutionLaboratoryPersonnel;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetTrialInstitutionLaboratoryPersonnel>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetTrialInstitutionLaboratoryPersonnel'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetTrialInstitutionLaboratoryPersonnelResponse(); }
}

// @Route("/api/trialinstitutionlaboratorypersonnel/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateTrialInstitutionLaboratoryPersonnel implements IReturn<CreateTrialInstitutionLaboratoryPersonnelResponse>
{
    /** @description The primary key Id of the Trial Institution Laboratory associated to the Trial Institution Laboratory Personnel */
    // @ApiMember(DataType="string", Description="The primary key Id of the Trial Institution Laboratory associated to the Trial Institution Laboratory Personnel", IsRequired=true, Name="TrialInstitutionLaboratoryId", ParameterType="path")
    public trialInstitutionLaboratoryId: number;

    public constructor(init?: Partial<CreateTrialInstitutionLaboratoryPersonnel>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateTrialInstitutionLaboratoryPersonnel'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateTrialInstitutionLaboratoryPersonnelResponse(); }
}

// @Route("/api/trialinstitutionlaboratorypersonnel/validate/{Id}", "POST")
// @Route("/api/trialinstitutionlaboratorypersonnel/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateTrialInstitutionLaboratoryPersonnel implements IReturn<ValidateTrialInstitutionLaboratoryPersonnelResponse>
{
    /** @description The Trial Institution Laboratory Personnel Form data to validate */
    // @ApiMember(DataType="TrialInstitutionLaboratoryPersonnel", Description="The Trial Institution Laboratory Personnel Form data to validate", IsRequired=true, Name="TrialInstitutionLaboratoryPersonnel", ParameterType="body")
    public trialInstitutionLaboratoryPersonnel: TrialInstitutionLaboratoryPersonnel;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateTrialInstitutionLaboratoryPersonnel>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateTrialInstitutionLaboratoryPersonnel'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateTrialInstitutionLaboratoryPersonnelResponse(); }
}

// @Route("/api/trialinstitutionlaboratory", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialInstitutionLaboratories implements IReturn<GetTrialInstitutionLaboratoriesResponse>
{

    public constructor(init?: Partial<GetTrialInstitutionLaboratories>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialInstitutionLaboratories'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialInstitutionLaboratoriesResponse(); }
}

// @Route("/api/trialinstitutionlaboratory/trialinstitutionid/{trialinstitutionid}", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialInstitutionLaboratoriesByTrialInstitutionId implements IReturn<GetTrialInstitutionLaboratoriesByTrialInstitutionIdResponse>
{
    /** @description The primary key Id of the Trial Institution */
    // @ApiMember(DataType="int", Description="The primary key Id of the Trial Institution", Name="TrialInstitutionId", ParameterType="path")
    public trialInstitutionId?: number;

    public constructor(init?: Partial<GetTrialInstitutionLaboratoriesByTrialInstitutionId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialInstitutionLaboratoriesByTrialInstitutionId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialInstitutionLaboratoriesByTrialInstitutionIdResponse(); }
}

// @Route("/api/trialinstitutionlaboratory/trialid/{trialid}", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialInstitutionLaboratoriesByTrialId implements IReturn<GetTrialInstitutionLaboratoriesByTrialIdResponse>
{
    /** @description The primary key Id of the Trial */
    // @ApiMember(DataType="int", Description="The primary key Id of the Trial", Name="TrialId", ParameterType="path")
    public trialId?: number;

    public constructor(init?: Partial<GetTrialInstitutionLaboratoriesByTrialId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialInstitutionLaboratoriesByTrialId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialInstitutionLaboratoriesByTrialIdResponse(); }
}

// @Route("/api/trialinstitutionlaboratory/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Trial Institution Laboratory not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialInstitutionLaboratoryById implements IReturn<GetTrialInstitutionLaboratoryByIdResponse>, IGet
{
    /** @description The primary key Id of the Trial Institution Laboratory */
    // @ApiMember(DataType="int", Description="The primary key Id of the Trial Institution Laboratory", Name="Id", ParameterType="path")
    public id?: number;

    public constructor(init?: Partial<GetTrialInstitutionLaboratoryById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialInstitutionLaboratoryById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialInstitutionLaboratoryByIdResponse(); }
}

// @Route("/api/trialinstitutionlaboratory/laboratoryid/{laboratoryId}", "GET")
// @ApiResponse(Description="Laboratory Id is invalid", StatusCode=400)
// @ApiResponse(Description="Institution Laboratory not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialInstitutionLaboratoryByLaboratoryId implements IReturn<GetTrialInstitutionLaboratoryByLaboratoryIdResponse>, IGet
{
    /** @description The laboratory id of the trial institution laboratory */
    // @ApiMember(DataType="int", Description="The laboratory id of the trial institution laboratory", Name="LaboratoryId", ParameterType="path")
    public laboratoryId?: number;

    public constructor(init?: Partial<GetTrialInstitutionLaboratoryByLaboratoryId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialInstitutionLaboratoryByLaboratoryId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialInstitutionLaboratoryByLaboratoryIdResponse(); }
}

// @Route("/api/trialinstitutionlaboratory/save/{Id}", "POST")
// @Route("/api/trialinstitutionlaboratory/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetTrialInstitutionLaboratory implements IReturn<SetTrialInstitutionLaboratoryResponse>
{
    /** @description The Trial Institution Laboratory Form data to save */
    // @ApiMember(DataType="TrialInstitutionLaboratory", Description="The Trial Institution Laboratory Form data to save", IsRequired=true, Name="Id", ParameterType="body")
    public trialInstitutionLaboratory: TrialInstitutionLaboratory;

    /** @description The Id */
    // @ApiMember(DataType="int", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetTrialInstitutionLaboratory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetTrialInstitutionLaboratory'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetTrialInstitutionLaboratoryResponse(); }
}

// @Route("/api/trialinstitutionlaboratory/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateTrialInstitutionLaboratory implements IReturn<CreateTrialInstitutionLaboratoryResponse>
{
    /** @description The primary key Id of the Laboratory associated to the trial institution laboratory */
    // @ApiMember(DataType="int", Description="The primary key Id of the Laboratory associated to the trial institution laboratory", Name="LaboratoryId", ParameterType="path")
    public laboratoryId?: number;

    /** @description The primary key Id of the TrialInstitution associated to the trial institution laboratory */
    // @ApiMember(DataType="int", Description="The primary key Id of the TrialInstitution associated to the trial institution laboratory", Name="TrialInstitutionId", ParameterType="path")
    public trialInstitutionId?: number;

    public constructor(init?: Partial<CreateTrialInstitutionLaboratory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateTrialInstitutionLaboratory'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateTrialInstitutionLaboratoryResponse(); }
}

// @Route("/api/trialinstitutionlaboratory/delete/{Id}", "POST")
// @Route("/api/trialinstitutionlaboratory/delete", "POST")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Trial Institution Laboratory not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class DeleteTrialInstitutionLaboratory implements IReturn<DeleteTrialInstitutionLaboratoryResponse>
{
    /** @description The Id */
    // @ApiMember(DataType="int", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<DeleteTrialInstitutionLaboratory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteTrialInstitutionLaboratory'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new DeleteTrialInstitutionLaboratoryResponse(); }
}

// @Route("/api/trialinstitutionlaboratory/validate/{Id}", "POST")
// @Route("/api/trialinstitutionlaboratory/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateTrialInstitutionLaboratory implements IReturn<ValidateTrialInstitutionLaboratoryResponse>
{
    /** @description The Trial Institution Laboratory Form data to validate */
    // @ApiMember(DataType="TrialInstitutionLaboratory", Description="The Trial Institution Laboratory Form data to validate", IsRequired=true, Name="Id", ParameterType="body")
    public trialInstitutionLaboratory: TrialInstitutionLaboratory;

    /** @description The Id */
    // @ApiMember(DataType="int", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateTrialInstitutionLaboratory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateTrialInstitutionLaboratory'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateTrialInstitutionLaboratoryResponse(); }
}

// @Route("/api/trialinstitutions", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialInstitutions implements IReturn<GetTrialInstitutionsResponse>
{

    public constructor(init?: Partial<GetTrialInstitutions>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialInstitutions'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialInstitutionsResponse(); }
}

// @Route("/api/trialinstitution/trialid/{trialId}", "GET")
// @ApiResponse(Description="Trial Id is invalid", StatusCode=400)
// @ApiResponse(Description="Trial Institution not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialInstitutionsByTrialId implements IReturn<GetTrialInstitutionsByTrialIdResponse>, IGet
{
    /** @description The Trial Id of the trial institution */
    // @ApiMember(DataType="string", Description="The Trial Id of the trial institution", IsRequired=true, Name="TrialId", ParameterType="path")
    public trialId: number;

    public constructor(init?: Partial<GetTrialInstitutionsByTrialId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialInstitutionsByTrialId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialInstitutionsByTrialIdResponse(); }
}

// @Route("/api/trialinstitution/institutionid/{institutionid}", "GET")
// @ApiResponse(Description="Institution Id is invalid", StatusCode=400)
// @ApiResponse(Description="Trial Institution not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialInstitutionsByInstitutionId implements IReturn<GetTrialInstitutionsByInstitutionIdResponse>, IGet
{
    /** @description The Institution Id of the trial institution */
    // @ApiMember(DataType="string", Description="The Institution Id of the trial institution", IsRequired=true, Name="InstitutionId", ParameterType="path")
    public institutionId: number;

    public constructor(init?: Partial<GetTrialInstitutionsByInstitutionId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialInstitutionsByInstitutionId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialInstitutionsByInstitutionIdResponse(); }
}

// @Route("/api/trialinstitution/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Trial Item not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialInstitutionById implements IReturn<GetTrialInstitutionByIdResponse>, IGet
{
    /** @description The primary key Id of the trial institution */
    // @ApiMember(DataType="string", Description="The primary key Id of the trial institution", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetTrialInstitutionById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialInstitutionById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialInstitutionByIdResponse(); }
}

// @Route("/api/trialinstitution/save/{Id}", "POST")
// @Route("/api/trialinstitution/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetTrialInstitution implements IReturn<SetTrialInstitutionResponse>
{
    /** @description The TrialInstitution Form data to save */
    // @ApiMember(DataType="TrialInstitution", Description="The TrialInstitution Form data to save", IsRequired=true, Name="trialInstitution", ParameterType="body")
    public trialInstitution: TrialInstitution;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetTrialInstitution>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetTrialInstitution'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetTrialInstitutionResponse(); }
}

// @Route("/api/trialinstitution/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateTrialInstitution implements IReturn<CreateTrialInstitutionResponse>
{
    public trialId: number;

    public constructor(init?: Partial<CreateTrialInstitution>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateTrialInstitution'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateTrialInstitutionResponse(); }
}

// @Route("/api/trialinstitution/validate/{Id}", "POST")
// @Route("/api/trialinstitution/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateTrialInstitution implements IReturn<ValidateTrialInstitutionResponse>
{
    /** @description The TrialInstitution Form data to validate */
    // @ApiMember(DataType="TrialInstitution", Description="The TrialInstitution Form data to validate", IsRequired=true, Name="trialInstitution", ParameterType="body")
    public trialInstitution: TrialInstitution;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateTrialInstitution>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateTrialInstitution'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateTrialInstitutionResponse(); }
}

/** @description TMD */
// @Route("/api/trial-institutions/get-by-trial", "GET")
// @Api(Description="TMD")
// @ApiResponse(Description="Not authorized", StatusCode=401)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
// @DataContract
export class GetTrialInstitutionsWithGroupsByTrial implements IReturn<GetTrialInstitutionsWithGroupsByTrialResponse>, IGet
{
    /** @description The trial id to get the trial institutions for */
    // @DataMember(Order=1)
    // @ApiMember(DataType="int", Description="The trial id to get the trial institutions for", IsRequired=true, Name="TrialId", ParameterType="query")
    public trialId: number;

    public constructor(init?: Partial<GetTrialInstitutionsWithGroupsByTrial>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialInstitutionsWithGroupsByTrial'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialInstitutionsWithGroupsByTrialResponse(); }
}

/** @description TMD */
// @Route("/api/trial-institutions/get-by-trial-and-id", "GET")
// @Api(Description="TMD")
// @ApiResponse(Description="Not authorized", StatusCode=401)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
// @DataContract
export class GetTrialInstitutionWithGroupsByTrialAndId implements IReturn<GetTrialInstitutionWithGroupsByTrialAndIdResponse>, IGet
{
    /** @description The trial id to get the trial institution for */
    // @DataMember(Order=1)
    // @ApiMember(DataType="int", Description="The trial id to get the trial institution for", IsRequired=true, Name="TrialId", ParameterType="query")
    public trialId: number;

    /** @description The institution id */
    // @DataMember(Order=2)
    // @ApiMember(DataType="int", Description="The institution id", IsRequired=true, Name="InstitutionId", ParameterType="query")
    public institutionId: number;

    public constructor(init?: Partial<GetTrialInstitutionWithGroupsByTrialAndId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialInstitutionWithGroupsByTrialAndId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialInstitutionWithGroupsByTrialAndIdResponse(); }
}

/** @description TMD */
// @Route("/api/trial-institutions/get-by-trial-and-code", "GET")
// @Api(Description="TMD")
// @ApiResponse(Description="Not authorized", StatusCode=401)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
// @DataContract
export class GetTrialInstitutionWithGroupsByTrialAndCode implements IReturn<GetTrialInstitutionWithGroupsByTrialAndCodeResponse>, IGet
{
    /** @description The trial id to get the trial institution for */
    // @DataMember(Order=1)
    // @ApiMember(DataType="int", Description="The trial id to get the trial institution for", IsRequired=true, Name="TrialId", ParameterType="query")
    public trialId: number;

    /** @description The institution code */
    // @DataMember(Order=2)
    // @ApiMember(DataType="string", Description="The institution code", IsRequired=true, Name="InstitutionCode", ParameterType="query")
    public institutionCode: string;

    public constructor(init?: Partial<GetTrialInstitutionWithGroupsByTrialAndCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialInstitutionWithGroupsByTrialAndCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialInstitutionWithGroupsByTrialAndCodeResponse(); }
}

// @Route("/api/trialitemcategories", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialItemCategoriesByTrialId implements IReturn<GetTrialItemCategoriesByTrialIdResponse>
{
    public trialId?: number;

    public constructor(init?: Partial<GetTrialItemCategoriesByTrialId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialItemCategoriesByTrialId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialItemCategoriesByTrialIdResponse(); }
}

// @Route("/api/trialitemimport/save/{Id}/{TrialId}", "POST")
// @Route("/api/trialitemimport/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetTrialItemImport implements IReturn<SetTrialItemImportResponse>
{
    /** @description The Trial Form data to save */
    // @ApiMember(DataType="Trial", Description="The Trial Form data to save", IsRequired=true, Name="trial", ParameterType="body")
    public trialItemImport: TrialItemImport;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    /** @description The primary key Id of the Soruce Trial */
    // @ApiMember(DataType="string", Description="The primary key Id of the Soruce Trial", IsRequired=true, Name="TrialId", ParameterType="path")
    public trialId: number;

    public constructor(init?: Partial<SetTrialItemImport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetTrialItemImport'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetTrialItemImportResponse(); }
}

// @Route("/api/trialitemupdate/id/{Id}/{TrialItemId}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Trial not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialItemUpdateById implements IReturn<GetTrialItemUpdateByIdResponse>, IGet
{
    /** @description The primary key Id of the Trial */
    // @ApiMember(DataType="string", Description="The primary key Id of the Trial", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    /** @description The primary key Id of the Trial Item */
    // @ApiMember(DataType="string", Description="The primary key Id of the Trial Item", IsRequired=true, Name="TrialItemId", ParameterType="path")
    public trialItemId: number;

    public constructor(init?: Partial<GetTrialItemUpdateById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialItemUpdateById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialItemUpdateByIdResponse(); }
}

// @Route("/api/trialitemupdate/save/{Id}/{TrialItemId}", "POST")
// @Route("/api/trialitemupdate/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetTrialItemUpdate implements IReturn<SetTrialItemUpdateResponse>
{
    /** @description The Trial Item Form data to save */
    // @ApiMember(DataType="TrialItemUpdate", Description="The Trial Item Form data to save", IsRequired=true, Name="TrialItemUpdate", ParameterType="body")
    public trialItemUpdate: TrialItemUpdate;

    /** @description The trial Id */
    // @ApiMember(DataType="string", Description="The trial Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    /** @description The primary key Id of Trial Item */
    // @ApiMember(DataType="string", Description="The primary key Id of Trial Item", IsRequired=true, Name="TrialItemId", ParameterType="path")
    public trialItemId: number;

    public constructor(init?: Partial<SetTrialItemUpdate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetTrialItemUpdate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetTrialItemUpdateResponse(); }
}

// @Route("/api/trialpersonnel/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Trial Personnel not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialPersonnelById implements IReturn<GetTrialPersonnelByIdResponse>, IGet
{
    /** @description The primary key Id of the trial personnel */
    // @ApiMember(DataType="string", Description="The primary key Id of the trial personnel", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetTrialPersonnelById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialPersonnelById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialPersonnelByIdResponse(); }
}

// @Route("/api/trialpersonnel/personnelid/{personnelId}", "GET")
// @ApiResponse(Description="Personnel Id is invalid", StatusCode=400)
// @ApiResponse(Description="Trial Personnel not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialPersonnelsByPersonnelId implements IReturn<GetTrialPersonnelsByPersonnelIdResponse>, IGet
{
    /** @description The Personnel Id of the trial personnel */
    // @ApiMember(DataType="string", Description="The Personnel Id of the trial personnel", IsRequired=true, Name="PersonnelId", ParameterType="path")
    public personnelId: number;

    public constructor(init?: Partial<GetTrialPersonnelsByPersonnelId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialPersonnelsByPersonnelId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialPersonnelsByPersonnelIdResponse(); }
}

// @Route("/api/trialpersonnel/trialid/{trialid}", "GET")
// @ApiResponse(Description="Trial Id is invalid", StatusCode=400)
// @ApiResponse(Description="Trial Personnel not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialPersonnelsByTrialId implements IReturn<GetTrialPersonnelsByTrialIdResponse>, IGet
{
    /** @description The Trial Id of the trial personnel */
    // @ApiMember(DataType="string", Description="The Trial Id of the trial personnel", IsRequired=true, Name="TrialId", ParameterType="path")
    public trialId: number;

    /** @description The Group Level Type of the trial personnel */
    // @ApiMember(DataType="string", Description="The Group Level Type of the trial personnel", Name="GroupLevelTypeId", ParameterType="path")
    public groupLevelTypeId?: number;

    public constructor(init?: Partial<GetTrialPersonnelsByTrialId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialPersonnelsByTrialId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialPersonnelsByTrialIdResponse(); }
}

// @Route("/api/trialpersonnel/institutionid/{institutionid}", "GET")
// @ApiResponse(Description="Institution Id is invalid", StatusCode=400)
// @ApiResponse(Description="Trial Personnel not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialPersonnelsByInstitutionId implements IReturn<GetTrialPersonnelsByInstitutionIdResponse>, IGet
{
    /** @description The Institution Id of the trial personnel */
    // @ApiMember(DataType="string", Description="The Institution Id of the trial personnel", IsRequired=true, Name="InstitutionId", ParameterType="path")
    public institutionId: number;

    /** @description The Group Level Type of the trial personnel */
    // @ApiMember(DataType="string", Description="The Group Level Type of the trial personnel", Name="GroupLevelTypeId", ParameterType="path")
    public groupLevelTypeId?: number;

    public constructor(init?: Partial<GetTrialPersonnelsByInstitutionId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialPersonnelsByInstitutionId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialPersonnelsByInstitutionIdResponse(); }
}

// @Route("/api/trialpersonnel/trialinstitutionid/{trialinstitutionid}", "GET")
// @ApiResponse(Description="Trial Institution Id is invalid", StatusCode=400)
// @ApiResponse(Description="Trial Personnel not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialPersonnelsByTrialInstitutionId implements IReturn<GetTrialPersonnelsByTrialInstitutionIdResponse>, IGet
{
    /** @description The Trial Institution Id of the trial personnel */
    // @ApiMember(DataType="string", Description="The Trial Institution Id of the trial personnel", IsRequired=true, Name="TrialInstitutionId", ParameterType="path")
    public trialInstitutionId: number;

    /** @description The Group Level Type of the trial personnel */
    // @ApiMember(DataType="string", Description="The Group Level Type of the trial personnel", Name="GroupLevelTypeId", ParameterType="path")
    public groupLevelTypeId?: number;

    public constructor(init?: Partial<GetTrialPersonnelsByTrialInstitutionId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialPersonnelsByTrialInstitutionId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialPersonnelsByTrialInstitutionIdResponse(); }
}

// @Route("/api/trialpersonnel/trialgroupid/{trialgroupid}", "GET")
// @ApiResponse(Description="Trial Group Id is invalid", StatusCode=400)
// @ApiResponse(Description="Trial Personnel not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialPersonnelsByTrialGroupId implements IReturn<GetTrialPersonnelsByTrialGroupIdResponse>, IGet
{
    /** @description The Trial Group Id of the trial personnel */
    // @ApiMember(DataType="string", Description="The Trial Group Id of the trial personnel", IsRequired=true, Name="TrialGroupId", ParameterType="path")
    public trialGroupId: number;

    /** @description The Group Level Type of the trial personnel */
    // @ApiMember(DataType="string", Description="The Group Level Type of the trial personnel", Name="GroupLevelTypeId", ParameterType="path")
    public groupLevelTypeId?: number;

    public constructor(init?: Partial<GetTrialPersonnelsByTrialGroupId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialPersonnelsByTrialGroupId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialPersonnelsByTrialGroupIdResponse(); }
}

// @Route("/api/trialpersonnel/groupid/{groupid}", "GET")
// @ApiResponse(Description="Group Id is invalid", StatusCode=400)
// @ApiResponse(Description="Trial Personnel not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialPersonnelsByGroupId implements IReturn<GetTrialPersonnelsByGroupIdResponse>, IGet
{
    /** @description The Group Id of the trial personnel */
    // @ApiMember(DataType="string", Description="The Group Id of the trial personnel", IsRequired=true, Name="GroupId", ParameterType="path")
    public groupId: number;

    /** @description The Group Level Type Id of the trial personnel */
    // @ApiMember(DataType="string", Description="The Group Level Type Id of the trial personnel", IsRequired=true, Name="GrouplevelTypeId", ParameterType="path")
    public groupLevelTypeId: number;

    public constructor(init?: Partial<GetTrialPersonnelsByGroupId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialPersonnelsByGroupId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialPersonnelsByGroupIdResponse(); }
}

// @Route("/api/trialpersonnel/save/{Id}", "POST")
// @Route("/api/trialpersonnel/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetTrialPersonnel implements IReturn<SetTrialPersonnelResponse>
{
    /** @description The TrialPersonnel Form data to save */
    // @ApiMember(DataType="TrialPersonnel", Description="The TrialPersonnel Form data to save", IsRequired=true, Name="TrialPersonnel", ParameterType="body")
    public trialPersonnel: TrialPersonnel;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetTrialPersonnel>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetTrialPersonnel'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetTrialPersonnelResponse(); }
}

// @Route("/api/trialpersonnel/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateTrialPersonnel implements IReturn<CreateTrialPersonnelResponse>
{
    public trialId?: number;
    public institutionId?: number;
    public groupId?: number;

    public constructor(init?: Partial<CreateTrialPersonnel>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateTrialPersonnel'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateTrialPersonnelResponse(); }
}

// @Route("/api/trialpersonnel/validate/{Id}", "POST")
// @Route("/api/trialpersonnel/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateTrialPersonnel implements IReturn<ValidateTrialPersonnelResponse>
{
    /** @description The TrialPersonnel Form data to save */
    // @ApiMember(DataType="TrialPersonnel", Description="The TrialPersonnel Form data to save", IsRequired=true, Name="TrialPersonnel", ParameterType="body")
    public trialPersonnel: TrialPersonnel;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateTrialPersonnel>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateTrialPersonnel'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateTrialPersonnelResponse(); }
}

// @Route("/api/trials", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrials implements IReturn<GetTrialsResponse>
{
    public showInActiveTrialItems: boolean;

    public constructor(init?: Partial<GetTrials>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrials'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialsResponse(); }
}

// @Route("/api/trial/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Trial not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialById implements IReturn<GetTrialByIdResponse>, IGet
{
    /** @description The primary key Id of the Trial */
    // @ApiMember(DataType="string", Description="The primary key Id of the Trial", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetTrialById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialByIdResponse(); }
}

// @Route("/api/trial/save/{Id}", "POST")
// @Route("/api/trial/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetTrial implements IReturn<SetTrialResponse>
{
    /** @description The Trial Form data to save */
    // @ApiMember(DataType="Trial", Description="The Trial Form data to save", IsRequired=true, Name="trial", ParameterType="body")
    public trial: Trial;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetTrial>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetTrial'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetTrialResponse(); }
}

// @Route("/api/trial/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateTrial implements IReturn<CreateTrialResponse>
{

    public constructor(init?: Partial<CreateTrial>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateTrial'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateTrialResponse(); }
}

// @Route("/api/trials/parents", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetParentTrials implements IReturn<GetParentTrialsResponse>
{

    public constructor(init?: Partial<GetParentTrials>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetParentTrials'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetParentTrialsResponse(); }
}

// @Route("/api/trial/validate/{Id}", "POST")
// @Route("/api/trial/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateTrial implements IReturn<ValidateTrialResponse>
{
    /** @description The Trial Form data to validate */
    // @ApiMember(DataType="Trial", Description="The Trial Form data to validate", IsRequired=true, Name="trial", ParameterType="body")
    public trial: Trial;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateTrial>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateTrial'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateTrialResponse(); }
}

// @Route("/api/institutionitem/{id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Institution Item not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetInstitutionItemById implements IReturn<GetInstitutionItemByIdResponse>, IGet
{
    /** @description The primary key Id of the institution item */
    // @ApiMember(DataType="string", Description="The primary key Id of the institution item", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetInstitutionItemById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInstitutionItemById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetInstitutionItemByIdResponse(); }
}

// @Route("/api/institutionitems/institution/{institutionid}", "GET")
// @ApiResponse(Description="InstitutionId is invalid", StatusCode=400)
// @ApiResponse(Description="Institution Items not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetInstitutionItemsByInstitutionId implements IReturn<GetInstitutionItemsByInstitutionIdResponse>, IGet
{
    /** @description The primary key Id of the institution */
    // @ApiMember(DataType="string", Description="The primary key Id of the institution", IsRequired=true, Name="InstitutionId", ParameterType="path")
    public institutionId: number;

    public constructor(init?: Partial<GetInstitutionItemsByInstitutionId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInstitutionItemsByInstitutionId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetInstitutionItemsByInstitutionIdResponse(); }
}

// @Route("/api/institutionitem/save/{id}", "POST")
// @Route("/api/institutionitem/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetInstitutionItem implements IReturn<SetInstitutionItemResponse>
{
    /** @description The InstitutionItem Form data to save */
    // @ApiMember(DataType="InstitutionItem", Description="The InstitutionItem Form data to save", IsRequired=true, Name="InstitutionItem", ParameterType="body")
    public institutionItem: InstitutionItem;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetInstitutionItem>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetInstitutionItem'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetInstitutionItemResponse(); }
}

// @Route("/api/institutionitems/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateInstitutionItem implements IReturn<CreateInstitutionItemResponse>
{
    /** @description The primary key Id of the institution */
    // @ApiMember(DataType="string", Description="The primary key Id of the institution", IsRequired=true, Name="InstitutionId", ParameterType="path")
    public institutionId: number;

    public constructor(init?: Partial<CreateInstitutionItem>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateInstitutionItem'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateInstitutionItemResponse(); }
}

// @Route("/api/search", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class Search implements IReturn<SearchResponse>
{
    public searchFor: string;
    public filter: string[];

    public constructor(init?: Partial<Search>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'Search'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SearchResponse(); }
}

// @Route("/api/searchpersonnel", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SearchPersonnel implements IReturn<SearchPersonnelResponse>
{
    public searchFor: string;

    public constructor(init?: Partial<SearchPersonnel>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SearchPersonnel'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SearchPersonnelResponse(); }
}

// @Route("/api/role", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetRoles implements IReturn<GetRolesResponse>
{

    public constructor(init?: Partial<GetRoles>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetRoles'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetRolesResponse(); }
}

// @Route("/api/role/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Role not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetRoleById implements IReturn<GetRoleByIdResponse>, IGet
{
    /** @description The primary key Id of the role */
    // @ApiMember(DataType="string", Description="The primary key Id of the role", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetRoleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetRoleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetRoleByIdResponse(); }
}

// @Route("/api/role/save/{Id}", "POST")
// @Route("/api/role/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetRole implements IReturn<SetRoleResponse>
{
    /** @description The Role Form data to save */
    // @ApiMember(DataType="Role", Description="The Role Form data to save", IsRequired=true, Name="Role", ParameterType="body")
    public role: Role;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetRole>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetRole'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetRoleResponse(); }
}

// @Route("/api/role/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateRole implements IReturn<CreateRoleResponse>
{

    public constructor(init?: Partial<CreateRole>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateRole'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateRoleResponse(); }
}

// @Route("/api/role/validate/{Id}", "POST")
// @Route("/api/role/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateRole implements IReturn<ValidateRoleResponse>
{
    /** @description The Role Form data to validate */
    // @ApiMember(DataType="Role", Description="The Role Form data to validate", IsRequired=true, Name="Role", ParameterType="body")
    public role: Role;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateRole>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateRole'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateRoleResponse(); }
}

// @Route("/api/quilldocument imageimage/id/{id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Quill document image not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetQuillDocumentImageById implements IReturn<GetQuillDocumentImageByIdResponse>, IGet
{
    /** @description The primary key Id of the quill document image */
    // @ApiMember(DataType="int", Description="The primary key Id of the quill document image", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetQuillDocumentImageById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetQuillDocumentImageById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetQuillDocumentImageByIdResponse(); }
}

// @Route("/api/quilldocumentimage/{quilldocumentid}", "GET")
// @ApiResponse(Description="QuillDocumentId is invalid", StatusCode=400)
// @ApiResponse(Description="Quill document image not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetQuillDocumentImageByQuillDocumentId implements IReturn<GetQuillDocumentImageByQuillDocumentIdResponse>, IGet
{
    /** @description The type of the quill document image */
    // @ApiMember(DataType="int", Description="The type of the quill document image", IsRequired=true, Name="Type", ParameterType="path")
    public quillDocumentId: number;

    public constructor(init?: Partial<GetQuillDocumentImageByQuillDocumentId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetQuillDocumentImageByQuillDocumentId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetQuillDocumentImageByQuillDocumentIdResponse(); }
}

// @Route("/api/quilldocumentimage/save/{Id}", "POST")
// @Route("/api/quilldocumentimage/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetQuillDocumentImage implements IReturn<SetQuillDocumentImageResponse>
{
    /** @description The QuillDocumentImage Form data to save */
    // @ApiMember(DataType="QuillDocumentImage", Description="The QuillDocumentImage Form data to save", IsRequired=true, Name="QuillDocumentImage", ParameterType="body")
    public quillDocumentImage: QuillDocumentImage;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetQuillDocumentImage>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetQuillDocumentImage'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetQuillDocumentImageResponse(); }
}

// @Route("/api/quilldocumentimage/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateQuillDocumentImage implements IReturn<CreateQuillDocumentImageResponse>
{
    /** @description The type of the quill document image */
    // @ApiMember(DataType="int", Description="The type of the quill document image", IsRequired=true, Name="Type", ParameterType="path")
    public quillDocumentId: number;

    public constructor(init?: Partial<CreateQuillDocumentImage>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateQuillDocumentImage'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateQuillDocumentImageResponse(); }
}

// @Route("/api/file/image/{name}", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetQuillDocumentImage implements IReturn<HttpResult>
{
    public name: string;

    public constructor(init?: Partial<GetQuillDocumentImage>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetQuillDocumentImage'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new HttpResult(); }
}

// @Route("/api/file/upload/image", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class UploadQuillDocumentImage implements IReturn<UploadQuillDocumentImageResponse>
{
    public quillDocumentId?: number;

    public constructor(init?: Partial<UploadQuillDocumentImage>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UploadQuillDocumentImage'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UploadQuillDocumentImageResponse(); }
}

// @Route("/api/quilldocument/id/{id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Quill document not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetQuillDocumentById implements IReturn<GetQuillDocumentByIdResponse>, IGet
{
    /** @description The primary key Id of the quill document */
    // @ApiMember(DataType="int", Description="The primary key Id of the quill document", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetQuillDocumentById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetQuillDocumentById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetQuillDocumentByIdResponse(); }
}

// @Route("/api/quilldocument/{type}/{page}", "GET")
// @ApiResponse(Description="Type is invalid", StatusCode=400)
// @ApiResponse(Description="Page is invalid", StatusCode=400)
// @ApiResponse(Description="Quill document not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetQuillDocumentByTypeAndPage implements IReturn<GetQuillDocumentByTypeAndPageResponse>, IGet
{
    /** @description The type of the quill document */
    // @ApiMember(DataType="int", Description="The type of the quill document", IsRequired=true, Name="Type", ParameterType="path")
    public type: QuillDocumentType;

    /** @description The page of the quill document */
    // @ApiMember(DataType="int", Description="The page of the quill document", IsRequired=true, Name="Page", ParameterType="path")
    public page: Page;

    public constructor(init?: Partial<GetQuillDocumentByTypeAndPage>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetQuillDocumentByTypeAndPage'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetQuillDocumentByTypeAndPageResponse(); }
}

// @Route("/api/quilldocument/search/{search}", "GET")
// @ApiResponse(Description="Search is invalid", StatusCode=400)
// @ApiResponse(Description="Quill documents not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetQuillDocumentsBySearch implements IReturn<GetQuillDocumentsBySearchResponse>, IGet
{
    /** @description The search term to be includeed in the quill document */
    // @ApiMember(DataType="string", Description="The search term to be includeed in the quill document", IsRequired=true, Name="Search", ParameterType="path")
    public search: string;

    public constructor(init?: Partial<GetQuillDocumentsBySearch>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetQuillDocumentsBySearch'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetQuillDocumentsBySearchResponse(); }
}

// @Route("/api/quilldocument/save/{Id}", "POST")
// @Route("/api/quilldocument/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetQuillDocument implements IReturn<SetQuillDocumentResponse>
{
    /** @description The QuillDocument Form data to save */
    // @ApiMember(DataType="QuillDocument", Description="The QuillDocument Form data to save", IsRequired=true, Name="QuillDocument", ParameterType="body")
    public quillDocument: QuillDocument;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetQuillDocument>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetQuillDocument'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetQuillDocumentResponse(); }
}

// @Route("/api/quilldocument/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateQuillDocument implements IReturn<CreateQuillDocumentResponse>
{
    /** @description The type of the quill document */
    // @ApiMember(DataType="int", Description="The type of the quill document", IsRequired=true, Name="Type", ParameterType="path")
    public type: QuillDocumentType;

    /** @description The page of the quill document */
    // @ApiMember(DataType="int", Description="The page of the quill document", IsRequired=true, Name="Page", ParameterType="path")
    public page: Page;

    public constructor(init?: Partial<CreateQuillDocument>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateQuillDocument'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateQuillDocumentResponse(); }
}

// @Route("/api/quilldocument/validate/{Id}", "POST")
// @Route("/api/quilldocument/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateQuillDocument implements IReturn<ValidateQuillDocumentResponse>
{
    /** @description The Quill Document Form data to validate */
    // @ApiMember(DataType="QuillDocument", Description="The Quill Document Form data to validate", IsRequired=true, Name="QuillDocument", ParameterType="body")
    public quillDocument: QuillDocument;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateQuillDocument>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateQuillDocument'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateQuillDocumentResponse(); }
}

// @Route("/api/projectinvestigator/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Project Investigator not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetProjectInvestigatorById implements IReturn<GetProjectInvestigatorByIdResponse>, IGet
{
    /** @description The primary key Id of the Project Investigator */
    // @ApiMember(DataType="string", Description="The primary key Id of the Project Investigator", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetProjectInvestigatorById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetProjectInvestigatorById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetProjectInvestigatorByIdResponse(); }
}

// @Route("/api/projectinvestigator/projectid/{projectid}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Project Investigator not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetProjectInvestigatorsByProjectId implements IReturn<GetProjectInvestigatorsByProjectIdResponse>, IGet
{
    /** @description The primary key Id of the Project */
    // @ApiMember(DataType="string", Description="The primary key Id of the Project", IsRequired=true, Name="ProjectId", ParameterType="path")
    public projectId: number;

    public constructor(init?: Partial<GetProjectInvestigatorsByProjectId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetProjectInvestigatorsByProjectId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetProjectInvestigatorsByProjectIdResponse(); }
}

// @Route("/api/projectinvestigator/save/{Id}", "POST")
// @Route("/api/projectinvestigator/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetProjectInvestigator implements IReturn<SetProjectInvestigatorResponse>
{
    /** @description The Project Investigator Form data to save */
    // @ApiMember(DataType="ProjectInvestigator", Description="The Project Investigator Form data to save", IsRequired=true, Name="ProjectInvestigator", ParameterType="body")
    public projectInvestigator: ProjectInvestigator;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetProjectInvestigator>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetProjectInvestigator'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetProjectInvestigatorResponse(); }
}

// @Route("/api/projectinvestigator/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateProjectInvestigator implements IReturn<CreateProjectInvestigatorResponse>
{
    public trialId?: number;
    public personnelId?: number;

    public constructor(init?: Partial<CreateProjectInvestigator>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateProjectInvestigator'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateProjectInvestigatorResponse(); }
}

// @Route("/api/projectinvestigator/validate/{Id}", "POST")
// @Route("/api/projectinvestigator/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateProjectInvestigator implements IReturn<ValidateProjectInvestigatorResponse>
{
    /** @description The Project Investigator Form data to validate */
    // @ApiMember(DataType="ProjectInvestigator", Description="The Project Investigator Form data to validate", IsRequired=true, Name="ProjectInvestigator", ParameterType="body")
    public projectInvestigator: ProjectInvestigator;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateProjectInvestigator>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateProjectInvestigator'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateProjectInvestigatorResponse(); }
}

// @Route("/api/projectitemimport/id/{Id}/{TrialId}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Project not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetProjectItemImportById implements IReturn<GetProjectItemImportByIdResponse>, IGet
{
    /** @description The primary key Id of the Destination Project */
    // @ApiMember(DataType="string", Description="The primary key Id of the Destination Project", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    /** @description The primary key Id of the Soruce Project */
    // @ApiMember(DataType="string", Description="The primary key Id of the Soruce Project", IsRequired=true, Name="TrialId", ParameterType="path")
    public trialId: number;

    public constructor(init?: Partial<GetProjectItemImportById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetProjectItemImportById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetProjectItemImportByIdResponse(); }
}

// @Route("/api/projectitemimport/save/{Id}/{TrialId}", "POST")
// @Route("/api/projectitemimport/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetProjectItemImport implements IReturn<SetProjectItemImportResponse>
{
    /** @description The Project Form data to save */
    // @ApiMember(DataType="Project", Description="The Project Form data to save", IsRequired=true, Name="Project", ParameterType="body")
    public projectItemImport: ProjectItemImport;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    /** @description The primary key Id of the Soruce Project */
    // @ApiMember(DataType="string", Description="The primary key Id of the Soruce Project", IsRequired=true, Name="ProjectId", ParameterType="path")
    public projectId: number;

    public constructor(init?: Partial<SetProjectItemImport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetProjectItemImport'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetProjectItemImportResponse(); }
}

// @Route("/api/projects", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetProjects implements IReturn<GetProjectsResponse>
{
    public showInActiveProjectItems: boolean;

    public constructor(init?: Partial<GetProjects>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetProjects'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetProjectsResponse(); }
}

// @Route("/api/project/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Project not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetProjectById implements IReturn<GetProjectByIdResponse>, IGet
{
    /** @description The primary key Id of the Project */
    // @ApiMember(DataType="string", Description="The primary key Id of the Project", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetProjectById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetProjectById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetProjectByIdResponse(); }
}

// @Route("/api/project/save/{Id}", "POST")
// @Route("/api/project/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetProject implements IReturn<SetProjectResponse>
{
    /** @description The Project Form data to save */
    // @ApiMember(DataType="Project", Description="The Project Form data to save", IsRequired=true, Name="project", ParameterType="body")
    public project: Project;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetProject>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetProject'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetProjectResponse(); }
}

// @Route("/api/project/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateProject implements IReturn<CreateProjectResponse>
{

    public constructor(init?: Partial<CreateProject>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateProject'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateProjectResponse(); }
}

// @Route("/api/project/validate/{Id}", "POST")
// @Route("/api/project/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateProject implements IReturn<ValidateProjectResponse>
{
    /** @description The Project Form data to validate */
    // @ApiMember(DataType="Project", Description="The Project Form data to validate", IsRequired=true, Name="project", ParameterType="body")
    public project: Project;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateProject>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateProject'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateProjectResponse(); }
}

// @Route("/api/projectedaccrual/trialid/{trialid}", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetProjectedAccrualByTrialId implements IReturn<GetProjectedAccrualByTrialIdResponse>
{
    public trialId: number;

    public constructor(init?: Partial<GetProjectedAccrualByTrialId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetProjectedAccrualByTrialId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetProjectedAccrualByTrialIdResponse(); }
}

// @Route("/api/projectedaccrual/id/{id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="ProjectedAccrual not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetProjectedAccrualById implements IReturn<GetProjectedAccrualByIdResponse>, IGet
{
    /** @description The primary key Id of the ProjectedAccrual */
    // @ApiMember(DataType="string", Description="The primary key Id of the ProjectedAccrual", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetProjectedAccrualById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetProjectedAccrualById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetProjectedAccrualByIdResponse(); }
}

// @Route("/api/projectedaccrual/save/{id}", "POST")
// @Route("/api/projectedaccrual/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetProjectedAccrual implements IReturn<SetProjectedAccrualResponse>
{
    /** @description The ProjectedAccrual Form data to save */
    // @ApiMember(DataType="ProjectedAccrual", Description="The ProjectedAccrual Form data to save", IsRequired=true, Name="ProjectedAccrual", ParameterType="body")
    public projectedAccrual: ProjectedAccrual;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetProjectedAccrual>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetProjectedAccrual'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetProjectedAccrualResponse(); }
}

// @Route("/api/projectedaccrual/update/{trialid}", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class UpdateProjectedAccrual implements IReturn<UpdateProjectedAccrualResponse>
{
    /** @description The ProjectedAccrual data to save */
    // @ApiMember(DataType="ProjectedAccrual", Description="The ProjectedAccrual data to save", IsRequired=true, Name="ProjectedAccrual", ParameterType="body")
    public projectedAccruals: ProjectedAccrual[] = [];

    /** @description The Trial Id of the Project Accrual */
    // @ApiMember(DataType="string", Description="The Trial Id of the Project Accrual", IsRequired=true, Name="TrialId", ParameterType="path")
    public trialId: number;

    public constructor(init?: Partial<UpdateProjectedAccrual>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateProjectedAccrual'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UpdateProjectedAccrualResponse(); }
}

// @Route("/api/openclinicauserrole", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetOpenClinicaUserRoles implements IReturn<GetOpenClinicaUserRolesResponse>
{

    public constructor(init?: Partial<GetOpenClinicaUserRoles>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetOpenClinicaUserRoles'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetOpenClinicaUserRolesResponse(); }
}

// @Route("/api/openclinicauserrole/rebuild", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetOpenClinicaUserRoleRebuild implements IReturn<SetOpenClinicaUserRoleRebuildResponse>
{
    public personnelIds: number[];

    public constructor(init?: Partial<SetOpenClinicaUserRoleRebuild>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetOpenClinicaUserRoleRebuild'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetOpenClinicaUserRoleRebuildResponse(); }
}

// @Route("/api/openclinicauserrole/changestatus/{Id}", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class PostOpenClinicaUserRoleChangeStatus implements IReturn<PostOpenClinicaUserRoleChangeStatusResponse>
{
    public id: number;
    public ocSyncStatus: OCSyncStatus;

    public constructor(init?: Partial<PostOpenClinicaUserRoleChangeStatus>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostOpenClinicaUserRoleChangeStatus'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PostOpenClinicaUserRoleChangeStatusResponse(); }
}

// @Route("/api/openclinicauserrole/resendemail/{Id}", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class PostOpenClinicaUserRoleResendEmail implements IReturn<PostOpenClinicaUserRoleResendEmailResponse>
{
    public id: number;

    public constructor(init?: Partial<PostOpenClinicaUserRoleResendEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostOpenClinicaUserRoleResendEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PostOpenClinicaUserRoleResendEmailResponse(); }
}

// @Route("/api/openclinicauserrole/import", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class PostOpenClinicaUserRoleImport implements IReturn<PostOpenClinicaUserRoleImportResponse>
{

    public constructor(init?: Partial<PostOpenClinicaUserRoleImport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostOpenClinicaUserRoleImport'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PostOpenClinicaUserRoleImportResponse(); }
}

// @Route("/api/personnelrole/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Personnel Role not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetPersonnelRoleById implements IReturn<GetPersonnelRoleByIdResponse>, IGet
{
    /** @description The primary key Id of the Personnel Role */
    // @ApiMember(DataType="string", Description="The primary key Id of the Personnel Role", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetPersonnelRoleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPersonnelRoleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPersonnelRoleByIdResponse(); }
}

// @Route("/api/personnelrole/save/{Id}", "POST")
// @Route("/api/personnelrole/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetPersonnelRole implements IReturn<SetPersonnelRoleResponse>
{
    /** @description The Personnel Role Form data to save */
    // @ApiMember(DataType="PersonnelRole", Description="The Personnel Role Form data to save", IsRequired=true, Name="PersonnelRole", ParameterType="body")
    public personnelRole: PersonnelRole;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetPersonnelRole>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetPersonnelRole'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetPersonnelRoleResponse(); }
}

// @Route("/api/personnelrole/validate/{Id}", "POST")
// @Route("/api/personnelrole/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidatePersonnelRole implements IReturn<ValidatePersonnelRoleResponse>
{
    /** @description The Personnel Role Form data to validate */
    // @ApiMember(DataType="PersonnelRole", Description="The Personnel Role Form data to validate", IsRequired=true, Name="PersonnelRole", ParameterType="body")
    public personnelRole: PersonnelRole;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidatePersonnelRole>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidatePersonnelRole'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidatePersonnelRoleResponse(); }
}

// @Route("/api/personnelrole/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreatePersonnelRole implements IReturn<CreatePersonnelRoleResponse>
{
    public trialId?: number;
    public personnelId?: number;
    public institutionId?: number;
    public groupId?: number;
    public departmentId?: number;
    public laboratoryId?: number;

    public constructor(init?: Partial<CreatePersonnelRole>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreatePersonnelRole'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreatePersonnelRoleResponse(); }
}

// @Route("/api/personnelrole/resendemail/{Id}", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class PostPersonnelRoleResendEmail implements IReturn<PostPersonnelRoleResendEmailResponse>
{
    public id: number;

    public constructor(init?: Partial<PostPersonnelRoleResendEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostPersonnelRoleResendEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PostPersonnelRoleResendEmailResponse(); }
}

// @Route("/api/personnelrole/export/{TrialId}/{InstitutionId}/{GroupId}/{LaboratoryId}", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ExportPersonnelRoles
{
    /** @description The primary key Id of the Trial */
    // @ApiMember(DataType="string", Description="The primary key Id of the Trial", IsRequired=true, Name="TrialId", ParameterType="path")
    public trialId: number;

    /** @description The primary key Id of the Institution */
    // @ApiMember(DataType="string", Description="The primary key Id of the Institution", IsRequired=true, Name="InstitutionId", ParameterType="path")
    public institutionId: number;

    /** @description The primary key Id of the Group */
    // @ApiMember(DataType="string", Description="The primary key Id of the Group", IsRequired=true, Name="GroupId", ParameterType="path")
    public groupId: number;

    /** @description The primary key Id of the Laboratory */
    // @ApiMember(DataType="string", Description="The primary key Id of the Laboratory", IsRequired=true, Name="LaboratoryId", ParameterType="path")
    public laboratoryId: number;

    public filter: string;
    public showInActive: string;

    public constructor(init?: Partial<ExportPersonnelRoles>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExportPersonnelRoles'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}

/** @description TMD */
// @Route("/api/trial-personnel/get-trial-personnel-by-person-id-and-trial-institution", "GET")
// @Api(Description="TMD")
// @ApiResponse(Description="Not authorized", StatusCode=401)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
// @DataContract
export class GetTrialPersonnelByPersonIdAndTrialInstitution implements IReturn<GetTrialPersonnelByPersonIdAndTrialInstitutionResponse>, IGet
{
    /** @description The personnel id */
    // @DataMember(Order=1)
    // @ApiMember(DataType="integer", Description="The personnel id", IsRequired=true, Name="PersonId", ParameterType="query")
    public personId: number;

    /** @description The trial id */
    // @DataMember(Order=2)
    // @ApiMember(DataType="integer", Description="The trial id", IsRequired=true, Name="TrialId", ParameterType="query")
    public trialId: number;

    /** @description The institution code */
    // @DataMember(Order=3)
    // @ApiMember(DataType="string", Description="The institution code", IsRequired=true, Name="InstitutionCode", ParameterType="query")
    public institutionCode: string;

    /** @description List of roles to query for */
    // @DataMember(Order=4)
    // @ApiMember(Description="List of roles to query for", Name="Roles", ParameterType="query")
    public roles: RoleType[];

    /** @description Whether or not to only return personnel when they have an active role (Defaults to true if not provided) */
    // @DataMember(Order=5)
    // @ApiMember(DataType="boolean", Description="Whether or not to only return personnel when they have an active role (Defaults to true if not provided)", Name="ActiveRolesOnly", ParameterType="query")
    public activeRolesOnly?: boolean;

    public constructor(init?: Partial<GetTrialPersonnelByPersonIdAndTrialInstitution>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialPersonnelByPersonIdAndTrialInstitution'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialPersonnelByPersonIdAndTrialInstitutionResponse(); }
}

// @Route("/api/personnel", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetPersonnel implements IReturn<GetPersonnelResponse>
{

    public constructor(init?: Partial<GetPersonnel>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPersonnel'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPersonnelResponse(); }
}

// @Route("/api/personnel/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Personnel not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetPersonnelById implements IReturn<GetPersonnelByIdResponse>, IGet
{
    /** @description The primary key Id of the Personnel */
    // @ApiMember(DataType="string", Description="The primary key Id of the Personnel", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetPersonnelById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPersonnelById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPersonnelByIdResponse(); }
}

// @Route("/api/personnel/save/{Id}", "POST")
// @Route("/api/personnel/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetPersonnel implements IReturn<SetPersonnelResponse>
{
    /** @description The Personnel Form data to save */
    // @ApiMember(DataType="Personnel", Description="The Personnel Form data to save", IsRequired=true, Name="personnel", ParameterType="body")
    public personnel: Personnel;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetPersonnel>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetPersonnel'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetPersonnelResponse(); }
}

// @Route("/api/personnel/validate/{Id}", "POST")
// @Route("/api/personnel/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidatePersonnel implements IReturn<ValidatePersonnelResponse>
{
    /** @description The Personnel Form data to validate */
    // @ApiMember(DataType="Personnel", Description="The Personnel Form data to validate", IsRequired=true, Name="personnel", ParameterType="body")
    public personnel: Personnel;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidatePersonnel>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidatePersonnel'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidatePersonnelResponse(); }
}

// @Route("/api/personnel/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreatePersonnel implements IReturn<CreatePersonnelResponse>
{

    public constructor(init?: Partial<CreatePersonnel>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreatePersonnel'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreatePersonnelResponse(); }
}

// @Route("/api/personnel/resendemail/{Id}", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class PostPersonnelResendEmail implements IReturn<PostPersonnelResendEmailResponse>
{
    public id: number;

    public constructor(init?: Partial<PostPersonnelResendEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostPersonnelResendEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PostPersonnelResendEmailResponse(); }
}

// @Route("/api/personnel/permissions/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Personnel not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetPersonnelPermissionsById implements IReturn<GetPersonnelPermissionsByIdResponse>, IGet
{
    /** @description The primary key Id of the Personnel */
    // @ApiMember(DataType="string", Description="The primary key Id of the Personnel", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetPersonnelPermissionsById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPersonnelPermissionsById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPersonnelPermissionsByIdResponse(); }
}

// @Route("/api/personnelbyrole", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetPersonnelByRole implements IReturn<GetPersonnelByRoleResponse>
{

    public constructor(init?: Partial<GetPersonnelByRole>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPersonnelByRole'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPersonnelByRoleResponse(); }
}

// @Route("/api/personnelcategory", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetPersonnelCategory implements IReturn<GetPersonnelCategoryResponse>
{

    public constructor(init?: Partial<GetPersonnelCategory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPersonnelCategory'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPersonnelCategoryResponse(); }
}

// @Route("/api/personneladvancedsearch", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetPersonnelAdvancedSearch implements IReturn<GetPersonnelAdvancedSearchResponse>
{
    public searchPersonnelAdvanced: SearchPersonnelAdvanced;

    public constructor(init?: Partial<GetPersonnelAdvancedSearch>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPersonnelAdvancedSearch'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GetPersonnelAdvancedSearchResponse(); }
}

// @Route("/api/personneltmdrole", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetPersonnelTmdRole implements IReturn<GetPersonnelTmdRoleResponse>
{

    public constructor(init?: Partial<GetPersonnelTmdRole>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPersonnelTmdRole'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPersonnelTmdRoleResponse(); }
}

/** @description TMD */
// @Route("/api/personnel/get-by-trial", "GET")
// @Api(Description="TMD")
// @ApiResponse(Description="Not authorized", StatusCode=401)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
// @DataContract
export class GetPersonnelByTrial implements IReturn<GetPersonnelByTrialResponse>, IGet
{
    /** @description The trial id to get the personnel for */
    // @DataMember(Order=1)
    // @ApiMember(DataType="integer", Description="The trial id to get the personnel for", IsRequired=true, Name="TrialId", ParameterType="query")
    public trialId: number;

    /** @description List of roles to query for */
    // @DataMember(Order=2)
    // @ApiMember(Description="List of roles to query for", Name="Roles", ParameterType="query")
    public roles: RoleType[];

    /** @description Whether to only return personnel when they have an active role (Defaults to true if not provided) */
    // @DataMember(Order=3)
    // @ApiMember(DataType="boolean", Description="Whether to only return personnel when they have an active role (Defaults to true if not provided)", Name="ActiveRolesOnly", ParameterType="query")
    public activeRolesOnly?: boolean;

    public constructor(init?: Partial<GetPersonnelByTrial>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPersonnelByTrial'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPersonnelByTrialResponse(); }
}

/** @description TMD */
// @Route("/api/personnel/get-by-trial-institution", "GET")
// @Api(Description="TMD")
// @ApiResponse(Description="Not authorized", StatusCode=401)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
// @DataContract
export class GetPersonnelByTrialInstitution implements IReturn<GetPersonnelByTrialInstitutionResponse>, IGet
{
    /** @description The trial id to get the personnel for */
    // @DataMember(Order=1)
    // @ApiMember(DataType="integer", Description="The trial id to get the personnel for", IsRequired=true, Name="TrialId", ParameterType="query")
    public trialId: number;

    /** @description The institution code */
    // @DataMember(Order=2)
    // @ApiMember(DataType="string", Description="The institution code", IsRequired=true, Name="InstitutionCode", ParameterType="query")
    public institutionCode: string;

    /** @description List of roles to query for */
    // @DataMember(Order=3)
    // @ApiMember(Description="List of roles to query for", Name="Roles", ParameterType="query")
    public roles: RoleType[];

    /** @description Whether or not to only return personnel when they have an active role (Defaults to true if not provided) */
    // @DataMember(Order=4)
    // @ApiMember(DataType="boolean", Description="Whether or not to only return personnel when they have an active role (Defaults to true if not provided)", Name="ActiveRolesOnly", ParameterType="query")
    public activeRolesOnly?: boolean;

    public constructor(init?: Partial<GetPersonnelByTrialInstitution>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPersonnelByTrialInstitution'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPersonnelByTrialInstitutionResponse(); }
}

// @Route("/api/personneltmdtrial", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetPersonnelTmdTrial implements IReturn<GetPersonnelTmdTrialResponse>
{

    public constructor(init?: Partial<GetPersonnelTmdTrial>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPersonnelTmdTrial'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPersonnelTmdTrialResponse(); }
}

// @Route("/api/personneltrialgroup", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetPersonnelTrialGroup implements IReturn<GetPersonnelTrialGroupResponse>
{

    public constructor(init?: Partial<GetPersonnelTrialGroup>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPersonnelTrialGroup'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPersonnelTrialGroupResponse(); }
}

/** @description TMD */
// @Route("/personnel/get-by-ids", "GET")
// @Api(Description="TMD")
// @ApiResponse(Description="Not authorized", StatusCode=401)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
// @DataContract
export class GetPersonnelByIds implements IReturn<GetPersonnelByIdsResponse>, IGet
{
    /** @description The ids of the personnel to get */
    // @DataMember(Order=1)
    // @ApiMember(Description="The ids of the personnel to get", IsRequired=true, Name="Ids", ParameterType="query")
    public ids: number[] = [];

    public constructor(init?: Partial<GetPersonnelByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPersonnelByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPersonnelByIdsResponse(); }
}

// @Route("/api/personneltraining/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Personnel Training not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetPersonnelTrainingById implements IReturn<GetPersonnelTrainingByIdResponse>, IGet
{
    /** @description The primary key Id of the Personnel Training */
    // @ApiMember(DataType="string", Description="The primary key Id of the Personnel Training", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetPersonnelTrainingById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPersonnelTrainingById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPersonnelTrainingByIdResponse(); }
}

// @Route("/api/personneltraining/personnelid/{personnelid}", "GET")
// @ApiResponse(Description="Personnel Id is invalid", StatusCode=400)
// @ApiResponse(Description="Personnel Training not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetPersonnelTrainingByPersonnelId implements IReturn<GetPersonnelTrainingByPersonnelIdResponse>, IGet
{
    /** @description The Personnel primary key Id of the Personnel Training */
    // @ApiMember(DataType="string", Description="The Personnel primary key Id of the Personnel Training", IsRequired=true, Name="PersonnelId", ParameterType="path")
    public personnelId: number;

    public constructor(init?: Partial<GetPersonnelTrainingByPersonnelId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPersonnelTrainingByPersonnelId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPersonnelTrainingByPersonnelIdResponse(); }
}

// @Route("/api/personneltraining/save/{Id}", "POST")
// @Route("/api/personneltraining/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetPersonnelTraining implements IReturn<SetPersonnelTrainingResponse>
{
    /** @description The Personnel Training Form data to save */
    // @ApiMember(DataType="PersonnelTraining", Description="The Personnel Training Form data to save", IsRequired=true, Name="PersonnelTraining", ParameterType="body")
    public personnelTraining: PersonnelTraining;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetPersonnelTraining>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetPersonnelTraining'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetPersonnelTrainingResponse(); }
}

// @Route("/api/personneltraining/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreatePersonnelTraining implements IReturn<CreatePersonnelTrainingResponse>
{
    public personnelId?: number;

    public constructor(init?: Partial<CreatePersonnelTraining>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreatePersonnelTraining'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreatePersonnelTrainingResponse(); }
}

// @Route("/api/personneltraining/validate/{Id}", "POST")
// @Route("/api/personneltraining/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidatePersonnelTraining implements IReturn<ValidatePersonnelTrainingResponse>
{
    /** @description The Personnel Training Form data to validate */
    // @ApiMember(DataType="PersonnelTraining", Description="The Personnel Training Form data to validate", IsRequired=true, Name="PersonnelTraining", ParameterType="body")
    public personnelTraining: PersonnelTraining;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidatePersonnelTraining>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidatePersonnelTraining'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidatePersonnelTrainingResponse(); }
}

// @Route("/bctapi/permission/single", "POST")
export class HasPermission implements IReturn<HasPermissionResponse>, IPost
{
    public permissionQuery: PermissionQuery;

    public constructor(init?: Partial<HasPermission>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'HasPermission'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new HasPermissionResponse(); }
}

// @Route("/bctapi/permission/multi", "POST")
export class HasPermissions implements IReturn<HasPermissionsResponse>, IPost
{
    public username: string;
    public permissionQueries: PermissionQuery[];

    public constructor(init?: Partial<HasPermissions>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'HasPermissions'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new HasPermissionsResponse(); }
}

// @Route("/bctapi/permission/any", "POST")
export class HasPermissionsAny implements IReturn<HasPermissionsAnyResponse>, IPost
{
    public username: string;
    public permissionQueries: PermissionQuery[];

    public constructor(init?: Partial<HasPermissionsAny>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'HasPermissionsAny'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new HasPermissionsAnyResponse(); }
}

// @Route("/bctapi/permission/all", "POST")
export class HasPermissionsAll implements IReturn<HasPermissionsAllResponse>, IPost
{
    public username: string;
    public permissionQueries: PermissionQuery[];

    public constructor(init?: Partial<HasPermissionsAll>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'HasPermissionsAll'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new HasPermissionsAllResponse(); }
}

// @Route("/bctapi/permission/evaluate-all", "POST")
export class EvaluateAllPermissions implements IReturn<EvaluateAllPermissionsResponse>, IPost
{
    public username: string;
    public permissionQueries: PermissionQuery[];

    public constructor(init?: Partial<EvaluateAllPermissions>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EvaluateAllPermissions'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new EvaluateAllPermissionsResponse(); }
}

// @Route("/bctapi/permission-configurations", "GET")
export class GetPermissionConfigurations implements IReturn<GetPermissionConfigurationsResponse>, IGet
{

    public constructor(init?: Partial<GetPermissionConfigurations>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPermissionConfigurations'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPermissionConfigurationsResponse(); }
}

// @Route("/bctapi/permission-configuration", "GET")
export class GetPermissionConfigurationByPermissionId implements IReturn<GetPermissionConfigurationByPermissionIdResponse>, IGet
{
    public permission: Permission;

    public constructor(init?: Partial<GetPermissionConfigurationByPermissionId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPermissionConfigurationByPermissionId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPermissionConfigurationByPermissionIdResponse(); }
}

// @Route("/bctapi/permissions/by-user-and-context", "POST")
export class GetPermissionsForUserAndContext implements IReturn<GetPermissionsForUserAndContextResponse>, IPost
{
    public userName: string;
    public permissionResolutionType?: PermissionResolutionType;
    public permissionContext: PermissionContext;
    public userType?: UserSessionType;
    public trialId?: number;
    public institutionCode: string;
    public email: string;

    public constructor(init?: Partial<GetPermissionsForUserAndContext>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPermissionsForUserAndContext'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GetPermissionsForUserAndContextResponse(); }
}

/** @description Permissions */
// @Route("/bctapi/permissions/by-username", "POST")
// @Api(Description="Permissions")
// @ApiResponse(Description="Not authorized", StatusCode=401)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
// @DataContract
export class GetPermissionsByUsername implements IReturn<GetPermissionsByUsernameResponse>, IPost
{
    /** @description The username to get the user for */
    // @DataMember(Order=1)
    // @ApiMember(DataType="string", Description="The username to get the user for", IsRequired=true, Name="Username", ParameterType="query")
    public username: string;

    /** @description Whether to return permissions for trial contexts */
    // @DataMember(Order=2)
    // @ApiMember(DataType="boolean", Description="Whether to return permissions for trial contexts", Name="IncludeTrialContexts", ParameterType="query")
    public includeTrialContexts?: boolean;

    /** @description Whether to return permissions for master group contexts */
    // @DataMember(Order=3)
    // @ApiMember(DataType="boolean", Description="Whether to return permissions for master group contexts", Name="IncludeMasterGroupContexts", ParameterType="query")
    public includeMasterGroupContexts?: boolean;

    /** @description Whether to return permissions for coordinating group contexts */
    // @DataMember(Order=4)
    // @ApiMember(DataType="boolean", Description="Whether to return permissions for coordinating group contexts", Name="IncludeCoordinatingGroupContexts", ParameterType="query")
    public includeCoordinatingGroupContexts?: boolean;

    /** @description Whether to return permissions for institution contexts */
    // @DataMember(Order=5)
    // @ApiMember(DataType="boolean", Description="Whether to return permissions for institution contexts", Name="IncludeInstitutionContexts", ParameterType="query")
    public includeInstitutionContexts?: boolean;

    /** @description Restrict returned contexts to specific trials */
    // @DataMember(Order=6)
    // @ApiMember(DataType="array", Description="Restrict returned contexts to specific trials", Name="TrialIds", ParameterType="query")
    public trialIds: number[];

    /** @description Restrict returned contexts to specific master groups */
    // @DataMember(Order=7)
    // @ApiMember(DataType="array", Description="Restrict returned contexts to specific master groups", Name="MasterGroupIds", ParameterType="query")
    public masterGroupIds: number[];

    /** @description Restrict returned contexts to specific coordinating groups */
    // @DataMember(Order=8)
    // @ApiMember(DataType="array", Description="Restrict returned contexts to specific coordinating groups", Name="CoordinatingGroupIds", ParameterType="query")
    public coordinatingGroupIds: number[];

    /** @description Restrict returned contexts to specific institutions */
    // @DataMember(Order=9)
    // @ApiMember(DataType="array", Description="Restrict returned contexts to specific institutions", Name="InstitutionIds", ParameterType="query")
    public institutionIds: number[];

    /** @description Restrict returned contexts to specific institutions */
    // @DataMember(Order=10)
    // @ApiMember(DataType="array", Description="Restrict returned contexts to specific institutions", Name="InstitutionCodes", ParameterType="query")
    public institutionCodes: string[];

    /** @description Whether to return permissions for global context */
    // @DataMember(Order=11)
    // @ApiMember(DataType="boolean", Description="Whether to return permissions for global context", Name="IncludeGlobalContext", ParameterType="query")
    public includeGlobalContext?: boolean;

    public constructor(init?: Partial<GetPermissionsByUsername>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPermissionsByUsername'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GetPermissionsByUsernameResponse(); }
}

/** @description Permission */
// @Route("/bctapi/user-groups/by-username", "POST")
// @Api(Description="Permission")
// @ApiResponse(Description="Not authorized", StatusCode=401)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
// @DataContract
export class GetUserGroupsByUsername implements IReturn<GetUserGroupsByUsernameResponse>
{
    /** @description User's TMD username */
    // @DataMember(Order=1)
    // @ApiMember(DataType="string", Description="User's TMD username", Format="string", IsRequired=true, Name="Username", ParameterType="path")
    public username: string;

    /** @description Trial IDs to filter */
    // @DataMember(Order=2)
    // @ApiMember(DataType="List<int>", Description="Trial IDs to filter", Name="TrialIds", ParameterType="path")
    public trialIds: number[];

    /** @description Permissions expected of each group */
    // @DataMember(Order=3)
    // @ApiMember(DataType="List<Permission>", Description="Permissions expected of each group", Name="HasPermissions", ParameterType="path")
    public hasPermissions: Permission[];

    public constructor(init?: Partial<GetUserGroupsByUsername>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetUserGroupsByUsername'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GetUserGroupsByUsernameResponse(); }
}

// @Route("/api/patient/trialinstitution/{trialid}/{institutionid}", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetPatientsByTrialInstitution implements IReturn<GetPatientsByTrialInstitutionResponse>
{
    /** @description The primary key Id of the trial */
    // @ApiMember(DataType="string", Description="The primary key Id of the trial", IsRequired=true, Name="TrialId", ParameterType="path")
    public trialId: number;

    /** @description The primary key Id of the institution */
    // @ApiMember(DataType="string", Description="The primary key Id of the institution", IsRequired=true, Name="InstitutionId", ParameterType="path")
    public institutionId: number;

    public constructor(init?: Partial<GetPatientsByTrialInstitution>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPatientsByTrialInstitution'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPatientsByTrialInstitutionResponse(); }
}

// @Route("/api/note/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Note not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetNoteById implements IReturn<GetNoteByIdResponse>, IGet
{
    /** @description The primary key Id of the Note */
    // @ApiMember(DataType="string", Description="The primary key Id of the Note", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetNoteById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetNoteById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetNoteByIdResponse(); }
}

// @Route("/api/note/save/{Id}", "POST")
// @Route("/api/note/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetNote implements IReturn<SetNoteResponse>
{
    /** @description The Note Form data to save */
    // @ApiMember(DataType="Note", Description="The Note Form data to save", IsRequired=true, Name="note", ParameterType="body")
    public note: Note;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetNote>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetNote'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetNoteResponse(); }
}

// @Route("/api/note/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateNote implements IReturn<CreateNoteResponse>
{
    public trialId?: number;
    public institutionId?: number;
    public trialInstitutionId?: number;
    public personnelId?: number;
    public groupId?: number;

    public constructor(init?: Partial<CreateNote>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateNote'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateNoteResponse(); }
}

// @Route("/api/note/validate/{Id}", "POST")
// @Route("/api/note/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateNote implements IReturn<ValidateNoteResponse>
{
    /** @description The Note Form data to validate */
    // @ApiMember(DataType="Note", Description="The Note Form data to validate", IsRequired=true, Name="note", ParameterType="body")
    public note: Note;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateNote>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateNote'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateNoteResponse(); }
}

// @Route("/api/notetypenotes/trialid/{trialid}", "GET")
// @ApiResponse(Description="TrialId is invalid", StatusCode=400)
// @ApiResponse(Description="Trial Notes not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetNoteTypeNotesByTrialId implements IReturn<GetNoteTypeNotesByTrialIdResponse>
{
    public trialId?: number;

    public constructor(init?: Partial<GetNoteTypeNotesByTrialId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetNoteTypeNotesByTrialId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetNoteTypeNotesByTrialIdResponse(); }
}

// @Route("/api/notetypenotes/trialinstitutionid/{trialinstitutionid}", "GET")
// @ApiResponse(Description="TrialInstitutionId is invalid", StatusCode=400)
// @ApiResponse(Description="Trial Institution Notes not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetNoteTypeNotesByTrialInstitutionId implements IReturn<GetNoteTypeNotesByTrialInstitutionIdResponse>
{
    public trialInstitutionId?: number;

    public constructor(init?: Partial<GetNoteTypeNotesByTrialInstitutionId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetNoteTypeNotesByTrialInstitutionId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetNoteTypeNotesByTrialInstitutionIdResponse(); }
}

// @Route("/api/notetypenotes/institutionid/{institutionid}", "GET")
// @ApiResponse(Description="InstitutionId is invalid", StatusCode=400)
// @ApiResponse(Description=" Institution Notes not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetNoteTypeNotesByInstitutionId implements IReturn<GetNoteTypeNotesByInstitutionIdResponse>
{
    public institutionId?: number;

    public constructor(init?: Partial<GetNoteTypeNotesByInstitutionId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetNoteTypeNotesByInstitutionId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetNoteTypeNotesByInstitutionIdResponse(); }
}

// @Route("/api/notetypenotes/personnelid/{personnelid}", "GET")
// @ApiResponse(Description="PersonnelId is invalid", StatusCode=400)
// @ApiResponse(Description=" Personnel Notes not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetNoteTypeNotesByPersonnelId implements IReturn<GetNoteTypeNotesByPersonnelIdResponse>
{
    public personnelId?: number;

    public constructor(init?: Partial<GetNoteTypeNotesByPersonnelId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetNoteTypeNotesByPersonnelId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetNoteTypeNotesByPersonnelIdResponse(); }
}

// @Route("/api/monitors", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetMonitors implements IReturn<GetMonitorsResponse>
{

    public constructor(init?: Partial<GetMonitors>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMonitors'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetMonitorsResponse(); }
}

// @Route("/api/monitoring/monitoringId/{monitoringId}", "GET")
// @ApiResponse(Description="Monitoring Id is invalid", StatusCode=400)
// @ApiResponse(Description="Monitoring not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetMonitorsByMonitoringId implements IReturn<GetMonitorsByMonitoringIdResponse>, IGet
{
    /** @description The Monitoring Id of the monitorings */
    // @ApiMember(DataType="int", Description="The Monitoring Id of the monitorings", IsRequired=true, Name="MonitoringId", ParameterType="path")
    public monitoringId: number;

    public constructor(init?: Partial<GetMonitorsByMonitoringId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMonitorsByMonitoringId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetMonitorsByMonitoringIdResponse(); }
}

// @Route("/api/monitor/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Monitor not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetMonitorById implements IReturn<GetMonitorByIdResponse>, IGet
{
    /** @description The primary key Id of the monitor */
    // @ApiMember(DataType="int", Description="The primary key Id of the monitor", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetMonitorById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMonitorById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetMonitorByIdResponse(); }
}

// @Route("/api/monitor/save/{Id}", "POST")
// @Route("/api/monitor/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetMonitor implements IReturn<SetMonitorResponse>
{
    /** @description The Monitor Form data to save */
    // @ApiMember(DataType="Monitor", Description="The Monitor Form data to save", IsRequired=true, Name="Monitor", ParameterType="body")
    public monitor: Monitor;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetMonitor>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetMonitor'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetMonitorResponse(); }
}

// @Route("/api/monitor/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateMonitor implements IReturn<CreateMonitorResponse>
{
    public monitoringId: number;

    public constructor(init?: Partial<CreateMonitor>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateMonitor'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateMonitorResponse(); }
}

// @Route("/api/monitor/validate/{Id}", "POST")
// @Route("/api/monitor/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateMonitor implements IReturn<ValidateMonitorResponse>
{
    /** @description The Monitor Form data to validate */
    // @ApiMember(DataType="Monitor", Description="The Monitor Form data to validate", IsRequired=true, Name="Monitor", ParameterType="body")
    public monitor: Monitor;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateMonitor>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateMonitor'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateMonitorResponse(); }
}

// @Route("/api/monitoringissues", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetMonitoringIssues implements IReturn<GetMonitoringIssuesResponse>
{

    public constructor(init?: Partial<GetMonitoringIssues>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMonitoringIssues'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetMonitoringIssuesResponse(); }
}

// @Route("/api/monitoring/monitoringid/{monitoringid}", "GET")
// @ApiResponse(Description="Monitoring Id is invalid", StatusCode=400)
// @ApiResponse(Description="MonitoringIssue not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetMonitoringIssuesByMonitoringId implements IReturn<GetMonitoringIssuesByMonitoringIdResponse>, IGet
{
    /** @description The Monitoring Id of the monitoring issues */
    // @ApiMember(DataType="int", Description="The Monitoring Id of the monitoring issues", IsRequired=true, Name="MonitoringId", ParameterType="path")
    public monitoringId: number;

    public constructor(init?: Partial<GetMonitoringIssuesByMonitoringId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMonitoringIssuesByMonitoringId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetMonitoringIssuesByMonitoringIdResponse(); }
}

// @Route("/api/monitoring/id/{id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="MonitoringIssue not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetMonitoringIssueById implements IReturn<GetMonitoringIssueByIdResponse>, IGet
{
    /** @description The primary key Id of the moniroring */
    // @ApiMember(DataType="int", Description="The primary key Id of the moniroring", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetMonitoringIssueById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMonitoringIssueById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetMonitoringIssueByIdResponse(); }
}

// @Route("/api/monitoringissue/save/{Id}", "POST")
// @Route("/api/monitoringissue/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetMonitoringIssue implements IReturn<SetMonitoringIssueResponse>
{
    /** @description The MonitoringIssue Form data to save */
    // @ApiMember(DataType="MonitoringIssue", Description="The MonitoringIssue Form data to save", IsRequired=true, Name="MonitoringIssue", ParameterType="body")
    public monitoringIssue: MonitoringIssue;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetMonitoringIssue>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetMonitoringIssue'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetMonitoringIssueResponse(); }
}

// @Route("/api/monitoringissue/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateMonitoringIssue implements IReturn<CreateMonitoringIssueResponse>
{
    public monitoringId: number;

    public constructor(init?: Partial<CreateMonitoringIssue>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateMonitoringIssue'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateMonitoringIssueResponse(); }
}

// @Route("/api/monitoringissue/validate/{Id}", "POST")
// @Route("/api/monitoringissue/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateMonitoringIssue implements IReturn<ValidateMonitoringIssueResponse>
{
    /** @description The MonitoringIssue Form data to validate */
    // @ApiMember(DataType="MonitoringIssue", Description="The MonitoringIssue Form data to validate", IsRequired=true, Name="MonitoringIssue", ParameterType="body")
    public monitoringIssue: MonitoringIssue;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateMonitoringIssue>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateMonitoringIssue'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateMonitoringIssueResponse(); }
}

// @Route("/api/monitorings", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetMonitorings implements IReturn<GetMonitoringsResponse>
{

    public constructor(init?: Partial<GetMonitorings>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMonitorings'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetMonitoringsResponse(); }
}

// @Route("/api/monitoring/trialinstitutionid/{trialinstitutionid}", "GET")
// @ApiResponse(Description="Trial Institution Id is invalid", StatusCode=400)
// @ApiResponse(Description="Monitoring not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetMonitoringsByTrialInstitutionId implements IReturn<GetMonitoringsByTrialInstitutionIdResponse>, IGet
{
    /** @description The Trial Institution Id of the monitorings */
    // @ApiMember(DataType="int", Description="The Trial Institution Id of the monitorings", IsRequired=true, Name="TrialInstitutionId", ParameterType="path")
    public trialInstitutionId: number;

    public constructor(init?: Partial<GetMonitoringsByTrialInstitutionId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMonitoringsByTrialInstitutionId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetMonitoringsByTrialInstitutionIdResponse(); }
}

// @Route("/api/monitoring/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Monitoring not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetMonitoringById implements IReturn<GetMonitoringByIdResponse>, IGet
{
    /** @description The primary key Id of the moniroring */
    // @ApiMember(DataType="int", Description="The primary key Id of the moniroring", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetMonitoringById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMonitoringById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetMonitoringByIdResponse(); }
}

// @Route("/api/monitoring/save/{Id}", "POST")
// @Route("/api/monitoring/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetMonitoring implements IReturn<SetMonitoringResponse>
{
    /** @description The Monitoring Form data to save */
    // @ApiMember(DataType="Monitoring", Description="The Monitoring Form data to save", IsRequired=true, Name="Monitoring", ParameterType="body")
    public monitoring: Monitoring;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetMonitoring>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetMonitoring'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetMonitoringResponse(); }
}

// @Route("/api/monitoring/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateMonitoring implements IReturn<CreateMonitoringResponse>
{
    public trialInstitutionId: number;

    public constructor(init?: Partial<CreateMonitoring>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateMonitoring'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateMonitoringResponse(); }
}

// @Route("/api/monitoring/validate/{Id}", "POST")
// @Route("/api/monitoring/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateMonitoring implements IReturn<ValidateMonitoringResponse>
{
    /** @description The Monitoring Form data to validate */
    // @ApiMember(DataType="Monitoring", Description="The Monitoring Form data to validate", IsRequired=true, Name="Monitoring", ParameterType="body")
    public monitoring: Monitoring;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateMonitoring>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateMonitoring'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateMonitoringResponse(); }
}

// @Route("/api/monitoringissuedocuments", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetMonitoringIssueDocuments implements IReturn<GetMonitoringIssueDocumentsResponse>
{

    public constructor(init?: Partial<GetMonitoringIssueDocuments>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMonitoringIssueDocuments'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetMonitoringIssueDocumentsResponse(); }
}

// @Route("/api/monitoringissuedocument/monitoringissuedocumentid/{monitoringissuedocumentid}", "GET")
// @ApiResponse(Description="Monitoring Id is invalid", StatusCode=400)
// @ApiResponse(Description="MonitoringIssueDocument not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetMonitoringIssueDocumentsByMonitoringIssueId implements IReturn<GetMonitoringIssueDocumentsByMonitoringIssueIdResponse>, IGet
{
    /** @description The Monitoring Issue Id of the monitoringissuedocuments */
    // @ApiMember(DataType="int", Description="The Monitoring Issue Id of the monitoringissuedocuments", IsRequired=true, Name="MonitoringIssueId", ParameterType="path")
    public monitoringIssueId: number;

    public constructor(init?: Partial<GetMonitoringIssueDocumentsByMonitoringIssueId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMonitoringIssueDocumentsByMonitoringIssueId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetMonitoringIssueDocumentsByMonitoringIssueIdResponse(); }
}

// @Route("/api/monitoringissuedocument/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="MonitoringIssueDocument not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetMonitoringIssueDocumentById implements IReturn<GetMonitoringIssueDocumentByIdResponse>, IGet
{
    /** @description The primary key Id of the monitoring issue */
    // @ApiMember(DataType="int", Description="The primary key Id of the monitoring issue", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetMonitoringIssueDocumentById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMonitoringIssueDocumentById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetMonitoringIssueDocumentByIdResponse(); }
}

// @Route("/api/monitoringissuedocument/save/{Id}", "POST")
// @Route("/api/monitoringissuedocument/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetMonitoringIssueDocument implements IReturn<SetMonitoringIssueDocumentResponse>
{
    /** @description The MonitoringIssueDocument Form data to save */
    // @ApiMember(DataType="MonitoringIssueDocument", Description="The MonitoringIssueDocument Form data to save", IsRequired=true, Name="MonitoringIssueDocument", ParameterType="body")
    public monitoringIssueDocument: MonitoringIssueDocument;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetMonitoringIssueDocument>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetMonitoringIssueDocument'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetMonitoringIssueDocumentResponse(); }
}

// @Route("/api/monitoringissuedocument/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateMonitoringIssueDocument implements IReturn<CreateMonitoringIssueDocumentResponse>
{
    public monitoringIssueId: number;

    public constructor(init?: Partial<CreateMonitoringIssueDocument>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateMonitoringIssueDocument'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateMonitoringIssueDocumentResponse(); }
}

// @Route("/api/monitoringissuedocument/validate/{Id}", "POST")
// @Route("/api/monitoringissuedocument/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateMonitoringIssueDocument implements IReturn<ValidateMonitoringIssueDocumentResponse>
{
    /** @description The MonitoringIssueDocument Form data to validate */
    // @ApiMember(DataType="MonitoringIssueDocument", Description="The MonitoringIssueDocument Form data to validate", IsRequired=true, Name="MonitoringIssueDocument", ParameterType="body")
    public monitoringIssueDocument: MonitoringIssueDocument;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateMonitoringIssueDocument>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateMonitoringIssueDocument'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateMonitoringIssueDocumentResponse(); }
}

// @Route("/api/monitoringdocuments", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetMonitoringDocuments implements IReturn<GetMonitoringDocumentsResponse>
{

    public constructor(init?: Partial<GetMonitoringDocuments>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMonitoringDocuments'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetMonitoringDocumentsResponse(); }
}

// @Route("/api/monitoringdocument/monitoringdocumentid/{monitoringdocumentid}", "GET")
// @ApiResponse(Description="Monitoring Id is invalid", StatusCode=400)
// @ApiResponse(Description="MonitoringDocument not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetMonitoringDocumentsByMonitoringId implements IReturn<GetMonitoringDocumentsByMonitoringIdResponse>, IGet
{
    /** @description The Monitoring Id of the monitoringdocuments */
    // @ApiMember(DataType="int", Description="The Monitoring Id of the monitoringdocuments", IsRequired=true, Name="MonitoringId", ParameterType="path")
    public monitoringId: number;

    public constructor(init?: Partial<GetMonitoringDocumentsByMonitoringId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMonitoringDocumentsByMonitoringId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetMonitoringDocumentsByMonitoringIdResponse(); }
}

// @Route("/api/monitoringdocument/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="MonitoringDocument not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetMonitoringDocumentById implements IReturn<GetMonitoringDocumentByIdResponse>, IGet
{
    /** @description The primary key Id of the moniroring */
    // @ApiMember(DataType="int", Description="The primary key Id of the moniroring", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetMonitoringDocumentById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMonitoringDocumentById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetMonitoringDocumentByIdResponse(); }
}

// @Route("/api/monitoringdocument/save/{Id}", "POST")
// @Route("/api/monitoringdocument/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetMonitoringDocument implements IReturn<SetMonitoringDocumentResponse>
{
    /** @description The MonitoringDocument Form data to save */
    // @ApiMember(DataType="MonitoringDocument", Description="The MonitoringDocument Form data to save", IsRequired=true, Name="MonitoringDocument", ParameterType="body")
    public monitoringDocument: MonitoringDocument;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetMonitoringDocument>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetMonitoringDocument'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetMonitoringDocumentResponse(); }
}

// @Route("/api/monitoringdocument/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateMonitoringDocument implements IReturn<CreateMonitoringDocumentResponse>
{
    public monitoringId: number;

    public constructor(init?: Partial<CreateMonitoringDocument>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateMonitoringDocument'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateMonitoringDocumentResponse(); }
}

// @Route("/api/monitoringdocument/validate/{Id}", "POST")
// @Route("/api/monitoringdocument/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateMonitoringDocument implements IReturn<ValidateMonitoringDocumentResponse>
{
    /** @description The MonitoringDocument Form data to validate */
    // @ApiMember(DataType="MonitoringDocument", Description="The MonitoringDocument Form data to validate", IsRequired=true, Name="MonitoringDocument", ParameterType="body")
    public monitoringDocument: MonitoringDocument;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateMonitoringDocument>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateMonitoringDocument'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateMonitoringDocumentResponse(); }
}

// @Route("/api/categories", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetCategories implements IReturn<GetCategoriesResponse>
{

    public constructor(init?: Partial<GetCategories>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCategories'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetCategoriesResponse(); }
}

// @Route("/api/category/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Category not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetCategoryById implements IReturn<GetCategoryByIdResponse>, IGet
{
    /** @description The primary key Id of the categories */
    // @ApiMember(DataType="string", Description="The primary key Id of the categories", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetCategoryById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCategoryById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetCategoryByIdResponse(); }
}

// @Route("/api/category/save/{Id}", "POST")
// @Route("/api/category/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetCategory implements IReturn<SetCategoryResponse>
{
    /** @description The Category Form data to save */
    // @ApiMember(DataType="Category", Description="The Category Form data to save", IsRequired=true, Name="Category", ParameterType="body")
    public category: Category;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetCategory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetCategory'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetCategoryResponse(); }
}

// @Route("/api/category/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateCategory implements IReturn<CreateCategoryResponse>
{

    public constructor(init?: Partial<CreateCategory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateCategory'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateCategoryResponse(); }
}

// @Route("/api/category/validate/{Id}", "POST")
// @Route("/api/category/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateCategory implements IReturn<ValidateCategoryResponse>
{
    /** @description The Category Form data to validate */
    // @ApiMember(DataType="Category", Description="The Category Form data to validate", IsRequired=true, Name="Category", ParameterType="body")
    public category: Category;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateCategory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateCategory'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateCategoryResponse(); }
}

// @Route("/api/country", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetCountries implements IReturn<GetCountriesResponse>
{

    public constructor(init?: Partial<GetCountries>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCountries'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetCountriesResponse(); }
}

// @Route("/api/country/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Country not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetCountryById implements IReturn<GetCountryByIdResponse>, IGet
{
    /** @description The primary key Id of the categories */
    // @ApiMember(DataType="string", Description="The primary key Id of the categories", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetCountryById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCountryById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetCountryByIdResponse(); }
}

// @Route("/api/country/save/{Id}", "POST")
// @Route("/api/country/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetCountry implements IReturn<SetCountryResponse>
{
    /** @description The Country Form data to save */
    // @ApiMember(DataType="Country", Description="The Country Form data to save", IsRequired=true, Name="Country", ParameterType="body")
    public country: Country;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetCountry>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetCountry'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetCountryResponse(); }
}

// @Route("/api/country/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateCountry implements IReturn<CreateCountryResponse>
{

    public constructor(init?: Partial<CreateCountry>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateCountry'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateCountryResponse(); }
}

// @Route("/api/country/validate/{Id}", "POST")
// @Route("/api/country/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateCountry implements IReturn<ValidateCountryResponse>
{
    /** @description The Country Form data to validate */
    // @ApiMember(DataType="Country", Description="The Country Form data to validate", IsRequired=true, Name="Country", ParameterType="body")
    public country: Country;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateCountry>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateCountry'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateCountryResponse(); }
}

// @Route("/api/institutioncoding", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetInstitutionCodings implements IReturn<GetInstitutionCodingsResponse>
{

    public constructor(init?: Partial<GetInstitutionCodings>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInstitutionCodings'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetInstitutionCodingsResponse(); }
}

// @Route("/api/institutioncoding/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="InstitutionCoding not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetInstitutionCodingById implements IReturn<GetInstitutionCodingByIdResponse>, IGet
{
    /** @description The primary key Id of the institutioncoding */
    // @ApiMember(DataType="string", Description="The primary key Id of the institutioncoding", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetInstitutionCodingById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInstitutionCodingById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetInstitutionCodingByIdResponse(); }
}

// @Route("/api/institutioncoding/save/{Id}", "POST")
// @Route("/api/institutioncoding/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetInstitutionCoding implements IReturn<SetInstitutionCodingResponse>
{
    /** @description The InstitutionCoding Form data to save */
    // @ApiMember(DataType="InstitutionCoding", Description="The InstitutionCoding Form data to save", IsRequired=true, Name="InstitutionCoding", ParameterType="body")
    public institutionCoding: InstitutionCoding;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetInstitutionCoding>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetInstitutionCoding'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetInstitutionCodingResponse(); }
}

// @Route("/api/institutioncoding/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateInstitutionCoding implements IReturn<CreateInstitutionCodingResponse>
{

    public constructor(init?: Partial<CreateInstitutionCoding>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateInstitutionCoding'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateInstitutionCodingResponse(); }
}

// @Route("/api/institutioncoding/validate/{Id}", "POST")
// @Route("/api/institutioncoding/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateInstitutionCoding implements IReturn<ValidateInstitutionCodingResponse>
{
    /** @description The InstitutionCoding Form data to validate */
    // @ApiMember(DataType="InstitutionCoding", Description="The InstitutionCoding Form data to validate", IsRequired=true, Name="InstitutionCoding", ParameterType="body")
    public institutionCoding: InstitutionCoding;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateInstitutionCoding>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateInstitutionCoding'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateInstitutionCodingResponse(); }
}

// @Route("/api/itemcomponenttype", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetItemComponentTypes implements IReturn<GetItemComponentTypesResponse>
{

    public constructor(init?: Partial<GetItemComponentTypes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetItemComponentTypes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetItemComponentTypesResponse(); }
}

// @Route("/api/itemcomponenttype/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="ItemComponentType not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetItemComponentTypeById implements IReturn<GetItemComponentTypeByIdResponse>, IGet
{
    /** @description The primary key Id of the itemcomponenttype */
    // @ApiMember(DataType="string", Description="The primary key Id of the itemcomponenttype", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetItemComponentTypeById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetItemComponentTypeById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetItemComponentTypeByIdResponse(); }
}

// @Route("/api/itemcomponenttype/save/{Id}", "POST")
// @Route("/api/itemcomponenttype/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetItemComponentType implements IReturn<SetItemComponentTypeResponse>
{
    /** @description The ItemComponentType Form data to save */
    // @ApiMember(DataType="ItemComponentType", Description="The ItemComponentType Form data to save", IsRequired=true, Name="ItemComponentType", ParameterType="body")
    public itemComponentType: ItemComponentType;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetItemComponentType>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetItemComponentType'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetItemComponentTypeResponse(); }
}

// @Route("/api/itemcomponenttype/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateItemComponentType implements IReturn<CreateItemComponentTypeResponse>
{

    public constructor(init?: Partial<CreateItemComponentType>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateItemComponentType'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateItemComponentTypeResponse(); }
}

// @Route("/api/itemcomponenttype/validate/{Id}", "POST")
// @Route("/api/itemcomponenttype/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateItemComponentType implements IReturn<ValidateItemComponentTypeResponse>
{
    /** @description The ItemComponentType Form data to validate */
    // @ApiMember(DataType="ItemComponentType", Description="The ItemComponentType Form data to validate", IsRequired=true, Name="ItemComponentType", ParameterType="body")
    public itemComponentType: ItemComponentType;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateItemComponentType>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateItemComponentType'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateItemComponentTypeResponse(); }
}

// @Route("/api/notetype", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetNoteTypes implements IReturn<GetNoteTypesResponse>
{

    public constructor(init?: Partial<GetNoteTypes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetNoteTypes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetNoteTypesResponse(); }
}

// @Route("/api/notetype/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="NoteType not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetNoteTypeById implements IReturn<GetNoteTypeByIdResponse>, IGet
{
    /** @description The primary key Id of the notetype */
    // @ApiMember(DataType="string", Description="The primary key Id of the notetype", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetNoteTypeById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetNoteTypeById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetNoteTypeByIdResponse(); }
}

// @Route("/api/notetype/save/{Id}", "POST")
// @Route("/api/notetype/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetNoteType implements IReturn<SetNoteTypeResponse>
{
    /** @description The NoteType Form data to save */
    // @ApiMember(DataType="NoteType", Description="The NoteType Form data to save", IsRequired=true, Name="NoteType", ParameterType="body")
    public noteType: NoteType;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetNoteType>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetNoteType'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetNoteTypeResponse(); }
}

// @Route("/api/notetype/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateNoteType implements IReturn<CreateNoteTypeResponse>
{

    public constructor(init?: Partial<CreateNoteType>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateNoteType'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateNoteTypeResponse(); }
}

// @Route("/api/notetype/validate/{Id}", "POST")
// @Route("/api/notetype/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateNoteType implements IReturn<ValidateNoteTypeResponse>
{
    /** @description The NoteType Form data to validate */
    // @ApiMember(DataType="NoteType", Description="The NoteType Form data to validate", IsRequired=true, Name="NoteType", ParameterType="body")
    public noteType: NoteType;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateNoteType>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateNoteType'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateNoteTypeResponse(); }
}

// @Route("/api/trialtype", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialTypes implements IReturn<GetTrialTypesResponse>
{

    public constructor(init?: Partial<GetTrialTypes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialTypes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialTypesResponse(); }
}

// @Route("/api/trialtype/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="TrialType not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTrialTypeById implements IReturn<GetTrialTypeByIdResponse>, IGet
{
    /** @description The primary key Id of the trialtype */
    // @ApiMember(DataType="string", Description="The primary key Id of the trialtype", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetTrialTypeById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialTypeById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialTypeByIdResponse(); }
}

// @Route("/api/trialtype/save/{Id}", "POST")
// @Route("/api/trialtype/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetTrialType implements IReturn<SetTrialTypeResponse>
{
    /** @description The TrialType Form data to save */
    // @ApiMember(DataType="TrialType", Description="The TrialType Form data to save", IsRequired=true, Name="TrialType", ParameterType="body")
    public trialType: TrialType;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetTrialType>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetTrialType'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetTrialTypeResponse(); }
}

// @Route("/api/trialtype/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateTrialType implements IReturn<CreateTrialTypeResponse>
{

    public constructor(init?: Partial<CreateTrialType>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateTrialType'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateTrialTypeResponse(); }
}

// @Route("/api/trialtype/validate/{Id}", "POST")
// @Route("/api/trialtype/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateTrialType implements IReturn<ValidateTrialTypeResponse>
{
    /** @description The TrialType Form data to validate */
    // @ApiMember(DataType="TrialType", Description="The TrialType Form data to validate", IsRequired=true, Name="TrialType", ParameterType="body")
    public trialType: TrialType;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateTrialType>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateTrialType'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateTrialTypeResponse(); }
}

// @Route("/api/laboratoryconfidentialitydeed/laboratoryid/{laboratoryid}", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetLaboratoryConfidentialityDeedByLaboratoryId implements IReturn<GetLaboratoryConfidentialityDeedByLaboratoryIdResponse>
{
    public laboratoryId: number;

    public constructor(init?: Partial<GetLaboratoryConfidentialityDeedByLaboratoryId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetLaboratoryConfidentialityDeedByLaboratoryId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetLaboratoryConfidentialityDeedByLaboratoryIdResponse(); }
}

// @Route("/api/laboratoryconfidentialitydeed/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Laboratory Confidentiality Deed not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetLaboratoryConfidentialityDeedById implements IReturn<GetLaboratoryConfidentialityDeedByIdResponse>, IGet
{
    /** @description The primary key Id of the laboratory confidentiality deed */
    // @ApiMember(DataType="string", Description="The primary key Id of the laboratory confidentiality deed", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetLaboratoryConfidentialityDeedById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetLaboratoryConfidentialityDeedById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetLaboratoryConfidentialityDeedByIdResponse(); }
}

// @Route("/api/laboratoryconfidentialitydeed/save/{Id}", "POST")
// @Route("/api/laboratoryconfidentialitydeed/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetLaboratoryConfidentialityDeed implements IReturn<SetLaboratoryConfidentialityDeedResponse>
{
    /** @description The Laboratory Confidentiality Deed Form data to save */
    // @ApiMember(DataType="LaboratoryConfidentialityDeed", Description="The Laboratory Confidentiality Deed Form data to save", IsRequired=true, Name="laboratoryConfidentialityDeed", ParameterType="body")
    public laboratoryConfidentialityDeed: LaboratoryConfidentialityDeed;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetLaboratoryConfidentialityDeed>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetLaboratoryConfidentialityDeed'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetLaboratoryConfidentialityDeedResponse(); }
}

// @Route("/api/laboratoryconfidentialitydeed/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateLaboratoryConfidentialityDeed implements IReturn<CreateLaboratoryConfidentialityDeedResponse>
{
    public laboratoryId: number;

    public constructor(init?: Partial<CreateLaboratoryConfidentialityDeed>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateLaboratoryConfidentialityDeed'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateLaboratoryConfidentialityDeedResponse(); }
}

// @Route("/api/laboratoryconfidentialitydeed/validate/{Id}", "POST")
// @Route("/api/laboratoryconfidentialitydeed/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateLaboratoryConfidentialityDeed implements IReturn<ValidateLaboratoryConfidentialityDeedResponse>
{
    /** @description The Laboratory Confidentiality Deed Form data to validate */
    // @ApiMember(DataType="LaboratoryConfidentialityDeed", Description="The Laboratory Confidentiality Deed Form data to validate", IsRequired=true, Name="laboratoryConfidentialityDeed", ParameterType="body")
    public laboratoryConfidentialityDeed: LaboratoryConfidentialityDeed;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateLaboratoryConfidentialityDeed>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateLaboratoryConfidentialityDeed'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateLaboratoryConfidentialityDeedResponse(); }
}

// @Route("/api/laboratoryconfidentialitydeed/delete/{Id}", "POST")
// @Route("/api/laboratoryconfidentialitydeed/delete", "POST")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Laboratory Confidentiality Deed not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class DeleteLaboratoryConfidentialityDeed implements IReturn<DeleteLaboratoryConfidentialityDeedResponse>
{
    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<DeleteLaboratoryConfidentialityDeed>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteLaboratoryConfidentialityDeed'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new DeleteLaboratoryConfidentialityDeedResponse(); }
}

// @Route("/api/laboratorycontract/laboratoryid/{laboratoryid}", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetLaboratoryContractByLaboratoryId implements IReturn<GetLaboratoryContractByLaboratoryIdResponse>
{
    public laboratoryId: number;

    public constructor(init?: Partial<GetLaboratoryContractByLaboratoryId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetLaboratoryContractByLaboratoryId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetLaboratoryContractByLaboratoryIdResponse(); }
}

// @Route("/api/laboratorycontract/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Laboratory Contract not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetLaboratoryContractById implements IReturn<GetLaboratoryContractByIdResponse>, IGet
{
    /** @description The primary key Id of the laboratory contract */
    // @ApiMember(DataType="string", Description="The primary key Id of the laboratory contract", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetLaboratoryContractById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetLaboratoryContractById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetLaboratoryContractByIdResponse(); }
}

// @Route("/api/laboratorycontract/save/{Id}", "POST")
// @Route("/api/laboratorycontract/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetLaboratoryContract implements IReturn<SetLaboratoryContractResponse>
{
    /** @description The LaboratoryContract Form data to save */
    // @ApiMember(DataType="LaboratoryContract", Description="The LaboratoryContract Form data to save", IsRequired=true, Name="laboratoryContract", ParameterType="body")
    public laboratoryContract: LaboratoryContract;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetLaboratoryContract>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetLaboratoryContract'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetLaboratoryContractResponse(); }
}

// @Route("/api/laboratorycontract/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateLaboratoryContract implements IReturn<CreateLaboratoryContractResponse>
{
    public laboratoryId: number;

    public constructor(init?: Partial<CreateLaboratoryContract>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateLaboratoryContract'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateLaboratoryContractResponse(); }
}

// @Route("/api/laboratorycontract/validate/{Id}", "POST")
// @Route("/api/laboratorycontract/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateLaboratoryContract implements IReturn<ValidateLaboratoryContractResponse>
{
    /** @description The LaboratoryContract Form data to validate */
    // @ApiMember(DataType="LaboratoryContract", Description="The LaboratoryContract Form data to validate", IsRequired=true, Name="laboratoryContract", ParameterType="body")
    public laboratoryContract: LaboratoryContract;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateLaboratoryContract>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateLaboratoryContract'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateLaboratoryContractResponse(); }
}

// @Route("/api/laboratorydepartments", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetLaboratoryDepartments implements IReturn<GetLaboratoryDepartmentsResponse>
{

    public constructor(init?: Partial<GetLaboratoryDepartments>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetLaboratoryDepartments'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetLaboratoryDepartmentsResponse(); }
}

// @Route("/api/laboratorydepartment/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Laboratory Department not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetLaboratoryDepartmentById implements IReturn<GetLaboratoryDepartmentByIdResponse>, IGet
{
    /** @description The primary key Id of the Laboratory Department */
    // @ApiMember(DataType="string", Description="The primary key Id of the Laboratory Department", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetLaboratoryDepartmentById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetLaboratoryDepartmentById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetLaboratoryDepartmentByIdResponse(); }
}

// @Route("/api/laboratorydepartment/laboratoryid/{laboratoryid}", "GET")
// @ApiResponse(Description="LaboratoryId is invalid", StatusCode=400)
// @ApiResponse(Description="Laboratory Department not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetLaboratoryDepartmentsByLaboratoryId implements IReturn<GetLaboratoryDepartmentsByLaboratoryIdResponse>, IGet
{
    /** @description The primary key Id of the Laboratory */
    // @ApiMember(DataType="string", Description="The primary key Id of the Laboratory", IsRequired=true, Name="LaboratoryId", ParameterType="path")
    public laboratoryId: number;

    public constructor(init?: Partial<GetLaboratoryDepartmentsByLaboratoryId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetLaboratoryDepartmentsByLaboratoryId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetLaboratoryDepartmentsByLaboratoryIdResponse(); }
}

// @Route("/api/laboratorydepartment/save/{Id}", "POST")
// @Route("/api/laboratorydepartment/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetLaboratoryDepartment implements IReturn<SetLaboratoryDepartmentResponse>
{
    /** @description The Laboratory Form data to save */
    // @ApiMember(DataType="Laboratory", Description="The Laboratory Form data to save", IsRequired=true, Name="laboratory Department", ParameterType="body")
    public laboratoryDepartment: LaboratoryDepartment;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetLaboratoryDepartment>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetLaboratoryDepartment'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetLaboratoryDepartmentResponse(); }
}

// @Route("/api/laboratorydepartment/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateLaboratoryDepartment implements IReturn<CreateLaboratoryDepartmentResponse>
{
    /** @description The primary key Id of the Laboratory associated to the Laboratory Department */
    // @ApiMember(DataType="string", Description="The primary key Id of the Laboratory associated to the Laboratory Department", IsRequired=true, Name="LaboratoryId", ParameterType="path")
    public laboratoryId: number;

    public constructor(init?: Partial<CreateLaboratoryDepartment>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateLaboratoryDepartment'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateLaboratoryDepartmentResponse(); }
}

// @Route("/api/laboratorydepartment/delete/{Id}", "POST")
// @Route("/api/laboratorydepartment/delete", "POST")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Laboratory Department not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class DeleteLaboratoryDepartment implements IReturn<DeleteLaboratoryDepartmentResponse>
{
    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<DeleteLaboratoryDepartment>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteLaboratoryDepartment'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new DeleteLaboratoryDepartmentResponse(); }
}

// @Route("/api/laboratorydepartment/validate/{Id}", "POST")
// @Route("/api/laboratorydepartment/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateLaboratoryDepartment implements IReturn<ValidateLaboratoryDepartmentResponse>
{
    /** @description The Laboratory Form data to validate */
    // @ApiMember(DataType="Laboratory", Description="The Laboratory Form data to validate", IsRequired=true, Name="laboratory Department", ParameterType="body")
    public laboratoryDepartment: LaboratoryDepartment;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateLaboratoryDepartment>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateLaboratoryDepartment'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateLaboratoryDepartmentResponse(); }
}

// @Route("/api/laboratoryfinance/laboratoryid/{laboratoryid}", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetLaboratoryFinanceByLaboratoryId implements IReturn<GetLaboratoryFinanceByLaboratoryIdResponse>
{
    public laboratoryId: number;

    public constructor(init?: Partial<GetLaboratoryFinanceByLaboratoryId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetLaboratoryFinanceByLaboratoryId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetLaboratoryFinanceByLaboratoryIdResponse(); }
}

// @Route("/api/laboratoryfinance/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Laboratory Finance not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetLaboratoryFinanceById implements IReturn<GetLaboratoryFinanceByIdResponse>, IGet
{
    /** @description The primary key Id of the laboratory finance */
    // @ApiMember(DataType="string", Description="The primary key Id of the laboratory finance", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetLaboratoryFinanceById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetLaboratoryFinanceById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetLaboratoryFinanceByIdResponse(); }
}

// @Route("/api/laboratoryfinance/save/{Id}", "POST")
// @Route("/api/laboratoryfinance/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetLaboratoryFinance implements IReturn<SetLaboratoryFinanceResponse>
{
    /** @description The LaboratoryFinance Form data to save */
    // @ApiMember(DataType="LaboratoryFinance", Description="The LaboratoryFinance Form data to save", IsRequired=true, Name="laboratoryFinance", ParameterType="body")
    public laboratoryFinance: LaboratoryFinance;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetLaboratoryFinance>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetLaboratoryFinance'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetLaboratoryFinanceResponse(); }
}

// @Route("/api/laboratoryfinance/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateLaboratoryFinance implements IReturn<CreateLaboratoryFinanceResponse>
{
    public laboratoryId: number;

    public constructor(init?: Partial<CreateLaboratoryFinance>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateLaboratoryFinance'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateLaboratoryFinanceResponse(); }
}

// @Route("/api/laboratoryfinance/validate/{Id}", "POST")
// @Route("/api/laboratoryfinance/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateLaboratoryFinance implements IReturn<ValidateLaboratoryFinanceResponse>
{
    /** @description The LaboratoryFinance Form data to validate */
    // @ApiMember(DataType="LaboratoryFinance", Description="The LaboratoryFinance Form data to validate", IsRequired=true, Name="laboratoryFinance", ParameterType="body")
    public laboratoryFinance: LaboratoryFinance;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateLaboratoryFinance>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateLaboratoryFinance'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateLaboratoryFinanceResponse(); }
}

// @Route("/api/laboratorypersonnels", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetLaboratoryPersonnels implements IReturn<GetLaboratoryPersonnelsResponse>
{

    public constructor(init?: Partial<GetLaboratoryPersonnels>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetLaboratoryPersonnels'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetLaboratoryPersonnelsResponse(); }
}

// @Route("/api/laboratorypersonnel/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Laboratory Personnel not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetLaboratoryPersonnelById implements IReturn<GetLaboratoryPersonnelByIdResponse>, IGet
{
    /** @description The primary key Id of the Laboratory Personnel */
    // @ApiMember(DataType="string", Description="The primary key Id of the Laboratory Personnel", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetLaboratoryPersonnelById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetLaboratoryPersonnelById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetLaboratoryPersonnelByIdResponse(); }
}

// @Route("/api/laboratorypersonnel/laboratoryid/{laboratoryId}", "GET")
// @ApiResponse(Description="Laboratory Id is invalid", StatusCode=400)
// @ApiResponse(Description="Laboratory personnel not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetLaboratoryPersonnelByLaboratoryId implements IReturn<GetLaboratoryPersonnelByLaboratoryIdResponse>, IGet
{
    /** @description The laboratory id of the laboratory personnel */
    // @ApiMember(DataType="string", Description="The laboratory id of the laboratory personnel", IsRequired=true, Name="LaboratoryId", ParameterType="path")
    public laboratoryId: number;

    public constructor(init?: Partial<GetLaboratoryPersonnelByLaboratoryId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetLaboratoryPersonnelByLaboratoryId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetLaboratoryPersonnelByLaboratoryIdResponse(); }
}

// @Route("/api/laboratorypersonnel/save/{Id}", "POST")
// @Route("/api/laboratorypersonnel/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetLaboratoryPersonnel implements IReturn<SetLaboratoryPersonnelResponse>
{
    /** @description The Laboratory Form data to save */
    // @ApiMember(DataType="Laboratory", Description="The Laboratory Form data to save", IsRequired=true, Name="laboratory Personnel", ParameterType="body")
    public laboratoryPersonnel: LaboratoryPersonnel;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetLaboratoryPersonnel>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetLaboratoryPersonnel'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetLaboratoryPersonnelResponse(); }
}

// @Route("/api/laboratorypersonnel/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateLaboratoryPersonnel implements IReturn<CreateLaboratoryPersonnelResponse>
{
    /** @description The primary key Id of the Laboratory associated to the Laboratory Personnel */
    // @ApiMember(DataType="string", Description="The primary key Id of the Laboratory associated to the Laboratory Personnel", IsRequired=true, Name="LaboratoryId", ParameterType="path")
    public laboratoryId: number;

    public constructor(init?: Partial<CreateLaboratoryPersonnel>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateLaboratoryPersonnel'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateLaboratoryPersonnelResponse(); }
}

// @Route("/api/laboratorypersonnel/validate/{Id}", "POST")
// @Route("/api/laboratorypersonnel/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateLaboratoryPersonnel implements IReturn<ValidateLaboratoryPersonnelResponse>
{
    /** @description The Laboratory Form data to validate */
    // @ApiMember(DataType="Laboratory", Description="The Laboratory Form data to validate", IsRequired=true, Name="laboratory Personnel", ParameterType="body")
    public laboratoryPersonnel: LaboratoryPersonnel;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateLaboratoryPersonnel>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateLaboratoryPersonnel'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateLaboratoryPersonnelResponse(); }
}

// @Route("/api/laboratories", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetLaboratories implements IReturn<GetLaboratoriesResponse>
{

    public constructor(init?: Partial<GetLaboratories>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetLaboratories'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetLaboratoriesResponse(); }
}

// @Route("/api/laboratory/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Laboratory not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetLaboratoryById implements IReturn<GetLaboratoryByIdResponse>, IGet
{
    /** @description The primary key Id of the Laboratory */
    // @ApiMember(DataType="string", Description="The primary key Id of the Laboratory", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetLaboratoryById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetLaboratoryById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetLaboratoryByIdResponse(); }
}

// @Route("/api/laboratory/save/{Id}", "POST")
// @Route("/api/laboratory/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetLaboratory implements IReturn<SetLaboratoryResponse>
{
    /** @description The Laboratory Form data to save */
    // @ApiMember(DataType="Laboratory", Description="The Laboratory Form data to save", IsRequired=true, Name="laboratory", ParameterType="body")
    public laboratory: Laboratory;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetLaboratory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetLaboratory'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetLaboratoryResponse(); }
}

// @Route("/api/laboratory/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateLaboratory implements IReturn<CreateLaboratoryResponse>
{

    public constructor(init?: Partial<CreateLaboratory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateLaboratory'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateLaboratoryResponse(); }
}

// @Route("/api/laboratory/validate/{Id}", "POST")
// @Route("/api/laboratory/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateLaboratory implements IReturn<ValidateLaboratoryResponse>
{
    /** @description The Laboratory Form data to validate */
    // @ApiMember(DataType="Laboratory", Description="The Laboratory Form data to validate", IsRequired=true, Name="laboratory", ParameterType="body")
    public laboratory: Laboratory;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateLaboratory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateLaboratory'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateLaboratoryResponse(); }
}

// @Route("/api/itemcomponents", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetItemComponents implements IReturn<GetItemComponentsResponse>
{
    public itemComponentTypeId?: number;
    public qaItemComponents?: boolean;

    public constructor(init?: Partial<GetItemComponents>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetItemComponents'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetItemComponentsResponse(); }
}

// @Route("/api/itemcomponent/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="ItemComponent not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetItemComponentById implements IReturn<GetItemComponentByIdResponse>, IGet
{
    /** @description The primary key Id of the item component */
    // @ApiMember(DataType="string", Description="The primary key Id of the item component", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public formProperties: FormProperty[];
    public registrationFormProperties: RegistrationFormProperty[];

    public constructor(init?: Partial<GetItemComponentById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetItemComponentById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetItemComponentByIdResponse(); }
}

// @Route("/api/itemcomponent/save/{Id}", "POST")
// @Route("/api/itemcomponent/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetItemComponent implements IReturn<SetItemComponentResponse>
{
    /** @description The Pre-registration Form data to save */
    // @ApiMember(DataType="PreRegistrationForm", Description="The Pre-registration Form data to save", IsRequired=true, Name="preRegistrationForm", ParameterType="body")
    public itemComponent: ItemComponent;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetItemComponent>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetItemComponent'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetItemComponentResponse(); }
}

// @Route("/api/itemcomponent/create/{CloneId}", "POST")
// @Route("/api/itemcomponent/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateItemComponent implements IReturn<CreateItemComponentResponse>
{
    public cloneId?: number;

    public constructor(init?: Partial<CreateItemComponent>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateItemComponent'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateItemComponentResponse(); }
}

// @Route("/api/departmentcontacts", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDepartmentContacts implements IReturn<GetDepartmentContactsResponse>
{

    public constructor(init?: Partial<GetDepartmentContacts>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDepartmentContacts'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDepartmentContactsResponse(); }
}

// @Route("/api/departmentcontact/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Department Contact not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDepartmentContactById implements IReturn<GetDepartmentContactByIdResponse>, IGet
{
    /** @description The primary key Id of the department contact */
    // @ApiMember(DataType="string", Description="The primary key Id of the department contact", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetDepartmentContactById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDepartmentContactById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDepartmentContactByIdResponse(); }
}

// @Route("/api/departmentcontact/save/{Id}", "POST")
// @Route("/api/departmentcontact/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetDepartmentContact implements IReturn<SetDepartmentContactResponse>
{
    /** @description The Department Contact Form data to save */
    // @ApiMember(DataType="DepartmentContact", Description="The Department Contact Form data to save", IsRequired=true, Name="departmentcontact", ParameterType="body")
    public departmentContact: DepartmentContact;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetDepartmentContact>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetDepartmentContact'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetDepartmentContactResponse(); }
}

// @Route("/api/departmentcontact/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateDepartmentContact implements IReturn<CreateDepartmentContactResponse>
{
    public departmentId: number;

    public constructor(init?: Partial<CreateDepartmentContact>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateDepartmentContact'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateDepartmentContactResponse(); }
}

// @Route("/api/departments", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDepartments implements IReturn<GetDepartmentsResponse>
{

    public constructor(init?: Partial<GetDepartments>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDepartments'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDepartmentsResponse(); }
}

// @Route("/api/department/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Trial Item not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDepartmentById implements IReturn<GetDepartmentByIdResponse>, IGet
{
    /** @description The primary key Id of the department */
    // @ApiMember(DataType="string", Description="The primary key Id of the department", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetDepartmentById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDepartmentById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDepartmentByIdResponse(); }
}

// @Route("/api/department/save/{Id}", "POST")
// @Route("/api/department/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetDepartment implements IReturn<SetDepartmentResponse>
{
    /** @description The Department Form data to save */
    // @ApiMember(DataType="Department", Description="The Department Form data to save", IsRequired=true, Name="department", ParameterType="body")
    public department: Department;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetDepartment>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetDepartment'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetDepartmentResponse(); }
}

// @Route("/api/department/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateDepartment implements IReturn<CreateDepartmentResponse>
{
    public institutionId: number;

    public constructor(init?: Partial<CreateDepartment>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateDepartment'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateDepartmentResponse(); }
}

// @Route("/api/institutioncode", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetInstitutionCodes implements IReturn<GetInstitutionCodesResponse>
{

    public constructor(init?: Partial<GetInstitutionCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInstitutionCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetInstitutionCodesResponse(); }
}

// @Route("/api/institutioncode/institutionid/{institutionid}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetInstitutionCodesByInstitutionId implements IReturn<GetInstitutionCodesByInstitutionIdResponse>, IGet
{
    /** @description The primary key Id of the institution */
    // @ApiMember(DataType="string", Description="The primary key Id of the institution", IsRequired=true, Name="InstitutionId", ParameterType="path")
    public institutionId: number;

    public constructor(init?: Partial<GetInstitutionCodesByInstitutionId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInstitutionCodesByInstitutionId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetInstitutionCodesByInstitutionIdResponse(); }
}

// @Route("/api/institutioncode/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="InstitutionCode not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetInstitutionCodeById implements IReturn<GetInstitutionCodeByIdResponse>, IGet
{
    /** @description The primary key Id of the institutioncode */
    // @ApiMember(DataType="string", Description="The primary key Id of the institutioncode", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetInstitutionCodeById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInstitutionCodeById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetInstitutionCodeByIdResponse(); }
}

// @Route("/api/institutioncode/save/{Id}", "POST")
// @Route("/api/institutioncode/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetInstitutionCode implements IReturn<SetInstitutionCodeResponse>
{
    /** @description The InstitutionCode Form data to save */
    // @ApiMember(DataType="InstitutionCode", Description="The InstitutionCode Form data to save", IsRequired=true, Name="InstitutionCode", ParameterType="body")
    public institutionCode: InstitutionCode;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetInstitutionCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetInstitutionCode'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetInstitutionCodeResponse(); }
}

// @Route("/api/institutioncode/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateInstitutionCode implements IReturn<CreateInstitutionCodeResponse>
{
    /** @description The primary key Id of the institution */
    // @ApiMember(DataType="string", Description="The primary key Id of the institution", IsRequired=true, Name="InstitutionId", ParameterType="path")
    public institutionId: number;

    public constructor(init?: Partial<CreateInstitutionCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateInstitutionCode'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateInstitutionCodeResponse(); }
}

// @Route("/api/institutioncode/validate/{Id}", "POST")
// @Route("/api/institutioncode/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateInstitutionCode implements IReturn<ValidateInstitutionCodeResponse>
{
    /** @description The InstitutionCode Form data to validate */
    // @ApiMember(DataType="InstitutionCode", Description="The InstitutionCode Form data to validate", IsRequired=true, Name="InstitutionCode", ParameterType="body")
    public institutionCode: InstitutionCode;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateInstitutionCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateInstitutionCode'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateInstitutionCodeResponse(); }
}

// @Route("/api/institutionconfidentialitydeed/institutionid/{institutionid}", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetInstitutionConfidentialityDeedByInstitutionId implements IReturn<GetInstitutionConfidentialityDeedByInstitutionIdResponse>
{
    public institutionId: number;

    public constructor(init?: Partial<GetInstitutionConfidentialityDeedByInstitutionId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInstitutionConfidentialityDeedByInstitutionId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetInstitutionConfidentialityDeedByInstitutionIdResponse(); }
}

// @Route("/api/institutionconfidentialitydeed/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Institution Confidentiality Deed not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetInstitutionConfidentialityDeedById implements IReturn<GetInstitutionConfidentialityDeedByIdResponse>, IGet
{
    /** @description The primary key Id of the institution confidentiality deed */
    // @ApiMember(DataType="string", Description="The primary key Id of the institution confidentiality deed", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetInstitutionConfidentialityDeedById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInstitutionConfidentialityDeedById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetInstitutionConfidentialityDeedByIdResponse(); }
}

// @Route("/api/institutionconfidentialitydeed/save/{Id}", "POST")
// @Route("/api/institutionconfidentialitydeed/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetInstitutionConfidentialityDeed implements IReturn<SetInstitutionConfidentialityDeedResponse>
{
    /** @description The Institution Confidentiality Deed Form data to save */
    // @ApiMember(DataType="InstitutionConfidentialityDeed", Description="The Institution Confidentiality Deed Form data to save", IsRequired=true, Name="institutionConfidentialityDeed", ParameterType="body")
    public institutionConfidentialityDeed: InstitutionConfidentialityDeed;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetInstitutionConfidentialityDeed>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetInstitutionConfidentialityDeed'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetInstitutionConfidentialityDeedResponse(); }
}

// @Route("/api/institutionconfidentialitydeed/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateInstitutionConfidentialityDeed implements IReturn<CreateInstitutionConfidentialityDeedResponse>
{
    public institutionId: number;

    public constructor(init?: Partial<CreateInstitutionConfidentialityDeed>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateInstitutionConfidentialityDeed'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateInstitutionConfidentialityDeedResponse(); }
}

// @Route("/api/institutionconfidentialitydeed/validate/{Id}", "POST")
// @Route("/api/institutionconfidentialitydeed/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateInstitutionConfidentialityDeed implements IReturn<ValidateInstitutionConfidentialityDeedResponse>
{
    /** @description The Institution Confidentiality Deed Form data to validate */
    // @ApiMember(DataType="InstitutionConfidentialityDeed", Description="The Institution Confidentiality Deed Form data to validate", IsRequired=true, Name="institutionConfidentialityDeed", ParameterType="body")
    public institutionConfidentialityDeed: InstitutionConfidentialityDeed;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateInstitutionConfidentialityDeed>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateInstitutionConfidentialityDeed'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateInstitutionConfidentialityDeedResponse(); }
}

// @Route("/api/institutionconfidentialitydeed/delete/{Id}", "POST")
// @Route("/api/institutionconfidentialitydeed/delete", "POST")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Institution Confidentiality Deed not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class DeleteInstitutionConfidentialityDeed implements IReturn<DeleteInstitutionConfidentialityDeedResponse>
{
    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<DeleteInstitutionConfidentialityDeed>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteInstitutionConfidentialityDeed'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new DeleteInstitutionConfidentialityDeedResponse(); }
}

// @Route("/api/institutioncontract/institutionid/{institutionid}", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetInstitutionContractByInstitutionId implements IReturn<GetInstitutionContractByInstitutionIdResponse>
{
    public institutionId: number;

    public constructor(init?: Partial<GetInstitutionContractByInstitutionId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInstitutionContractByInstitutionId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetInstitutionContractByInstitutionIdResponse(); }
}

// @Route("/api/institutioncontract/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Institution Contract not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetInstitutionContractById implements IReturn<GetInstitutionContractByIdResponse>, IGet
{
    /** @description The primary key Id of the institution contract */
    // @ApiMember(DataType="string", Description="The primary key Id of the institution contract", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetInstitutionContractById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInstitutionContractById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetInstitutionContractByIdResponse(); }
}

// @Route("/api/institutioncontract/save/{Id}", "POST")
// @Route("/api/institutioncontract/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetInstitutionContract implements IReturn<SetInstitutionContractResponse>
{
    /** @description The InstitutionContract Form data to save */
    // @ApiMember(DataType="InstitutionContract", Description="The InstitutionContract Form data to save", IsRequired=true, Name="institutionContract", ParameterType="body")
    public institutionContract: InstitutionContract;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetInstitutionContract>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetInstitutionContract'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetInstitutionContractResponse(); }
}

// @Route("/api/institutioncontract/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateInstitutionContract implements IReturn<CreateInstitutionContractResponse>
{
    public institutionId: number;

    public constructor(init?: Partial<CreateInstitutionContract>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateInstitutionContract'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateInstitutionContractResponse(); }
}

// @Route("/api/institutioncontract/validate/{Id}", "POST")
// @Route("/api/institutioncontract/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateInstitutionContract implements IReturn<ValidateInstitutionContractResponse>
{
    /** @description The InstitutionContract Form data to validate */
    // @ApiMember(DataType="InstitutionContract", Description="The InstitutionContract Form data to validate", IsRequired=true, Name="institutionContract", ParameterType="body")
    public institutionContract: InstitutionContract;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateInstitutionContract>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateInstitutionContract'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateInstitutionContractResponse(); }
}

// @Route("/api/institutionfinance/institutionid/{institutionid}", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetInstitutionFinanceByInstitutionId implements IReturn<GetInstitutionFinanceByInstitutionIdResponse>
{
    public institutionId: number;

    public constructor(init?: Partial<GetInstitutionFinanceByInstitutionId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInstitutionFinanceByInstitutionId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetInstitutionFinanceByInstitutionIdResponse(); }
}

// @Route("/api/institutionfinance/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Institution Finance not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetInstitutionFinanceById implements IReturn<GetInstitutionFinanceByIdResponse>, IGet
{
    /** @description The primary key Id of the institution finance */
    // @ApiMember(DataType="string", Description="The primary key Id of the institution finance", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetInstitutionFinanceById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInstitutionFinanceById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetInstitutionFinanceByIdResponse(); }
}

// @Route("/api/institutionfinance/save/{Id}", "POST")
// @Route("/api/institutionfinance/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetInstitutionFinance implements IReturn<SetInstitutionFinanceResponse>
{
    /** @description The InstitutionFinance Form data to save */
    // @ApiMember(DataType="InstitutionFinance", Description="The InstitutionFinance Form data to save", IsRequired=true, Name="institutionFinance", ParameterType="body")
    public institutionFinance: InstitutionFinance;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetInstitutionFinance>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetInstitutionFinance'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetInstitutionFinanceResponse(); }
}

// @Route("/api/institutionfinance/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateInstitutionFinance implements IReturn<CreateInstitutionFinanceResponse>
{
    public institutionId: number;

    public constructor(init?: Partial<CreateInstitutionFinance>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateInstitutionFinance'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateInstitutionFinanceResponse(); }
}

// @Route("/api/institutionfinance/validate/{Id}", "POST")
// @Route("/api/institutionfinance/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateInstitutionFinance implements IReturn<ValidateInstitutionFinanceResponse>
{
    /** @description The InstitutionFinance Form data to validate */
    // @ApiMember(DataType="InstitutionFinance", Description="The InstitutionFinance Form data to validate", IsRequired=true, Name="institutionFinance", ParameterType="body")
    public institutionFinance: InstitutionFinance;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateInstitutionFinance>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateInstitutionFinance'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateInstitutionFinanceResponse(); }
}

// @Route("/api/institutionitemcategories", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetInstitutionItemCategoriesByInstitutionId implements IReturn<GetInstitutionItemCategoriesByInstitutionIdResponse>
{
    public institutionId?: number;

    public constructor(init?: Partial<GetInstitutionItemCategoriesByInstitutionId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInstitutionItemCategoriesByInstitutionId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetInstitutionItemCategoriesByInstitutionIdResponse(); }
}

// @Route("/api/institutionitemtemplatecategories", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetInstitutionItemTemplateCategories implements IReturn<GetInstitutionItemTemplateCategoriesResponse>
{

    public constructor(init?: Partial<GetInstitutionItemTemplateCategories>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInstitutionItemTemplateCategories'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetInstitutionItemTemplateCategoriesResponse(); }
}

// @Route("/api/institutionitemtemplatecategory/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Institution Item Template Category not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetInstitutionItemTemplateCategoryById implements IReturn<GetInstitutionItemTemplateCategoryByIdResponse>, IGet
{
    /** @description The primary key Id of the institution item template categories */
    // @ApiMember(DataType="string", Description="The primary key Id of the institution item template categories", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetInstitutionItemTemplateCategoryById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInstitutionItemTemplateCategoryById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetInstitutionItemTemplateCategoryByIdResponse(); }
}

// @Route("/api/institutionitemtemplatecategory/save/{Id}", "POST")
// @Route("/api/institutionitemtemplatecategory/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetInstitutionItemTemplateCategory implements IReturn<SetInstitutionItemTemplateCategoryResponse>
{
    /** @description The InstitutionItemTemplateCategory Form data to save */
    // @ApiMember(DataType="InstitutionItemTemplateCategory", Description="The InstitutionItemTemplateCategory Form data to save", IsRequired=true, Name="InstitutionItemTemplateCategory", ParameterType="body")
    public institutionItemTemplateCategory: InstitutionItemTemplateCategory;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetInstitutionItemTemplateCategory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetInstitutionItemTemplateCategory'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetInstitutionItemTemplateCategoryResponse(); }
}

// @Route("/api/institutionitemtemplatecategory/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateInstitutionItemTemplateCategory implements IReturn<CreateInstitutionItemTemplateCategoryResponse>
{

    public constructor(init?: Partial<CreateInstitutionItemTemplateCategory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateInstitutionItemTemplateCategory'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateInstitutionItemTemplateCategoryResponse(); }
}

// @Route("/api/institutionitemtemplatecategory/validate/{Id}", "POST")
// @Route("/api/institutionitemtemplatecategory/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateInstitutionItemTemplateCategory implements IReturn<ValidateInstitutionItemTemplateCategoryResponse>
{
    /** @description The InstitutionItemTemplateCategory Form data to validate */
    // @ApiMember(DataType="InstitutionItemTemplateCategory", Description="The InstitutionItemTemplateCategory Form data to validate", IsRequired=true, Name="InstitutionItemTemplateCategory", ParameterType="body")
    public institutionItemTemplateCategory: InstitutionItemTemplateCategory;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateInstitutionItemTemplateCategory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateInstitutionItemTemplateCategory'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateInstitutionItemTemplateCategoryResponse(); }
}

// @Route("/api/institutionitemtemplates", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetInstitutionItemTemplates implements IReturn<GetInstitutionItemTemplatesResponse>
{
    public institutionId: number;

    public constructor(init?: Partial<GetInstitutionItemTemplates>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInstitutionItemTemplates'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetInstitutionItemTemplatesResponse(); }
}

// @Route("/api/institutionitemtemplate/id/{id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Institution Item Template not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetInstitutionItemTemplateById implements IReturn<GetInstitutionItemTemplateByIdResponse>, IGet
{
    /** @description The primary key Id of the InstitutionItemtemplate */
    // @ApiMember(DataType="string", Description="The primary key Id of the InstitutionItemtemplate", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetInstitutionItemTemplateById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInstitutionItemTemplateById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetInstitutionItemTemplateByIdResponse(); }
}

// @Route("/api/institutionitemtemplate/save/{id}", "POST")
// @Route("/api/institutionitemtemplate/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetInstitutionItemTemplate implements IReturn<SetInstitutionItemTemplateResponse>
{
    /** @description The InstitutionItemTemplate Form data to save */
    // @ApiMember(DataType="InstitutionItemTemplate", Description="The InstitutionItemTemplate Form data to save", IsRequired=true, Name="InstitutionItemTemplate", ParameterType="body")
    public institutionItemTemplate: InstitutionItemTemplate;

    public collection: Collection;
    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetInstitutionItemTemplate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetInstitutionItemTemplate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetInstitutionItemTemplateResponse(); }
}

// @Route("/api/institutionitemtemplate/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateInstitutionItemTemplate implements IReturn<CreateInstitutionItemTemplateResponse>
{
    public institutionId?: number;

    public constructor(init?: Partial<CreateInstitutionItemTemplate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateInstitutionItemTemplate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateInstitutionItemTemplateResponse(); }
}

// @Route("/api/institutionitemtemplate/validate/{id}", "POST")
// @Route("/api/institutionitemtemplate/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateInstitutionItemTemplate implements IReturn<ValidateInstitutionItemTemplateResponse>
{
    /** @description The InstitutionItemTemplate Form data to validate */
    // @ApiMember(DataType="InstitutionItemTemplate", Description="The InstitutionItemTemplate Form data to validate", IsRequired=true, Name="InstitutionItemTemplate", ParameterType="body")
    public institutionItemTemplate: InstitutionItemTemplate;

    public collection: Collection;
    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateInstitutionItemTemplate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateInstitutionItemTemplate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateInstitutionItemTemplateResponse(); }
}

// @Route("/api/institutionlaboratory", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetInstitutionLaboratories implements IReturn<GetInstitutionLaboratoriesResponse>
{

    public constructor(init?: Partial<GetInstitutionLaboratories>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInstitutionLaboratories'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetInstitutionLaboratoriesResponse(); }
}

// @Route("/api/institutionlaboratory/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Institution Laboratory not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetInstitutionLaboratoryById implements IReturn<GetInstitutionLaboratoryByIdResponse>, IGet
{
    /** @description The primary key Id of the Institution Laboratory */
    // @ApiMember(DataType="string", Description="The primary key Id of the Institution Laboratory", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetInstitutionLaboratoryById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInstitutionLaboratoryById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetInstitutionLaboratoryByIdResponse(); }
}

// @Route("/api/institutionlaboratory/laboratoryid/{laboratoryId}", "GET")
// @ApiResponse(Description="Laboratory Id is invalid", StatusCode=400)
// @ApiResponse(Description="Institution Laboratory not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetInstitutionLaboratoryByLaboratoryId implements IReturn<GetInstitutionLaboratoryByLaboratoryIdResponse>, IGet
{
    /** @description The laboratory id of the institution laboratory */
    // @ApiMember(DataType="string", Description="The laboratory id of the institution laboratory", IsRequired=true, Name="LaboratoryId", ParameterType="path")
    public laboratoryId: number;

    public constructor(init?: Partial<GetInstitutionLaboratoryByLaboratoryId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInstitutionLaboratoryByLaboratoryId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetInstitutionLaboratoryByLaboratoryIdResponse(); }
}

// @Route("/api/institutionlaboratory/institutionid/{institutionId}", "GET")
// @ApiResponse(Description="Institution Id is invalid", StatusCode=400)
// @ApiResponse(Description="Institution Laboratory not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetInstitutionLaboratoryByInstitutionId implements IReturn<GetInstitutionLaboratoryByInstitutionIdResponse>, IGet
{
    /** @description The institution id of the institution laboratory */
    // @ApiMember(DataType="string", Description="The institution id of the institution laboratory", IsRequired=true, Name="InstitutionId", ParameterType="path")
    public institutionId: number;

    public constructor(init?: Partial<GetInstitutionLaboratoryByInstitutionId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInstitutionLaboratoryByInstitutionId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetInstitutionLaboratoryByInstitutionIdResponse(); }
}

// @Route("/api/institutionlaboratory/save/{Id}", "POST")
// @Route("/api/institutionlaboratory/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetInstitutionLaboratory implements IReturn<SetInstitutionLaboratoryResponse>
{
    /** @description The Laboratory Form data to save */
    // @ApiMember(DataType="Laboratory", Description="The Laboratory Form data to save", IsRequired=true, Name="Id", ParameterType="body")
    public institutionLaboratory: InstitutionLaboratory;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetInstitutionLaboratory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetInstitutionLaboratory'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetInstitutionLaboratoryResponse(); }
}

// @Route("/api/institutionlaboratory/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateInstitutionLaboratory implements IReturn<CreateInstitutionLaboratoryResponse>
{
    /** @description The primary key Id of the Laboratory associated to the institution laboratory */
    // @ApiMember(DataType="string", Description="The primary key Id of the Laboratory associated to the institution laboratory", IsRequired=true, Name="LaboratoryId", ParameterType="path")
    public laboratoryId: number;

    /** @description The primary key Id of the Institution associated to the institution laboratory */
    // @ApiMember(DataType="string", Description="The primary key Id of the Institution associated to the institution laboratory", IsRequired=true, Name="InstitutionId", ParameterType="path")
    public institutionId: number;

    public constructor(init?: Partial<CreateInstitutionLaboratory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateInstitutionLaboratory'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateInstitutionLaboratoryResponse(); }
}

// @Route("/api/institutionlaboratory/delete/{Id}", "POST")
// @Route("/api/institutionlaboratory/delete", "POST")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Institution Laboratory not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class DeleteInstitutionLaboratory implements IReturn<DeleteInstitutionLaboratoryResponse>
{
    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<DeleteInstitutionLaboratory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteInstitutionLaboratory'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new DeleteInstitutionLaboratoryResponse(); }
}

// @Route("/api/institutionlaboratory/validate/{Id}", "POST")
// @Route("/api/institutionlaboratory/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateInstitutionLaboratory implements IReturn<ValidateInstitutionLaboratoryResponse>
{
    /** @description The Laboratory Form data to validate */
    // @ApiMember(DataType="Laboratory", Description="The Laboratory Form data to validate", IsRequired=true, Name="Id", ParameterType="body")
    public institutionLaboratory: InstitutionLaboratory;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateInstitutionLaboratory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateInstitutionLaboratory'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateInstitutionLaboratoryResponse(); }
}

// @Route("/api/institutionprocedures/institutionId/{institutionId}", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetInstitutionProceduresByInstitutionId implements IReturn<GetInstitutionProceduresByInstitutionIdResponse>
{
    public institutionId: number;

    public constructor(init?: Partial<GetInstitutionProceduresByInstitutionId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInstitutionProceduresByInstitutionId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetInstitutionProceduresByInstitutionIdResponse(); }
}

// @Route("/api/institutionprocedure/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Institution procedure not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetInstitutionProcedureById implements IReturn<GetInstitutionProcedureByIdResponse>, IGet
{
    /** @description The primary key Id of the institution procedure */
    // @ApiMember(DataType="string", Description="The primary key Id of the institution procedure", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetInstitutionProcedureById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInstitutionProcedureById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetInstitutionProcedureByIdResponse(); }
}

// @Route("/api/institutionprocedure/save/{Id}", "POST")
// @Route("/api/institutionprocedure/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetInstitutionProcedure implements IReturn<SetInstitutionProcedureResponse>
{
    /** @description The InstitutionProcedure Form data to save */
    // @ApiMember(DataType="InstitutionProcedure", Description="The InstitutionProcedure Form data to save", IsRequired=true, Name="institutionProcedure", ParameterType="body")
    public institutionProcedure: InstitutionProcedure;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetInstitutionProcedure>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetInstitutionProcedure'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetInstitutionProcedureResponse(); }
}

// @Route("/api/institutionprocedure/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateInstitutionProcedure implements IReturn<CreateInstitutionProcedureResponse>
{
    public institutionId: number;

    public constructor(init?: Partial<CreateInstitutionProcedure>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateInstitutionProcedure'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateInstitutionProcedureResponse(); }
}

// @Route("/api/institutionprocedure/validate/{Id}", "POST")
// @Route("/api/institutionprocedure/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateInstitutionProcedure implements IReturn<ValidateInstitutionProcedureResponse>
{
    /** @description The InstitutionProcedure Form data to validate */
    // @ApiMember(DataType="InstitutionProcedure", Description="The InstitutionProcedure Form data to validate", IsRequired=true, Name="institutionProcedure", ParameterType="body")
    public institutionProcedure: InstitutionProcedure;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateInstitutionProcedure>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateInstitutionProcedure'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateInstitutionProcedureResponse(); }
}

// @Route("/api/institutions", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetInstitutions implements IReturn<GetInstitutionsResponse>
{

    public constructor(init?: Partial<GetInstitutions>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInstitutions'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetInstitutionsResponse(); }
}

// @Route("/api/institution/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Institution not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetInstitutionById implements IReturn<GetInstitutionByIdResponse>, IGet
{
    /** @description The primary key Id of the Institution */
    // @ApiMember(DataType="string", Description="The primary key Id of the Institution", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetInstitutionById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInstitutionById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetInstitutionByIdResponse(); }
}

// @Route("/api/institution/save/{Id}", "POST")
// @Route("/api/institution/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetInstitution implements IReturn<SetInstitutionResponse>
{
    /** @description The Institution Form data to save */
    // @ApiMember(DataType="Institution", Description="The Institution Form data to save", IsRequired=true, Name="institution", ParameterType="body")
    public institution: Institution;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetInstitution>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetInstitution'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetInstitutionResponse(); }
}

// @Route("/api/institution/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateInstitution implements IReturn<CreateInstitutionResponse>
{

    public constructor(init?: Partial<CreateInstitution>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateInstitution'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateInstitutionResponse(); }
}

// @Route("/api/institution/validate/{Id}", "POST")
// @Route("/api/institution/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateInstitution implements IReturn<ValidateInstitutionResponse>
{
    /** @description The Institution Form data to validate */
    // @ApiMember(DataType="Institution", Description="The Institution Form data to validate", IsRequired=true, Name="institution", ParameterType="body")
    public institution: Institution;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateInstitution>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateInstitution'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateInstitutionResponse(); }
}

export class GetBrokenInstitutionUrls implements IReturn<GetBrokenInstitutionUrlsResponse>
{

    public constructor(init?: Partial<GetBrokenInstitutionUrls>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetBrokenInstitutionUrls'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetBrokenInstitutionUrlsResponse(); }
}

// @Route("/api/healthdistricts", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetHealthDistricts implements IReturn<GetHealthDistrictsResponse>
{
    public showInActiveHealthDistrictItems: boolean;

    public constructor(init?: Partial<GetHealthDistricts>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetHealthDistricts'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetHealthDistrictsResponse(); }
}

// @Route("/api/healthdistrict/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Health district not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetHealthDistrictById implements IReturn<GetHealthDistrictByIdResponse>, IGet
{
    /** @description The primary key Id of the health district */
    // @ApiMember(DataType="string", Description="The primary key Id of the health district", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetHealthDistrictById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetHealthDistrictById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetHealthDistrictByIdResponse(); }
}

// @Route("/api/healthdistrict/save/{Id}", "POST")
// @Route("/api/healthdistrict/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetHealthDistrict implements IReturn<SetHealthDistrictResponse>
{
    /** @description The health district Form data to save */
    // @ApiMember(DataType="HealthDistrict", Description="The health district Form data to save", IsRequired=true, Name="HealthDistrict", ParameterType="body")
    public healthDistrict: HealthDistrict;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetHealthDistrict>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetHealthDistrict'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetHealthDistrictResponse(); }
}

// @Route("/api/healthdistrict/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateHealthDistrict implements IReturn<CreateHealthDistrictResponse>
{

    public constructor(init?: Partial<CreateHealthDistrict>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateHealthDistrict'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateHealthDistrictResponse(); }
}

// @Route("/api/healthdistrict/validate/{Id}", "POST")
// @Route("/api/healthdistrict/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateHealthDistrict implements IReturn<ValidateHealthDistrictResponse>
{
    /** @description The health district Form data to validate */
    // @ApiMember(DataType="HealthDistrict", Description="The health district Form data to validate", IsRequired=true, Name="HealthDistrict", ParameterType="body")
    public healthDistrict: HealthDistrict;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateHealthDistrict>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateHealthDistrict'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateHealthDistrictResponse(); }
}

// @Route("/api/groupconfidentialitydeed/groupid/{groupid}", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetGroupConfidentialityDeedByGroupId implements IReturn<GetGroupConfidentialityDeedByGroupIdResponse>
{
    public groupId: number;

    public constructor(init?: Partial<GetGroupConfidentialityDeedByGroupId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetGroupConfidentialityDeedByGroupId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetGroupConfidentialityDeedByGroupIdResponse(); }
}

// @Route("/api/groupconfidentialitydeed/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Group Confidentiality Deed not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetGroupConfidentialityDeedById implements IReturn<GetGroupConfidentialityDeedByIdResponse>, IGet
{
    /** @description The primary key Id of the group confidentiality deed */
    // @ApiMember(DataType="string", Description="The primary key Id of the group confidentiality deed", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetGroupConfidentialityDeedById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetGroupConfidentialityDeedById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetGroupConfidentialityDeedByIdResponse(); }
}

// @Route("/api/groupconfidentialitydeed/save/{Id}", "POST")
// @Route("/api/groupconfidentialitydeed/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetGroupConfidentialityDeed implements IReturn<SetGroupConfidentialityDeedResponse>
{
    /** @description The Group Confidentiality Deed Form data to save */
    // @ApiMember(DataType="GroupConfidentialityDeed", Description="The Group Confidentiality Deed Form data to save", IsRequired=true, Name="groupConfidentialityDeed", ParameterType="body")
    public groupConfidentialityDeed: GroupConfidentialityDeed;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetGroupConfidentialityDeed>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetGroupConfidentialityDeed'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetGroupConfidentialityDeedResponse(); }
}

// @Route("/api/groupconfidentialitydeed/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateGroupConfidentialityDeed implements IReturn<CreateGroupConfidentialityDeedResponse>
{
    public groupId: number;

    public constructor(init?: Partial<CreateGroupConfidentialityDeed>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateGroupConfidentialityDeed'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateGroupConfidentialityDeedResponse(); }
}

// @Route("/api/groupconfidentialitydeed/validate/{Id}", "POST")
// @Route("/api/groupconfidentialitydeed/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateGroupConfidentialityDeed implements IReturn<ValidateGroupConfidentialityDeedResponse>
{
    /** @description The Group Confidentiality Deed Form data to validate */
    // @ApiMember(DataType="GroupConfidentialityDeed", Description="The Group Confidentiality Deed Form data to validate", IsRequired=true, Name="groupConfidentialityDeed", ParameterType="body")
    public groupConfidentialityDeed: GroupConfidentialityDeed;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateGroupConfidentialityDeed>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateGroupConfidentialityDeed'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateGroupConfidentialityDeedResponse(); }
}

// @Route("/api/groupconfidentialitydeed/delete/{Id}", "POST")
// @Route("/api/groupconfidentialitydeed/delete", "POST")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Group Confidentiality Deed not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class DeleteGroupConfidentialityDeed implements IReturn<DeleteGroupConfidentialityDeedResponse>
{
    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<DeleteGroupConfidentialityDeed>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteGroupConfidentialityDeed'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new DeleteGroupConfidentialityDeedResponse(); }
}

// @Route("/api/groupcontract/groupid/{groupid}", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetGroupContractByGroupId implements IReturn<GetGroupContractByGroupIdResponse>
{
    public groupId: number;

    public constructor(init?: Partial<GetGroupContractByGroupId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetGroupContractByGroupId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetGroupContractByGroupIdResponse(); }
}

// @Route("/api/groupcontract/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Group Contract not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetGroupContractById implements IReturn<GetGroupContractByIdResponse>, IGet
{
    /** @description The primary key Id of the group contract */
    // @ApiMember(DataType="string", Description="The primary key Id of the group contract", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetGroupContractById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetGroupContractById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetGroupContractByIdResponse(); }
}

// @Route("/api/groupcontract/save/{Id}", "POST")
// @Route("/api/groupcontract/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetGroupContract implements IReturn<SetGroupContractResponse>
{
    /** @description The GroupContract Form data to save */
    // @ApiMember(DataType="GroupContract", Description="The GroupContract Form data to save", IsRequired=true, Name="groupContract", ParameterType="body")
    public groupContract: GroupContract;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetGroupContract>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetGroupContract'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetGroupContractResponse(); }
}

// @Route("/api/groupcontract/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateGroupContract implements IReturn<CreateGroupContractResponse>
{
    public groupId: number;

    public constructor(init?: Partial<CreateGroupContract>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateGroupContract'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateGroupContractResponse(); }
}

// @Route("/api/groupcontract/validate/{Id}", "POST")
// @Route("/api/groupcontract/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateGroupContract implements IReturn<ValidateGroupContractResponse>
{
    /** @description The GroupContract Form data to validate */
    // @ApiMember(DataType="GroupContract", Description="The GroupContract Form data to validate", IsRequired=true, Name="groupContract", ParameterType="body")
    public groupContract: GroupContract;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateGroupContract>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateGroupContract'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateGroupContractResponse(); }
}

// @Route("/api/groupfinance/groupid/{groupid}", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetGroupFinanceByGroupId implements IReturn<GetGroupFinanceByGroupIdResponse>
{
    public groupId: number;

    public constructor(init?: Partial<GetGroupFinanceByGroupId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetGroupFinanceByGroupId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetGroupFinanceByGroupIdResponse(); }
}

// @Route("/api/groupfinance/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Group Finance not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetGroupFinanceById implements IReturn<GetGroupFinanceByIdResponse>, IGet
{
    /** @description The primary key Id of the group finance */
    // @ApiMember(DataType="string", Description="The primary key Id of the group finance", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetGroupFinanceById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetGroupFinanceById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetGroupFinanceByIdResponse(); }
}

// @Route("/api/groupfinance/save/{Id}", "POST")
// @Route("/api/groupfinance/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetGroupFinance implements IReturn<SetGroupFinanceResponse>
{
    /** @description The GroupFinance Form data to save */
    // @ApiMember(DataType="GroupFinance", Description="The GroupFinance Form data to save", IsRequired=true, Name="groupFinance", ParameterType="body")
    public groupFinance: GroupFinance;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetGroupFinance>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetGroupFinance'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetGroupFinanceResponse(); }
}

// @Route("/api/groupfinance/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateGroupFinance implements IReturn<CreateGroupFinanceResponse>
{
    public groupId: number;

    public constructor(init?: Partial<CreateGroupFinance>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateGroupFinance'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateGroupFinanceResponse(); }
}

// @Route("/api/groupfinance/validate/{Id}", "POST")
// @Route("/api/groupfinance/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateGroupFinance implements IReturn<ValidateGroupFinanceResponse>
{
    /** @description The GroupFinance Form data to validate */
    // @ApiMember(DataType="GroupFinance", Description="The GroupFinance Form data to validate", IsRequired=true, Name="groupFinance", ParameterType="body")
    public groupFinance: GroupFinance;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateGroupFinance>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateGroupFinance'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateGroupFinanceResponse(); }
}

// @Route("/api/groupitemcategories", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetGroupItemCategoriesByGroupId implements IReturn<GetGroupItemCategoriesByGroupIdResponse>
{
    public groupId?: number;

    public constructor(init?: Partial<GetGroupItemCategoriesByGroupId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetGroupItemCategoriesByGroupId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetGroupItemCategoriesByGroupIdResponse(); }
}

// @Route("/api/groupitemimport/id/{Id}/{TrialId}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Group not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetGroupItemImportById implements IReturn<GetGroupItemImportByIdResponse>, IGet
{
    /** @description The primary key Id of the Destination Group */
    // @ApiMember(DataType="string", Description="The primary key Id of the Destination Group", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    /** @description The primary key Id of the Soruce Group */
    // @ApiMember(DataType="string", Description="The primary key Id of the Soruce Group", IsRequired=true, Name="TrialGroupId", ParameterType="path")
    public trialGroupId: number;

    public constructor(init?: Partial<GetGroupItemImportById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetGroupItemImportById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetGroupItemImportByIdResponse(); }
}

// @Route("/api/groupitemimport/save/{Id}/{TrialId}", "POST")
// @Route("/api/groupitemimport/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetGroupItemImport implements IReturn<SetGroupItemImportResponse>
{
    /** @description The Group Form data to save */
    // @ApiMember(DataType="Group", Description="The Group Form data to save", IsRequired=true, Name="Group", ParameterType="body")
    public groupItemImport: GroupItemImport;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    /** @description The primary key Id of the Soruce Group */
    // @ApiMember(DataType="string", Description="The primary key Id of the Soruce Group", IsRequired=true, Name="TrialGroupId", ParameterType="path")
    public trialGroupId: number;

    public constructor(init?: Partial<SetGroupItemImport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetGroupItemImport'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetGroupItemImportResponse(); }
}

// @Route("/api/groupitem/{id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Group Item not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetGroupItemById implements IReturn<GetGroupItemByIdResponse>, IGet
{
    /** @description The primary key Id of the group item */
    // @ApiMember(DataType="string", Description="The primary key Id of the group item", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetGroupItemById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetGroupItemById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetGroupItemByIdResponse(); }
}

// @Route("/api/groupitems/group/{groupid}", "GET")
// @ApiResponse(Description="GroupId is invalid", StatusCode=400)
// @ApiResponse(Description="Group Items not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetGroupItemsByGroupId implements IReturn<GetGroupItemsByGroupIdResponse>, IGet
{
    /** @description The primary key Id of the group */
    // @ApiMember(DataType="string", Description="The primary key Id of the group", IsRequired=true, Name="GroupId", ParameterType="path")
    public groupId: number;

    public constructor(init?: Partial<GetGroupItemsByGroupId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetGroupItemsByGroupId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetGroupItemsByGroupIdResponse(); }
}

// @Route("/api/groupitem/save/{id}", "POST")
// @Route("/api/groupitem/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetGroupItem implements IReturn<SetGroupItemResponse>
{
    /** @description The GroupItem Form data to save */
    // @ApiMember(DataType="GroupItem", Description="The GroupItem Form data to save", IsRequired=true, Name="GroupItem", ParameterType="body")
    public groupItem: GroupItem;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetGroupItem>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetGroupItem'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetGroupItemResponse(); }
}

// @Route("/api/groupitems/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateGroupItem implements IReturn<CreateGroupItemResponse>
{
    /** @description The primary key Id of the group */
    // @ApiMember(DataType="string", Description="The primary key Id of the group", IsRequired=true, Name="GroupId", ParameterType="path")
    public groupId: number;

    public constructor(init?: Partial<CreateGroupItem>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateGroupItem'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateGroupItemResponse(); }
}

// @Route("/api/groups", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetGroups implements IReturn<GetGroupsResponse>
{
    public showInActive: boolean;

    public constructor(init?: Partial<GetGroups>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetGroups'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetGroupsResponse(); }
}

// @Route("/api/group/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Group not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetGroupById implements IReturn<GetGroupByIdResponse>, IGet
{
    /** @description The primary key Id of the Group */
    // @ApiMember(DataType="string", Description="The primary key Id of the Group", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetGroupById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetGroupById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetGroupByIdResponse(); }
}

// @Route("/api/group/save/{Id}", "POST")
// @Route("/api/group/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetGroup implements IReturn<SetGroupResponse>
{
    /** @description The Group Form data to save */
    // @ApiMember(DataType="Group", Description="The Group Form data to save", IsRequired=true, Name="group", ParameterType="body")
    public group: Group;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetGroup>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetGroup'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetGroupResponse(); }
}

// @Route("/api/group/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateGroup implements IReturn<CreateGroupResponse>
{

    public constructor(init?: Partial<CreateGroup>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateGroup'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateGroupResponse(); }
}

// @Route("/api/group/validate/{Id}", "POST")
// @Route("/api/group/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateGroup implements IReturn<ValidateGroupResponse>
{
    /** @description The Group Form data to validate */
    // @ApiMember(DataType="Group", Description="The Group Form data to validate", IsRequired=true, Name="group", ParameterType="body")
    public group: Group;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateGroup>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateGroup'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateGroupResponse(); }
}

// @Route("/api/file/temp/upload", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class UploadTempFile implements IReturn<UploadTempFileResponse>
{
    public json: boolean;

    public constructor(init?: Partial<UploadTempFile>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UploadTempFile'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UploadTempFileResponse(); }
}

// @Route("/api/file/temp/info/{Guid}", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTempFileInfo implements IReturn<GetTempFileInfoResponse>
{
    /** @description The Guid (name) of the temporary file to retrieve */
    // @ApiMember(DataType="string", Description="The Guid (name) of the temporary file to retrieve", IsRequired=true, Name="Guid", ParameterType="path")
    public guid: string;

    public constructor(init?: Partial<GetTempFileInfo>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTempFileInfo'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTempFileInfoResponse(); }
}

// @Route("/api/file/temp/get/{Guid}", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTempFile
{
    /** @description The Guid (name) of the temporary file to retrieve */
    // @ApiMember(DataType="string", Description="The Guid (name) of the temporary file to retrieve", IsRequired=true, Name="Guid", ParameterType="path")
    public guid: string;

    public constructor(init?: Partial<GetTempFile>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTempFile'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}

// @Route("/source-document/{Id}", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetSourceDocumentFile
{
    /** @description The Id of the source document */
    // @ApiMember(DataType="integer", Description="The Id of the source document", Format="int", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetSourceDocumentFile>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSourceDocumentFile'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}

// @Route("/source-document/download/{Id}", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class DownloadSourceDocumentFile
{
    /** @description The Id of the source document */
    // @ApiMember(DataType="integer", Description="The Id of the source document", Format="int", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<DownloadSourceDocumentFile>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DownloadSourceDocumentFile'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}

// @Route("/api/fellowships", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetFellowships implements IReturn<GetFellowshipsResponse>
{
    public showInActiveFellowshipItems: boolean;

    public constructor(init?: Partial<GetFellowships>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetFellowships'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetFellowshipsResponse(); }
}

// @Route("/api/fellowship/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Fellowship not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetFellowshipById implements IReturn<GetFellowshipByIdResponse>, IGet
{
    /** @description The primary key Id of the fellowship */
    // @ApiMember(DataType="string", Description="The primary key Id of the fellowship", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetFellowshipById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetFellowshipById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetFellowshipByIdResponse(); }
}

// @Route("/api/fellowship/personnelid/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Fellowship not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetFellowshipsByPersonnelId implements IReturn<GetFellowshipsByPersonnelIdResponse>, IGet
{
    /** @description The primary key Id of the personnel */
    // @ApiMember(DataType="string", Description="The primary key Id of the personnel", IsRequired=true, Name="Id", ParameterType="path")
    public personnelId: number;

    public constructor(init?: Partial<GetFellowshipsByPersonnelId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetFellowshipsByPersonnelId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetFellowshipsByPersonnelIdResponse(); }
}

// @Route("/api/fellowship/save/{Id}", "POST")
// @Route("/api/fellowship/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetFellowship implements IReturn<SetFellowshipResponse>
{
    /** @description The fellowship Form data to save */
    // @ApiMember(DataType="Fellowship", Description="The fellowship Form data to save", IsRequired=true, Name="Fellowship", ParameterType="body")
    public fellowship: Fellowship;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetFellowship>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetFellowship'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetFellowshipResponse(); }
}

// @Route("/api/fellowship/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateFellowship implements IReturn<CreateFellowshipResponse>
{
    public personnelId: number;

    public constructor(init?: Partial<CreateFellowship>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateFellowship'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateFellowshipResponse(); }
}

// @Route("/api/fellowship/validate/{Id}", "POST")
// @Route("/api/fellowship/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateFellowship implements IReturn<ValidateFellowshipResponse>
{
    /** @description The fellowship Form data to validate */
    // @ApiMember(DataType="Fellowship", Description="The fellowship Form data to validate", IsRequired=true, Name="Fellowship", ParameterType="body")
    public fellowship: Fellowship;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateFellowship>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateFellowship'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateFellowshipResponse(); }
}

// @Route("/api/committeemeetingattendances", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetCommitteeMeetingAttendances implements IReturn<GetCommitteeMeetingAttendancesResponse>
{
    public committeeMeetingId: number;

    public constructor(init?: Partial<GetCommitteeMeetingAttendances>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCommitteeMeetingAttendances'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetCommitteeMeetingAttendancesResponse(); }
}

// @Route("/api/committeemeetingattendance/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Committee meeting attendance not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetCommitteeMeetingAttendanceById implements IReturn<GetCommitteeMeetingAttendanceByIdResponse>, IGet
{
    /** @description The primary key Id of the committee meeting attendance */
    // @ApiMember(DataType="string", Description="The primary key Id of the committee meeting attendance", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetCommitteeMeetingAttendanceById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCommitteeMeetingAttendanceById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetCommitteeMeetingAttendanceByIdResponse(); }
}

// @Route("/api/committeemeetingattendance/committeemeetingid/{committeeMeetingId}", "GET")
// @ApiResponse(Description="Committee Meeting Id is invalid", StatusCode=400)
// @ApiResponse(Description="Committee meeting attendance not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetCommitteeMeetingAttendanceByCommitteeMeetingId implements IReturn<GetCommitteeMeetingAttendanceByCommitteeMeetingIdResponse>, IGet
{
    /** @description The committee id of the committee meeting attendance */
    // @ApiMember(DataType="string", Description="The committee id of the committee meeting attendance", IsRequired=true, Name="CommitteeMeetingId", ParameterType="path")
    public committeeMeetingId: number;

    public constructor(init?: Partial<GetCommitteeMeetingAttendanceByCommitteeMeetingId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCommitteeMeetingAttendanceByCommitteeMeetingId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetCommitteeMeetingAttendanceByCommitteeMeetingIdResponse(); }
}

// @Route("/api/committeemeetingattendance/save/{Id}", "POST")
// @Route("/api/committeemeetingattendance/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetCommitteeMeetingAttendance implements IReturn<SetCommitteeMeetingAttendanceResponse>
{
    /** @description The CommitteeMeetingAttendance Form data to save */
    // @ApiMember(DataType="CommitteeMeetingAttendance", Description="The CommitteeMeetingAttendance Form data to save", IsRequired=true, Name="committeeMeetingAttendance", ParameterType="body")
    public committeeMeetingAttendance: CommitteeMeetingAttendance;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetCommitteeMeetingAttendance>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetCommitteeMeetingAttendance'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetCommitteeMeetingAttendanceResponse(); }
}

// @Route("/api/committeemeetingattendance/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateCommitteeMeetingAttendance implements IReturn<CreateCommitteeMeetingAttendanceResponse>
{
    public committeeMeetingId: number;

    public constructor(init?: Partial<CreateCommitteeMeetingAttendance>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateCommitteeMeetingAttendance'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateCommitteeMeetingAttendanceResponse(); }
}

// @Route("/api/committeemeetingattendance/validate/{Id}", "POST")
// @Route("/api/committeemeetingattendance/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateCommitteeMeetingAttendance implements IReturn<ValidateCommitteeMeetingAttendanceResponse>
{
    /** @description The CommitteeMeetingAttendance Form data to validate */
    // @ApiMember(DataType="CommitteeMeetingAttendance", Description="The CommitteeMeetingAttendance Form data to validate", IsRequired=true, Name="committeeMeetingAttendance", ParameterType="body")
    public committeeMeetingAttendance: CommitteeMeetingAttendance;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateCommitteeMeetingAttendance>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateCommitteeMeetingAttendance'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateCommitteeMeetingAttendanceResponse(); }
}

// @Route("/api/committeemeetings", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetCommitteeMeetings implements IReturn<GetCommitteeMeetingsResponse>
{
    public committeeId: number;

    public constructor(init?: Partial<GetCommitteeMeetings>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCommitteeMeetings'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetCommitteeMeetingsResponse(); }
}

// @Route("/api/committeemeeting/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Committee meeting not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetCommitteeMeetingById implements IReturn<GetCommitteeMeetingByIdResponse>, IGet
{
    /** @description The primary key Id of the committee meeting */
    // @ApiMember(DataType="string", Description="The primary key Id of the committee meeting", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetCommitteeMeetingById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCommitteeMeetingById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetCommitteeMeetingByIdResponse(); }
}

// @Route("/api/committeemeeting/committeeid/{committeeId}", "GET")
// @ApiResponse(Description="Committee Id is invalid", StatusCode=400)
// @ApiResponse(Description="Committee meeting not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetCommitteeMeetingByCommitteeId implements IReturn<GetCommitteeMeetingByCommitteeIdResponse>, IGet
{
    /** @description The committee id of the committee meeting */
    // @ApiMember(DataType="string", Description="The committee id of the committee meeting", IsRequired=true, Name="CommitteeId", ParameterType="path")
    public committeeId: number;

    public constructor(init?: Partial<GetCommitteeMeetingByCommitteeId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCommitteeMeetingByCommitteeId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetCommitteeMeetingByCommitteeIdResponse(); }
}

// @Route("/api/committeemeeting/save/{Id}", "POST")
// @Route("/api/committeemeeting/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetCommitteeMeeting implements IReturn<SetCommitteeMeetingResponse>
{
    /** @description The CommitteeMeeting Form data to save */
    // @ApiMember(DataType="CommitteeMeeting", Description="The CommitteeMeeting Form data to save", IsRequired=true, Name="committeeMeeting", ParameterType="body")
    public committeeMeeting: CommitteeMeeting;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetCommitteeMeeting>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetCommitteeMeeting'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetCommitteeMeetingResponse(); }
}

// @Route("/api/committeemeeting/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateCommitteeMeeting implements IReturn<CreateCommitteeMeetingResponse>
{
    public committeeId: number;

    public constructor(init?: Partial<CreateCommitteeMeeting>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateCommitteeMeeting'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateCommitteeMeetingResponse(); }
}

// @Route("/api/committeemeeting/validate/{Id}", "POST")
// @Route("/api/committeemeeting/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateCommitteeMeeting implements IReturn<ValidateCommitteeMeetingResponse>
{
    /** @description The CommitteeMeeting Form data to validate */
    // @ApiMember(DataType="CommitteeMeeting", Description="The CommitteeMeeting Form data to validate", IsRequired=true, Name="committeeMeeting", ParameterType="body")
    public committeeMeeting: CommitteeMeeting;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateCommitteeMeeting>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateCommitteeMeeting'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateCommitteeMeetingResponse(); }
}

// @Route("/api/committeememberroles", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetCommitteeMemberRoles implements IReturn<GetCommitteeMemberRolesResponse>
{
    public committeeId: number;
    public committeeMemberId: number;

    public constructor(init?: Partial<GetCommitteeMemberRoles>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCommitteeMemberRoles'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetCommitteeMemberRolesResponse(); }
}

// @Route("/api/committeememberrole/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Committee member role not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetCommitteeMemberRoleById implements IReturn<GetCommitteeMemberRoleByIdResponse>, IGet
{
    /** @description The primary key Id of the committee member role */
    // @ApiMember(DataType="string", Description="The primary key Id of the committee member role", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetCommitteeMemberRoleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCommitteeMemberRoleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetCommitteeMemberRoleByIdResponse(); }
}

// @Route("/api/committeememberrole/personnelid/{personnelid}", "GET")
// @ApiResponse(Description="PersonnelId is invalid", StatusCode=400)
// @ApiResponse(Description="Committee member role not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetCommitteeMemberRolesByPersonnelId implements IReturn<GetCommitteeMemberRolesByPersonnelIdResponse>, IGet
{
    /** @description The primary key Id of the personnel */
    // @ApiMember(DataType="string", Description="The primary key Id of the personnel", IsRequired=true, Name="PersonnelId", ParameterType="path")
    public personnelId: number;

    public constructor(init?: Partial<GetCommitteeMemberRolesByPersonnelId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCommitteeMemberRolesByPersonnelId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetCommitteeMemberRolesByPersonnelIdResponse(); }
}

// @Route("/api/committeememberrole/committeeid/{committeeId}/committeememberid/{committeememberId}", "GET")
// @ApiResponse(Description="Committee Id or Committee Member Id is invalid", StatusCode=400)
// @ApiResponse(Description="Committee member role not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetCommitteeMemberRoleByCommitteeId implements IReturn<GetCommitteeMemberRoleByCommitteeIdResponse>, IGet
{
    /** @description The committee id of the committee member role */
    // @ApiMember(DataType="string", Description="The committee id of the committee member role", IsRequired=true, Name="CommitteeId", ParameterType="path")
    public committeeId: number;

    /** @description The committee member id of the committee member role */
    // @ApiMember(DataType="string", Description="The committee member id of the committee member role", IsRequired=true, Name="CommitteeMemberId", ParameterType="path")
    public committeeMemberId: number;

    public constructor(init?: Partial<GetCommitteeMemberRoleByCommitteeId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCommitteeMemberRoleByCommitteeId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetCommitteeMemberRoleByCommitteeIdResponse(); }
}

// @Route("/api/committeememberrole/save/{Id}", "POST")
// @Route("/api/committeememberrole/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetCommitteeMemberRole implements IReturn<SetCommitteeMemberRoleResponse>
{
    /** @description The CommitteeMemberRole Form data to save */
    // @ApiMember(DataType="CommitteeMemberRole", Description="The CommitteeMemberRole Form data to save", IsRequired=true, Name="committeeMemberRole", ParameterType="body")
    public committeeMemberRole: CommitteeMemberRole;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetCommitteeMemberRole>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetCommitteeMemberRole'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetCommitteeMemberRoleResponse(); }
}

// @Route("/api/committeememberrole/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateCommitteeMemberRole implements IReturn<CreateCommitteeMemberRoleResponse>
{
    public committeeId: number;
    public committeeMemberId: number;

    public constructor(init?: Partial<CreateCommitteeMemberRole>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateCommitteeMemberRole'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateCommitteeMemberRoleResponse(); }
}

// @Route("/api/committeememberrole/validate/{Id}", "POST")
// @Route("/api/committeememberrole/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateCommitteeMemberRole implements IReturn<ValidateCommitteeMemberRoleResponse>
{
    /** @description The CommitteeMemberRole Form data to validate */
    // @ApiMember(DataType="CommitteeMemberRole", Description="The CommitteeMemberRole Form data to validate", IsRequired=true, Name="committeeMemberRole", ParameterType="body")
    public committeeMemberRole: CommitteeMemberRole;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateCommitteeMemberRole>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateCommitteeMemberRole'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateCommitteeMemberRoleResponse(); }
}

// @Route("/api/committeemembers", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetCommitteeMembers implements IReturn<GetCommitteeMembersResponse>
{
    public committeeId: number;

    public constructor(init?: Partial<GetCommitteeMembers>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCommitteeMembers'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetCommitteeMembersResponse(); }
}

// @Route("/api/committeemember/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Committee member not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetCommitteeMemberById implements IReturn<GetCommitteeMemberByIdResponse>, IGet
{
    /** @description The primary key Id of the committee member */
    // @ApiMember(DataType="string", Description="The primary key Id of the committee member", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetCommitteeMemberById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCommitteeMemberById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetCommitteeMemberByIdResponse(); }
}

// @Route("/api/committeemember/committeeid/{committeeId}", "GET")
// @ApiResponse(Description="Committee Id is invalid", StatusCode=400)
// @ApiResponse(Description="Committee member not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetCommitteeMemberByCommitteeId implements IReturn<GetCommitteeMemberByCommitteeIdResponse>, IGet
{
    /** @description The committee id of the committee member */
    // @ApiMember(DataType="string", Description="The committee id of the committee member", IsRequired=true, Name="CommitteeId", ParameterType="path")
    public committeeId: number;

    public constructor(init?: Partial<GetCommitteeMemberByCommitteeId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCommitteeMemberByCommitteeId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetCommitteeMemberByCommitteeIdResponse(); }
}

// @Route("/api/committeemember/save/{Id}", "POST")
// @Route("/api/committeemember/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetCommitteeMember implements IReturn<SetCommitteeMemberResponse>
{
    /** @description The CommitteeMember Form data to save */
    // @ApiMember(DataType="CommitteeMember", Description="The CommitteeMember Form data to save", IsRequired=true, Name="committeeMember", ParameterType="body")
    public committeeMember: CommitteeMember;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetCommitteeMember>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetCommitteeMember'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetCommitteeMemberResponse(); }
}

// @Route("/api/committeemember/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateCommitteeMember implements IReturn<CreateCommitteeMemberResponse>
{
    public committeeId: number;

    public constructor(init?: Partial<CreateCommitteeMember>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateCommitteeMember'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateCommitteeMemberResponse(); }
}

// @Route("/api/committeemember/validate/{Id}", "POST")
// @Route("/api/committeemember/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateCommitteeMember implements IReturn<ValidateCommitteeMemberResponse>
{
    /** @description The CommitteeMember Form data to validate */
    // @ApiMember(DataType="CommitteeMember", Description="The CommitteeMember Form data to validate", IsRequired=true, Name="committeeMember", ParameterType="body")
    public committeeMember: CommitteeMember;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateCommitteeMember>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateCommitteeMember'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateCommitteeMemberResponse(); }
}

// @Route("/api/committeeregularinvitees", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetCommitteeRegularInvitees implements IReturn<GetCommitteeRegularInviteesResponse>
{
    public committeeId: number;

    public constructor(init?: Partial<GetCommitteeRegularInvitees>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCommitteeRegularInvitees'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetCommitteeRegularInviteesResponse(); }
}

// @Route("/api/committeeregularinvitee/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Trial Item not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetCommitteeRegularInviteeById implements IReturn<GetCommitteeRegularInviteeByIdResponse>, IGet
{
    /** @description The primary key Id of the committee regular invitee */
    // @ApiMember(DataType="string", Description="The primary key Id of the committee regular invitee", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetCommitteeRegularInviteeById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCommitteeRegularInviteeById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetCommitteeRegularInviteeByIdResponse(); }
}

// @Route("/api/committeeregularinvitee/committeeid/{committeeId}", "GET")
// @ApiResponse(Description="Committee Id is invalid", StatusCode=400)
// @ApiResponse(Description="Committee Regular Invitee not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetCommitteeRegularInviteeByCommitteeId implements IReturn<GetCommitteeRegularInviteeByCommitteeIdResponse>, IGet
{
    /** @description The committee id of the committee regular invitee */
    // @ApiMember(DataType="string", Description="The committee id of the committee regular invitee", IsRequired=true, Name="CommitteeId", ParameterType="path")
    public committeeId: number;

    public constructor(init?: Partial<GetCommitteeRegularInviteeByCommitteeId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCommitteeRegularInviteeByCommitteeId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetCommitteeRegularInviteeByCommitteeIdResponse(); }
}

// @Route("/api/committeeregularinvitee/save/{Id}", "POST")
// @Route("/api/committeeregularinvitee/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetCommitteeRegularInvitee implements IReturn<SetCommitteeRegularInviteeResponse>
{
    /** @description The Committee Regular Invitee Form data to save */
    // @ApiMember(DataType="CommitteeRegularInvitee", Description="The Committee Regular Invitee Form data to save", IsRequired=true, Name="committeeRegularInvitee", ParameterType="body")
    public committeeRegularInvitee: CommitteeRegularInvitee;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetCommitteeRegularInvitee>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetCommitteeRegularInvitee'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetCommitteeRegularInviteeResponse(); }
}

// @Route("/api/committeeregularinvitee/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateCommitteeRegularInvitee implements IReturn<CreateCommitteeRegularInviteeResponse>
{
    public committeeId: number;

    public constructor(init?: Partial<CreateCommitteeRegularInvitee>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateCommitteeRegularInvitee'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateCommitteeRegularInviteeResponse(); }
}

// @Route("/api/committeeregularinvitee/validate/{Id}", "POST")
// @Route("/api/committeeregularinvitee/validate", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateCommitteeRegularInvitee implements IReturn<ValidateCommitteeRegularInviteeResponse>
{
    /** @description The Committee Regular Invitee Form data to validate */
    // @ApiMember(DataType="CommitteeRegularInvitee", Description="The Committee Regular Invitee Form data to validate", IsRequired=true, Name="committeeRegularInvitee", ParameterType="body")
    public committeeRegularInvitee: CommitteeRegularInvitee;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<ValidateCommitteeRegularInvitee>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateCommitteeRegularInvitee'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateCommitteeRegularInviteeResponse(); }
}

// @Route("/api/collectioninstance/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="CollectionInstance not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetCollectionInstanceById implements IReturn<GetCollectionInstanceByIdResponse>, IGet
{
    /** @description The primary key Id of the CollectionInstance */
    // @ApiMember(DataType="string", Description="The primary key Id of the CollectionInstance", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetCollectionInstanceById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCollectionInstanceById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetCollectionInstanceByIdResponse(); }
}

// @Route("/api/collectioninstance/save/{Id}", "POST")
// @Route("/api/collectioninstance/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetCollectionInstance implements IReturn<SetCollectionInstanceResponse>
{
    /** @description The CollectionInstance Form data to save */
    // @ApiMember(DataType="CollectionInstance", Description="The CollectionInstance Form data to save", IsRequired=true, Name="collectionInstance", ParameterType="body")
    public collectionInstance: CollectionInstance;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetCollectionInstance>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetCollectionInstance'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetCollectionInstanceResponse(); }
}

// @Route("/api/collection/id/{Id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="Collection not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetCollectionById implements IReturn<GetCollectionByIdResponse>, IGet
{
    /** @description The primary key Id of the Collection */
    // @ApiMember(DataType="string", Description="The primary key Id of the Collection", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetCollectionById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCollectionById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetCollectionByIdResponse(); }
}

// @Route("/api/collection/save/{Id}", "POST")
// @Route("/api/collection/save", "POST")
// @ApiResponse(Description="Form data invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetCollection implements IReturn<SetCollectionResponse>
{
    /** @description The Collection Form data to save */
    // @ApiMember(DataType="Collection", Description="The Collection Form data to save", IsRequired=true, Name="collection", ParameterType="body")
    public collection: Collection;

    /** @description The Id */
    // @ApiMember(DataType="string", Description="The Id", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<SetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetCollection'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetCollectionResponse(); }
}

// @Route("/api/collection/create", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateCollection implements IReturn<CreateCollectionResponse>
{

    public constructor(init?: Partial<CreateCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateCollection'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateCollectionResponse(); }
}

// @Route("/api/accrualanz/{id}", "GET")
// @ApiResponse(Description="Id is invalid", StatusCode=400)
// @ApiResponse(Description="AccrualANZ not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetAccrualANZById implements IReturn<GetAccrualANZByIdResponse>, IGet
{
    /** @description The primary key Id of the AccrualANZ */
    // @ApiMember(DataType="int", Description="The primary key Id of the AccrualANZ", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetAccrualANZById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAccrualANZById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetAccrualANZByIdResponse(); }
}

// @Route("/api/accrualanz/trial/{trialid}", "GET")
// @ApiResponse(Description="GroupId is invalid", StatusCode=400)
// @ApiResponse(Description="Group Items not found", StatusCode=404)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetAccrualANZByTrialId implements IReturn<GetAccrualANZByTrialIdResponse>, IGet
{
    /** @description The primary key Id of the trial */
    // @ApiMember(DataType="int", Description="The primary key Id of the trial", IsRequired=true, Name="TrialId", ParameterType="path")
    public trialId: number;

    public constructor(init?: Partial<GetAccrualANZByTrialId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAccrualANZByTrialId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetAccrualANZByTrialIdResponse(); }
}

/** @description TMD */
// @Route("/api/member/get-by-outlook-id", "GET")
// @Api(Description="TMD")
// @ApiResponse(Description="Not authorized", StatusCode=401)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
// @DataContract
export class GetMemberByOutlookId implements IReturn<GetMemberByOutlookIdResponse>, IGet
{
    /** @description The outlook id to get the member for */
    // @DataMember(Order=1)
    // @ApiMember(DataType="string", Description="The outlook id to get the member for", IsRequired=true, Name="OutlookId", ParameterType="query")
    public outlookId: string;

    public constructor(init?: Partial<GetMemberByOutlookId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMemberByOutlookId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetMemberByOutlookIdResponse(); }
}

/** @description TMD */
// @Route("/api/member/get-by-member-id", "GET")
// @Api(Description="TMD")
// @ApiResponse(Description="Not authorized", StatusCode=401)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
// @DataContract
export class GetMemberByMemberId implements IReturn<GetMemberByMemberIdResponse>, IGet
{
    /** @description The member id to get the member for */
    // @DataMember(Order=1)
    // @ApiMember(DataType="string", Description="The member id to get the member for", IsRequired=true, Name="MemberId", ParameterType="query")
    public memberId: string;

    public constructor(init?: Partial<GetMemberByMemberId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMemberByMemberId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetMemberByMemberIdResponse(); }
}

/** @description TMD */
// @Route("/api/member/get-by-username", "GET")
// @Api(Description="TMD")
// @ApiResponse(Description="Not authorized", StatusCode=401)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
// @DataContract
export class GetMemberByUsername implements IReturn<GetMemberByUsernameResponse>, IGet
{
    /** @description The username to get the member for */
    // @DataMember(Order=1)
    // @ApiMember(DataType="string", Description="The username to get the member for", IsRequired=true, Name="Username", ParameterType="query")
    public username: string;

    public constructor(init?: Partial<GetMemberByUsername>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMemberByUsername'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetMemberByUsernameResponse(); }
}

/** @description TMD */
// @Route("/api/member/get-by-member-status-id", "GET")
// @Api(Description="TMD")
// @ApiResponse(Description="Not authorized", StatusCode=401)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
// @DataContract
export class GetMemberByMemberStatusId implements IReturn<GetMemberByMemberStatusIdResponse>, IGet
{
    /** @description The member status id to get the member for */
    // @DataMember(Order=1)
    // @ApiMember(DataType="integer", Description="The member status id to get the member for", Format="int32", IsRequired=true, Name="MemberStatusId", ParameterType="query")
    public memberStatusId: number;

    public constructor(init?: Partial<GetMemberByMemberStatusId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMemberByMemberStatusId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetMemberByMemberStatusIdResponse(); }
}

/** @description TMD */
// @Route("/api/member/get-by-member-ids", "GET")
// @Api(Description="TMD")
// @ApiResponse(Description="Not authorized", StatusCode=401)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
// @DataContract
export class GetMemberByMemberIds implements IReturn<GetMemberByMemberIdsResponse>, IGet
{
    /** @description The member ids to get the member for */
    // @DataMember(Order=1)
    // @ApiMember(DataType="array", Description="The member ids to get the member for", IsRequired=true, Name="MemberId", ParameterType="query")
    public memberIds: string[] = [];

    public constructor(init?: Partial<GetMemberByMemberIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMemberByMemberIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetMemberByMemberIdsResponse(); }
}

/** @description TMD */
// @Route("/api/member/get-with-outstanding-applications", "GET")
// @Api(Description="TMD")
// @ApiResponse(Description="Not authorized", StatusCode=401)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
// @DataContract
export class GetMembersWithOutstandingApplications implements IReturn<GetMembersWithOutstandingApplicationsResponse>, IGet
{

    public constructor(init?: Partial<GetMembersWithOutstandingApplications>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMembersWithOutstandingApplications'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetMembersWithOutstandingApplicationsResponse(); }
}

/** @description TMD */
// @Route("/api/membership/get-type-by-names", "GET")
// @Api(Description="TMD")
// @ApiResponse(Description="Not authorized", StatusCode=401)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
// @DataContract
export class GetMembershipType implements IReturn<GetMembershipTypeResponse>, IGet
{
    /** @description The username to retrieve the type for */
    // @DataMember(Order=1)
    // @ApiMember(DataType="string", Description="The username to retrieve the type for", Name="Username", ParameterType="query")
    public username?: string;

    /** @description The member id to retrieve the type for */
    // @DataMember(Order=2)
    // @ApiMember(DataType="string", Description="The member id to retrieve the type for", Name="MemberId", ParameterType="query")
    public memberId?: string;

    /** @description The first name of the user to retrieve the type for */
    // @DataMember(Order=3)
    // @ApiMember(DataType="string", Description="The first name of the user to retrieve the type for", Name="FirstName", ParameterType="query")
    public firstName?: string;

    /** @description The last name of the user to retrieve the type for */
    // @DataMember(Order=4)
    // @ApiMember(DataType="string", Description="The last name of the user to retrieve the type for", Name="LastName", ParameterType="query")
    public lastName?: string;

    /** @description The email of the user to retrieve the type for */
    // @DataMember(Order=5)
    // @ApiMember(DataType="string", Description="The email of the user to retrieve the type for", Name="Email", ParameterType="query")
    public email?: string;

    public constructor(init?: Partial<GetMembershipType>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMembershipType'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetMembershipTypeResponse(); }
}

/** @description TMD */
// @Route("/api/member/renew", "POST")
// @Api(Description="TMD")
// @ApiResponse(Description="Not authorized", StatusCode=401)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
// @DataContract
export class MemberRenew implements IReturn<MemberRenewResponse>, IPost
{
    /** @description The member id to renew for */
    // @DataMember(Order=1)
    // @ApiMember(DataType="string", Description="The member id to renew for", IsRequired=true, Name="MemberId", ParameterType="model")
    public memberId: string;

    /** @description The date of renewal */
    // @DataMember(Order=2)
    // @ApiMember(DataType="string", Description="The date of renewal", Format="date", IsRequired=true, Name="RenewDate", ParameterType="model")
    public renewDate: string;

    /** @description Whether to update from affiliate member to full member */
    // @DataMember(Order=3)
    // @ApiMember(DataType="boolean", Description="Whether to update from affiliate member to full member", Name="UpgradeRequested", ParameterType="model")
    public upgradeRequested?: boolean;

    /** @description The reason for upgrading */
    // @DataMember(Order=4)
    // @ApiMember(DataType="string", Description="The reason for upgrading", Name="UpgradeReason", ParameterType="model")
    public upgradeReason?: string;

    public constructor(init?: Partial<MemberRenew>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MemberRenew'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MemberRenewResponse(); }
}

/** @description TMD */
// @Route("/api/member/cancel", "POST")
// @Api(Description="TMD")
// @ApiResponse(Description="Not authorized", StatusCode=401)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
// @DataContract
export class MemberCancel implements IReturn<MemberCancelResponse>, IPost
{
    /** @description The member id to cancel for */
    // @DataMember(Order=1)
    // @ApiMember(DataType="string", Description="The member id to cancel for", IsRequired=true, Name="MemberId", ParameterType="model")
    public memberId: string;

    /** @description The reason for canceling */
    // @DataMember(Order=2)
    // @ApiMember(DataType="string", Description="The reason for canceling", Name="CancelReason", ParameterType="model")
    public cancelReason?: string;

    public constructor(init?: Partial<MemberCancel>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MemberCancel'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MemberCancelResponse(); }
}

/** @description TMD */
// @Route("/api/member/apply", "POST")
// @Api(Description="TMD")
// @ApiResponse(Description="Not authorized", StatusCode=401)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
// @DataContract
export class PostResearchMemberApplication implements IReturn<PostResearchMemberApplicationResponse>, IPost
{
    /** @description The membership application */
    // @DataMember(Order=1)
    // @ApiMember(Description="The membership application", IsRequired=true, Name="Application", ParameterType="model")
    public application: ResearchMemberApplication;

    public constructor(init?: Partial<PostResearchMemberApplication>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostResearchMemberApplication'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PostResearchMemberApplicationResponse(); }
}

/** @description TMD */
// @Route("/api/member/supporter", "POST")
// @Api(Description="TMD")
// @ApiResponse(Description="Your request was not understood or failed validation.", ResponseType="typeof(TMD.Members.Requests.PostResearchMemberApplicationSupporterResponse)", StatusCode=400)
// @ApiResponse(Description="Requested information not found.", ResponseType="typeof(TMD.Members.Requests.PostResearchMemberApplicationSupporterResponse)", StatusCode=404)
// @ApiResponse(Description="Oops, something broke.", ResponseType="typeof(TMD.Members.Requests.PostResearchMemberApplicationSupporterResponse)", StatusCode=500)
// @DataContract
export class PostResearchMemberApplicationSupporter implements IReturn<PostResearchMemberApplicationSupporterResponse>, IPost
{
    /** @description The name of the supporter. */
    // @DataMember(Order=1)
    // @ApiMember(DataType="string", Description="The name of the supporter.", IsRequired=true, Name="Name", ParameterType="model")
    public name: string;

    public constructor(init?: Partial<PostResearchMemberApplicationSupporter>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostResearchMemberApplicationSupporter'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PostResearchMemberApplicationSupporterResponse(); }
}

/** @description TMD */
// @Route("/api/member-apply/support", "POST")
// @Api(Description="TMD")
// @ApiResponse(Description="Your request was not understood or failed validation.", ResponseType="typeof(TMD.Members.Requests.PostResearchMemberApplicationSupportResponse)", StatusCode=400)
// @ApiResponse(Description="Oops, something broke.", ResponseType="typeof(TMD.Members.Requests.PostResearchMemberApplicationSupportResponse)", StatusCode=500)
// @DataContract
export class PostResearchMemberApplicationSupport implements IReturn<PostResearchMemberApplicationSupportResponse>, IPost
{
    /** @description Whether the supporter approves or denies the application. */
    // @DataMember(Order=1)
    // @ApiMember(DataType="string", Description="Whether the supporter approves or denies the application.", IsRequired=true, Name="Action", ParameterType="model")
    public action: string;

    /** @description The member id of the supporter. */
    // @DataMember(Order=2)
    // @ApiMember(DataType="string", Description="The member id of the supporter.", IsRequired=true, Name="MemberId", ParameterType="model")
    public memberId: string;

    /** @description The guid of the application. */
    // @DataMember(Order=3)
    // @ApiMember(DataType="string", Description="The guid of the application.", IsRequired=true, Name="Guid", ParameterType="model")
    public guid: string;

    public constructor(init?: Partial<PostResearchMemberApplicationSupport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostResearchMemberApplicationSupport'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PostResearchMemberApplicationSupportResponse(); }
}

/** @description TMD */
// @Route("/api/member-apply/finalise-board-approve", "POST")
// @Api(Description="TMD")
// @ApiResponse(Description="Your request was not understood or failed validation.", StatusCode=400)
// @ApiResponse(Description="Oops, something broke.", StatusCode=500)
// @DataContract
export class FinaliseMemberApplicationBoardApprove implements IReturn<FinaliseMemberApplicationBoardApproveResponse>, IPost
{
    /** @description The member id of the applicant. */
    // @DataMember(Order=1)
    // @ApiMember(DataType="string", Description="The member id of the applicant.", IsRequired=true, Name="MemberId", ParameterType="model")
    public memberId: string;

    /** @description The newly created username. */
    // @DataMember(Order=2)
    // @ApiMember(DataType="string", Description="The newly created username.", IsRequired=true, Name="OnlineId", ParameterType="model")
    public onlineId: string;

    public constructor(init?: Partial<FinaliseMemberApplicationBoardApprove>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FinaliseMemberApplicationBoardApprove'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FinaliseMemberApplicationBoardApproveResponse(); }
}

/** @description TMD */
// @Route("/api/member/application", "POST")
// @Api(Description="TMD")
// @ApiResponse(Description="Not authorized", StatusCode=401)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
// @DataContract
export class SaveApplication implements IReturn<SaveApplicationResponse>, IPost
{
    /** @description The membership application */
    // @DataMember(Order=1)
    // @ApiMember(Description="The membership application", IsRequired=true, Name="Application", ParameterType="model")
    public application: Application;

    public constructor(init?: Partial<SaveApplication>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaveApplication'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SaveApplicationResponse(); }
}

/** @description TMD */
// @Route("/api/membership/exists", "GET")
// @Api(Description="TMD")
// @ApiResponse(Description="Not authorized", StatusCode=401)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
// @DataContract
export class GetMemberExists implements IReturn<GetMemberExistsResponse>, IGet
{
    /** @description The first name of the user to check */
    // @DataMember(Order=1)
    // @ApiMember(DataType="string", Description="The first name of the user to check", IsRequired=true, Name="FirstName", ParameterType="query")
    public firstName: string;

    /** @description The last name of the user to check */
    // @DataMember(Order=2)
    // @ApiMember(DataType="string", Description="The last name of the user to check", IsRequired=true, Name="LastName", ParameterType="query")
    public lastName: string;

    /** @description The email of the user to check */
    // @DataMember(Order=3)
    // @ApiMember(DataType="string", Description="The email of the user to check", IsRequired=true, Name="Email", ParameterType="query")
    public email: string;

    /** @description Whether to include ceased members in the search */
    // @DataMember(Order=3)
    // @ApiMember(DataType="boolean", Description="Whether to include ceased members in the search", Name="IncludedCeasedMembers", ParameterType="query")
    public includeCeasedMembers?: boolean;

    public constructor(init?: Partial<GetMemberExists>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMemberExists'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetMemberExistsResponse(); }
}

/** @description TMD */
// @Route("/api/members/specialities", "GET")
// @Api(Description="TMD")
// @ApiResponse(Description="Not authorized", StatusCode=401)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
// @DataContract
export class GetSpecialities implements IReturn<GetSpecialitiesResponse>, IGet
{

    public constructor(init?: Partial<GetSpecialities>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSpecialities'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetSpecialitiesResponse(); }
}

/** @description TMD */
// @Route("/api/members/interest-lookup", "GET")
// @Api(Description="TMD")
// @ApiResponse(Description="Not authorized", StatusCode=401)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
// @DataContract
export class GetInterestLookup implements IReturn<GetInterestLookupResponse>, IGet
{

    public constructor(init?: Partial<GetInterestLookup>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInterestLookup'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetInterestLookupResponse(); }
}

/** @description TMD */
// @Route("/api/member/update-profile", "POST")
// @Api(Description="TMD")
// @ApiResponse(Description="Not authorized", StatusCode=401)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
// @DataContract
export class PostMemberProfileUpdate implements IReturn<PostMemberProfileUpdateResponse>, IPost
{
    /** @description The user to update */
    // @DataMember(Order=1)
    // @ApiMember(Description="The user to update", IsRequired=true, Name="Username", ParameterType="model")
    public username: string;

    /** @description The member's speciality */
    // @DataMember(Order=2)
    // @ApiMember(Description="The member's speciality", IsRequired=true, Name="SpecialityId", ParameterType="model")
    public specialityId: number;

    /** @description The member's additional specialities */
    // @DataMember(Order=3)
    // @ApiMember(Description="The member's additional specialities", Name="AdditionalSpecialities", ParameterType="model")
    public additionalSpecialities?: AdditionalSpeciality[];

    /** @description The member's interest areas */
    // @DataMember(Order=4)
    // @ApiMember(Description="The member's interest areas", Name="InterestAreas", ParameterType="model")
    public interestAreas?: InterestArea[];

    public constructor(init?: Partial<PostMemberProfileUpdate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostMemberProfileUpdate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PostMemberProfileUpdateResponse(); }
}

/** @description Sign In */
// @Route("/auth", "GET,POST")
// @Route("/auth/{provider}", "GET,POST")
// @Api(Description="Sign In")
// @DataContract
export class Authenticate implements IReturn<AuthenticateResponse>, IPost
{
    /** @description AuthProvider, e.g. credentials */
    // @DataMember(Order=1)
    public provider: string;

    // @DataMember(Order=2)
    public userName: string;

    // @DataMember(Order=3)
    public password: string;

    // @DataMember(Order=4)
    public rememberMe?: boolean;

    // @DataMember(Order=5)
    public accessToken: string;

    // @DataMember(Order=6)
    public accessTokenSecret: string;

    // @DataMember(Order=7)
    public returnUrl: string;

    // @DataMember(Order=8)
    public errorView: string;

    // @DataMember(Order=9)
    public meta: { [index:string]: string; };

    public constructor(init?: Partial<Authenticate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'Authenticate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AuthenticateResponse(); }
}

// @Route("/assignroles", "POST")
// @DataContract
export class AssignRoles implements IReturn<AssignRolesResponse>, IPost
{
    // @DataMember(Order=1)
    public userName: string;

    // @DataMember(Order=2)
    public permissions: string[];

    // @DataMember(Order=3)
    public roles: string[];

    // @DataMember(Order=4)
    public meta: { [index:string]: string; };

    public constructor(init?: Partial<AssignRoles>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AssignRoles'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AssignRolesResponse(); }
}

// @Route("/unassignroles", "POST")
// @DataContract
export class UnAssignRoles implements IReturn<UnAssignRolesResponse>, IPost
{
    // @DataMember(Order=1)
    public userName: string;

    // @DataMember(Order=2)
    public permissions: string[];

    // @DataMember(Order=3)
    public roles: string[];

    // @DataMember(Order=4)
    public meta: { [index:string]: string; };

    public constructor(init?: Partial<UnAssignRoles>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UnAssignRoles'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UnAssignRolesResponse(); }
}

// @Route("/apikeys")
// @Route("/apikeys/{Environment}")
// @DataContract
export class GetApiKeys implements IReturn<GetApiKeysResponse>, IGet
{
    // @DataMember(Order=1)
    public environment: string;

    // @DataMember(Order=2)
    public meta: { [index:string]: string; };

    public constructor(init?: Partial<GetApiKeys>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetApiKeys'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetApiKeysResponse(); }
}

// @Route("/apikeys/regenerate")
// @Route("/apikeys/regenerate/{Environment}")
// @DataContract
export class RegenerateApiKeys implements IReturn<RegenerateApiKeysResponse>, IPost
{
    // @DataMember(Order=1)
    public environment: string;

    // @DataMember(Order=2)
    public meta: { [index:string]: string; };

    public constructor(init?: Partial<RegenerateApiKeys>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegenerateApiKeys'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RegenerateApiKeysResponse(); }
}

